(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._root_vjca1_2{box-sizing:border-box;background:var(--dixa-color-neutral-000);flex-direction:column;flex-grow:1;height:100%;display:flex}._slotLeft_vjca1_11,._slotCenter_vjca1_12,._slotRight_vjca1_13{align-items:center;gap:8px;display:flex}._slotLeft_vjca1_11{grid-area:slotLeft;justify-content:flex-start}._slotCenter_vjca1_12{text-align:center;grid-area:slotCenter;justify-content:center}._slotRight_vjca1_13{grid-area:slotRight;justify-content:flex-end}._head_vjca1_35{background-color:var(--dixa-color-neutral-000);gap:var(--dixa-size-spacer-300);min-height:64px;padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400);box-sizing:border-box;border-bottom:1px solid var(--dixa-color-neutral-200);grid-template:"slotLeft slotRight"/auto 1fr;display:grid}#pageHead{z-index:1;position:relative;container-type:inline-size}._head_vjca1_35:has(._slotCenter_vjca1_12){grid-template:"slotLeft slotCenter slotRight"/1fr auto 1fr}@container (width<=500px){._head_vjca1_35{padding:var(--dixa-size-spacer-300)}._head_vjca1_35:has(._slotCenter_vjca1_12){grid-template:"slotLeft slotRight""slotCenter slotCenter"/1fr 1fr}}@container (width<=300px){._head_vjca1_35{grid-template:"slotRight""slotLeft"/1fr}._head_vjca1_35:has(._slotCenter_vjca1_12){grid-template:"slotLeft""slotRight""slotCenter"/1fr}}._controls_vjca1_83{gap:var(--dixa-size-spacer-200);flex-wrap:wrap;justify-content:flex-end;display:inline-flex}._link_vjca1_90{justify-content:start;align-items:center;column-gap:var(--dixa-size-spacer-100);height:100%;color:var(--dixa-typography-color-link);font-size:var(--dixa-typography-size-300);text-decoration:none;display:flex}._link_vjca1_90:hover,._link_vjca1_90:focus{color:var(--dixa-color-blue-700)}._link_vjca1_90:active{color:var(--dixa-color-blue-900)}._linkArrow_vjca1_106{height:var(--dixa-typography-size-300);width:var(--dixa-typography-size-300);display:block}._body_vjca1_112{flex:1;position:relative;overflow-y:auto}._hablaPageBody_vjca1_122._hablaPageBody_vjca1_122{flex-direction:row}._modalBody_1eukg_1{width:600px}._message_8a2au_1{margin-bottom:var(--dixa-size-spacer-400)}._editor_friuv_1,._editor_friuv_1 .monaco-editor,._editor_friuv_1 .overflow-guard,._wrapper_11awi_1{border-radius:var(--dixa-size-border-radius-100)}._wrapperDark_11awi_5{background-color:var(--dixa-color-neutral-100);padding-left:calc(var(--dixa-size-spacer-300) * 1.25);padding-right:calc(var(--dixa-size-spacer-300) * 1.25)}._marginBottom_11awi_11{margin-bottom:var(--dixa-size-spacer-100)}._noFieldLabel_m67db_1>[data-testid=fieldLabel]{display:none}._tableWrapper_1vb1f_1{height:100%;overflow-y:auto}._table_1vb1f_1{border-collapse:collapse}._tableRow_1vb1f_10._isSyncedWithElevio_1vb1f_10 td{background-color:var(--dixa-color-neutral-000)}._tableRow_1vb1f_10 th:first-of-type,._tableRow_1vb1f_10 td:first-of-type{padding-left:var(--dixa-size-spacer-400);padding-top:var(--dixa-size-spacer-250);padding-bottom:var(--dixa-size-spacer-250)}._th_1vb1f_21,._td_1vb1f_22{padding:var(--dixa-size-spacer-300)}._th_1vb1f_21{background-color:var(--dixa-color-neutral-100);text-align:start}._th_1vb1f_21 .checkbox--checkbox__input{width:var(--dixa-size-spacer-300);height:var(--dixa-size-spacer-300);top:0;left:0}._td_1vb1f_22 a{text-decoration:none}._actionColumn_1vb1f_42{width:1%}._externalLink_1vb1f_46{align-items:center;gap:var(--dixa-size-spacer-200);display:flex}._internalLink_1vb1f_52{font-weight:var(--dixa-typography-weight-semibold);color:var(--dixa-typography-color-link);text-decoration:none}._wrapper_1j5v5_1{padding:var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100)}._header_1j5v5_7{cursor:pointer;padding:var(--dixa-size-spacer-200);color:var(--dixa-typography-color-primary);justify-content:space-between;align-items:center}._body_1j5v5_15{border-radius:var(--dixa-size-border-radius-100);background:var(--dixa-color-neutral-000);padding:var(--dixa-size-spacer-300)}._bodyOpen_1j5v5_21{margin-top:var(--dixa-size-spacer-200)}code,pre{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100)}code{padding:0 var(--dixa-size-spacer-100)}pre{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-100) var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300)}._code_1w4at_18 li{padding-bottom:var(--dixa-size-spacer-200)}._fieldSet_2u3fk_1{border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-400);padding-top:var(--dixa-size-spacer-400);padding-bottom:var(--dixa-size-spacer-200);margin-bottom:var(--dixa-size-spacer-300);box-sizing:border-box}._fieldSetLegend_2u3fk_11{padding:0 var(--dixa-size-spacer-200);margin-left:-var(--dixa-size-spacer-200)}._formField_1bcx8_1{margin-bottom:0}._fieldSet_1bcx8_5{padding:var(--dixa-size-spacer-400);margin-bottom:0}._pre_1bcx8_10{margin:0;margin-top:var(--dixa-size-spacer-100);text-overflow:ellipsis;flex-grow:1;flex-shrink:1}._copyIcon_1bcx8_18{display:block}._copied_1bcx8_22{color:var(--dixa-typography-color-success)}._alert_smz2d_1{margin-top:var(--dixa-size-spacer-100)}._uploadDropzoneWrapper_smz2d_5,._uploadImageWrapper_smz2d_6,._uploadDropzoneLoadingWrapper_smz2d_7{width:160px;height:80px}._uploadImageWrapper_smz2d_6{padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);box-sizing:border-box;min-width:160px}._uploadImage_smz2d_6{object-fit:contain;width:100%;height:100%;font-size:10px}._uploadDropzoneLoadingWrapper_smz2d_7{background-color:var(--dixa-color-neutral-100);border:1px dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);box-sizing:border-box;cursor:wait}._dropzone_1wf8u_1{background-color:var(--dixa-color-neutral-100);border:1px dashed var(--dixa-color-neutral-300);cursor:pointer;border-radius:3px}._dropzone_1wf8u_1._isFocused_1wf8u_7{background-color:var(--dixa-color-purple-100);border-color:var(--dixa-color-purple-500)}._dropzone_1wf8u_1._isDragAccept_1wf8u_11{background-color:var(--dixa-color-green-100);border-color:var(--dixa-color-green-500)}._dropzone_1wf8u_1._isDragReject_1wf8u_15{background-color:var(--dixa-color-red-100);border-color:var(--dixa-color-red-500)}._heading_1wf8u_20{margin-top:var(--dixa-size-spacer-100)}._uploadErrorText_1wf8u_24{margin-top:var(--dixa-size-spacer-300)}._table_tz287_1{border-collapse:collapse}._tabContentWrapper_1315b_1{container-type:inline-size}._tabContentContainer_1315b_5{overflow-y:auto}._tabContent_1315b_1{padding:var(--dixa-size-spacer-400);overflow-y:auto}._tabContent_1315b_1._inactive_1315b_14{display:none}._tabContent_1315b_1 form,._tabContent_1315b_1 ._preview_1315b_19{width:100%}._tabContent_1315b_1 form{box-sizing:border-box}._tabContent_1315b_1._customHostname_1315b_27 form{min-width:600px}@container (width>=800px){._tabContent_1315b_1{display:flex}._tabContent_1315b_1 form{width:50%;max-width:600px}._tabContent_1315b_1 ._preview_1315b_19{flex-grow:1;width:50%}}._tab_1315b_1{line-height:var(--dixa-typography-line-height-200);border-top:none}._tabsWrapper_1315b_49{padding:0 var(--dixa-size-spacer-400);border-bottom:1px solid var(--dixa-color-neutral-200)}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import * as e from "@apollo/client";
import { ApolloClient as t, ApolloLink as n, ApolloProvider as r, InMemoryCache as i, createHttpLink as a, from as o, gql as s } from "@apollo/client";
import { createPersistedQueryLink as c } from "@apollo/client/link/persisted-queries";
import { setContext as l } from "@apollo/client/link/context";
import { authManager as u } from "lib-shared-auth";
import { config as d } from "lib-shared-backend-config";
import { Badge as f, Banner as p, Box as m, Button as h, ButtonList as g, Collapsible as _, ColorPicker as v, DropdownButton as y, EmptyState as b, FieldAlert as x, FieldColorPicker as S, FieldSelect as C, FieldWrapper as w, FlexBox as T, FormField as E, FormGrid as D, Icon as ee, IconButton as te, InputSelectionList as O, InputText as ne, Modal as re, ModalBody as ie, ModalFoot as k, ModalHead as ae, Page as oe, SelectionList as se, Skeleton as A, Spinner as ce, Switch as le, Table as j, Tabs as ue, Tag as de, Text as M, Tooltip as fe } from "@dixa/lib-shared-habla";
import pe from "classnames";
import * as me from "react";
import he, { Fragment as ge, Suspense as _e, createContext as ve, forwardRef as ye, isValidElement as be, lazy as xe, memo as Se, useCallback as N, useContext as Ce, useEffect as P, useImperativeHandle as we, useMemo as Te, useReducer as Ee, useRef as F, useState as I } from "react";
import { Link as De, UNSAFE_DataRouterContext as Oe, UNSAFE_NavigationContext as ke, useLocation as Ae, useNavigate as je, useParams as Me, useRoutes as Ne } from "react-router-dom";
import { Fragment as L, jsx as R, jsxs as z } from "react/jsx-runtime";
import { Sentry as Pe, SentryTeam as Fe } from "lib-shared-sentry";
import { Controller as Ie, appendErrors as Le, get as Re, set as ze, useForm as Be } from "react-hook-form";
import { ampli as Ve } from "lib-shared-tracking";
// \0rolldown/runtime.js
var He = Object.create, Ue = Object.defineProperty, We = Object.getOwnPropertyDescriptor, Ge = Object.getOwnPropertyNames, Ke = Object.getPrototypeOf, qe = Object.prototype.hasOwnProperty, B = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, V = (e, t) => () => (t || (e((t = { exports: {} }).exports, t, t.exports), e = null), t.exports), Je = (e, t) => {
	let n = {};
	for (var r in e) Ue(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Ue(n, Symbol.toStringTag, { value: "Module" }), n;
}, Ye = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Ge(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !qe.call(e, s) && s !== n && Ue(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = We(t, s)) || r.enumerable
	});
	return e;
}, Xe = (e, t, n) => (n = e == null ? {} : He(Ke(e)), Ye(t || !e || !e.__esModule || !qe.call(e, "default") ? Ue(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), Ze = (e) => {
	let t = new DataView(e), n = "";
	for (let e = 0; e < t.byteLength; e += 4) n += t.getUint32(e).toString(16).padStart(8, "0");
	return n;
}, Qe = ((e) => async (t, { outputFormat: n = "hex" } = {}) => {
	typeof t == "string" && (t = new globalThis.TextEncoder().encode(t));
	let r = await globalThis.crypto.subtle.digest(e, t);
	return n === "hex" ? Ze(r) : r;
})("SHA-256"), $e = "authData";
async function et() {
	await u.getAuthData();
	let e = localStorage.getItem($e);
	return e ? JSON.parse(e) : null;
}
async function tt() {
	return `Bearer ${(await et())?.access_token}`;
}
// ../utils/src/apollo.ts
function nt() {
	return l(async (e, { headers: t }) => {
		let n = await tt();
		return { headers: {
			...t,
			authorization: n
		} };
	});
}
// ../management-common/src/apolloClient.ts
var rt = "beta";
function it() {
	let e = `${d.url.knowledgeApi}/management/api/${rt}/graphql`;
	return n.split((e) => !!e.getContext().longRunning, a({ uri: `${e}/long-running` }), a({ uri: e }));
}
var at = new i({ typePolicies: {
	Article: { fields: { tags: { merge(e, t) {
		return t;
	} } } },
	Collection: { merge: !0 },
	ArticleTranslation: { keyFields: [
		"articleId",
		"languageId",
		"version",
		["__typename"]
	] },
	TranslationQuery: { merge: !0 },
	ArticleList: { keyFields: ["query", ["results"]] },
	ArticleListItem: { fields: { titles: { merge(e, t) {
		return t;
	} } } },
	Query: { fields: {
		category: { read(e, { args: t, toReference: n }) {
			if (t?.id) return n({
				__typename: "Category",
				id: t.id
			});
		} },
		article: { read(e, { args: t, toReference: n }) {
			if (t?.id) return n({
				__typename: "Article",
				id: t.id
			});
		} },
		aiDraft: { read(e, { args: t, toReference: n }) {
			if (t?.id) return n({
				__typename: "AiDraft",
				id: t.id
			});
		} },
		articles: { keyArgs: ["$filters", "$query"] },
		collections: {
			keyArgs: !1,
			merge(e, t, { args: n }) {
				return !e || !n?.offset ? t : {
					...t,
					results: [...e.results.slice(0, n.offset), ...t.results]
				};
			}
		}
	} }
} }), ot;
function st() {
	if (!ot) {
		let e = o([
			c({
				sha256: Qe,
				useGETForHashedQueries: !1
			}),
			nt(),
			it()
		].filter(Boolean));
		ot = new t({
			link: e,
			cache: at,
			assumeImmutableResults: !0,
			defaultOptions: { query: { canonizeResults: !0 } },
			connectToDevTools: !0
		});
	}
	return ot;
}
// ../utils/src/components/page/page.module.scss
var ct, lt, ut, dt, ft, pt, mt, ht, gt, _t, vt, yt = B((() => {
	ct = "_root_vjca1_2", lt = "_slotLeft_vjca1_11", ut = "_slotCenter_vjca1_12", dt = "_slotRight_vjca1_13", ft = "_head_vjca1_35", pt = "_controls_vjca1_83", mt = "_link_vjca1_90", ht = "_linkArrow_vjca1_106", gt = "_body_vjca1_112", _t = "_hablaPageBody_vjca1_122", vt = {
		root: ct,
		slotLeft: lt,
		slotCenter: ut,
		slotRight: dt,
		head: ft,
		controls: pt,
		link: mt,
		linkArrow: ht,
		body: gt,
		hablaPageBody: _t
	};
}));
// ../utils/src/components/page/head.tsx
function bt({ title: e }) {
	return /* @__PURE__ */ R(M.Heading, {
		variant: "heading-2",
		as: "h1",
		"data-testid": "main-heading",
		children: e
	});
}
function xt({ subtitle: e }) {
	return /* @__PURE__ */ R(M.Paragraph, {
		variant: "4",
		subdued: !0,
		children: e
	});
}
var St, Ct, wt, Tt = B((() => {
	yt(), St = ({ backProps: e, backText: t }) => /* @__PURE__ */ z(De, {
		className: vt.link,
		...e,
		children: [/* @__PURE__ */ R(ee, {
			name: "angle-left",
			className: vt.linkArrow
		}), t]
	}), Ct = ({ title: e, subtitle: t, className: n }) => t ? /* @__PURE__ */ z(T, {
		className: n,
		flexDirection: "column",
		children: [/* @__PURE__ */ R(T, {
			alignItems: "center",
			children: /* @__PURE__ */ R(bt, { title: e })
		}), /* @__PURE__ */ R(m, { children: /* @__PURE__ */ R(xt, { subtitle: t }) })]
	}) : /* @__PURE__ */ R(T, {
		className: n,
		alignItems: "center",
		children: /* @__PURE__ */ R(bt, { title: e })
	}), wt = ({ className: e, slotCenter: t, slotLeft: n, slotRight: r, children: i }) => /* @__PURE__ */ z("div", {
		className: e,
		id: "pageHead",
		children: [/* @__PURE__ */ z("div", {
			className: pe("pageHead", vt.head),
			children: [
				!!n && /* @__PURE__ */ R(m, {
					className: vt.slotLeft,
					children: n
				}),
				!!t && /* @__PURE__ */ R(m, {
					className: vt.slotCenter,
					children: t
				}),
				!!r && /* @__PURE__ */ R(m, {
					className: vt.slotRight,
					children: r
				})
			]
		}), i && /* @__PURE__ */ R("div", { children: i })]
	});
})), Et, Dt, Ot = B((() => {
	Tt(), yt(), Et = ({ className: e, children: t, flexDirection: n, ...r }) => /* @__PURE__ */ R("div", {
		className: pe(vt.root, e),
		...r,
		children: t
	}), Dt = ({ children: e, padding: t, flexDirection: n, ...r }) => /* @__PURE__ */ R(oe.Body, {
		className: vt.hablaPageBody,
		...r,
		children: e
	}), Et.Body = Dt, Et.Head = wt, Et.HeadTitle = Ct, Et.HeadBackLink = St, Et.Section = oe.Section, Et.Tabs = oe.Tabs;
})), kt, At = B((() => {
	Ot(), kt = Et;
}));
// ../management-common/src/graphql.ts
function jt(t) {
	let n = {
		...H,
		...t
	};
	return e.useQuery(hn, n);
}
function Mt(t) {
	let n = {
		...H,
		...t
	};
	return e.useQuery(gn, n);
}
function Nt(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(_n, n);
}
function Pt(t) {
	let n = {
		...H,
		...t
	};
	return e.useQuery(vn, n);
}
function Ft(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(yn, n);
}
function It(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(bn, n);
}
function Lt(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(xn, n);
}
function Rt(t) {
	let n = {
		...H,
		...t
	};
	return e.useQuery(Sn, n);
}
function zt(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(Cn, n);
}
function Bt(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(wn, n);
}
function Vt(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(Tn, n);
}
function Ht(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(En, n);
}
function Ut(t) {
	let n = {
		...H,
		...t
	};
	return e.useQuery(Dn, n);
}
function Wt(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(On, n);
}
function Gt(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(kn, n);
}
function Kt(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(An, n);
}
function qt(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(jn, n);
}
function Jt(t) {
	let n = {
		...H,
		...t
	};
	return e.useMutation(Mn, n);
}
function Yt(t) {
	let n = {
		...H,
		...t
	};
	return e.useQuery(Nn, n);
}
function Xt(t) {
	let n = {
		...H,
		...t
	};
	return e.useQuery(Pn, n);
}
var H, Zt, Qt, $t, en, tn, nn, rn, an, on, sn, cn, ln, un, dn, fn, pn, mn, hn, gn, _n, vn, yn, bn, xn, Sn, Cn, wn, Tn, En, Dn, On, kn, An, jn, Mn, Nn, Pn, U = B((() => {
	H = {}, Zt = /* @__PURE__ */ function(e) {
		return e.NotAllowed = "NOT_ALLOWED", e.Taken = "TAKEN", e;
	}({}), Qt = /* @__PURE__ */ function(e) {
		return e.Ar = "ar", e.Bg = "bg", e.Ca = "ca", e.CaValencia = "ca_valencia", e.Cs = "cs", e.Da = "da", e.De = "de", e.DeAt = "de_at", e.DeBe = "de_be", e.DeCh = "de_ch", e.Ee = "ee", e.El = "el", e.En = "en", e.EnAu = "en_au", e.EnCa = "en_ca", e.EnGb = "en_gb", e.EnIe = "en_ie", e.EnNz = "en_nz", e.EnUs = "en_us", e.Es = "es", e.Es_419 = "es_419", e.Et = "et", e.Eu = "eu", e.Fa = "fa", e.Fi = "fi", e.Fr = "fr", e.FrBe = "fr_be", e.FrCa = "fr_ca", e.FrCh = "fr_ch", e.Gl = "gl", e.Hi = "hi", e.Hr = "hr", e.Hu = "hu", e.Id = "id", e.Is = "is", e.It = "it", e.ItCh = "it_ch", e.Iw = "iw", e.Ja = "ja", e.Ko = "ko", e.Lt = "lt", e.Lv = "lv", e.Nb = "nb", e.Nl = "nl", e.NlBe = "nl_be", e.Nn = "nn", e.No = "no", e.Pl = "pl", e.Pt = "pt", e.PtBr = "pt_br", e.Ro = "ro", e.Ru = "ru", e.Sk = "sk", e.Sl = "sl", e.Sq = "sq", e.Sr = "sr", e.Sv = "sv", e.Th = "th", e.Tr = "tr", e.Uk = "uk", e.Vi = "vi", e.Zh = "zh", e.ZhHant = "zh_hant", e;
	}({}), $t = /* @__PURE__ */ function(e) {
		return e.Active = "ACTIVE", e.Error = "ERROR", e.Pending = "PENDING", e;
	}({}), en = s`
  fragment AiDraftListItem on AiDraft {
    __typename
    id
    title
    type
    languageId
    createdAt
    modifiedAt
    initiatedFromConversation
    referencedConversationIds
    collectionId
    categoryId
    possibleCollectionIds
    forArticleId
    internalOnly
    isLocked
    initiatedBy {
      id
      name
      email
      avatarUrl
    }
    summary
    htmlContent
  }
`, s`
  fragment ArticleNode on Article {
    id
    parent {
      id
    }
    titles {
      title
      languageId
    }
  }
`, s`
  fragment ArticleListItemNode on ArticleListItem {
    id
    parentCategories {
      id
    }
    titles {
      title
      languageId
    }
  }
`, tn = s`
  fragment ArticleListItemResult on ArticleListItem {
    __typename
    id
    isSyncedWithElevio: isLocked
    title(languageId: $languageId)
    titles {
      languageId
      title
    }
    publicationStatus(languageId: $languageId)
    parentCollections {
      id
      internalKbEnabled
      title
      linkedResources {
        id
        name
        ... on Queue {
          id
          name
        }
      }
    }
    createdAt
    updatedAt
    createdBy {
      name
      deactivated
    }
    updatedBy {
      name
      deactivated
    }
    parentCategories {
      id
      title(languageId: $languageId)
      parentCollections {
        id
        title
      }
    }
  }
`, nn = s`
  fragment CategoryFields on Category {
    id
    parent {
      id
    }
    titles {
      title
      languageId
    }
    restrictions {
      direct
      inherited {
        restriction
        from {
          id
        }
      }
    }
    isSyncedWithElevio: isLocked
  }
`, rn = s`
  fragment ArticleFields on Article {
    id
    isSyncedWithElevio: isLocked
    updatedAt
    indexedAt
    parent {
      id
    }
    titles {
      title
      languageId
    }
    restrictions {
      direct
      inherited {
        restriction
        from {
          id
        }
      }
    }
  }
`, an = s`
  fragment CategoryChild on Category {
    ...CategoryFields
    articles {
      ...ArticleFields
    }
    categories {
      ...CategoryFields
    }
  }
  ${nn}
  ${rn}
`, s`
  fragment CategoryNode on Category {
    id
    parent {
      id
    }
    restrictions {
      direct
    }
  }
`, on = s`
  fragment CollectionFields on Collection {
    id
    title
    internalKbEnabled
    internalOnly
    isSyncedWithElevio: isLocked
    description
    themeColors {
      icon
    }
    linkedResources {
      id
      name
      ... on Queue {
        id
        name
      }
    }
    linkedHelpCenters {
      id
      name
    }
  }
`, sn = s`
  fragment LanguageFields on Language {
    languageId
    description
    nativeDescription
  }
`, cn = s`
  fragment ManagementOrganizationSettings on OrganisationSettingsPayload {
    availableLanguages {
      ...LanguageFields
    }
    defaultLanguage {
      ...LanguageFields
    }
    enabledLanguages {
      ...LanguageFields
    }
  }
  ${sn}
`, ln = s`
  fragment SettingsFields on SettingsPayload {
    isOrganisationSetup
    canCreateCollections
  }
`, un = s`
  fragment AiSettingsVersion on AiSettingsVersionPayload {
    id
    version
    name
    isDraft
    isActive
    createdAt
    settings {
      judgeInstructions
      internalJudgeInstructions
      writerInstructions
      similarity
      minSimilarConversations
    }
  }
`, dn = s`
  fragment ArticleFullFields on Article {
    id
    aiAssisted
    createdAt
    createdBy {
      name
      email
    }
    updatedAt
    updatedBy {
      name
      email
    }
    indexedAt
    indexedBy {
      name
      email
    }
    parent {
      id
      ... on Category {
        titles {
          title
          languageId
        }
      }
    }
    tags {
      id
      name
      color
      type
      isDeactivated
    }
    isSyncedWithElevio: isLocked
    noIndex
    titles {
      title
      languageId
    }
    translations {
      draft {
        languageId
        articleId
        title
        publicationStatus
        version {
          __typename
        }
      }
    }
    parentCollections {
      id
      title
    }
  }
`, fn = s`
  fragment ArticleTranslationFields on ArticleTranslation {
    articleId
    languageId
    version {
      __typename
    }
    title
    aiAssisted
    titleTranslatedAt
    titleUpdatedAt
    content
    updatedAt
    updatedBy {
      name
      email
    }
    publicationStatus
    seoTitle
    metaDescription
    slug
    effectiveSlug
    path
  }
`, pn = s`
  fragment HelpCenterCustomHostname on HelpCenter {
    id
    customHostname {
      hostname
      records {
        cname {
          record {
            aliasOf
            hostname
          }
          status
          verificationErrors
        }
        ssl {
          records {
            name
            value
          }
          status
        }
      }
    }
  }
`, mn = s`
  fragment HelpCenter on HelpCenter {
    id
    name
    subdomain
    hostname
    isHelpCenterIndexable
    googleSiteVerification
    collection {
      id
    }
    isActive
    favicon {
      availableAt
    }
    logo {
      filename
      fileType
      availableAt
      size
      uploadedAt
      originalFileName
    }
    companyUrl
    favicon {
      filename
      fileType
      availableAt
      size
      uploadedAt
      originalFileName
    }
    translations {
      languageId
      title
      tagline
    }
    theme {
      id
      colors {
        websiteBackground
        pageBackground
        text
        link
        accent
        accentText
      }
    }
    themeCustomization {
      headerHtml {
        value
        enabled
      }
      footerHtml {
        value
        enabled
      }
      css {
        value
        enabled
      }
      js {
        value
        enabled
      }
    }
    enabledLanguages {
      languageId
    }
    defaultLanguage {
      languageId
      description
    }
  }
`, s`
  fragment CategoryTitles on Category {
    id
    titles {
      title
      languageId
    }
  }
`, s`
  mutation AiDraftApprove($id: ID!, $alsoPublish: Boolean!) {
    aiDraftApprove(id: $id, alsoPublish: $alsoPublish) {
      id
    }
  }
`, s`
  query AiDraft($id: ID!) {
    aiDraft(id: $id) {
      ...AiDraftListItem
    }
  }
  ${en}
`, s`
  mutation AiDraftUpdate(
    $id: ID!
    $feedback: NonEmptyString
    $collectionId: ID
    $categoryId: ID
  ) {
    aiDraftUpdate(
      id: $id
      feedback: $feedback
      collectionId: $collectionId
      categoryId: $categoryId
    ) {
      ...AiDraftListItem
    }
  }
  ${en}
`, s`
  query AiDrafts(
    $searchQuery: NonEmptyString
    $filters: AiDraftFiltersInput
    $limit: Limit
    $offset: Offset
  ) {
    aiDrafts(
      searchQuery: $searchQuery
      filters: $filters
      limit: $limit
      offset: $offset
    ) {
      results {
        ...AiDraftListItem
      }
      pagination {
        hasMore
        end
        total
      }
    }
  }
  ${en}
`, s`
  mutation ArticleCreate(
    $translations: [ArticleTranslationInput!]!
    $parentId: ID!
  ) {
    articleCreate(translations: $translations, parentId: $parentId) {
      ...ArticleFields
    }
  }
  ${rn}
`, s`
  mutation ArticleDelete($id: ID!) {
    articleDelete(id: $id)
  }
`, s`
  mutation ArticleMove(
    $entityId: ID!
    $currentParentId: ID!
    $newParentId: ID
    $newPosition: PositiveInt
  ) {
    contentMove(
      entityId: $entityId
      currentParentId: $currentParentId
      newParentId: $newParentId
      newPosition: $newPosition
    ) {
      id
    }
  }
`, s`
  mutation ArticleTranslationUpdate(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString
    $content: ContentJson
    $titleUpdatedAt: String
    $titleTranslatedAt: String
  ) {
    articleTranslationUpdate(
      articleId: $articleId
      languageId: $languageId
      title: $title
      content: $content
      titleUpdatedAt: $titleUpdatedAt
      titleTranslatedAt: $titleTranslatedAt
    ) {
      ...ArticleTranslationFields
    }
  }
  ${fn}
`, s`
  mutation ArticleDetachFromElevio($id: ID!) {
    articleUnlock(id: $id) {
      id
      isSyncedWithElevio: isLocked
    }
  }
`, s`
  query Articles(
    $languageId: LanguageId!
    $limit: Limit
    $offset: Offset
    $filters: ArticleFiltersInput
    $query: ArticleSearchInput
  ) {
    articles(limit: $limit, offset: $offset) {
      query(query: $query, filters: $filters) {
        results {
          ...ArticleListItemResult
        }
        pagination {
          hasMore
          end
        }
      }
    }
  }
  ${tn}
`, s`
  mutation CategoryCreate(
    $parentId: ID!
    $translations: [CategoryTranslationInputInput!]!
  ) {
    categoryCreate(parentId: $parentId, translations: $translations) {
      ...CategoryFields
    }
  }
  ${nn}
`, s`
  mutation CategoryDelete($categoryId: ID!) {
    categoryDelete(id: $categoryId)
  }
`, s`
  query CategoryDropdown($collectionId: ID!) {
    collection(id: $collectionId) {
      categories {
        id
        isSyncedWithElevio: isLocked
        titles {
          title
          languageId
        }
        categories {
          id
          isSyncedWithElevio: isLocked
          titles {
            title
            languageId
          }
          categories {
            id
            isSyncedWithElevio: isLocked
            titles {
              title
              languageId
            }
            categories {
              id
              isSyncedWithElevio: isLocked
              titles {
                title
                languageId
              }
              categories {
                id
                isSyncedWithElevio: isLocked
                titles {
                  title
                  languageId
                }
              }
            }
          }
        }
      }
    }
  }
`, s`
  mutation CategoryMove(
    $entityId: ID!
    $currentParentId: ID!
    $newParentId: ID
    $newPosition: PositiveInt
  ) {
    contentMove(
      entityId: $entityId
      currentParentId: $currentParentId
      newParentId: $newParentId
      newPosition: $newPosition
    ) {
      id
      categories {
        id
        parent {
          id
        }
      }
    }
  }
`, s`
  query CategoryMoveQ($id: ID!) {
    category(id: $id) {
      id
      parent {
        id
      }
    }
  }
`, s`
  query CategoryNode($id: ID!) {
    category(id: $id) {
      ...CategoryChild
    }
  }
  ${an}
`, s`
  query Category($id: ID!) {
    category(id: $id) {
      id
      titles {
        languageId
        title
      }
      parent {
        id
      }
      restrictions {
        direct
      }
      isSyncedWithElevio: isLocked
    }
  }
`, s`
  mutation CategoryTranslationDelete($id: ID!, $languageId: LanguageId!) {
    categoryTranslationDelete(id: $id, languageId: $languageId) {
      ...CategoryFields
    }
  }
  ${nn}
`, s`
  mutation CategoryTranslationUpsert(
    $id: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
  ) {
    categoryTranslationUpsert(id: $id, languageId: $languageId, title: $title) {
      ...CategoryFields
    }
  }
  ${nn}
`, s`
  mutation CategoryUpdate($id: ID!) {
    categoryUpdate(id: $id) {
      ...CategoryFields
    }
  }
  ${nn}
`, s`
  mutation CollectionCreate(
    $title: NonEmptyString!
    $internalKbEnabled: Boolean!
    $internalOnly: Boolean
  ) {
    collectionCreate(
      title: $title
      internalKbEnabled: $internalKbEnabled
      internalOnly: $internalOnly
    ) {
      ...CollectionFields
    }
  }
  ${on}
`, s`
  mutation CollectionDelete($id: ID!) {
    collectionDelete(id: $id)
  }
`, s`
  mutation CollectionDetach($id: ID!) {
    collectionUnlock(id: $id) {
      ...CollectionFields
    }
  }
  ${on}
`, hn = s`
  query Collection($id: ID!) {
    collection(id: $id) {
      ...CollectionFields
    }
  }
  ${on}
`, s`
  query CollectionStats($id: ID!) {
    collection(id: $id) {
      id
      statistics {
        categoryCount
        articleCount
        queueCount
      }
    }
  }
`, s`
  query CollectionTree($id: ID!) {
    collection(id: $id) {
      ...CollectionFields
      categories {
        ...CategoryFields
        articles {
          ...ArticleFields
        }
        categories {
          ...CategoryFields
          articles {
            ...ArticleFields
          }
          categories {
            ...CategoryFields
            articles {
              ...ArticleFields
            }
            categories {
              ...CategoryFields
              articles {
                ...ArticleFields
              }
              categories {
                ...CategoryFields
                articles {
                  ...ArticleFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${on}
  ${nn}
  ${rn}
`, s`
  mutation CollectionUpdate(
    $id: ID!
    $title: NonEmptyString
    $externalResources: ResourcesUpdateInput
    $internalKbEnabled: Boolean!
    $internalOnly: Boolean
    $icon: Color!
    $description: String
  ) {
    collectionUpdate(
      id: $id
      title: $title
      externalResources: $externalResources
      internalKbEnabled: $internalKbEnabled
      internalOnly: $internalOnly
      themeColors: { icon: $icon }
      description: $description
    ) {
      ...CollectionFields
    }
  }
  ${on}
`, gn = s`
  query CollectionsFetch($offset: Offset, $limit: Limit) {
    collections(includeInternalOnly: true, offset: $offset, limit: $limit) {
      results {
        id
        title
        internalKbEnabled
        internalOnly
        isSyncedWithElevio: isLocked
      }
    }
    settings {
      ...SettingsFields
    }
  }
  ${ln}
`, _n = s`
  mutation FileUpload($fileName: NonEmptyString!) {
    fileUploadRequest(filename: $fileName) {
      uploadUrl
      method
      contentType
      customHeaders
      expiresAt
      filename
      availableAt
    }
  }
`, s`
  query OptimisticArticleParent($id: ID!) {
    category(id: $id) {
      id
      articles {
        id
      }
    }
  }
`, s`
  query OptimisticCategory($id: ID!) {
    category(id: $id) {
      id
      categories {
        id
        parent {
          id
        }
      }
    }
  }
`, s`
  query OptimisticCollection($id: ID!) {
    collection(id: $id) {
      id
      categories {
        id
        parent {
          id
        }
      }
    }
  }
`, s`
  mutation OrganizationEnableLanguages($languageIds: [LanguageId!]!) {
    organisationEnableLanguages(languageIds: $languageIds) {
      ...ManagementOrganizationSettings
    }
  }
  ${cn}
`, s`
  mutation OrganizationRemoveLanguage($languageId: LanguageId!) {
    organisationDisableLanguage(languageId: $languageId) {
      ...ManagementOrganizationSettings
    }
  }
  ${cn}
`, s`
  mutation OrganizationSetDefaultLanguage($languageId: LanguageId!) {
    organisationSetDefaultLanguage(languageId: $languageId) {
      ...ManagementOrganizationSettings
    }
  }
  ${cn}
`, vn = s`
  query OrganizationSettings {
    organisationSettings {
      ...ManagementOrganizationSettings
    }
  }
  ${cn}
`, s`
  query Owners {
    articles {
      owners {
        id
        name
        fullName {
          givenName
          middleNames
          familyName
        }
        avatarUrl
      }
    }
  }
`, s`
  mutation ParentAddChild($childId: ID!, $parentId: ID!) {
    parentAddChild(childId: $childId, parentId: $parentId) {
      id
    }
  }
`, s`
  query Settings {
    settings {
      ...SettingsFields
    }
  }
  ${ln}
`, s`
  mutation SetupOrganisation {
    setupOrganisation {
      id
      title
    }
  }
`, s`
  mutation AiDraftDelete($id: ID!) {
    aiDraftDelete(id: $id)
  }
`, s`
  query AiDraftLiveUpdate($id: ID!) {
    aiDraft(id: $id) {
      ...AiDraftListItem
      approvedAt
    }
  }
  ${en}
`, s`
  query AiDraftsByCsid($csid: Long!) {
    aiDraftsByCsid(csid: $csid) {
      ...AiDraftListItem
    }
  }
  ${en}
`, s`
  mutation AiDraftsGenerate($csid: Long!, $languageId: LanguageId!) {
    aiDraftsGenerate(csid: $csid, languageId: $languageId) {
      ...AiDraftListItem
    }
  }
  ${en}
`, s`
  mutation AiSettingsDraftUpdate(
    $judgeInstructions: String
    $internalJudgeInstructions: String
    $writerInstructions: String
    $minSimilarConversations: Int!
    $similarity: SimilarityLevel!
  ) {
    organisationUpdateAiSettingsDraft(
      judgeInstructions: $judgeInstructions
      internalJudgeInstructions: $internalJudgeInstructions
      writerInstructions: $writerInstructions
      minSimilarConversations: $minSimilarConversations
      similarity: $similarity
    ) {
      ...AiSettingsVersion
    }
  }
  ${un}
`, s`
  mutation AiSettingsVersionActivate($id: ID!) {
    organisationActivateAiSettingsVersion(id: $id) {
      ...AiSettingsVersion
    }
  }
  ${un}
`, s`
  mutation AiSettingsVersionCreate($name: String!, $activate: Boolean!) {
    organisationCreateAiSettingsVersion(name: $name, activate: $activate) {
      ...AiSettingsVersion
    }
  }
  ${un}
`, s`
  query AiSettingsVersion($id: ID) {
    aiSettingsVersion(id: $id) {
      ...AiSettingsVersion
    }
  }
  ${un}
`, s`
  mutation AiSettingsVersionRename($id: ID!, $name: String!) {
    organisationRenameAiSettingsVersion(id: $id, name: $name) {
      ...AiSettingsVersion
    }
  }
  ${un}
`, s`
  query AiSettingsVersions {
    aiSettingsVersions {
      id
      version
      name
      isActive
      createdAt
      createdBy {
        id
        name
        email
        avatarUrl
      }
    }
  }
`, s`
  query ArticleEditor($id: ID!) {
    article(id: $id) {
      ...ArticleFullFields
    }
  }
  ${dn}
`, s`
  query ArticleHasChanges($articleId: ID!) {
    article(id: $articleId) {
      id
      translations {
        draft {
          articleId
          languageId
          publicationStatus
        }
      }
    }
  }
`, s`
  query ArticleLinkLookup(
    $languageId: LanguageId!
    $filters: ArticleFiltersInput
    $query: ArticleSearchInput
  ) {
    articles(limit: 15, offset: 0) {
      query(query: $query, filters: $filters) {
        results {
          id
          title(languageId: $languageId)
          parentCategories {
            id
            title(languageId: $languageId)
          }
        }
      }
    }
  }
`, s`
  mutation ArticleNoIndexUpdate($articleId: ID!, $noIndex: Boolean!) {
    articleUpdate(id: $articleId, noIndex: $noIndex) {
      ...ArticleFullFields
    }
  }
  ${dn}
`, s`
  mutation ArticlePublish($articleId: ID!) {
    articlePublish(articleId: $articleId) {
      ...ArticleFullFields
    }
  }
  ${dn}
`, s`
  mutation ArticleTranslationDelete($articleId: ID!, $languageId: LanguageId!) {
    articleTranslationDelete(articleId: $articleId, languageId: $languageId)
  }
`, s`
  mutation ArticleTranslationDraftCreate(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
    $content: ContentJson!
  ) {
    articleTranslationCreate(
      articleId: $articleId
      languageId: $languageId
      title: $title
      content: $content
    ) {
      ...ArticleTranslationFields
    }
  }
  ${fn}
`, s`
  mutation ArticleTranslationDraftUpdate(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
    $content: ContentJson!
    $titleUpdatedAt: String
    $titleTranslatedAt: String
  ) {
    articleTranslationUpdate(
      articleId: $articleId
      languageId: $languageId
      title: $title
      content: $content
      titleUpdatedAt: $titleUpdatedAt
      titleTranslatedAt: $titleTranslatedAt
    ) {
      ...ArticleTranslationFields
    }
  }
  ${fn}
`, s`
  query ArticleTranslation($id: ID!, $languageId: LanguageId!) {
    articleTranslation(id: $id, languageId: $languageId) {
      articleId
      publicationStatus
      draft {
        ...ArticleTranslationFields
      }
    }
  }
  ${fn}
`, s`
  query ArticleTranslationHelpCenters($id: ID!, $languageId: LanguageId!) {
    article(id: $id) {
      id
      translation(languageId: $languageId) {
        draft {
          articleId
          languageId
          version {
            __typename
          }
          availableAt {
            helpCenters {
              id
              url
            }
          }
        }
      }
    }
  }
`, s`
  mutation ArticleTranslationPublish(
    $articleId: ID!
    $languageId: LanguageId!
  ) {
    articleTranslationPublish(articleId: $articleId, languageId: $languageId)
  }
`, s`
  mutation ArticleTranslationRevertDraft(
    $articleId: ID!
    $languageId: LanguageId!
    $version: PositiveInt
    $publish: Boolean
  ) {
    articleTranslationRevertDraft(
      articleId: $articleId
      languageId: $languageId
      version: $version
      publish: $publish
    ) {
      ...ArticleTranslationFields
    }
  }
  ${fn}
`, s`
  mutation ArticleTranslationSeoUpdate(
    $articleId: ID!
    $languageId: LanguageId!
    $seoTitle: String
    $metaDescription: String
    $slug: String
  ) {
    articleTranslationUpdate(
      articleId: $articleId
      languageId: $languageId
      seoTitle: $seoTitle
      metaDescription: $metaDescription
      slug: $slug
    ) {
      ...ArticleTranslationFields
    }
  }
  ${fn}
`, s`
  mutation ArticleTranslationUnpublish(
    $articleId: ID!
    $languageId: LanguageId!
  ) {
    articleTranslationUnpublish(articleId: $articleId, languageId: $languageId)
  }
`, s`
  query ArticleTranslationVersion(
    $articleId: ID!
    $languageId: LanguageId!
    $versionNumber: PositiveInt!
  ) {
    article(id: $articleId) {
      translation(languageId: $languageId) {
        version(versionNumber: $versionNumber) {
          articleId
          languageId
          version {
            __typename
          }
          title
          content
        }
      }
    }
  }
`, s`
  query ArticleTranslationVersions($articleId: ID!, $languageId: LanguageId!) {
    article(id: $articleId) {
      translations {
        versions(languageId: $languageId) {
          publishedAt
          publishedBy {
            name
          }
          title
          version {
            __typename
            ... on Indexed {
              versionNumber
            }
          }
          isCurrentlyIndexed
          aiAssisted
          referencedConversationIds
        }
      }
    }
  }
`, s`
  mutation ArticleUnpublish($articleId: ID!) {
    articleUnpublish(articleId: $articleId) {
      ...ArticleFullFields
    }
  }
  ${dn}
`, s`
  mutation ArticleUpdate($articleId: ID!, $tags: TagsInput) {
    articleUpdate(id: $articleId, tags: $tags) {
      ...ArticleFullFields
    }
  }
  ${dn}
`, yn = s`
  mutation HelpCenterAddCompanyLogo($id: ID!, $logo: String!) {
    helpCenterUpdate(id: $id, logo: $logo) {
      id
      logo {
        filename
        fileType
        availableAt
        size
        uploadedAt
        originalFileName
      }
    }
  }
`, bn = s`
  mutation HelpCenterAddFavicon($id: ID!, $favicon: String!) {
    helpCenterUpdate(id: $id, favicon: $favicon) {
      id
      favicon {
        filename
        fileType
        availableAt
        size
        uploadedAt
        originalFileName
      }
    }
  }
`, xn = s`
  mutation HelpCenterCreate(
    $subdomain: String!
    $translations: [HelpCenterTranslationInput!]!
    $name: NonEmptyString!
    $collectionId: ID!
    $defaultLanguageId: LanguageId!
    $isHelpCenterIndexable: Boolean!
  ) {
    helpCenterCreate(
      subdomain: $subdomain
      translations: $translations
      name: $name
      collectionId: $collectionId
      defaultLanguage: $defaultLanguageId
      isHelpCenterIndexable: $isHelpCenterIndexable
    ) {
      id
      name
      translation(languageId: $defaultLanguageId) {
        languageId
        title
        tagline
      }
      subdomain
      hostname
      customHostname {
        hostname
      }
      isHelpCenterIndexable
      collection {
        id
        title
      }
      isActive
      favicon {
        filename
        fileType
        availableAt
      }
      logo {
        filename
        fileType
        availableAt
      }
    }
  }
`, Sn = s`
  query HelpCenterCustomHostnameFetch($id: ID!) {
    helpCenter(id: $id) {
      ...HelpCenterCustomHostname
    }
  }
  ${pn}
`, Cn = s`
  mutation HelpCenterCustomizationDeleteFavicon($helpCenterId: ID!) {
    helpCenterUpdate(id: $helpCenterId, favicon: "") {
      favicon {
        availableAt
        filename
      }
    }
  }
`, wn = s`
  mutation HelpCenterCustomizationDeleteLogo($helpCenterId: ID!) {
    helpCenterUpdate(id: $helpCenterId, logo: "") {
      logo {
        availableAt
        filename
      }
    }
  }
`, Tn = s`
  mutation HelpCenterDelete($id: ID!, $deregisterCustomHostname: Boolean) {
    helpCenterDelete(
      id: $id
      deregisterCustomHostname: $deregisterCustomHostname
    )
  }
`, En = s`
  mutation HelpCenterDeregisterHostname($id: ID!) {
    helpCenterDeregisterHostname(id: $id) {
      ...HelpCenterCustomHostname
    }
  }
  ${pn}
`, Dn = s`
  query HelpCenterFetch($id: ID!) {
    helpCenter(id: $id) {
      ...HelpCenter
    }
  }
  ${mn}
`, On = s`
  mutation HelpCenterRegisterHostname($id: ID!, $customHostname: String!) {
    helpCenterRegisterHostname(id: $id, customHostname: $customHostname) {
      ...HelpCenterCustomHostname
    }
  }
  ${pn}
`, kn = s`
  mutation HelpCenterUpdateAdvancedCustomization(
    $helpCenterId: ID!
    $themeCustomization: HelpCenterThemeCustomizationInput!
  ) {
    helpCenterUpdate(
      id: $helpCenterId
      themeCustomization: $themeCustomization
    ) {
      id
      themeCustomization {
        headerHtml {
          value
          enabled
        }
        footerHtml {
          value
          enabled
        }
        css {
          value
          enabled
        }
        js {
          value
          enabled
        }
      }
    }
  }
`, An = s`
  mutation HelpCenterUpdateCustomization(
    $helpCenterId: ID!
    $themeId: ID!
    $colors: HelpCenterThemeColorsUpdateInput!
    $companyUrl: URL!
  ) {
    helpCenterUpdate(id: $helpCenterId, companyUrl: $companyUrl) {
      ...HelpCenter
    }
    helpCenterThemeUpdate(id: $themeId, colors: $colors) {
      id
      name
      colors {
        websiteBackground
        pageBackground
        text
        link
        accent
        accentText
      }
    }
  }
  ${mn}
`, jn = s`
  mutation HelpCenterUpdateCustomizationTranslations(
    $helpCenterId: ID!
    $translation: HelpCenterTranslationInput!
  ) {
    helpCenterUpdate(id: $helpCenterId, translation: $translation) {
      ...HelpCenter
    }
  }
  ${mn}
`, Mn = s`
  mutation HelpCenterUpdateSettings(
    $id: ID!
    $subdomain: String
    $collectionId: ID
    $active: Boolean!
    $name: NonEmptyString!
    $isHelpCenterIndexable: Boolean!
    $enableLanguages: [LanguageId!]
    $disableLanguages: [LanguageId!]
    $defaultLanguage: LanguageId
    $googleSiteVerification: String
  ) {
    helpCenterUpdate(
      id: $id
      subdomain: $subdomain
      collectionId: $collectionId
      active: $active
      name: $name
      isHelpCenterIndexable: $isHelpCenterIndexable
      enableLanguages: $enableLanguages
      disableLanguages: $disableLanguages
      defaultLanguage: $defaultLanguage
      googleSiteVerification: $googleSiteVerification
    ) {
      ...HelpCenter
    }
  }
  ${mn}
`, Nn = s`
  query HelpCenters {
    helpCenters(offset: 0, limit: 50) {
      results {
        id
        name
        hostname
        customHostname {
          hostname
        }
        isActive
        collection {
          id
          title
        }
      }
    }
  }
`, Pn = s`
  query SubdomainAvailability($subdomain: String!) {
    subdomainAvailability(subdomain: $subdomain) {
      isAvailable
      reason
    }
  }
`, s`
  mutation KnowledgeGapDraftCreate(
    $translations: [ArticleTranslationInput!]!
    $parentId: ID!
  ) {
    articleCreate(translations: $translations, parentId: $parentId) {
      id
    }
  }
`, s`
  mutation KnowledgeGapDraftUpsert(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
    $contentHtml: String!
  ) {
    articleTranslationUpsert(
      articleId: $articleId
      languageId: $languageId
      title: $title
      contentHtml: $contentHtml
      aiAssisted: true
    ) {
      articleId
      languageId
      version {
        __typename
      }
    }
  }
`, s`
  query KnowledgeGapJudge($csid: Long!, $aiSettingsVersionId: ID) {
    knowledgeGapJudge(csid: $csid, aiSettingsVersionId: $aiSettingsVersionId) {
      __typename
      ... on KnowledgeGapJudgeOutcome_Judged {
        similarConversationIds
        gaps {
          articleId
          aiDraftId
          gapType
          gapDescription
        }
        drafts {
          type
          internalOnly
          languageId
          forArticleId
          collection {
            id
            name
          }
          category {
            id
            name
          }
          title
          htmlContent
          summary
        }
      }
      ... on KnowledgeGapJudgeOutcome_NotEnoughSimilarConversations {
        similarConversationIds
        required
      }
      ... on KnowledgeGapJudgeOutcome_Skipped {
        reason
      }
    }
  }
`;
}));
At(), U();
function Fn({ selectedLanguageId: e, onCompleted: t, fetchPolicy: n = "cache-first" } = {}) {
	let { data: r, ...i } = Pt({
		fetchPolicy: n,
		onCompleted: t
	});
	return {
		...i,
		data: In(r, e)
	};
}
function In(e, t) {
	if (!e?.organisationSettings) return;
	let n = e.organisationSettings.enabledLanguages.find((e) => e.languageId === t) || e.organisationSettings.defaultLanguage;
	return {
		...e.organisationSettings,
		selectedLanguage: n
	};
}
// ../../../node_modules/serialize-query-params/dist/serialize.js
function Ln(e, t) {
	if (e == null) return e;
	if (e.length === 0 && (!t || t && e !== "")) return null;
	let n = e instanceof Array ? e[0] : e;
	return n == null ? n : !t && n === "" ? null : n;
}
function Rn(e) {
	return e == null ? e : String(e);
}
function zn(e) {
	let t = Ln(e, !0);
	return t == null ? t : String(t);
}
var Bn = B((() => {})), Vn, Hn = B((() => {
	Bn(), Vn = {
		encode: Rn,
		decode: zn
	};
}));
// ../../../node_modules/serialize-query-params/dist/objectToSearchString.js
function Un(e) {
	let t = new URLSearchParams(), n = Object.entries(e);
	for (let [e, r] of n) if (r != null) {
		if (Array.isArray(r)) for (let n of r) t.append(e, n ?? "");
		else t.append(e, r);
	}
	return t.toString();
}
var Wn = B((() => {})), Gn = B((() => {
	Xn(), "{}[],\":".split("").map((e) => [e, encodeURIComponent(e)]);
}));
// ../../../node_modules/serialize-query-params/dist/encodeQueryParams.js
function Kn(e, t) {
	let n = {}, r = Object.keys(t);
	for (let i of r) {
		let r = t[i];
		n[i] = e[i] ? e[i].encode(t[i]) : r == null ? r : String(r);
	}
	return n;
}
var qn = B((() => {}));
// ../../../node_modules/serialize-query-params/dist/searchStringToObject.js
function Jn(e) {
	let t = new URLSearchParams(e), n = {};
	for (let [e, r] of t) Object.prototype.hasOwnProperty.call(n, e) ? Array.isArray(n[e]) ? n[e].push(r) : n[e] = [n[e], r] : n[e] = r;
	return n;
}
var Yn = B((() => {})), Xn = B((() => {
	Hn(), Gn(), qn(), Yn(), Wn();
})), Zn = B((() => {})), Qn, $n, er = B((() => {
	Qn = class {
		constructor() {
			this.paramsMap = /* @__PURE__ */ new Map(), this.registeredParams = /* @__PURE__ */ new Map();
		}
		set(e, t, n, r) {
			this.paramsMap.set(e, {
				stringified: t,
				decoded: n,
				decode: r
			});
		}
		has(e, t, n) {
			if (!this.paramsMap.has(e)) return !1;
			let r = this.paramsMap.get(e);
			return r ? r.stringified === t && (n == null || r.decode === n) : !1;
		}
		get(e) {
			if (this.paramsMap.has(e)) return this.paramsMap.get(e)?.decoded;
		}
		registerParams(e) {
			for (let t of e) {
				let e = this.registeredParams.get(t) || 0;
				this.registeredParams.set(t, e + 1);
			}
		}
		unregisterParams(e) {
			for (let t of e) {
				let e = (this.registeredParams.get(t) || 0) - 1;
				e <= 0 ? (this.registeredParams.delete(t), this.paramsMap.has(t) && this.paramsMap.delete(t)) : this.registeredParams.set(t, e);
			}
		}
		clear() {
			this.paramsMap.clear(), this.registeredParams.clear();
		}
	}, $n = new Qn();
}));
// ../../../node_modules/use-query-params/dist/inheritedParams.js
function tr(e, t) {
	let n = {}, r = !1, i = Object.keys(e), a = i;
	if (t.includeKnownParams || t.includeKnownParams !== !1 && i.length === 0) {
		let e = Object.keys(t.params ?? {});
		a.push(...e);
	}
	for (let i of a) {
		let a = e[i];
		typeof a == "object" && a ? n[i] = a : (r = !0, n[i] = t.params?.[i] ?? Vn);
	}
	return r ? n : e;
}
function nr(e, t, n, r) {
	if (!n || !t.length) return e;
	let i = { ...e }, a = !1;
	for (let e of t) Object.prototype.hasOwnProperty.call(i, e) || (i[e] = n[e] ?? r, a = !0);
	return a ? i : e;
}
var rr = B((() => {
	Xn();
}));
// ../../../node_modules/use-query-params/dist/shallowEqual.js
function ir(e, t) {
	return e === t ? e !== 0 || t !== 0 || 1 / e == 1 / t : e !== e && t !== t;
}
function ar(e, t, n) {
	if (ir(e, t)) return !0;
	if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
	let r = Object.keys(e), i = Object.keys(t);
	if (r.length !== i.length) return !1;
	for (let i = 0; i < r.length; i++) {
		let a = n?.[r[i]]?.equals ?? ir;
		if (!or.call(t, r[i]) || !a(e[r[i]], t[r[i]])) return !1;
	}
	return !0;
}
var or, sr = B((() => {
	or = Object.prototype.hasOwnProperty;
}));
// ../../../node_modules/use-query-params/dist/latestValues.js
function cr(e, t, n) {
	let r = {}, i = Object.keys(t);
	for (let a of i) {
		let i = t[a], o = e[a], s;
		if (n.has(a, o, i.decode)) s = n.get(a);
		else {
			if (s = i.decode(o), i.equals && n.has(a, o)) {
				let e = n.get(a);
				i.equals(s, e) && (s = e);
			}
			s !== void 0 && n.set(a, o, s, i.decode);
		}
		s === void 0 && i.default !== void 0 && (s = i.default), r[a] = s;
	}
	return r;
}
function lr() {
	let e;
	function t(t, n, r) {
		let i = cr(t, n, r);
		return e != null && ar(e, i) ? e : (e = i, i);
	}
	return t;
}
var ur = B((() => {
	sr();
}));
// ../../../node_modules/use-query-params/dist/urlName.js
function dr(e) {
	let t;
	for (let n in e) if (e[n].urlName) {
		let r = `${e[n].urlName}\0${n}`;
		t ? t.push(r) : t = [r];
	}
	return t ? t.join("\n") : void 0;
}
function fr(e) {
	if (e) return Object.fromEntries(e.split("\n").map((e) => e.split("\0")));
}
function pr(e, t) {
	let n = {};
	for (let r in e) t[r]?.urlName == null ? n[r] = e[r] : n[t[r].urlName] = e[r];
	return n;
}
var mr = B((() => {})), hr, gr, _r, vr, yr, br = B((() => {
	sr(), mr(), vr = {}, yr = (e, t, n) => {
		if (hr === t && _r === e && gr === n) return vr;
		hr = t, _r = e;
		let r = e(t ?? "");
		gr = n;
		let i = fr(n);
		for (let [e, t] of Object.entries(r)) {
			i?.[e] && (delete r[e], e = i[e], r[e] = t);
			let n = vr[e];
			ar(t, n) && (r[e] = n);
		}
		return vr = r, r;
	};
}));
// ../../../node_modules/use-query-params/dist/options.js
function xr(e, t) {
	t ??= {};
	let n = {
		...e,
		...t
	};
	return t.params && e.params && (n.params = {
		...e.params,
		...t.params
	}), n;
}
var Sr, Cr = B((() => {
	Xn(), Sr = {
		searchStringToObject: Jn,
		objectToSearchString: Un,
		updateType: "pushIn",
		includeKnownParams: void 0,
		includeAllParams: !1,
		removeDefaultsFromUrl: !1,
		enableBatching: !1,
		skipUpdateWhenNoChange: !0
	};
}));
// ../../../node_modules/use-query-params/dist/QueryParamProvider.js
function wr() {
	let e = me.useContext(Or);
	if (e === void 0 || e === Dr) throw Error("useQueryParams must be used within a QueryParamProvider");
	return e;
}
function Tr({ children: e, adapter: t, options: n }) {
	let { adapter: r, options: i } = me.useContext(Or), a = me.useMemo(() => ({
		adapter: t ?? r,
		options: xr(i, n)
	}), [
		t,
		n,
		r,
		i
	]);
	return /* @__PURE__ */ me.createElement(Or.Provider, { value: a }, e);
}
function Er({ children: e, adapter: t, options: n }) {
	let r = t;
	return r ? /* @__PURE__ */ me.createElement(r, null, (t) => /* @__PURE__ */ me.createElement(Tr, {
		adapter: t,
		options: n
	}, e)) : /* @__PURE__ */ me.createElement(Tr, { options: n }, e);
}
var Dr, Or, kr = B((() => {
	Cr(), Dr = {
		adapter: {},
		options: Sr
	}, Or = me.createContext(Dr);
}));
// ../../../node_modules/use-query-params/dist/removeDefaults.js
function Ar(e, t) {
	for (let n in e) t[n]?.default !== void 0 && e[n] !== void 0 && t[n].encode(t[n].default) === e[n] && (e[n] = void 0);
}
var jr = B((() => {}));
// ../../../node_modules/use-query-params/dist/updateSearchString.js
function Mr({ changes: e, updateType: t, currentSearchString: n, paramConfigMap: r, options: i }) {
	let { searchStringToObject: a, objectToSearchString: o } = i;
	t ??= i.updateType;
	let s, c = yr(a, n), l = nr(r, Object.keys(e), i.params), u;
	u = typeof e == "function" ? e(cr(c, l, $n)) : e, s = Kn(l, u), i.removeDefaultsFromUrl && Ar(s, l), s = pr(s, l);
	let d;
	return d = o(t === "push" || t === "replace" ? s : {
		...c,
		...s
	}), d?.length && d[0] !== "?" && (d = `?${d}`), d ?? "";
}
function Nr({ searchString: e, adapter: t, navigate: n, updateType: r }) {
	let i = {
		...t.location,
		search: e
	};
	n && (typeof r == "string" && r.startsWith("replace") ? t.replace(i) : t.push(i));
}
function Pr(e, { immediate: t } = {}) {
	Lr.push(e);
	let n = t ? Fr : Ir;
	Lr.length === 1 && n(() => {
		let t = Lr.slice();
		Lr.length = 0;
		let n = t[0].currentSearchString, r;
		for (let e = 0; e < t.length; ++e) r = Mr(e === 0 ? t[e] : {
			...t[e],
			currentSearchString: r
		});
		e.options.skipUpdateWhenNoChange && r === n || Nr({
			searchString: r ?? "",
			adapter: t[t.length - 1].adapter,
			navigate: !0,
			updateType: t[t.length - 1].updateType
		});
	});
}
var Fr, Ir, Lr, Rr = B((() => {
	Xn(), er(), rr(), ur(), br(), jr(), mr(), Fr = (e) => e(), Ir = (e) => setTimeout(() => e(), 0), Lr = [];
}));
// ../../../node_modules/use-query-params/dist/useQueryParams.js
function zr(e, t) {
	let { adapter: n, options: r } = wr(), [i] = I(lr), { paramConfigMap: a, options: o } = Br(e, t), s = Te(() => xr(r, o), [r, o]), c = tr(a, s), l = yr(s.searchStringToObject, n.location.search, dr(c));
	s.includeAllParams && (c = nr(c, Object.keys(l), s.params, Vn));
	let u = i(l, c, $n), d = Object.keys(c).join("\0");
	P(() => {
		let e = d.split("\0");
		return $n.registerParams(e), () => {
			$n.unregisterParams(e);
		};
	}, [d]);
	let f = {
		adapter: n,
		paramConfigMap: c,
		options: s
	}, p = F(f);
	p.current ??= f, P(() => {
		p.current.adapter = n, p.current.paramConfigMap = c, p.current.options = s;
	}, [
		n,
		c,
		s
	]);
	let [m] = I(() => (e, t) => {
		let { adapter: n, paramConfigMap: r, options: i } = p.current;
		t ??= i.updateType, Pr({
			changes: e,
			updateType: t,
			currentSearchString: n.location.search,
			paramConfigMap: r,
			options: i,
			adapter: n
		}, { immediate: !i.enableBatching });
	});
	return [u, m];
}
function Br(e, t) {
	let n, r;
	return e === void 0 ? (n = {}, r = t) : Array.isArray(e) ? (n = Object.fromEntries(e.map((e) => [e, "inherit"])), r = t) : (n = e, r = t), {
		paramConfigMap: n,
		options: r
	};
}
var Vr, Hr = B((() => {
	Xn(), er(), rr(), ur(), br(), Cr(), kr(), Rr(), mr(), Vr = zr;
})), Ur, Wr = B((() => {
	Hr(), Ur = (e, t, n) => {
		let r = Te(() => ({ [e]: t ?? "inherit" }), [e, t]), [i, a] = Vr(r, n);
		return [i[e], N((t, n) => a(typeof t == "function" ? (n) => {
			let r = t(n[e]);
			return { [e]: r };
		} : { [e]: t }, n), [e, a])];
	};
})), Gr = B((() => {
	Hr();
})), Kr = B((() => {
	Hr();
})), qr = B((() => {
	Xn(), Zn(), Wr(), Hr(), Gr(), Kr(), kr();
}));
// ../management-common/src/contexts/language.ts
function Jr() {
	let [e, t] = Ur("langId", Vn);
	return [e || null, t];
}
var Yr, Xr = B((() => {
	qr(), Yr = ve({}), Yr.displayName = "LanguageContext";
}));
// ../management-common/src/contexts/languageProvider.tsx
Xr();
var Zr = ({ children: e }) => {
	let [t, n] = Jr(), { data: r, loading: i, error: a } = Fn({
		selectedLanguageId: t,
		fetchPolicy: "cache-and-network"
	});
	if (a) throw a;
	return i || !r ? /* @__PURE__ */ R(kt, { children: /* @__PURE__ */ R(T, {
		width: "100%",
		height: "100%",
		justifyContent: "center",
		alignItems: "center",
		children: /* @__PURE__ */ R(ce, { size: 64 })
	}) }) : /* @__PURE__ */ R(Yr.Provider, {
		value: {
			...r,
			currentLanguage: t,
			setCurrentLanguage: n
		},
		children: e
	});
};
// ../modal/src/Context.tsx
function Qr({ children: e }) {
	let [t, n] = I(null), r = N((e, t) => {
		n({
			modal: e,
			props: t
		});
	}, []), i = N(() => n(null), []), [a, o] = t ? [t.modal, t.props] : [];
	return /* @__PURE__ */ z(ei.Provider, {
		value: {
			showModal: r,
			hideModal: i
		},
		children: [e, /* @__PURE__ */ R(_e, {
			fallback: null,
			children: a && /* @__PURE__ */ R(a, { ...o })
		})]
	});
}
function $r() {
	let { showModal: e, hideModal: t } = Ce(ei);
	return {
		showModal: e,
		hideModal: t
	};
}
var ei, ti = B((() => {
	ei = ve({
		hideModal: () => {},
		showModal: () => {}
	});
})), ni, ri, ii = B((() => {
	ni = "_modalBody_1eukg_1", ri = { modalBody: ni };
}));
// ../modal/src/ModalWrapper/index.tsx
function ai({ children: e, className: t, allowEscClose: n = !0 }) {
	let { hideModal: r } = $r();
	return /* @__PURE__ */ R(re, {
		allowEscClose: n,
		className: pe(ri.modalBody, t),
		isOpen: !0,
		onClose: r,
		children: e
	});
}
var oi = B((() => {
	ti(), ii();
})), si = B((() => {
	ti(), oi();
}));
// ../utils/src/components/bugTracking.tsx
si();
function ci({ children: e, fallback: t }) {
	function n(e) {
		Pe.captureException(e, { tags: { team: Fe.Knowledge } });
	}
	return /* @__PURE__ */ R(Pe.ErrorBoundary, {
		fallback: t,
		onError: n,
		children: e
	});
}
var li = { message: "_message_8a2au_1" };
// ../utils/src/components/knowledgeErrorPlaceholder.tsx
function ui({ message: e }) {
	return /* @__PURE__ */ R(M.Paragraph, {
		className: li.message,
		variant: "4",
		subdued: !0,
		children: e || "Something went wrong, please reload and try again. If this issue persists, please contact support."
	});
}
// ../utils/src/components/loading.tsx
function di(e) {
	let { width: t = "100%", height: n = "100%", size: r = 56, ...i } = e;
	return /* @__PURE__ */ z(T, {
		style: {
			width: t,
			height: n,
			display: "inline-flex"
		},
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
		background: "neutral.000",
		children: [/* @__PURE__ */ R(ce, {
			...i,
			size: r
		}), e.text && /* @__PURE__ */ R(M.Paragraph, {
			padding: "300",
			children: e.text
		})]
	});
}
// ../utils/src/contexts/notification.tsx
var fi, pi = B((() => {
	fi = ve((e) => {
		console.log("Notification: ", e);
	}), fi.displayName = "NotificationContext";
}));
// ../../../node_modules/use-query-params/adapters/react-router-6/index.js
pi();
var mi = ({ children: e }) => {
	let { navigator: t } = Ce(ke), n = je(), r = Ce(Oe)?.router, i = Ae();
	return e({
		replace(e) {
			n(e.search || "?", {
				replace: !0,
				state: e.state
			});
		},
		push(e) {
			n(e.search || "?", {
				replace: !1,
				state: e.state
			});
		},
		get location() {
			return r?.state?.location ?? t?.location ?? i;
		}
	});
}, hi, gi = B((() => {
	hi = ve({ seoMeta: !1 });
})), _i = /* @__PURE__ */ V(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.path = void 0;
	function t(e) {
		let a = n(e), o = (e) => "/" + a.map((t) => t.kind === "param" ? i(e, t.paramName) : t.value).filter((e) => e !== "").join("/");
		if (o.pattern = r(e), o.parts = a, o.path = (n) => t(`${e}/${n}`), !o.pattern.startsWith("/")) throw Error(`Paths must begin with slashes, but ${JSON.stringify(o.pattern)} doesn't.`);
		return o;
	}
	e.path = t;
	function n(e) {
		return e.split("/").map((e) => e.startsWith(":") ? {
			kind: "param",
			paramName: e.replace(/^:/, "")
		} : {
			kind: "constant",
			value: e
		});
	}
	function r(e) {
		return e === "/" ? e : e.replace(/\/+/g, "/").replace(/^(.+)\/$/, (e, t) => t);
	}
	function i(e, t) {
		let n = e[t];
		if (typeof n != "string") throw Error(`When generating a path, the path param ${JSON.stringify(t)} didn't exist on params object ${JSON.stringify(e)}. The types should have prevented this, so either you defeated them (e.g., with \`as\`) or this is a bug!`);
		return n;
	}
})), vi, yi, bi, xi, Si, Ci, wi, Ti, Ei, Di, Oi, ki, Ai, ji, Mi, Ni, Pi, Fi, Ii, Li = B((() => {
	vi = _i(), qr(), yi = (0, vi.path)("/knowledge"), bi = yi.path("/collection"), xi = yi.path("/collection/:collectionId"), Si = yi.path("/settings"), Ci = Si.path("/ai-suggestions"), wi = Ci.path("/versions"), Ti = wi.path("/:versionId"), Ei = yi.path("/article-editor/:articleId"), Di = Ei.path("/version-history"), Oi = yi.path("/articles"), ki = yi.path("/article-suggestions"), Ai = (0, vi.path)("/internal-kb"), ji = Ai.path("/collection/:collectionId"), Mi = Ai.path("/collection/:collectionId/article/:articleId"), Ni = (0, vi.path)("/settings"), Pi = Ni.path("/help-centers"), Fi = Pi.path("/:helpCenterId"), Ii = {
		content: () => bi({}),
		articleSuggestions: () => ki({}),
		articles: (e) => e?.length ? `${Oi({})}?${e}` : Oi({}),
		collectionEdit: ({ collectionId: e, articlesFiltersStore: t }) => {
			let { collectionId: n, ...r } = t, i = Un(r);
			return i.length ? `${xi({ collectionId: e })}?${i}` : xi({ collectionId: e });
		},
		articleVersionHistory: ({ articleId: e, languageId: t }) => {
			let n = Di({ articleId: e });
			return t ? `${n}?langId=${t}` : n;
		},
		articleEdit: ({ articleId: e, collectionId: t, languageId: n }) => {
			let r = {};
			n && (r.langId = n), t && (r.collectionId = t);
			let i = Object.keys(r).length > 0 ? new URLSearchParams(r).toString() : "";
			return `${Ei({ articleId: e })}${i.length ? `?${i}` : ""}`;
		},
		knowledgeSettingsPath: () => Si({}),
		aiSuggestionsSettings: () => Ci({}),
		aiSuggestionsVersions: () => wi({}),
		aiSuggestionsVersion: ({ versionId: e }) => Ti({ versionId: e }),
		internalKBDashboard: () => Ai({}),
		internalKBCollection: ({ collectionId: e }) => ji({ collectionId: e }),
		internalKBArticle: ({ collectionId: e, articleId: t, languageId: n }) => ({
			path: Mi({
				collectionId: e,
				articleId: t
			}),
			search: `langId=${n}`
		}),
		helpCentersPath: () => Pi({}),
		helpCenterSettingsPath: ({ helpCenterId: e }) => Fi({ helpCenterId: e })
	};
}));
// src/components/helpCenterErrorMessage.tsx
function Ri({ errorMessage: e }) {
	return /* @__PURE__ */ R(b, {
		title: "Something went wrong",
		description: e,
		icon: "exclamation"
	});
}
var zi = B((() => {}));
// ../../../node_modules/@hookform/resolvers/dist/resolvers.mjs
function Bi(e) {
	return e.replace(/\[(\d+)]/g, ".$1").replace(/[[\]]/g, "");
}
var Vi, Hi, Ui, Wi, Gi = B((() => {
	Vi = (e, t, n) => {
		if (e && "reportValidity" in e) {
			let r = Re(n, t);
			e.setCustomValidity(r && r.message || ""), e.reportValidity();
		}
	}, Hi = (e, t) => {
		for (let n in t.fields) {
			let r = t.fields[n];
			r && r.ref && "reportValidity" in r.ref ? Vi(r.ref, n, e) : r && r.refs && r.refs.forEach((t) => Vi(t, n, e));
		}
	}, Ui = (e, t) => {
		t.shouldUseNativeValidation && Hi(e, t);
		let n = {};
		for (let r in e) {
			let i = Re(t.fields, r), a = Object.assign(e[r] || {}, { ref: i && i.refs ? i.refs[0] : i && i.ref });
			if (Wi(t.names || Object.keys(e), r)) {
				let e = Object.assign({}, Re(n, r));
				ze(e, "root", a), ze(n, r, e);
			} else ze(n, r, a);
		}
		return n;
	}, Wi = (e, t) => {
		let n = Bi(t).replace(/[.*+?^${}()|\\]/g, "\\$&");
		return e.some((e) => Bi(e).match(`^${n}\\.\\d+`));
	};
}));
// ../../../node_modules/@hookform/resolvers/zod/dist/zod.mjs
function Ki() {
	return Ki = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, Ki.apply(null, arguments);
}
function qi(e, t) {
	try {
		var n = e();
	} catch (e) {
		return t(e);
	}
	return n && n.then ? n.then(void 0, t) : n;
}
function Ji(e, t) {
	for (var n = Object.create(null); e.length;) {
		var r = e[0], i = r.code, a = r.message, o = r.path.join(".");
		if (!n[o]) {
			if ("unionErrors" in r) {
				var s = r.unionErrors.reduce(function(e, t) {
					return t.errors.length < e.errors.length ? t : e;
				}).errors[0];
				n[o] = {
					message: s?.message ?? a,
					type: s?.code ?? i
				};
			} else n[o] = {
				message: a,
				type: i
			};
		}
		if ("unionErrors" in r && r.unionErrors.forEach(function(t) {
			return t.errors.forEach(function(t) {
				return e.push(t);
			});
		}), t) {
			var c = n[o].types, l = c && c[r.code];
			n[o] = Le(o, t, n, i, l ? [].concat(l, r.message) : r.message);
		}
		e.shift();
	}
	return n;
}
function Yi(e, t) {
	for (var n = Object.create(null), r = function() {
		var r = e[0], i = r.code, a = r.message, o = r.path.join(".");
		if (!n[o]) {
			if (r.code === "invalid_union" && r.errors.length > 0) {
				var s = r.errors.reduce(function(e, t) {
					return t.length < e.length ? t : e;
				})[0];
				n[o] = {
					message: s?.message ?? a,
					type: s?.code ?? i
				};
			} else n[o] = {
				message: a,
				type: i
			};
		}
		if (r.code === "invalid_union" && r.errors.forEach(function(t) {
			return t.forEach(function(t) {
				return e.push(Ki({}, t, { path: [].concat(r.path, t.path) }));
			});
		}), t) {
			var c = n[o].types, l = c && c[r.code];
			n[o] = Le(o, t, n, i, l ? [].concat(l, r.message) : r.message);
		}
		e.shift();
	}; e.length;) r();
	return n;
}
function Xi(e, t, n) {
	if (n === void 0 && (n = {}), function(e) {
		return "_zod" in e && typeof e._zod == "object";
	}(e)) return function(r, i, a) {
		try {
			return Promise.resolve(qi(function() {
				function i(e) {
					return a.shouldUseNativeValidation && Hi({}, a), {
						errors: {},
						values: n.raw ? Object.assign({}, r) : e
					};
				}
				var o = e;
				return n.mode === "sync" ? i(o.parse(r, t)) : Promise.resolve(o.parseAsync(r, t)).then(i);
			}, function(e) {
				if (function(e) {
					var t;
					return !(e == null || (t = e._zod) == null || (t = t.traits) == null || !t.has("$ZodError"));
				}(e)) return {
					values: {},
					errors: Ui(Yi(e.issues, !a.shouldUseNativeValidation && a.criteriaMode === "all"), a)
				};
				throw e;
			}));
		} catch (e) {
			return Promise.reject(e);
		}
	};
	if (function(e) {
		return "_def" in e && typeof e._def == "object";
	}(e)) return function(r, i, a) {
		try {
			return Promise.resolve(qi(function() {
				return Promise.resolve(e[n.mode === "sync" ? "parse" : "parseAsync"](r, t)).then(function(e) {
					return a.shouldUseNativeValidation && Hi({}, a), {
						errors: {},
						values: n.raw ? Object.assign({}, r) : e
					};
				});
			}, function(e) {
				if (function(e) {
					return Array.isArray(e?.issues);
				}(e)) return {
					values: {},
					errors: Ui(Ji(e.errors, !a.shouldUseNativeValidation && a.criteriaMode === "all"), a)
				};
				throw e;
			}));
		} catch (e) {
			return Promise.reject(e);
		}
	};
	throw Error("Invalid input: not a Zod schema");
}
var Zi = B((() => {
	Gi();
}));
// ../form/src/utils/index.ts
function Qi(e) {
	return { error: e.error?.message || void 0 };
}
var $i = B((() => {}));
// ../../../node_modules/@monaco-editor/loader/lib/es/_virtual/_rollupPluginBabelHelpers.js
function ea(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function ta(e) {
	if (Array.isArray(e)) return e;
}
function na(e, t, n) {
	return (t = da(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function ra(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function ia() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function aa(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function oa(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? aa(Object(n), !0).forEach(function(t) {
			na(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : aa(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function sa(e, t) {
	if (e == null) return {};
	var n, r, i = ca(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function ca(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
function la(e, t) {
	return ta(e) || ra(e, t) || fa(e, t) || ia();
}
function ua(e, t) {
	if (typeof e != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t);
		if (typeof r != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function da(e) {
	var t = ua(e, "string");
	return typeof t == "symbol" ? t : t + "";
}
function fa(e, t) {
	if (e) {
		if (typeof e == "string") return ea(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ea(e, t) : void 0;
	}
}
var pa = B((() => {}));
// ../../../node_modules/state-local/lib/es/state-local.js
function ma(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function ha(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ga(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ha(Object(n), !0).forEach(function(t) {
			ma(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ha(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function _a() {
	var e = [...arguments];
	return function(t) {
		return e.reduceRight(function(e, t) {
			return t(e);
		}, t);
	};
}
function va(e) {
	return function t() {
		var n = this, r = [...arguments];
		return r.length >= e.length ? e.apply(this, r) : function() {
			var e = [...arguments];
			return t.apply(n, [].concat(r, e));
		};
	};
}
function ya(e) {
	return {}.toString.call(e).includes("Object");
}
function ba(e) {
	return !Object.keys(e).length;
}
function xa(e) {
	return typeof e == "function";
}
function Sa(e, t) {
	return Object.prototype.hasOwnProperty.call(e, t);
}
function Ca(e, t) {
	return ya(t) || Ma("changeType"), Object.keys(t).some(function(t) {
		return !Sa(e, t);
	}) && Ma("changeField"), t;
}
function wa(e) {
	xa(e) || Ma("selectorType");
}
function Ta(e) {
	xa(e) || ya(e) || Ma("handlerType"), ya(e) && Object.values(e).some(function(e) {
		return !xa(e);
	}) && Ma("handlersType");
}
function Ea(e) {
	e || Ma("initialIsRequired"), ya(e) || Ma("initialType"), ba(e) && Ma("initialContent");
}
function Da(e, t) {
	throw Error(e[t] || e.default);
}
function Oa(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	Na.initial(e), Na.handler(t);
	var n = { current: e }, r = va(ja)(n, t), i = va(Aa)(n), a = va(Na.changes)(e), o = va(ka)(n);
	function s() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(e) {
			return e;
		};
		return Na.selector(e), e(n.current);
	}
	function c(e) {
		_a(r, i, a, o)(e);
	}
	return [s, c];
}
function ka(e, t) {
	return xa(t) ? t(e.current) : t;
}
function Aa(e, t) {
	return e.current = ga(ga({}, e.current), t), t;
}
function ja(e, t, n) {
	return xa(t) ? t(e.current) : Object.keys(n).forEach(function(n) {
		return t[n]?.call(t, e.current[n]);
	}), n;
}
var Ma, Na, Pa, Fa = B((() => {
	Ma = va(Da)({
		initialIsRequired: "initial state is required",
		initialType: "initial state should be an object",
		initialContent: "initial state shouldn't be an empty object",
		handlerType: "handler should be an object or a function",
		handlersType: "all handlers should be a functions",
		selectorType: "selector should be a function",
		changeType: "provided value of changes should be an object",
		changeField: "it seams you want to change a field in the state which is not specified in the \"initial\" state",
		default: "an unknown error accured in `state-local` package"
	}), Na = {
		changes: Ca,
		selector: wa,
		handler: Ta,
		initial: Ea
	}, Pa = { create: Oa };
})), Ia, La = B((() => {
	Ia = { paths: { vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.55.1/min/vs" } };
}));
// ../../../node_modules/@monaco-editor/loader/lib/es/utils/curry.js
function Ra(e) {
	return function t() {
		var n = this, r = [...arguments];
		return r.length >= e.length ? e.apply(this, r) : function() {
			var e = [...arguments];
			return t.apply(n, [].concat(r, e));
		};
	};
}
var za = B((() => {}));
// ../../../node_modules/@monaco-editor/loader/lib/es/utils/isObject.js
function Ba(e) {
	return {}.toString.call(e).includes("Object");
}
var Va = B((() => {}));
// ../../../node_modules/@monaco-editor/loader/lib/es/validators/index.js
function Ha(e) {
	return e || Ka("configIsRequired"), Ba(e) || Ka("configType"), e.urls ? (Ua(), { paths: { vs: e.urls.monacoBase } }) : e;
}
function Ua() {
	console.warn(Ga.deprecation);
}
function Wa(e, t) {
	throw Error(e[t] || e.default);
}
var Ga, Ka, qa, Ja = B((() => {
	za(), Va(), Ga = {
		configIsRequired: "the configuration object is required",
		configType: "the configuration object should be an object",
		default: "an unknown error accured in `@monaco-editor/loader` package",
		deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
	}, Ka = Ra(Wa)(Ga), qa = { config: Ha };
})), Ya, Xa = B((() => {
	Ya = function() {
		var e = [...arguments];
		return function(t) {
			return e.reduceRight(function(e, t) {
				return t(e);
			}, t);
		};
	};
}));
// ../../../node_modules/@monaco-editor/loader/lib/es/utils/deepMerge.js
function Za(e, t) {
	return Object.keys(t).forEach(function(n) {
		t[n] instanceof Object && e[n] && Object.assign(t[n], Za(e[n], t[n]));
	}), oa(oa({}, e), t);
}
var Qa = B((() => {
	pa();
}));
// ../../../node_modules/@monaco-editor/loader/lib/es/utils/makeCancelable.js
function $a(e) {
	var t = !1, n = new Promise(function(n, r) {
		e.then(function(e) {
			return t ? r(eo) : n(e);
		}), e.catch(r);
	});
	return n.cancel = function() {
		return t = !0;
	}, n;
}
var eo, to = B((() => {
	eo = {
		type: "cancelation",
		msg: "operation is manually canceled"
	};
}));
// ../../../node_modules/@monaco-editor/loader/lib/es/loader/index.js
function no(e) {
	var t = qa.config(e), n = t.monaco, r = sa(t, uo);
	ho(function(e) {
		return {
			config: Za(e.config, r),
			monaco: n
		};
	});
}
function ro() {
	var e = mo(function(e) {
		return {
			monaco: e.monaco,
			isInitialized: e.isInitialized,
			resolve: e.resolve
		};
	});
	if (!e.isInitialized) {
		if (ho({ isInitialized: !0 }), e.monaco) return e.resolve(e.monaco), $a(go);
		if (window.monaco && window.monaco.editor) return co(window.monaco), e.resolve(window.monaco), $a(go);
		Ya(io, oo)(so);
	}
	return $a(go);
}
function io(e) {
	return document.body.appendChild(e);
}
function ao(e) {
	var t = document.createElement("script");
	return e && (t.src = e), t;
}
function oo(e) {
	var t = mo(function(e) {
		return {
			config: e.config,
			reject: e.reject
		};
	}), n = ao(`${t.config.paths.vs}/loader.js`);
	return n.onload = function() {
		return e();
	}, n.onerror = t.reject, n;
}
function so() {
	var e = mo(function(e) {
		return {
			config: e.config,
			resolve: e.resolve,
			reject: e.reject
		};
	}), t = window.require;
	t.config(e.config), t(["vs/editor/editor.main"], function(t) {
		var n = t.m || t;
		co(n), e.resolve(n);
	}, function(t) {
		e.reject(t);
	});
}
function co(e) {
	mo().monaco || ho({ monaco: e });
}
function lo() {
	return mo(function(e) {
		return e.monaco;
	});
}
var uo, fo, po, mo, ho, go, _o, vo = B((() => {
	pa(), Fa(), La(), Ja(), Xa(), Qa(), to(), uo = ["monaco"], fo = Pa.create({
		config: Ia,
		isInitialized: !1,
		resolve: null,
		reject: null,
		monaco: null
	}), po = la(fo, 2), mo = po[0], ho = po[1], go = new Promise(function(e, t) {
		return ho({
			resolve: e,
			reject: t
		});
	}), _o = {
		config: no,
		init: ro,
		__getMonacoInstance: lo
	};
})), yo = B((() => {
	vo();
})), bo = /* @__PURE__ */ Je({
	DiffEditor: () => Bo,
	Editor: () => Wo,
	default: () => Go,
	loader: () => _o,
	useMonaco: () => Vo
});
function xo({ children: e }) {
	return he.createElement("div", { style: Fo.container }, e);
}
function So({ width: e, height: t, isEditorReady: n, loading: r, _ref: i, className: a, wrapperProps: o }) {
	return he.createElement("section", {
		style: {
			...Po.wrapper,
			width: e,
			height: t
		},
		...o
	}, !n && he.createElement(Io, null, r), he.createElement("div", {
		ref: i,
		style: {
			...Po.fullWidth,
			...!n && Po.hide
		},
		className: a
	}));
}
function Co(e) {
	P(e, []);
}
function wo(e, t, n = !0) {
	let r = F(!0);
	P(r.current || !n ? () => {
		r.current = !1;
	} : e, t);
}
function To() {}
function Eo(e, t, n, r) {
	return Do(e, r) || Oo(e, t, n, r);
}
function Do(e, t) {
	return e.editor.getModel(ko(e, t));
}
function Oo(e, t, n, r) {
	return e.editor.createModel(t, n, r ? ko(e, r) : void 0);
}
function ko(e, t) {
	return e.Uri.parse(t);
}
function Ao({ original: e, modified: t, language: n, originalLanguage: r, modifiedLanguage: i, originalModelPath: a, modifiedModelPath: o, keepCurrentOriginalModel: s = !1, keepCurrentModifiedModel: c = !1, theme: l = "light", loading: u = "Loading...", options: d = {}, height: f = "100%", width: p = "100%", className: m, wrapperProps: h = {}, beforeMount: g = To, onMount: _ = To }) {
	let [v, y] = I(!1), [b, x] = I(!0), S = F(null), C = F(null), w = F(null), T = F(_), E = F(g), D = F(!1);
	Ro(() => {
		let e = _o.init();
		return e.then((e) => (C.current = e) && x(!1)).catch((e) => e?.type !== "cancelation" && console.error("Monaco initialization: error:", e)), () => S.current ? O() : e.cancel();
	}), zo(() => {
		if (S.current && C.current) {
			let t = S.current.getOriginalEditor(), i = Eo(C.current, e || "", r || n || "text", a || "");
			i !== t.getModel() && t.setModel(i);
		}
	}, [a], v), zo(() => {
		if (S.current && C.current) {
			let e = S.current.getModifiedEditor(), r = Eo(C.current, t || "", i || n || "text", o || "");
			r !== e.getModel() && e.setModel(r);
		}
	}, [o], v), zo(() => {
		let e = S.current.getModifiedEditor();
		e.getOption(C.current.editor.EditorOption.readOnly) ? e.setValue(t || "") : t !== e.getValue() && (e.executeEdits("", [{
			range: e.getModel().getFullModelRange(),
			text: t || "",
			forceMoveMarkers: !0
		}]), e.pushUndoStop());
	}, [t], v), zo(() => {
		S.current?.getModel()?.original.setValue(e || "");
	}, [e], v), zo(() => {
		let { original: e, modified: t } = S.current.getModel();
		C.current.editor.setModelLanguage(e, r || n || "text"), C.current.editor.setModelLanguage(t, i || n || "text");
	}, [
		n,
		r,
		i
	], v), zo(() => {
		C.current?.editor.setTheme(l);
	}, [l], v), zo(() => {
		S.current?.updateOptions(d);
	}, [d], v);
	let ee = N(() => {
		if (!C.current) return;
		E.current(C.current);
		let s = Eo(C.current, e || "", r || n || "text", a || ""), c = Eo(C.current, t || "", i || n || "text", o || "");
		S.current?.setModel({
			original: s,
			modified: c
		});
	}, [
		n,
		t,
		i,
		e,
		r,
		a,
		o
	]), te = N(() => {
		!D.current && w.current && (S.current = C.current.editor.createDiffEditor(w.current, {
			automaticLayout: !0,
			...d
		}), ee(), C.current?.editor.setTheme(l), y(!0), D.current = !0);
	}, [
		d,
		l,
		ee
	]);
	P(() => {
		v && T.current(S.current, C.current);
	}, [v]), P(() => {
		!b && !v && te();
	}, [
		b,
		v,
		te
	]);
	function O() {
		let e = S.current?.getModel();
		s || e?.original?.dispose(), c || e?.modified?.dispose(), S.current?.dispose();
	}
	return he.createElement(Lo, {
		width: p,
		height: f,
		isEditorReady: v,
		loading: u,
		_ref: w,
		className: m,
		wrapperProps: h
	});
}
function jo() {
	let [e, t] = I(_o.__getMonacoInstance());
	return Ro(() => {
		let n;
		return e || (n = _o.init(), n.then((e) => {
			t(e);
		})), () => n?.cancel();
	}), e;
}
function Mo(e) {
	let t = F();
	return P(() => {
		t.current = e;
	}, [e]), t.current;
}
function No({ defaultValue: e, defaultLanguage: t, defaultPath: n, value: r, language: i, path: a, theme: o = "light", line: s, loading: c = "Loading...", options: l = {}, overrideServices: u = {}, saveViewState: d = !0, keepCurrentModel: f = !1, width: p = "100%", height: m = "100%", className: h, wrapperProps: g = {}, beforeMount: _ = To, onMount: v = To, onChange: y, onValidate: b = To }) {
	let [x, S] = I(!1), [C, w] = I(!0), T = F(null), E = F(null), D = F(null), ee = F(v), te = F(_), O = F(), ne = F(r), re = Ho(a), ie = F(!1), k = F(!1);
	Ro(() => {
		let e = _o.init();
		return e.then((e) => (T.current = e) && w(!1)).catch((e) => e?.type !== "cancelation" && console.error("Monaco initialization: error:", e)), () => E.current ? oe() : e.cancel();
	}), zo(() => {
		let o = Eo(T.current, e || r || "", t || i || "", a || n || "");
		o !== E.current?.getModel() && (d && Uo.set(re, E.current?.saveViewState()), E.current?.setModel(o), d && E.current?.restoreViewState(Uo.get(a)));
	}, [a], x), zo(() => {
		E.current?.updateOptions(l);
	}, [l], x), zo(() => {
		!E.current || r === void 0 || (E.current.getOption(T.current.editor.EditorOption.readOnly) ? E.current.setValue(r) : r !== E.current.getValue() && (k.current = !0, E.current.executeEdits("", [{
			range: E.current.getModel().getFullModelRange(),
			text: r,
			forceMoveMarkers: !0
		}]), E.current.pushUndoStop(), k.current = !1));
	}, [r], x), zo(() => {
		let e = E.current?.getModel();
		e && i && T.current?.editor.setModelLanguage(e, i);
	}, [i], x), zo(() => {
		s !== void 0 && E.current?.revealLine(s);
	}, [s], x), zo(() => {
		T.current?.editor.setTheme(o);
	}, [o], x);
	let ae = N(() => {
		if (D.current && T.current && !ie.current) {
			te.current(T.current);
			let c = a || n, f = Eo(T.current, r || e || "", t || i || "", c || "");
			E.current = T.current?.editor.create(D.current, {
				model: f,
				automaticLayout: !0,
				...l
			}, u), d && E.current.restoreViewState(Uo.get(c)), T.current.editor.setTheme(o), s !== void 0 && E.current.revealLine(s), S(!0), ie.current = !0;
		}
	}, [
		e,
		t,
		n,
		r,
		i,
		a,
		l,
		u,
		d,
		o,
		s
	]);
	P(() => {
		x && ee.current(E.current, T.current);
	}, [x]), P(() => {
		!C && !x && ae();
	}, [
		C,
		x,
		ae
	]), ne.current = r, P(() => {
		x && y && (O.current?.dispose(), O.current = E.current?.onDidChangeModelContent((e) => {
			k.current || y(E.current.getValue(), e);
		}));
	}, [x, y]), P(() => {
		if (x) {
			let e = T.current.editor.onDidChangeMarkers((e) => {
				let t = E.current.getModel()?.uri;
				if (t && e.find((e) => e.path === t.path)) {
					let e = T.current.editor.getModelMarkers({ resource: t });
					b?.(e);
				}
			});
			return () => {
				e?.dispose();
			};
		}
		return () => {};
	}, [x, b]);
	function oe() {
		O.current?.dispose(), f ? d && Uo.set(a, E.current.saveViewState()) : E.current.getModel()?.dispose(), E.current.dispose();
	}
	return he.createElement(Lo, {
		width: p,
		height: m,
		isEditorReady: x,
		loading: c,
		_ref: D,
		className: h,
		wrapperProps: g
	});
}
var Po, Fo, Io, Lo, Ro, zo, Bo, Vo, Ho, Uo, Wo, Go, Ko = B((() => {
	yo(), Po = {
		wrapper: {
			display: "flex",
			position: "relative",
			textAlign: "initial"
		},
		fullWidth: { width: "100%" },
		hide: { display: "none" }
	}, Fo = { container: {
		display: "flex",
		height: "100%",
		width: "100%",
		justifyContent: "center",
		alignItems: "center"
	} }, Io = xo, Lo = Se(So), Ro = Co, zo = wo, Bo = Se(Ao), Vo = jo, Ho = Mo, Uo = /* @__PURE__ */ new Map(), Wo = Se(No), Go = Wo;
}));
// ../form/src/components/ui/lazyCodeEditor.tsx
function qo(e) {
	let t = e.height || 240;
	return /* @__PURE__ */ R(_e, {
		fallback: /* @__PURE__ */ R(Jo, { height: t }),
		children: /* @__PURE__ */ R(Yo, { ...e })
	});
}
var Jo, Yo, Xo = B((() => {
	Jo = ({ height: e }) => /* @__PURE__ */ R(T, {
		alignItems: "center",
		justifyContent: "center",
		style: { height: `${e}px` },
		children: /* @__PURE__ */ R(ce, { bgColor: "#1e1e1e" })
	}), Yo = xe(() => Promise.resolve().then(() => (Ko(), bo)).then((e) => ({ default: e.Editor })));
})), Zo, Qo, $o = B((() => {
	Zo = "_editor_friuv_1", Qo = { editor: Zo };
}));
// ../form/src/components/hookForm/fieldCodeEditor.tsx
function es({ control: e, name: t, height: n = 240, label: r, language: i, description: a, required: o, setError: s, clearErrors: c }) {
	return /* @__PURE__ */ R(Ie, {
		control: e,
		name: t,
		render: ({ field: e, fieldState: l }) => {
			let u = Qi(l);
			return /* @__PURE__ */ R(w, {
				label: r,
				required: o,
				meta: u,
				description: a,
				children: /* @__PURE__ */ R(qo, {
					className: Qo.editor,
					height: n,
					theme: "vs-dark",
					defaultLanguage: i,
					options: {
						minimap: { enabled: !1 },
						folding: !1,
						lineHeight: 20,
						formatOnPaste: !0,
						formatOnType: !0,
						padding: { top: 16 }
					},
					onMount: (e) => e.getAction("editor.action.formatDocument")?.run(),
					value: e.value,
					onChange: e.onChange,
					onValidate: (e) => {
						if (e.length) {
							let { message: n, startLineNumber: r, startColumn: i } = e[0];
							s(t, { message: `${n} at line ${r}, column ${i}` });
						} else c(t);
					}
				})
			});
		}
	});
}
var ts = B((() => {
	$i(), Xo(), $o();
}));
// ../form/src/components/ui/fieldColorInput.tsx
function ns(e) {
	return /* @__PURE__ */ z(S, {
		...e,
		colorPickerProps: { ...e.colorPickerProps },
		children: [/* @__PURE__ */ R(v.Sliders, {}), /* @__PURE__ */ R(v.Input, { onBlur: e.onBlur })]
	});
}
var rs = B((() => {}));
// ../form/src/components/hookForm/fieldColorInput.tsx
function is({ label: e, control: t, name: n, disabled: r }) {
	return /* @__PURE__ */ R(Ie, {
		control: t,
		name: n,
		render: ({ field: t, fieldState: n }) => {
			let { ref: i, ...a } = t, o = n.error?.message;
			return /* @__PURE__ */ R(ns, {
				input: {
					...a,
					onChange(e) {
						e && a.onChange(e);
					},
					value: a.value
				},
				onBlur: () => a.onBlur(),
				label: e,
				meta: { error: o },
				disabled: r
			});
		}
	});
}
var as = B((() => {
	rs();
}));
// ../form/src/components/hookForm/fieldInputText.tsx
function os({ control: e, name: t, label: n, placeholder: r, required: i, description: a, helpIcon: o, disabled: s, prefix: c }) {
	return /* @__PURE__ */ R(Ie, {
		control: e,
		name: t,
		render: ({ field: e, fieldState: t }) => {
			let { ref: l, value: u = "", ...d } = e, f = Qi(t);
			return /* @__PURE__ */ R(w, {
				label: n,
				required: i,
				meta: f,
				description: a,
				helpIcon: o,
				noLabel: !n,
				children: /* @__PURE__ */ R(ne, {
					...d,
					value: u,
					placeholder: r,
					disabled: s,
					prefix: c
				})
			});
		}
	});
}
var ss = B((() => {
	$i();
})), cs = B((() => {}));
// ../form/src/components/hookForm/fieldInputTextInline.tsx
function ls({ control: e, fieldName: t, label: n, spans: r = { left: 2 } }) {
	return /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(E, {
		span: r.left,
		children: /* @__PURE__ */ R(T, {
			alignItems: "start",
			margin: "11px 0 0",
			children: /* @__PURE__ */ R(M.Paragraph, {
				variant: "3",
				subdued: !0,
				children: n
			})
		})
	}), /* @__PURE__ */ R(E, {
		span: 6 - r.left,
		children: /* @__PURE__ */ R(os, {
			control: e,
			name: t
		})
	})] });
}
var us = B((() => {
	ss();
}));
// ../form/src/components/hookForm/fieldSelectionList.tsx
function ds({ control: e, name: t, label: n, required: r, description: i, itemsLoading: a, equalityFn: o, placeholders: s, listItems: c, multiple: l = !0, disabled: u }) {
	return /* @__PURE__ */ R(Ie, {
		control: e,
		name: t,
		render: ({ field: e, fieldState: t }) => {
			let d = Qi(t);
			return /* @__PURE__ */ R(w, {
				label: n,
				required: r,
				meta: d,
				description: i,
				children: /* @__PURE__ */ R(O, {
					multiple: l,
					value: e.value,
					onChange: (t) => e.onChange(t.selectedValues),
					disabled: a || u,
					placeholder: a ? s.loading : s.empty,
					equalityFn: o,
					getItemTitleByValue: fs,
					selectionListProps: { style: {
						maxHeight: 300,
						overflow: "auto"
					} },
					children: (c || []).map((e) => /* @__PURE__ */ R(se.Item, {
						value: e,
						children: /* @__PURE__ */ R(M.Paragraph, { children: e.name })
					}, e.id))
				})
			});
		}
	});
}
function fs(e) {
	return /* @__PURE__ */ R(L, { children: e?.name });
}
var ps = B((() => {
	$i();
})), ms, hs, gs, _s, vs = B((() => {
	ms = "_wrapper_11awi_1", hs = "_wrapperDark_11awi_5", gs = "_marginBottom_11awi_11", _s = {
		wrapper: ms,
		wrapperDark: hs,
		marginBottom: gs
	};
}));
// ../form/src/components/ui/toggleBox.tsx
function ys({ name: e, onChange: t, value: n, heading: r, subHeading: i, className: a, dark: o = !1, padding: s, disabled: c }) {
	return /* @__PURE__ */ z(T, {
		justifyContent: "flex-start",
		alignItems: "center",
		className: pe(_s.wrapper, a, { [_s.wrapperDark]: o }),
		gap: "300",
		children: [/* @__PURE__ */ R(le, {
			name: e,
			id: e,
			title: r,
			onChange: (e) => t(e.currentTarget.value !== "true"),
			value: n.toString(),
			checked: n,
			disabled: c
		}), /* @__PURE__ */ z(T, {
			flexDirection: "column",
			style: { padding: s || "300 0" },
			children: [/* @__PURE__ */ R(M.Paragraph, {
				variant: "1",
				className: pe({ [_s.marginBottom]: !!i }),
				children: r
			}), !!i && /* @__PURE__ */ R(M.Paragraph, {
				variant: "4",
				subdued: !0,
				children: i
			})]
		})]
	});
}
var bs = B((() => {
	vs();
}));
// ../form/src/components/hookForm/fieldTogglePanel.tsx
function xs({ control: e, name: t, heading: n, subHeading: r, dark: i = !1, noAlert: a, padding: o, disabled: s = !1 }) {
	return /* @__PURE__ */ R(Ie, {
		name: t,
		control: e,
		render: ({ field: e, fieldState: t }) => {
			let c = Qi(t), { ref: l, ...u } = e;
			return /* @__PURE__ */ R(w, {
				noLabel: !0,
				meta: c,
				noAlert: a,
				children: /* @__PURE__ */ R(m, {
					background: i ? "neutral.100" : void 0,
					borderRadius: "100",
					children: /* @__PURE__ */ R(ys, {
						...u,
						onChange: e.onChange,
						heading: n,
						subHeading: r,
						dark: i,
						padding: o,
						disabled: s
					})
				})
			});
		}
	});
}
var Ss = B((() => {
	$i(), bs();
})), Cs = B((() => {
	ts(), as(), ss(), cs(), us(), ps(), Ss(), Xo(), bs();
}));
// ../management-common/src/hooks/usePaginatedCollections.ts
function ws({ fetchAll: e = !1, ...t } = {}) {
	let n = Mt({
		...t,
		variables: Ts
	}), { fetchMore: r } = n, i = n.data?.collections.results.length ?? 0, [a, o] = I(), s = i >= 50 && i !== a, c = N(() => r({ variables: {
		offset: i,
		limit: 50
	} }).then(({ data: e }) => {
		let t = e.collections.results.length;
		t < 50 && o(i + t);
	}), [r, i]), l = F();
	return P(() => {
		e && s && l.current !== i && (l.current = i, c().finally(() => {
			l.current === i && (l.current = void 0);
		}));
	}, [
		e,
		s,
		i,
		c
	]), {
		...n,
		hasMore: s,
		fetchNextPage: c
	};
}
var Ts, Es = B((() => {
	U(), Ts = {
		offset: 0,
		limit: 50
	};
}));
// ../management-common/src/components/collectionSelect.tsx
function Ds({ collectionId: e, required: t, label: n = "Collection", excludeInternalOnly: r = !1, setCollectionId: i }) {
	let { data: a, loading: o } = ws({ fetchAll: !0 }), s = jt({
		skip: !e,
		variables: { id: e || "" }
	}), c = a?.collections.results.filter(({ internalOnly: e }) => !r || !e).map(({ id: e, title: t }) => ({
		id: e,
		name: t
	})) || [];
	function l(e) {
		e && i(e?.toString());
	}
	return /* @__PURE__ */ R(C, {
		disabled: !1,
		searchable: !0,
		label: n,
		required: t,
		input: {
			name: s.data?.collection?.title || "",
			value: e || "",
			onChange: l
		},
		items: c,
		loading: o
	});
}
var Os = B((() => {
	U(), Es();
}));
// ../delivery-common/src/hooks/useDebounce.ts
function ks(e, t) {
	let [n, r] = I(e);
	return P(() => {
		let n = setTimeout(() => r(e), t);
		return () => {
			clearTimeout(n);
		};
	}, [e, t]), n;
}
var As = B((() => {}));
// ../management-common/src/hooks/useCheckSubdomainAvailability.ts
function js({ subdomain: e, initialSubdomain: t, subdomainErrorMessage: n }) {
	let { loading: r, data: i, error: a } = Xt({
		variables: { subdomain: ks(e, 500) },
		skip: !e || e === t,
		fetchPolicy: "network-only"
	}), o = n ? [n] : [];
	return a?.graphQLErrors.length && (o = o.concat(a.graphQLErrors.map((e) => e.message))), i?.subdomainAvailability?.isAvailable === !1 && (i.subdomainAvailability.reason === Zt.Taken && o.push("Subdomain is not available"), i.subdomainAvailability.reason === Zt.NotAllowed && o.push("Subdomain is not allowed")), {
		data: i,
		errors: o,
		loading: r
	};
}
var Ms = B((() => {
	As(), U();
}));
// ../utils/src/hooks/useNotification.ts
function Ns() {
	let e = Ce(fi);
	return {
		errorNotify: N(({ title: t = "Something went wrong", text: n, ...r }) => {
			e({
				icon: "exclamation-circle-filled",
				time: 2e3,
				status: "danger",
				reason: null,
				waitingTime: null,
				startTime: null,
				leftAction: null,
				...r,
				title: t,
				text: n
			});
		}, [e]),
		successNotify: N(({ title: t, text: n, ...r }) => {
			e({
				icon: "check-circle-filled",
				time: 3e3,
				status: "success",
				reason: null,
				waitingTime: null,
				startTime: null,
				leftAction: null,
				...r,
				title: t,
				text: n
			});
		}, [e]),
		notify: e
	};
}
var Ps = B((() => {}));
// ../../../node_modules/zod/v4/core/util.js
function Fs(e) {
	let t = Object.values(e).filter((e) => typeof e == "number");
	return Object.entries(e).filter(([e, n]) => t.indexOf(+e) === -1).map(([e, t]) => t);
}
function Is(e, t = "|") {
	return e.map((e) => nc(e)).join(t);
}
function Ls(e, t) {
	return typeof t == "bigint" ? t.toString() : t;
}
function Rs(e) {
	return new Mc(e);
}
function zs(e) {
	return e == null;
}
function Bs(e) {
	let t = +!!e.startsWith("^"), n = e.endsWith("$") ? e.length - 1 : e.length;
	return e.slice(t, n);
}
function Vs(e, t, n) {
	Object.defineProperty(e, t, {
		value: n,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}
function Hs(e) {
	let t = Object.getOwnPropertyDescriptor(e, "shape");
	return t?.get ? t.get.raw : t?.value;
}
function Us(e) {
	return Hs(e._zod.def) ?? e._zod.def.shape;
}
function Ws(e, t, n) {
	Object.defineProperty(e, t, {
		get() {
			let e = n();
			return Vs(this, t, e), e;
		},
		enumerable: !0,
		configurable: !0
	});
}
function Gs(e, t, n) {
	t in e ? Vs(e, t, n) : e[t] = n;
}
function Ks(e, t, n, r) {
	let i = Us(t);
	for (let a of n) {
		let n = Object.getOwnPropertyDescriptor(i, a);
		n.enumerable && (n.get ? Ws(e, a, () => {
			let e = t._zod.def.shape[a];
			return r ? r(e, a) : e;
		}) : Gs(e, a, r ? r(n.value, a) : n.value));
	}
}
function qs(e, t) {
	for (let n of Reflect.ownKeys(t)) {
		let r = Object.getOwnPropertyDescriptor(t, n);
		r.enumerable && (r.get ? Ws(e, n, () => t[n]) : Gs(e, n, r.value));
	}
}
function Js(...e) {
	let t = {};
	for (let n of e) {
		let e = Object.getOwnPropertyDescriptors(n);
		Object.assign(t, e);
	}
	return Object.defineProperties({}, t);
}
function Ys(e) {
	return JSON.stringify(e);
}
function Xs(e) {
	return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
function Zs(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function Qs(e) {
	if (Zs(e) === !1) return !1;
	let t = e.constructor;
	if (t === void 0 || typeof t != "function") return !0;
	let n = t.prototype;
	return Zs(n) !== !1 && Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") !== !1;
}
function $s(e) {
	return Qs(e) ? { ...e } : Array.isArray(e) ? [...e] : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : e;
}
function ec(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function tc(e, t, n) {
	let r = new e._zod.constr(t ?? e._zod.def);
	return (!t || n?.parent) && (r._zod.parent = e), r;
}
function W(e) {
	let t = e;
	if (!t) return {};
	if (typeof t == "string") return { error: () => t };
	if (t?.message !== void 0) {
		if (t?.error !== void 0) throw Error("Cannot specify both `message` and `error` params");
		t.error = t.message;
	}
	return delete t.message, typeof t.error == "string" ? {
		...t,
		error: () => t.error
	} : t;
}
function nc(e) {
	return typeof e == "bigint" ? e.toString() + "n" : typeof e == "string" ? `"${e}"` : `${e}`;
}
function rc(e) {
	return Object.keys(e).filter((t) => e[t]._zod.optin !== void 0 && e[t]._zod.optout === "optional");
}
function ic(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".pick() cannot be used on object schemas containing refinements");
	let i = {};
	return Ks(i, e, ac(e, t)), tc(e, Js(n, {
		shape: i,
		checks: []
	}));
}
function ac(e, t) {
	let n = Us(e), r = [];
	for (let e of Reflect.ownKeys(t)) {
		if (!Object.getOwnPropertyDescriptor(n, e)?.enumerable) throw Error(`Unrecognized key: "${String(e)}"`);
		t[e] && r.push(e);
	}
	return r;
}
function oc(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".omit() cannot be used on object schemas containing refinements");
	let i = new Set(ac(e, t)), a = {};
	return Ks(a, e, Reflect.ownKeys(Us(e)).filter((e) => !i.has(e))), tc(e, Js(n, {
		shape: a,
		checks: []
	}));
}
function sc(e, t) {
	if (!Qs(t)) throw Error("Invalid input to extend: expected a plain object");
	let n = e._zod.def.checks;
	if (n && n.length > 0) {
		let n = Us(e);
		for (let e of Reflect.ownKeys(t)) if (Object.getOwnPropertyDescriptor(n, e) !== void 0) throw Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
	}
	return tc(e, Js(e._zod.def, { shape: cc(e, t) }));
}
function cc(e, t) {
	let n = {};
	return Ks(n, e, Reflect.ownKeys(Us(e))), qs(n, t), n;
}
function lc(e, t) {
	if (!Qs(t)) throw Error("Invalid input to safeExtend: expected a plain object");
	return tc(e, Js(e._zod.def, { shape: cc(e, t) }));
}
function uc(e, t) {
	if (!t?._zod?.def) throw Error("Invalid input to merge: expected an object schema. To merge a plain shape, use `.extend()`.");
	if (e._zod.def.checks?.length) throw Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
	let n = {};
	return Ks(n, e, Reflect.ownKeys(Us(e))), Ks(n, t, Reflect.ownKeys(Us(t))), tc(e, Js(e._zod.def, {
		shape: n,
		get catchall() {
			return t._zod.def.catchall;
		},
		checks: t._zod.def.checks ?? []
	}));
}
function dc(e, t, n, r = "partial") {
	let i = t._zod.def.checks;
	if (i && i.length > 0) throw Error(`.${r}() cannot be used on object schemas containing refinements`);
	let a = n ? new Set(ac(t, n)) : void 0, o = {};
	return Ks(o, t, Reflect.ownKeys(Us(t)), e && ((t, n) => a && !a.has(n) ? t : new e({
		type: "optional",
		innerType: t
	}))), tc(t, Js(t._zod.def, {
		shape: o,
		checks: []
	}));
}
function fc(e, t, n) {
	let r = n ? new Set(ac(t, n)) : void 0, i = {};
	return Ks(i, t, Reflect.ownKeys(Us(t)), (t, n) => r && !r.has(n) ? t : new e({
		type: "nonoptional",
		innerType: t
	})), tc(t, Js(t._zod.def, { shape: i }));
}
function pc(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue !== !0) return !0;
	return !1;
}
function mc(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue === !1) return !0;
	return !1;
}
function hc(e, t) {
	return t.map((t) => {
		var n;
		return (n = t).path ?? (n.path = []), t.path.unshift(e), t;
	});
}
function gc(e) {
	return typeof e == "string" ? e : e?.message;
}
function _c(e) {
	let t = [];
	for (let n of e ?? []) {
		let e = n._zod.def;
		if (!/_(length|size)$|_equals$/.test(e.check)) break;
		let r = e.maximum ?? e.length ?? e.size;
		r >= 0 && t.push([r, n]);
	}
	return t;
}
function vc(e, t, n) {
	var r;
	for (let i = t; i < e.length; i++) (r = e[i]).schema ?? (r.schema = n);
}
function yc(e, t, n) {
	var r;
	let i = e.inst?._zod?.traits;
	i?.has("$ZodType") && (i.has("$ZodCheck") ? (r = e).schema ?? (r.schema = e.inst) : e.schema = e.inst);
	let a = e.schema === e.inst ? void 0 : e.schema?._zod.def?.error, o = e.message ? e.message : gc(e.inst?._zod.def?.error?.(e)) ?? gc(a?.(e)) ?? gc(t?.error?.(e)) ?? gc(n.customError?.(e)) ?? gc(n.localeError?.(e)) ?? "Invalid input", s = {};
	for (let t of Object.keys(e)) t !== "inst" && t !== "schema" && t !== "continue" && t !== "input" && t !== "__proto__" && (s[t] = e[t]);
	return s.path ??= [], s.message = o, t?.reportInput && (s.input = e.input), s;
}
function bc(e) {
	let t = e.length;
	if (!Rc.test(e)) return t;
	let n = t;
	for (let r = 0; r < t - 1; r++) (e.charCodeAt(r) & 64512) == 55296 && (e.charCodeAt(r + 1) & 64512) == 56320 && (n--, r++);
	return n;
}
function xc(e) {
	return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Sc(e) {
	let t = typeof e;
	switch (t) {
		case "number": return Number.isNaN(e) ? "nan" : "number";
		case "object": {
			if (e === null) return "null";
			if (Array.isArray(e)) return "array";
			let t = e;
			if (t && Object.getPrototypeOf(t) !== Object.prototype && "constructor" in t && t.constructor) return t.constructor.name;
		}
	}
	return t;
}
function Cc(...e) {
	let [t, n, r] = e;
	return typeof t == "string" ? {
		message: t,
		code: "custom",
		input: n,
		inst: r
	} : { ...t };
}
function wc(e, t) {
	for (let n in t) {
		let r = Object.getOwnPropertyDescriptor(t, n);
		r.get ? Object.defineProperty(e, n, {
			...r,
			enumerable: !1
		}) : Oc(e, n, r.value);
	}
}
function Tc(e, t, n, r = !0) {
	return Object.defineProperty(e, t, {
		configurable: !0,
		writable: !0,
		enumerable: r,
		value: n
	}), n;
}
function Ec(e, t, n) {
	return Tc(e, t, n, !1);
}
/* @__NO_SIDE_EFFECTS__ */
function Dc(e, t) {
	for (let n in e) {
		let r = e[n];
		Object.defineProperty(t, n, {
			configurable: !0,
			enumerable: !0,
			get() {
				return Tc(this, n, r(this));
			},
			set(e) {
				Tc(this, n, e);
			}
		});
	}
	return t;
}
function Oc(e, t, n) {
	Object.defineProperty(e, t, {
		configurable: !0,
		get() {
			return this == null ? n : Tc(this, t, n.bind(this));
		},
		set(e) {
			Tc(this, t, e);
		}
	});
}
function kc(e, t) {
	let n = Object.getPrototypeOf(e);
	return t in n ? void 0 : n;
}
function G(e, t, n) {
	let r = Object.getPrototypeOf(e._zod);
	t in r && zc !== e._zod ? zc = void 0 : (zc = e._zod, Object.defineProperty(r, t, {
		configurable: !0,
		get() {
			Object.defineProperty(this, t, Vc);
			let e = Bc;
			Bc = !1;
			try {
				let r = n(this);
				return Bc ? delete this[t] : Object.defineProperty(this, t, {
					configurable: !0,
					writable: !0,
					value: r
				}), Bc ||= e, r;
			} catch (n) {
				throw delete this[t], Bc ||= e, n;
			}
		},
		set(e) {
			Object.defineProperty(this, t, {
				configurable: !0,
				writable: !0,
				value: e
			});
		}
	}));
}
function Ac(e, t, n, r) {
	let i = kc(e, t);
	i && Object.defineProperty(i, t, {
		configurable: !0,
		get() {
			let e = {
				configurable: !0,
				writable: !0,
				enumerable: r,
				value: void 0
			};
			return Object.defineProperty(this, t, e), e.value = n(this), Object.defineProperty(this, t, e), e.value;
		},
		set(e) {
			Object.defineProperty(this, t, {
				configurable: !0,
				writable: !0,
				enumerable: r,
				value: e
			});
		}
	});
}
function jc(e) {
	let t = () => e;
	return t[Hc] = !0, t;
}
var Mc, Nc, Pc, Fc, Ic, Lc, Rc, zc, Bc, Vc, Hc, Uc = B((() => {
	Qc(), Mc = class {
		constructor(e) {
			this._getter = e, this._value = void 0;
		}
		get value() {
			let e = this._getter;
			return e !== void 0 && (this._value = e(), this._getter = void 0), this._value;
		}
	}, Nc = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {}, Pc = /* @__PURE__*/ Rs(() => {
		if (Zc.jitless || typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare")) return !1;
		try {
			return Function(""), !0;
		} catch {
			return !1;
		}
	}), Fc = /* @__PURE__*/ new Set([
		"string",
		"number",
		"symbol"
	]), Ic = {
		safeint: [-(2 ** 53 - 1), 2 ** 53 - 1],
		int32: [-2147483648, 2147483647],
		uint32: [0, 4294967295],
		float32: [-34028234663852886e22, 34028234663852886e22],
		float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
	}, Lc = {
		int64: [/* @__PURE__*/ BigInt("-9223372036854775808"), /* @__PURE__*/ BigInt("9223372036854775807")],
		uint64: [/* @__PURE__*/ BigInt(0), /* @__PURE__*/ BigInt("18446744073709551615")]
	}, Rc = /[\uD800-\uDBFF]/, Bc = !1, Vc = {
		configurable: !0,
		get() {
			Bc = !0;
		}
	}, Hc = "~constantCatch";
}));
// ../../../node_modules/zod/v4/core/core.js
function Wc(e) {
	let t = Jc;
	if (t) {
		let n = t.stackTraceLimit;
		if (typeof n == "number") {
			try {
				t.stackTraceLimit = 0;
			} catch {
				return Jc = null, new e();
			}
			try {
				return new e();
			} finally {
				t.stackTraceLimit = n;
			}
		}
	}
	return new e();
}
/* @__NO_SIDE_EFFECTS__ */
function K(e, t, n, r) {
	let i = {};
	function a(e) {
		this.def = e, this.constr = d, this.traits = /* @__PURE__ */ new Set();
	}
	a.prototype = i;
	let o = n, s = o && /* @__PURE__ */ new WeakSet();
	function c(n, r) {
		if (!n._zod) {
			qc.value = new a(r);
			try {
				Object.defineProperty(n, "_zod", qc);
			} finally {
				qc.value = void 0;
			}
		} else if (n._zod.traits.has(e)) return;
		if (n._zod.traits.add(e), t(n, r), s) {
			let e = Object.getPrototypeOf(n), t = n._zod.constr.prototype, r = e;
			for (; r && r !== t;) r = Object.getPrototypeOf(r);
			let i = r ?? e;
			s.has(i) || (s.add(i), wc(i, o));
		}
		let i = d.prototype;
		for (let e in i) Object.prototype.hasOwnProperty.call(i, e) && (e in n || (n[e] = i[e].bind(n)));
	}
	let l = r?.Parent ?? Object;
	class u extends l {}
	Object.defineProperty(u, "name", { value: e });
	function d(e) {
		let t = r?.Parent ? Wc(u) : this;
		c(t, e);
		let n = t._zod.deferred;
		if (n) {
			for (let e of n) e();
			t._zod.deferred = void 0;
		}
		let i = globalThis.__zod_globalConfig?.postProcessor;
		return i && i(t), t;
	}
	return Object.defineProperty(d, "init", { value: c }), Object.defineProperty(d, Symbol.hasInstance, { value: (t) => r?.Parent && t instanceof r.Parent ? !0 : t?._zod?.traits?.has(e) }), Object.defineProperty(d, "name", { value: e }), d;
}
function Gc(e) {
	return e && Object.assign(Zc, e), Zc;
}
var Kc, qc, Jc, Yc, Xc, Zc, Qc = B((() => {
	Uc(), qc = {
		value: void 0,
		enumerable: !1
	}, Jc = "captureStackTrace" in Error ? Error : null, Yc = class extends Error {
		constructor() {
			super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
		}
	}, Xc = class extends Error {
		constructor(e) {
			super(`Encountered unidirectional transform during encode: ${e}`), this.name = "ZodEncodeError";
		}
	}, (Kc = globalThis).__zod_globalConfig ?? (Kc.__zod_globalConfig = {}), Zc = globalThis.__zod_globalConfig;
}));
// ../../../node_modules/zod/v4/core/errors.js
function $c() {
	let e = this._zod;
	return e.message ??= JSON.stringify(e.def, Ls, 2), e.message;
}
function el(e) {
	this._zod.message = e;
}
function tl(e, t, n) {
	return Object.prototype.hasOwnProperty.call(e, t) || (t === "__proto__" ? Object.defineProperty(e, t, {
		value: n(),
		writable: !0,
		enumerable: !0,
		configurable: !0
	}) : e[t] = n()), e[t];
}
function nl(e, t = (e) => e.message) {
	let n = {}, r = [];
	for (let i of e.issues) i.path.length > 0 ? tl(n, i.path[0], () => []).push(t(i)) : r.push(t(i));
	return {
		formErrors: r,
		fieldErrors: n
	};
}
function rl(e, t = (e) => e.message) {
	let n = { _errors: [] }, r = (e, i = []) => {
		for (let a of e.issues) if (a.code === "invalid_union" && a.errors.length) a.errors.map((e) => r({ issues: e }, [...i, ...a.path]));
		else if (a.code === "invalid_key") r({ issues: a.issues }, [...i, ...a.path]);
		else if (a.code === "invalid_element") r({ issues: a.issues }, [...i, ...a.path]);
		else {
			let e = [...i, ...a.path];
			if (e.length === 0) n._errors.push(t(a));
			else {
				let r = n, i = 0;
				for (; i < e.length;) {
					let n = e[i], o = i === e.length - 1;
					if (n === "_errors") {
						o && r._errors.push(t(a)), i++;
						continue;
					}
					Object.prototype.hasOwnProperty.call(r, n) || Object.defineProperty(r, n, {
						value: { _errors: [] },
						enumerable: !0,
						writable: !0,
						configurable: !0
					});
					let s = r[n];
					o && s._errors.push(t(a)), r = s, i++;
				}
			}
		}
	};
	return r(e), n;
}
var il, al, ol, sl, cl, ll = B((() => {
	Qc(), Uc(), il = {
		get: $c,
		set: el,
		enumerable: !0,
		configurable: !0
	}, al = {
		value: void 0,
		enumerable: !1
	}, ol = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]), sl = (e, t) => {
		e.name = "$ZodError", al.value = t, Object.defineProperty(e, "issues", al), al.value = void 0, Object.defineProperty(e, "message", il);
		let n = Object.getPrototypeOf(e);
		ol.has(n) || (ol.add(n), Object.defineProperty(n, "toString", {
			configurable: !0,
			enumerable: !1,
			get() {
				let e = () => this.message;
				return Object.defineProperty(this, "toString", {
					value: e,
					configurable: !0,
					writable: !0
				}), e;
			},
			set(e) {
				Object.defineProperty(this, "toString", {
					value: e,
					configurable: !0,
					writable: !0
				});
			}
		}));
	}, cl = /* @__PURE__ */ K("$ZodError", sl);
}));
// ../../../node_modules/zod/v4/core/parse.js
function ul(e, t) {
	return {
		callee: t?.callee ?? e,
		Err: t?.Err
	};
}
function dl(e, t, n) {
	let r;
	return {
		success: !1,
		get error() {
			return r || (r = new e(t.map((e) => yc(e, n, Gc()))), t = void 0, n = void 0), r;
		},
		set error(e) {
			r = e, t = void 0, n = void 0;
		}
	};
}
function fl(e, t, n) {
	let r = n ? {
		...n,
		async: !1,
		abortEarly: !0
	} : {
		async: !1,
		abortEarly: !0
	}, i = e._zod.bag.fallbackRun, a;
	if (i ? (r[vl] = !0, a = i({
		value: t,
		issues: []
	}, r)) : a = e._zod.run({
		value: t,
		issues: []
	}, r), a instanceof Promise) throw new Yc();
	return a.issues.length === 0;
}
var pl, ml, hl, gl, _l, vl, yl, bl, xl, Sl, Cl, wl, Tl, El, Dl, Ol, kl = B((() => {
	Qc(), Uc(), pl = (e) => {
		let t = (n, r, i, a) => {
			let o = i ? {
				...i,
				async: !1
			} : { async: !1 }, s = n._zod.run({
				value: r,
				issues: []
			}, o);
			if (s instanceof Promise) throw new Yc();
			if (s.issues.length) {
				let n = new ((a?.Err) ?? e)(s.issues.map((e) => yc(e, o, Gc())));
				throw Nc(n, a?.callee ?? t), n;
			}
			return s.value;
		};
		return t;
	}, ml = (e) => {
		let t = async (n, r, i, a) => {
			let o = i ? {
				...i,
				async: !0
			} : { async: !0 }, s = n._zod.run({
				value: r,
				issues: []
			}, o);
			if (s instanceof Promise && (s = await s), s.issues.length) {
				let n = new ((a?.Err) ?? e)(s.issues.map((e) => yc(e, o, Gc())));
				throw Nc(n, a?.callee ?? t), n;
			}
			return s.value;
		};
		return t;
	}, hl = (e) => (t, n, r) => {
		let i = r ? {
			...r,
			async: !1
		} : { async: !1 }, a = t._zod.run({
			value: n,
			issues: []
		}, i);
		if (a instanceof Promise) throw new Yc();
		return a.issues.length ? dl(e, a.issues, i) : {
			success: !0,
			data: a.value
		};
	}, gl = (e) => async (t, n, r) => {
		let i = r ? {
			...r,
			async: !0
		} : { async: !0 }, a = t._zod.run({
			value: n,
			issues: []
		}, i);
		return a instanceof Promise && (a = await a), a.issues.length ? dl(e, a.issues, i) : {
			success: !0,
			data: a.value
		};
	}, _l = /* @__PURE__ */ Symbol.for("zod.compile.invalid"), vl = /* @__PURE__ */ Symbol.for("zod.compile.fallback"), yl = ((e, t, n) => {
		let r = e._zod.bag.validator;
		if (r !== void 0) {
			if (r(t) !== _l) return !0;
			if (r.definite === !0 && n === void 0) return !1;
		}
		return fl(e, t, n);
	}), bl = async (e, t, n) => {
		let r = n ? {
			...n,
			async: !0,
			abortEarly: !0
		} : {
			async: !0,
			abortEarly: !0
		}, i = e._zod.run({
			value: t,
			issues: []
		}, r);
		return i instanceof Promise && (i = await i), i.issues.length === 0;
	}, xl = (e) => {
		let t = pl(e), n = (e, r, i, a) => {
			let o = i ? {
				...i,
				direction: "backward"
			} : { direction: "backward" };
			return t(e, r, o, ul(n, a));
		};
		return n;
	}, Sl = (e) => {
		let t = pl(e), n = (e, r, i, a) => t(e, r, i, ul(n, a));
		return n;
	}, Cl = (e) => {
		let t = ml(e), n = async (e, r, i, a) => {
			let o = i ? {
				...i,
				direction: "backward"
			} : { direction: "backward" };
			return await t(e, r, o, ul(n, a));
		};
		return n;
	}, wl = (e) => {
		let t = ml(e), n = async (e, r, i, a) => await t(e, r, i, ul(n, a));
		return n;
	}, Tl = (e) => (t, n, r) => {
		let i = r ? {
			...r,
			direction: "backward"
		} : { direction: "backward" };
		return hl(e)(t, n, i);
	}, El = (e) => (t, n, r) => hl(e)(t, n, r), Dl = (e) => async (t, n, r) => {
		let i = r ? {
			...r,
			direction: "backward"
		} : { direction: "backward" };
		return gl(e)(t, n, i);
	}, Ol = (e) => async (t, n, r) => gl(e)(t, n, r);
}));
// ../../../node_modules/zod/v4/core/regexes.js
function Al(e) {
	return RegExp(`^[a-zA-Z0-9_-]{${e}}$`);
}
function jl() {
	return new RegExp(Kl, "u");
}
function Ml(e) {
	return RegExp(`^${e}$`);
}
function Nl(e) {
	let t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
	return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : e.seconds ? `${t}:[0-5]\\d(?:\\.\\d+)?` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Pl(e) {
	return RegExp(`^${Nl(e)}$`);
}
function Fl(e) {
	let t = ["Z"];
	e.offset && t.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
	let n = `${Nl({
		precision: e.precision,
		seconds: !0
	})}(?:${t.join("|")})`, r = e.local ? `${n}|${Nl({ precision: e.precision })}` : n;
	return RegExp(`^${tu}T(?:${r})$`);
}
var Il, Ll, Rl, zl, Bl, Vl, Hl, Ul, Wl, Gl, Kl, ql, Jl, Yl, Xl, Zl, Ql, $l, eu, tu, nu, ru, iu, au, ou, su = B((() => {
	Il = /^[cC][0-9a-z]{6,}$/, Ll = /^[0-9a-z]+$/, Rl = /^[0-7][0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{25}$/, zl = /^[0-9a-vA-V]{20}$/, Bl = /^[A-Za-z0-9]{27}$/, Vl = /^[a-zA-Z0-9_-]{21}$/, Hl = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Ul = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Wl = (e) => e ? RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Gl = /^(?:[A-Za-z0-9_'+\-]+\.)*[A-Za-z0-9_'+\-]*[A-Za-z0-9_+-]@(?:[A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Kl = "^(?=[\\s\\S]*[\\p{Extended_Pictographic}\\p{Regional_Indicator}\\u20E3])[\\p{Extended_Pictographic}\\p{Emoji_Component}]+$", ql = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Jl = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Yl = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Xl = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Zl = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Ql = /^(?:[A-Za-z0-9_-]{4})*(?:[A-Za-z0-9_-]{2,3})?$/, $l = /^https?$/, eu = /^\+[1-9]\d{6,14}$/, tu = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", nu = /*@__PURE__*/ Ml(tu), ru = /^[\s\S]{0,}$/, iu = /^(?:true|false)$/i, au = /^[^A-Z]*$/, ou = /^[^a-z]*$/;
})), cu, lu, uu, du, fu, pu, mu, hu, gu, _u, vu, yu, bu, xu = B((() => {
	Qc(), su(), Uc(), cu = /*@__PURE__*/ K("$ZodCheck", (e, t) => {
		var n;
		e._zod ??= {}, e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
	}), lu = (e) => {
		let t = e.value;
		return !zs(t) && t.length !== void 0;
	}, uu = /*@__PURE__*/ K("$ZodCheckMaxLength", (e, t) => {
		var n;
		cu.init(e, t), (n = e._zod.def).when ?? (n.when = lu), e._zod.check = (n) => {
			let r = n.value, i = r.length;
			if ((typeof r == "string" && i > t.maximum ? bc(r) : i) <= t.maximum) return;
			let a = xc(r);
			n.issues.push({
				origin: a,
				code: "too_big",
				maximum: t.maximum,
				inclusive: !0,
				input: r,
				inst: e,
				continue: !t.abort
			});
		};
	}), du = /*@__PURE__*/ K("$ZodCheckMinLength", (e, t) => {
		var n;
		cu.init(e, t), (n = e._zod.def).when ?? (n.when = lu), e._zod.check = (n) => {
			let r = n.value, i = r.length;
			if ((typeof r == "string" && i >= t.minimum && i < t.minimum * 2 ? bc(r) : i) >= t.minimum) return;
			let a = xc(r);
			n.issues.push({
				origin: a,
				code: "too_small",
				minimum: t.minimum,
				inclusive: !0,
				input: r,
				inst: e,
				continue: !t.abort
			});
		};
	}), fu = /*@__PURE__*/ K("$ZodCheckLengthEquals", (e, t) => {
		var n;
		cu.init(e, t), (n = e._zod.def).when ?? (n.when = lu), e._zod.check = (n) => {
			let r = n.value, i = r.length, a = typeof r == "string" && i >= t.length && i <= t.length * 2 ? bc(r) : i;
			if (a === t.length) return;
			let o = xc(r), s = a > t.length;
			n.issues.push({
				origin: o,
				...s ? {
					code: "too_big",
					maximum: t.length
				} : {
					code: "too_small",
					minimum: t.length
				},
				inclusive: !0,
				exact: !0,
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		};
	}), pu = /*@__PURE__*/ K("$ZodCheckStringFormat", (e, t) => {
		var n, r;
		cu.init(e, t), t.pattern ? (n = e._zod).check ?? (n.check = (n) => {
			t.pattern.lastIndex = 0, t.pattern.test(n.value) || n.issues.push({
				origin: "string",
				code: "invalid_format",
				format: t.format,
				input: n.value,
				...t.pattern ? { pattern: t.pattern.toString() } : {},
				inst: e,
				continue: !t.abort
			});
		}) : (r = e._zod).check ?? (r.check = () => {});
	}), mu = /*@__PURE__*/ K("$ZodCheckRegex", (e, t) => {
		pu.init(e, t), e._zod.check = (n) => {
			t.pattern.lastIndex = 0, t.pattern.test(n.value) || n.issues.push({
				origin: "string",
				code: "invalid_format",
				format: "regex",
				input: n.value,
				pattern: t.pattern.toString(),
				inst: e,
				continue: !t.abort
			});
		};
	}), hu = /*@__PURE__*/ K("$ZodCheckLowerCase", (e, t) => {
		t.pattern ??= au, pu.init(e, t);
	}), gu = /*@__PURE__*/ K("$ZodCheckUpperCase", (e, t) => {
		t.pattern ??= ou, pu.init(e, t);
	}), _u = /*@__PURE__*/ K("$ZodCheckIncludes", (e, t) => {
		cu.init(e, t);
		let n = ec(t.includes);
		t.pattern = new RegExp(typeof t.position == "number" ? `^.{${t.position},}${n}` : n), e._zod.check = (n) => {
			n.value.includes(t.includes, t.position) || n.issues.push({
				origin: "string",
				code: "invalid_format",
				format: "includes",
				includes: t.includes,
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		};
	}), vu = /*@__PURE__*/ K("$ZodCheckStartsWith", (e, t) => {
		cu.init(e, t);
		let n = RegExp(`^${ec(t.prefix)}.*`);
		t.pattern ??= n, e._zod.check = (n) => {
			n.value.startsWith(t.prefix) || n.issues.push({
				origin: "string",
				code: "invalid_format",
				format: "starts_with",
				prefix: t.prefix,
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		};
	}), yu = /*@__PURE__*/ K("$ZodCheckEndsWith", (e, t) => {
		cu.init(e, t);
		let n = RegExp(`.*${ec(t.suffix)}$`);
		t.pattern ??= n, e._zod.check = (n) => {
			n.value.endsWith(t.suffix) || n.issues.push({
				origin: "string",
				code: "invalid_format",
				format: "ends_with",
				suffix: t.suffix,
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		};
	}), bu = /*@__PURE__*/ K("$ZodCheckOverwrite", (e, t) => {
		cu.init(e, t), e._zod.check = (e) => {
			e.value = t.tx(e.value);
		};
	});
})), Su, Cu = B((() => {
	Su = class {
		constructor(e = [], t = {}) {
			this.content = [], this.indent = 0, this.args = e, this.closed = t;
		}
		indented(e) {
			this.indent += 1;
			try {
				e(this);
			} finally {
				--this.indent;
			}
		}
		write(e) {
			if (typeof e == "function") {
				e(this, { execution: "sync" }), e(this, { execution: "async" });
				return;
			}
			let t = e.split("\n").filter((e) => e), n = Math.min(...t.map((e) => e.length - e.trimStart().length)), r = t.map((e) => e.slice(n)).map((e) => " ".repeat(this.indent * 2) + e);
			for (let e of r) this.content.push(e);
		}
		compile() {
			let e = Function, t = this?.content ?? [""];
			return new e(...Object.keys(this.closed), `return function (${this.args.join(", ")}) {\n${t.join("\n")}\n};`)(...Object.values(this.closed));
		}
	};
})), wu, Tu = B((() => {
	wu = {
		major: 4,
		minor: 6,
		patch: 7
	};
}));
// ../../../node_modules/zod/v4/core/schemas.js
async function Eu(e, t) {
	let n = { async: !0 };
	return ed(await e._zod.run({
		value: t,
		issues: []
	}, n), n);
}
function Du(e) {
	return {
		validate: (t) => {
			let n = { async: !1 };
			try {
				let r = e._zod.run({
					value: t,
					issues: []
				}, n);
				if (!(r instanceof Promise)) return ed(r, n);
			} catch {}
			return Eu(e, t);
		},
		vendor: "zod",
		version: 1
	};
}
function Ou(e) {
	try {
		return typeof URL < "u" && typeof URL.canParse == "function" ? URL.canParse(e) : (new URL(e), !0);
	} catch {
		return !1;
	}
}
function ku(e, t) {
	return !("normalize" in t) && !("hostname" in t) && !("protocol" in t) ? Ou(e) || 2 : Au(e, t);
}
function Au(e, t) {
	if (!t.normalize && t.protocol?.source === $l.source && !/^https?:\/\//i.test(e)) return 1;
	try {
		if (typeof URL < "u") {
			let t = URL;
			if (typeof t.parse == "function") return t.parse(e) ?? 2;
		}
		return new URL(e);
	} catch {
		return 2;
	}
}
function ju(e) {
	return e.replace(ad, "");
}
function Mu(e, t) {
	return t.lastIndex = 0, t.test(e.hostname);
}
function Nu(e, t) {
	return t.lastIndex = 0, t.test(e.protocol.endsWith(":") ? e.protocol.slice(0, -1) : e.protocol);
}
function Pu(e) {
	return yd.test(e) ? Ou(`http://[${e}]`) : !1;
}
function Fu(e) {
	let t = e.split("/");
	if (t.length !== 2) return !1;
	let [n, r] = t;
	if (!r) return !1;
	let i = Number(r);
	return `${i}` !== r || i < 0 || i > 128 ? !1 : Pu(n);
}
function Iu(e) {
	if (e === "") return !0;
	if (/\s/.test(e) || e.length % 4 != 0) return !1;
	try {
		return atob(e), !0;
	} catch {
		return !1;
	}
}
function Lu(e) {
	if (!Td.test(e)) return !1;
	let t = e.replace(/[-_]/g, (e) => e === "-" ? "+" : "/");
	return Iu(t.padEnd(Math.ceil(t.length / 4) * 4, "="));
}
function Ru(e, t = null) {
	try {
		let n = e.split(".");
		if (n.length !== 3) return !1;
		let [r] = n;
		if (!r) return !1;
		let i = JSON.parse(atob(r));
		return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
	} catch {
		return !1;
	}
}
function zu(e, t) {
	let n = _c(e._zod.def.checks);
	if (!n.length) return;
	let r = Math.min(...n.map((e) => e[0])), i = e._zod.parse;
	e._zod.parse = (n, a) => {
		let o = t(n.value);
		if (o > r && !a?.skipChecks && a?.direction !== "backward") {
			for (let [t, r] of _c(e._zod.def.checks)) if (o > t && r._zod.def.when(n)) {
				let t = n.issues.length;
				return r._zod.check(n), n.issues[t].continue = !1, vc(n.issues, t, e), n;
			}
		}
		return i(n, a);
	};
}
function Bu(e, t, n) {
	e.issues.length && t.issues.push(...hc(n, e.issues)), t.value[n] = e.value;
}
function Vu(e, t, n, r, i, a) {
	let o = n in r, s = a === "optional";
	if (o || !s || i !== "optional") {
		if (e.issues.length) {
			if (i !== void 0 && s && !o) return;
			t.issues.push(...hc(n, e.issues));
		}
		!o && i === void 0 ? e.issues.length || t.issues.push({
			code: "invalid_type",
			expected: "nonoptional",
			input: void 0,
			path: [n]
		}) : e.value === void 0 ? (o || i === "defaulted" && !s) && (t.value[n] = void 0) : t.value[n] = e.value;
	}
}
function Hu(e) {
	let t = Object.keys(e.shape), n = Object.getOwnPropertySymbols(e.shape), r = n.length ? n : Pd, i = r.length ? [...t, ...r] : t;
	for (let t of i) if (!e.shape?.[t]?._zod?.traits?.has("$ZodType")) throw Error(`Invalid element at key "${String(t)}": expected a Zod schema`);
	let a = rc(e.shape);
	return {
		...e,
		allKeys: i,
		symbolKeys: r,
		keySet: new Set(t),
		numKeys: t.length,
		optionalKeys: new Set(a)
	};
}
function Uu(e, t, n, r, i, a, o) {
	let s = [], c = i.keySet, l = i.catchall._zod, u = l.def.type, d = l.optin, f = l.optout, p = 0;
	for (let i in t) {
		if (o && n.issues.length !== p) {
			if (pc(n, p)) break;
			p = n.issues.length;
		}
		if (c.has(i)) continue;
		if (i === "__proto__") {
			u === "never" && s.push(i);
			continue;
		}
		if (u === "never") {
			s.push(i);
			continue;
		}
		let a = l.run({
			value: t[i],
			issues: []
		}, r);
		a instanceof Promise ? e.push(a.then((e) => Vu(e, n, i, t, d, f))) : Vu(a, n, i, t, d, f);
	}
	return s.length && n.issues.push({
		code: "unrecognized_keys",
		keys: s,
		input: t,
		inst: a,
		continue: !0
	}), e.length ? Promise.all(e).then(() => n) : n;
}
function Wu(e, t, n, r) {
	for (let n of e) if (n.issues.length === 0) return t.value = n.value, t;
	let i = e.filter((e) => !pc(e));
	return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
		code: "invalid_union",
		input: t.value,
		inst: n,
		errors: e.map((e) => e.issues.map((e) => yc(e, r, Gc())))
	}), t);
}
function Gu(e, t) {
	if (e === t || e instanceof Date && t instanceof Date && +e == +t) return {
		valid: !0,
		data: e
	};
	if (Qs(e) && Qs(t)) {
		let n = Object.keys(t), r = Object.keys(e).filter((e) => n.indexOf(e) !== -1), i = {
			...e,
			...t
		};
		Object.prototype.hasOwnProperty.call(i, "__proto__") && delete i.__proto__;
		for (let n of r) {
			if (n === "__proto__") continue;
			let r = Gu(e[n], t[n]);
			if (!r.valid) return {
				valid: !1,
				mergeErrorPath: [n, ...r.mergeErrorPath]
			};
			i[n] = r.data;
		}
		return {
			valid: !0,
			data: i
		};
	}
	if (Array.isArray(e) && Array.isArray(t)) {
		if (e.length !== t.length) return {
			valid: !1,
			mergeErrorPath: []
		};
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = t[r], o = Gu(i, a);
			if (!o.valid) return {
				valid: !1,
				mergeErrorPath: [r, ...o.mergeErrorPath]
			};
			n.push(o.data);
		}
		return {
			valid: !0,
			data: n
		};
	}
	return {
		valid: !1,
		mergeErrorPath: []
	};
}
function Ku(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i, a = /* @__PURE__ */ new Map(), o = (e, t) => {
		let n;
		if (e.code === "unrecognized_keys" && !e.path?.length) i ??= e, n = e.keys;
		else if (e.code === "invalid_key" && e.origin === "record" && e.path?.length === 1) {
			let t = String(e.path[0]);
			a.has(t) || a.set(t, e), n = [t];
		} else return !1;
		for (let e of n) r.has(e) || r.set(e, {}), r.get(e)[t] = !0;
		return !0;
	};
	for (let n of t.issues) o(n, "l") || e.issues.push(n);
	for (let t of n.issues) o(t, "r") || e.issues.push(t);
	let s = [...r].filter(([, e]) => e.l && e.r).map(([e]) => e);
	if (s.length) {
		let t = i ? s.filter((e) => i.keys.includes(e)) : [];
		t.length && e.issues.push({
			...i,
			keys: t
		});
		for (let n of s) !t.includes(n) && a.has(n) && e.issues.push(a.get(n));
	}
	let c = Gu(t.value, n.value);
	if (!c.valid) {
		if (pc(e)) return e;
		throw Error(`Unmergable intersection. Error path: ${JSON.stringify(c.mergeErrorPath)}`);
	}
	return e.value = c.data, e;
}
function qu(e, t) {
	return e.value = t.issues.length ? void 0 : t.value, e;
}
function Ju(e, t) {
	return e.value === void 0 && (e.value = t.defaultValue), e;
}
function Yu(e, t) {
	return !e.issues.length && e.value === void 0 && e.issues.push({
		code: "invalid_type",
		expected: "nonoptional",
		input: e.value,
		inst: t
	}), e;
}
function Xu(e, t, n, r) {
	return t.issues.length ? (e.value = n.catchValue({
		...t,
		value: e.value,
		error: { issues: t.issues.map((e) => yc(e, r, Gc())) },
		input: e.value
	}), e) : (e.value = t.value, t.memo && (e.memo = !0), e);
}
function Zu(e, t, n) {
	return e.issues.some((e) => e.code !== "unrecognized_keys") ? (e.aborted = !0, e) : t._zod.run({
		value: e.value,
		issues: e.issues
	}, n);
}
function Qu(e) {
	return e.memo || (e.value = Object.freeze(e.value)), e;
}
function $u(e, t, n, r) {
	if (!e) {
		let e = {
			code: "custom",
			input: n,
			inst: r,
			path: [...r._zod.def.path ?? []],
			continue: !r._zod.def.abort
		};
		r._zod.def.params && (e.params = r._zod.def.params), t.issues.push(Cc(e));
	}
}
var q, ed, td, J, nd, rd, id, ad, od, sd, cd, ld, ud, dd, fd, pd, md, hd, gd, _d, vd, yd, bd, xd, Sd, Cd, wd, Td, Ed, Dd, Od, kd, Ad, jd, Md, Nd, Pd, Fd, Id, Ld, Rd, zd, Bd, Vd, Hd, Ud, Wd, Gd, Kd, qd, Jd, Yd, Xd, Zd, Qd = B((() => {
	xu(), Qc(), Cu(), su(), Uc(), Tu(), q = /*@__PURE__*/ K("$ZodType", (e, t) => {
		var n;
		e ??= {}, e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = wu;
		let r = e._zod.def.checks, i = e._zod.traits.has("$ZodCheck") ? [e, ...r ?? []] : r?.length ? [...r] : [];
		for (let t of i) for (let n of t._zod.onattach) n(e);
		if (i.length === 0) (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
			e._zod.run = e._zod.parse;
		});
		else {
			let t = (t, n, r) => {
				if (t.memo) return t;
				let i = pc(t), a;
				for (let o of n) {
					if (o._zod.def.when) {
						if (mc(t) || !o._zod.def.when(t)) continue;
					} else if (i) continue;
					let n = t.issues.length, s = o._zod.check(t);
					if (s instanceof Promise && r?.async === !1) throw new Yc();
					if (a || s instanceof Promise) a = (a ?? Promise.resolve()).then(async () => {
						await s, t.issues.length !== n && (vc(t.issues, n, e), i ||= pc(t, n));
					});
					else {
						if (t.issues.length === n) continue;
						vc(t.issues, n, e), i ||= pc(t, n);
					}
				}
				return a ? a.then(() => t) : t;
			}, n = (n, r, a) => {
				if (pc(n)) return n.aborted = !0, n;
				let o = t(r, i, a);
				if (o instanceof Promise) {
					if (a.async === !1) throw new Yc();
					return o.then((t) => e._zod.parse(t, a));
				}
				return e._zod.parse(o, a);
			};
			e._zod.run = (r, a) => {
				if (a.skipChecks) return e._zod.parse(r, a);
				if (a.direction === "backward") {
					let t = e._zod.parse({
						value: r.value,
						issues: []
					}, {
						...a,
						skipChecks: !0
					});
					return t instanceof Promise ? t.then((e) => n(e, r, a)) : n(t, r, a);
				}
				let o = e._zod.parse(r, a);
				if (o instanceof Promise) {
					if (a.async === !1) throw new Yc();
					return o.then((e) => t(e, i, a));
				}
				return t(o, i, a);
			};
		}
	}, {
		get "~standard"() {
			return Ec(this, "~standard", Du(this));
		},
		set "~standard"(e) {
			Tc(this, "~standard", e);
		}
	}), ed = (e, t) => e.issues.length ? { issues: e.issues.map((e) => yc(e, t, Gc())) } : { value: e.value }, td = /*@__PURE__*/ K("$ZodString", (e, t) => {
		q.init(e, t), e._zod.pattern = t.pattern ?? ru, e._zod.parse = (n, r) => {
			if (t.coerce) try {
				n.value = String(n.value);
			} catch {}
			return typeof n.value == "string" || n.issues.push({
				expected: "string",
				code: "invalid_type",
				input: n.value,
				inst: e
			}), n;
		};
	}), J = /*@__PURE__*/ K("$ZodStringFormat", (e, t) => {
		pu.init(e, t), td.init(e, t);
	}), nd = /*@__PURE__*/ K("$ZodGUID", (e, t) => {
		t.pattern ??= Ul, J.init(e, t);
	}), rd = /*@__PURE__*/ K("$ZodUUID", (e, t) => {
		if (t.version) {
			let e = {
				v1: 1,
				v2: 2,
				v3: 3,
				v4: 4,
				v5: 5,
				v6: 6,
				v7: 7,
				v8: 8
			}[t.version];
			if (e === void 0) throw Error(`Invalid UUID version: "${t.version}"`);
			t.pattern ??= Wl(e);
		} else t.pattern ??= Wl();
		J.init(e, t);
	}), id = /*@__PURE__*/ K("$ZodEmail", (e, t) => {
		t.pattern ??= Gl, J.init(e, t);
	}), ad = /[\t\n\r]/g, od = /*@__PURE__*/ K("$ZodURL", (e, t) => {
		J.init(e, t), e._zod.check = (n) => {
			try {
				let r = n.value.trim(), i = ku(r, t);
				if (i === 1) {
					n.issues.push({
						code: "invalid_format",
						format: "url",
						note: "Invalid URL format",
						input: n.value,
						inst: e,
						continue: !t.abort
					});
					return;
				}
				if (i === 2) {
					n.issues.push({
						code: "invalid_format",
						format: "url",
						input: n.value,
						inst: e,
						continue: !t.abort
					});
					return;
				}
				if (i === !0) {
					n.value = ju(r);
					return;
				}
				t.hostname && !Mu(i, t.hostname) && n.issues.push({
					code: "invalid_format",
					format: "url",
					note: "Invalid hostname",
					pattern: t.hostname.source,
					input: n.value,
					inst: e,
					continue: !t.abort
				}), t.protocol && !Nu(i, t.protocol) && n.issues.push({
					code: "invalid_format",
					format: "url",
					note: "Invalid protocol",
					pattern: t.protocol.source,
					input: n.value,
					inst: e,
					continue: !t.abort
				}), n.value = t.normalize ? i.href : ju(r);
				return;
			} catch {
				n.issues.push({
					code: "invalid_format",
					format: "url",
					input: n.value,
					inst: e,
					continue: !t.abort
				});
			}
		};
	}), sd = /*@__PURE__*/ K("$ZodEmoji", (e, t) => {
		t.pattern ??= jl(), J.init(e, t);
	}), cd = /*@__PURE__*/ K("$ZodNanoID", (e, t) => {
		if (t.length !== void 0 && (!Number.isInteger(t.length) || t.length < 1)) throw Error(`Invalid nanoid length: ${t.length}`);
		t.pattern ??= t.length === void 0 ? Vl : Al(t.length), J.init(e, t);
	}), ld = /*@__PURE__*/ K("$ZodCUID", (e, t) => {
		t.pattern ??= Il, J.init(e, t);
	}), ud = /*@__PURE__*/ K("$ZodCUID2", (e, t) => {
		t.pattern ??= Ll, J.init(e, t);
	}), dd = /*@__PURE__*/ K("$ZodULID", (e, t) => {
		t.pattern ??= Rl, J.init(e, t);
	}), fd = /*@__PURE__*/ K("$ZodXID", (e, t) => {
		t.pattern ??= zl, J.init(e, t);
	}), pd = /*@__PURE__*/ K("$ZodKSUID", (e, t) => {
		t.pattern ??= Bl, J.init(e, t);
	}), md = /*@__PURE__*/ K("$ZodISODateTime", (e, t) => {
		t.pattern ??= Fl(t), J.init(e, t);
	}), hd = /*@__PURE__*/ K("$ZodISODate", (e, t) => {
		t.pattern ??= nu, J.init(e, t);
	}), gd = /*@__PURE__*/ K("$ZodISOTime", (e, t) => {
		t.pattern ??= Pl(t), J.init(e, t);
	}), _d = /*@__PURE__*/ K("$ZodISODuration", (e, t) => {
		t.pattern ??= Hl, J.init(e, t);
	}), vd = /*@__PURE__*/ K("$ZodIPv4", (e, t) => {
		t.pattern ??= ql, J.init(e, t);
	}), yd = /^[0-9a-fA-F:.]+$/, bd = /*@__PURE__*/ K("$ZodIPv6", (e, t) => {
		t.pattern ??= Jl, J.init(e, t), e._zod.check = (n) => {
			Pu(n.value) || n.issues.push({
				code: "invalid_format",
				format: "ipv6",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		};
	}), xd = /*@__PURE__*/ K("$ZodCIDRv4", (e, t) => {
		t.pattern ??= Yl, J.init(e, t);
	}), Sd = /*@__PURE__*/ K("$ZodCIDRv6", (e, t) => {
		t.pattern ??= Xl, J.init(e, t), e._zod.check = (n) => {
			Fu(n.value) || n.issues.push({
				code: "invalid_format",
				format: "cidrv6",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		};
	}), Cd = /^[0-9a-zA-Z+/]*={0,2}$/, wd = /*@__PURE__*/ K("$ZodBase64", (e, t) => {
		t.pattern ??= Cd, J.init(e, t), e._zod.check = (n) => {
			Iu(n.value) || n.issues.push({
				code: "invalid_format",
				format: "base64",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		};
	}), Td = /^[A-Za-z0-9_-]*$/, Ed = /*@__PURE__*/ K("$ZodBase64URL", (e, t) => {
		t.pattern ??= Td, J.init(e, t), e._zod.check = (n) => {
			Lu(n.value) || n.issues.push({
				code: "invalid_format",
				format: "base64url",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		};
	}), Dd = /*@__PURE__*/ K("$ZodE164", (e, t) => {
		t.pattern ??= eu, J.init(e, t);
	}), Od = /*@__PURE__*/ K("$ZodJWT", (e, t) => {
		J.init(e, t), e._zod.check = (n) => {
			Ru(n.value, t.alg) || n.issues.push({
				code: "invalid_format",
				format: "jwt",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		};
	}), kd = /*@__PURE__*/ K("$ZodBoolean", (e, t) => {
		q.init(e, t), e._zod.pattern = iu, e._zod.parse = (n, r) => {
			if (t.coerce) try {
				n.value = !!n.value;
			} catch {}
			let i = n.value;
			return typeof i == "boolean" || n.issues.push({
				expected: "boolean",
				code: "invalid_type",
				input: i,
				inst: e
			}), n;
		};
	}), Ad = /*@__PURE__*/ K("$ZodUnknown", (e, t) => {
		q.init(e, t), e._zod.parse = (e) => e;
	}), jd = /*@__PURE__*/ K("$ZodNever", (e, t) => {
		q.init(e, t), e._zod.parse = (t, n) => (t.issues.push({
			expected: "never",
			code: "invalid_type",
			input: t.value,
			inst: e
		}), t);
	}), Md = (e) => Array.isArray(e) ? e.length : -1, Nd = /*@__PURE__*/ K("$ZodArray", (e, t) => {
		q.init(e, t);
		let n = Zc.memoizer;
		n?.attach(e), e._zod.parse = (r, i) => {
			let a = r.value;
			if (!Array.isArray(a)) return r.issues.push({
				expected: "array",
				code: "invalid_type",
				input: a,
				inst: e
			}), r;
			r.value = n ? n.alloc(e, r, Array(a.length), i) : Array(a.length);
			let o = [], s = i?.abortEarly;
			for (let e = 0; e < a.length; e++) {
				let n = a[e], c = t.element._zod.run({
					value: n,
					issues: []
				}, i);
				if (c instanceof Promise) o.push(c.then((t) => Bu(t, r, e)));
				else if (Bu(c, r, e), s && c.issues.length !== 0 && pc(c)) break;
			}
			return o.length ? Promise.all(o).then(() => r) : r;
		}, zu(e, Md);
	}), Pd = [], Fd = /*@__PURE__*/ K("$ZodObject", (e, t) => {
		q.init(e, t);
		let n = Object.getOwnPropertyDescriptor(t, "shape"), r = n?.get ? n.get.raw : t.shape ?? {};
		if (r) {
			let e = () => {
				let n = { ...r };
				return Object.defineProperty(t, "shape", { value: n }), e.raw = n, n;
			};
			e.raw = r, Object.defineProperty(t, "shape", { get: e });
		}
		let i = Rs(() => Hu(t));
		G(e, "propValues", (e) => {
			let t = e.def.shape, n = {};
			for (let e in t) {
				let r = t[e]._zod;
				if (r.values) {
					Object.prototype.hasOwnProperty.call(n, e) || Vs(n, e, /* @__PURE__ */ new Set());
					for (let t of r.values) n[e].add(t);
					r.optin !== void 0 && n[e].add(void 0);
				}
			}
			return n;
		});
		let a = Zs, o = t.catchall, s, c = Zc.memoizer;
		c?.attach(e), e._zod.parse = (t, n) => {
			s ??= i.value;
			let r = t.value;
			if (!a(r)) return t.issues.push({
				expected: "object",
				code: "invalid_type",
				input: r,
				inst: e
			}), t;
			t.value = c ? c.alloc(e, t, {}, n) : {};
			let l = [], u = s.shape, d = n?.abortEarly, f = t.issues.length;
			for (let e of s.allKeys) {
				if (d && t.issues.length !== f) {
					if (pc(t, f)) break;
					f = t.issues.length;
				}
				if (e === "__proto__") continue;
				let i = u[e], a = i._zod.optin, o = i._zod.optout, s = i._zod.run({
					value: r[e],
					issues: []
				}, n);
				s instanceof Promise ? l.push(s.then((n) => Vu(n, t, e, r, a, o))) : Vu(s, t, e, r, a, o);
			}
			return o ? Uu(l, r, t, n, i.value, e, d === !0) : l.length ? Promise.all(l).then(() => t) : t;
		};
	}), Id = /*@__PURE__*/ K("$ZodObjectJIT", (e, t) => {
		Fd.init(e, t);
		let n = e._zod.parse, r = Rs(() => Hu(t)), i = Zc.memoizer, a = (t) => {
			let n = r.value, a = n.symbolKeys, o = new Su(["payload", "ctx"], {
				shape: t,
				inst: e,
				memo: i,
				syms: a
			}), s = (e) => `shape[${e}]._zod.run({ value: input[${e}], issues: [] }, ctx)`, c = (e, t) => `
          let ${e}_ab = false;
          for (let i = 0; i < ${e}.issues.length; i++) {
            const iss = ${e}.issues[i];
            iss.path = iss.path ? [${t}, ...iss.path] : [${t}];
            payload.issues.push(iss);
            if (iss.continue !== true) ${e}_ab = true;
          }
          if (${e}_ab && ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }`;
			o.write("const input = payload.value;");
			let l = Object.create(null), u = 0;
			for (let e of n.allKeys) l[e] = `key_${u++}`;
			o.write(i ? "const newResult = memo.alloc(inst, payload, {}, ctx);" : "const newResult = {};");
			for (let e of n.allKeys) {
				if (e === "__proto__") continue;
				let n = l[e], r = typeof e == "symbol" ? `syms[${a.indexOf(e)}]` : Ys(e), i = `${r} in input`, u = t[e], d = u?._zod?.optin, f = d !== void 0, p = u?._zod?.optout === "optional";
				if (o.write(`const ${n} = ${s(r)};`), f && p) {
					let e = d === "optional" ? `${n}_present` : `${n}.value !== undefined || ${n}_present`;
					o.write(`
        const ${n}_present = ${i};
        if (!${n}.issues.length || ${n}_present) {
          if (${n}.issues.length) {${c(n, r)}
          }

          if (${e}) {
            newResult[${r}] = ${n}.value;
          }
        }

      `);
				} else f ? (o.write(`
        if (${n}.issues.length) {${c(n, r)}
        }
      `), d === "defaulted" ? o.write(`newResult[${r}] = ${n}.value;`) : o.write(`
        if (${n}.value !== undefined || ${i}) {
          newResult[${r}] = ${n}.value;
        }
      `)) : o.write(`
        const ${n}_present = ${i};
        if (${n}.issues.length) {${c(n, r)}
        }
        if (!${n}_present && !${n}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${r}]
          });
          if (ctx && ctx.abortEarly) {
            payload.value = newResult;
            return payload;
          }
        }

        if (${n}_present) {
          newResult[${r}] = ${n}.value;
        }

      `);
			}
			return o.write("payload.value = newResult;"), o.write("return payload;"), o.compile();
		}, o, s = Zs, c = !Zc.jitless, l = c && Pc.value, u = t.catchall, d;
		e._zod.parse = (i, f) => {
			d ??= r.value;
			let p = i.value;
			return s(p) ? c && l && f?.async === !1 && f.jitless !== !0 ? (o ||= a(t.shape), i = o(i, f), u ? Uu([], p, i, f, d, e, f?.abortEarly === !0) : i) : n(i, f) : (i.issues.push({
				expected: "object",
				code: "invalid_type",
				input: p,
				inst: e
			}), i);
		};
	}), Ld = /*@__PURE__*/ K("$ZodUnion", (e, t) => {
		q.init(e, t), G(e, "optin", (e) => e.def.options.some((e) => e._zod.optin === "defaulted") ? "defaulted" : e.def.options.some((e) => e._zod.optin !== void 0) ? "optional" : void 0), G(e, "optout", (e) => e.def.options.some((e) => e._zod.optout === "optional") ? "optional" : void 0), G(e, "values", (e) => {
			if (e.def.options.every((e) => e._zod.values)) return new Set(e.def.options.flatMap((e) => Array.from(e._zod.values)));
		}), G(e, "pattern", (e) => {
			if (e.def.options.every((e) => e._zod.pattern)) {
				let t = e.def.options.map((e) => e._zod.pattern);
				return RegExp(`^(${t.map((e) => Bs(e.source)).join("|")})$`);
			}
		});
		let n = t.options.length === 1 ? t.options[0]._zod.run : null;
		e._zod.parse = (r, i) => {
			if (n) return n(r, i);
			let a = !1, o = [];
			for (let e of t.options) {
				let t = e._zod.run({
					value: r.value,
					issues: []
				}, i);
				if (t instanceof Promise) o.push(t), a = !0;
				else {
					if (t.issues.length === 0) return t;
					o.push(t);
				}
			}
			return a ? Promise.all(o).then((t) => Wu(t, r, e, i)) : Wu(o, r, e, i);
		};
	}), Rd = /*@__PURE__*/ K("$ZodIntersection", (e, t) => {
		q.init(e, t), e._zod.parse = (e, n) => {
			let r = e.value, i = t.left._zod.run({
				value: r,
				issues: []
			}, n), a = t.right._zod.run({
				value: r,
				issues: []
			}, n);
			return i instanceof Promise || a instanceof Promise ? Promise.all([i, a]).then(([t, n]) => Ku(e, t, n)) : Ku(e, i, a);
		};
	}), zd = /*@__PURE__*/ K("$ZodEnum", (e, t) => {
		q.init(e, t);
		let n = Fs(t.entries), r = new Set(n);
		e._zod.values = r, G(e, "pattern", (e) => {
			let t = Fs(e.def.entries).filter((e) => Fc.has(typeof e));
			return RegExp(t.length ? `^(${t.map((e) => ec(e.toString())).join("|")})$` : "^[^\\s\\S]$");
		}), e._zod.parse = (t, i) => {
			let a = t.value;
			return r.has(a) || t.issues.push({
				code: "invalid_value",
				values: n,
				input: a,
				inst: e
			}), t;
		};
	}), Bd = /*@__PURE__*/ K("$ZodLiteral", (e, t) => {
		q.init(e, t);
		let n = new Set(t.values);
		e._zod.values = n, G(e, "pattern", (e) => {
			let t = e.def.values;
			return RegExp(t.length ? `^(${t.map((e) => typeof e == "string" ? ec(e) : e ? ec(e.toString()) : String(e)).join("|")})$` : "^[^\\s\\S]$");
		}), e._zod.parse = (r, i) => {
			let a = r.value;
			return n.has(a) || r.issues.push({
				code: "invalid_value",
				values: t.values,
				input: a,
				inst: e
			}), r;
		};
	}), Vd = /*@__PURE__*/ K("$ZodTransform", (e, t) => {
		q.init(e, t), e._zod.optin = "optional", Zc.memoizer?.guard(e), e._zod.parse = (n, r) => {
			if (r.direction === "backward") throw new Xc(e.constructor.name);
			let i = t.transform(n.value, n);
			if (r.async) return (i instanceof Promise ? i : Promise.resolve(i)).then((e) => (n.value = e, n));
			if (i instanceof Promise) throw new Yc();
			return n.value = i, n;
		};
	}), Hd = /*@__PURE__*/ K("$ZodOptional", (e, t) => {
		q.init(e, t), G(e, "optin", (e) => e.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional"), e._zod.optout = "optional", G(e, "values", (e) => {
			let t = e.def.innerType._zod.values;
			return t ? /* @__PURE__ */ new Set([...t, void 0]) : void 0;
		}), G(e, "pattern", (e) => {
			let t = e.def.innerType._zod.pattern;
			return t ? RegExp(`^(${Bs(t.source)})?$`) : void 0;
		}), e._zod.parse = (e, n) => {
			if (e.value === void 0) {
				if (t.innerType._zod.optin !== "defaulted") return e;
				let r = t.innerType._zod.run({
					value: e.value,
					issues: []
				}, n);
				return r instanceof Promise ? r.then((t) => qu(e, t)) : qu(e, r);
			}
			return t.innerType._zod.run(e, n);
		};
	}), Ud = /*@__PURE__*/ K("$ZodExactOptional", (e, t) => {
		Hd.init(e, t), G(e, "values", (e) => e.def.innerType._zod.values), G(e, "pattern", (e) => e.def.innerType._zod.pattern), e._zod.parse = (e, n) => t.innerType._zod.run(e, n);
	}), Wd = /*@__PURE__*/ K("$ZodNullable", (e, t) => {
		q.init(e, t), G(e, "optin", (e) => e.def.innerType._zod.optin), G(e, "optout", (e) => e.def.innerType._zod.optout), G(e, "pattern", (e) => {
			let t = e.def.innerType._zod.pattern;
			return t ? RegExp(`^(${Bs(t.source)}|null)$`) : void 0;
		}), G(e, "values", (e) => e.def.innerType._zod.values ? /* @__PURE__ */ new Set([...e.def.innerType._zod.values, null]) : void 0), e._zod.parse = (e, n) => e.value === null ? e : t.innerType._zod.run(e, n);
	}), Gd = /*@__PURE__*/ K("$ZodDefault", (e, t) => {
		q.init(e, t), e._zod.optin = "defaulted", G(e, "values", (e) => e.def.innerType._zod.values), e._zod.parse = (e, n) => {
			if (n.direction === "backward") return t.innerType._zod.run(e, n);
			if (e.value === void 0) return e.value = t.defaultValue, e;
			let r = t.innerType._zod.run(e, n);
			return r instanceof Promise ? r.then((e) => Ju(e, t)) : Ju(r, t);
		};
	}), Kd = /*@__PURE__*/ K("$ZodPrefault", (e, t) => {
		q.init(e, t), e._zod.optin = "defaulted", G(e, "values", (e) => e.def.innerType._zod.values), e._zod.parse = (e, n) => (n.direction === "backward" || e.value === void 0 && (e.value = t.defaultValue), t.innerType._zod.run(e, n));
	}), qd = /*@__PURE__*/ K("$ZodNonOptional", (e, t) => {
		q.init(e, t), G(e, "values", (e) => {
			let t = e.def.innerType._zod.values;
			return t ? new Set([...t].filter((e) => e !== void 0)) : void 0;
		}), e._zod.parse = (n, r) => {
			let i = t.innerType._zod.run(n, r);
			return i instanceof Promise ? i.then((t) => Yu(t, e)) : Yu(i, e);
		};
	}), Jd = /*@__PURE__*/ K("$ZodCatch", (e, t) => {
		q.init(e, t), G(e, "optin", (e) => e.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional"), G(e, "optout", (e) => e.def.innerType._zod.optout), G(e, "values", (e) => e.def.innerType._zod.values), e._zod.parse = (e, n) => {
			if (n.direction === "backward") return t.innerType._zod.run(e, n);
			let r = t.innerType._zod.run({
				value: e.value,
				issues: []
			}, n);
			return r instanceof Promise ? r.then((r) => Xu(e, r, t, n)) : Xu(e, r, t, n);
		};
	}), Yd = /*@__PURE__*/ K("$ZodPipe", (e, t) => {
		q.init(e, t), G(e, "values", (e) => e.def.in._zod.values), G(e, "optin", (e) => e.def.in._zod.optin), G(e, "optout", (e) => e.def.out._zod.optout), G(e, "propValues", (e) => e.def.in._zod.propValues), e._zod.parse = (e, n) => {
			if (n.direction === "backward") {
				let r = t.out._zod.run(e, n);
				return r instanceof Promise ? r.then((e) => Zu(e, t.in, n)) : Zu(r, t.in, n);
			}
			let r = t.in._zod.run(e, n);
			return r instanceof Promise ? r.then((e) => Zu(e, t.out, n)) : Zu(r, t.out, n);
		};
	}), Xd = /*@__PURE__*/ K("$ZodReadonly", (e, t) => {
		q.init(e, t), G(e, "propValues", (e) => e.def.innerType._zod.propValues), G(e, "values", (e) => e.def.innerType._zod.values), G(e, "optin", (e) => e.def.innerType?._zod?.optin), G(e, "optout", (e) => e.def.innerType?._zod?.optout), e._zod.parse = (e, n) => {
			if (n.direction === "backward") return t.innerType._zod.run(e, n);
			let r = t.innerType._zod.run(e, n);
			return r instanceof Promise ? r.then(Qu) : Qu(r);
		};
	}), Zd = /*@__PURE__*/ K("$ZodCustom", (e, t) => {
		cu.init(e, t), q.init(e, t), e._zod.parse = (e, t) => e, e._zod.check = (n) => {
			let r = n.value, i = t.fn(r);
			if (i instanceof Promise) return i.then((t) => $u(t, n, r, e));
			$u(i, n, r, e);
		};
	});
}));
// ../../../node_modules/zod/v4/core/memoizer.js
function $d(e) {
	return typeof e == "object" && !!e;
}
function ef(e) {
	return e.map((e) => e.path ? {
		...e,
		path: e.path.slice()
	} : { ...e });
}
function tf(e, t, n) {
	let r = uf.get(e);
	if (r !== void 0) return r ? pf : df;
	if (t.has(e)) return pf;
	t.add(e);
	let i = df, a = (e) => {
		if (i !== pf && e?._zod) {
			let r = tf(e, t, n);
			r > i && (i = r);
		}
	}, o = (e, r) => {
		let i = df;
		for (let a of Reflect.ownKeys(e)) {
			let o = Object.getOwnPropertyDescriptor(e, a);
			if (r && !o.enumerable) continue;
			let s = o.get ? ff : o.value?._zod ? tf(o.value, t, n) : df;
			s > i && (i = s);
		}
		return i;
	}, s = (e) => {
		e > i && (i = e);
	}, c = e._zod.def;
	switch (c.type) {
		case "object": {
			let e = Hs(c);
			s(e ? o(e, !0) : ff), a(c.catchall);
			break;
		}
		case "array":
			a(c.element);
			break;
		case "tuple":
			for (let e of c.items) a(e);
			a(c.rest);
			break;
		case "record":
		case "map":
			a(c.keyType), a(c.valueType);
			break;
		case "set":
			a(c.valueType);
			break;
		case "union":
			for (let e of c.options) a(e);
			break;
		case "intersection":
			a(c.left), a(c.right);
			break;
		case "optional":
		case "nullable":
		case "default":
		case "prefault":
		case "catch":
		case "readonly":
		case "nonoptional":
		case "promise":
		case "success":
			a(c.innerType);
			break;
		case "pipe":
			a(c.in), a(c.out);
			break;
		case "function":
			a(c.input), a(c.output);
			break;
		case "lazy": {
			let r = c._cachedInner ?? (n ? e._zod.innerType : void 0);
			s(r ? tf(r, t, !1) : ff);
			break;
		}
		case "template_literal":
		case "string":
		case "number":
		case "int":
		case "boolean":
		case "bigint":
		case "symbol":
		case "undefined":
		case "null":
		case "void":
		case "never":
		case "any":
		case "unknown":
		case "date":
		case "nan":
		case "enum":
		case "literal":
		case "file":
		case "transform":
		case "custom": break;
		default: for (let e in c) {
			let t = Object.getOwnPropertyDescriptor(c, e);
			if (!t || t.get) continue;
			let n = t.value;
			if (n && typeof n == "object") {
				if (n._zod) a(n);
				else if (Array.isArray(n)) for (let e of n) a(e);
			}
		}
	}
	return t.delete(e), nf(e, i);
}
function nf(e, t) {
	return t !== ff && uf.set(e, t === pf), t;
}
function rf(e, t) {
	let n = e.buckets.get(t);
	return n || (n = /* @__PURE__ */ new WeakMap(), e.buckets.set(t, n)), n;
}
function af() {
	return gf;
}
function of(e, t) {
	let n = e[cf]?.backEdges;
	return n !== void 0 && $d(t) && n.has(t);
}
var sf, cf, lf, uf, df, ff, pf, mf, hf, gf, _f = B((() => {
	Uc(), sf = class extends Error {
		constructor() {
			super("Cannot parse a reference cycle that closes through a transform"), this.name = "ZodCyclicError";
		}
	}, cf = "~memo", lf = [], uf = /*@__PURE__*/ new WeakMap(), df = 0, ff = 1, pf = 2, hf = [], gf = {
		alloc(e, t, n) {
			let r = mf;
			if (!r) return n;
			mf = void 0;
			let i = {
				value: n,
				issues: null
			};
			return r.set(t.value, i), hf.push(i), n;
		},
		guard(e) {
			var t;
			(t = e._zod).deferred ?? (t.deferred = []), e._zod.deferred.push(() => {
				let t = e._zod.parse, n = (e, n) => {
					if (n.direction !== "backward" && of(n, e.value)) throw new sf();
					return t(e, n);
				};
				e._zod.parse = n, e._zod.run === t && (e._zod.run = n);
			});
		},
		attach(e) {
			var t;
			let n, r = !1, i, a;
			(t = e._zod).deferred ?? (t.deferred = []), e._zod.deferred.push(() => {
				let t = e._zod.parse, o = (s, c) => {
					if (n === void 0) {
						let i = tf(e, /* @__PURE__ */ new Set(), !1);
						if (i === df) return e._zod.parse = t, e._zod.run === o && (e._zod.run = t), t(s, c);
						i === pf || r ? n = !0 : r = !0;
					}
					let l = s.value;
					if (!$d(l)) return t(s, c);
					let u = c[cf];
					u || (u = {
						buckets: /* @__PURE__ */ new WeakMap(),
						backEdges: void 0
					}, c[cf] = u);
					let d;
					i === c ? d = a : (d = rf(u, e), i = c, a = d);
					let f = d.get(l);
					if (f) return s.value = f.value, f.issues ? f.issues.length && s.issues.push(...ef(f.issues)) : (s.memo = !0, u.backEdges ?? (u.backEdges = /* @__PURE__ */ new WeakSet()), u.backEdges.add(f.value)), s;
					mf = d;
					let p = hf.length, m = t(s, c);
					mf = void 0;
					let h = hf.length > p ? hf.pop() : void 0;
					return m instanceof Promise ? m.then((e) => (h && (h.issues = e.issues.length ? ef(e.issues) : lf), e)) : (h && (h.issues = m.issues.length ? ef(m.issues) : lf), m);
				};
				e._zod.parse = o, e._zod.run === t && (e._zod.run = o);
			});
		}
	};
}));
// ../../../node_modules/zod/v4/locales/en.js
function vf() {
	return { localeError: yf() };
}
var yf, bf = B((() => {
	Uc(), yf = () => {
		let e = {
			string: {
				unit: "characters",
				verb: "to have"
			},
			file: {
				unit: "bytes",
				verb: "to have"
			},
			array: {
				unit: "items",
				verb: "to have"
			},
			set: {
				unit: "items",
				verb: "to have"
			},
			map: {
				unit: "entries",
				verb: "to have"
			}
		};
		function t(t) {
			return e[t] ?? null;
		}
		let n = {
			regex: "input",
			email: "email address",
			url: "URL",
			emoji: "emoji",
			uuid: "UUID",
			uuidv4: "UUIDv4",
			uuidv6: "UUIDv6",
			nanoid: "nanoid",
			guid: "GUID",
			cuid: "cuid",
			cuid2: "cuid2",
			ulid: "ULID",
			xid: "XID",
			ksuid: "KSUID",
			datetime: "ISO datetime",
			date: "ISO date",
			time: "ISO time",
			duration: "ISO duration",
			ipv4: "IPv4 address",
			ipv6: "IPv6 address",
			mac: "MAC address",
			cidrv4: "IPv4 range",
			cidrv6: "IPv6 range",
			base64: "base64-encoded string",
			base64url: "base64url-encoded string",
			json_string: "JSON string",
			e164: "E.164 number",
			currency_code: "currency code",
			credit_card: "credit card number",
			iban: "IBAN",
			jwt: "JWT",
			template_literal: "input"
		}, r = { nan: "NaN" };
		function i(e, t) {
			return e === "number" && typeof t == "number" && !Number.isFinite(t) ? String(t) : r[e] ?? e;
		}
		return (e) => {
			switch (e.code) {
				case "invalid_type": return `Invalid input: expected ${i(e.expected)}, received ${i(Sc(e.input), e.input)}`;
				case "invalid_value": return e.values.length === 1 ? `Invalid input: expected ${nc(e.values[0])}` : `Invalid option: expected one of ${Is(e.values, "|")}`;
				case "too_big": {
					let n = e.exact ? "exactly " : e.inclusive ? "<=" : "<", r = t(e.origin);
					return r ? `Too big: expected ${e.origin ?? "value"} to have ${n}${e.maximum.toString()} ${r.unit ?? "elements"}` : `Too big: expected ${e.origin ?? "value"} to be ${n}${e.maximum.toString()}`;
				}
				case "too_small": {
					let n = e.exact ? "exactly " : e.inclusive ? ">=" : ">", r = t(e.origin);
					return r ? `Too small: expected ${e.origin} to have ${n}${e.minimum.toString()} ${r.unit}` : `Too small: expected ${e.origin} to be ${n}${e.minimum.toString()}`;
				}
				case "invalid_format": {
					let t = e;
					return t.format === "starts_with" ? `Invalid string: must start with "${t.prefix}"` : t.format === "ends_with" ? `Invalid string: must end with "${t.suffix}"` : t.format === "includes" ? `Invalid string: must include "${t.includes}"` : t.format === "regex" ? `Invalid string: must match pattern ${t.pattern}` : `Invalid ${n[t.format] ?? e.format}`;
				}
				case "not_multiple_of": return `Invalid number: must be a multiple of ${e.divisor}`;
				case "unrecognized_keys": return `Unrecognized key${e.keys.length > 1 ? "s" : ""}: ${Is(e.keys, ", ")}`;
				case "invalid_key": return `Invalid key in ${e.origin}`;
				case "invalid_union": return e.options && Array.isArray(e.options) && e.options.length > 0 ? `Invalid discriminator value. Expected ${e.options.map((e) => `'${e}'`).join(" | ")}` : e.inclusive === !1 ? "Invalid input: more than one option matched" : "Invalid input";
				case "invalid_element": return `Invalid value in ${e.origin}`;
				default: return "Invalid input";
			}
		};
	};
}));
// ../../../node_modules/zod/v4/core/registries.js
function xf() {
	return new Cf();
}
var Sf, Cf, wf, Tf = B((() => {
	Cf = class {
		constructor() {
			this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
		}
		add(e, ...t) {
			let n = t[0];
			return this._map.set(e, n), n && typeof n == "object" && "id" in n && this._idmap.set(n.id, e), this;
		}
		clear() {
			return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
		}
		remove(e) {
			let t = this._map.get(e);
			return t && typeof t == "object" && "id" in t && this._idmap.delete(t.id), this._map.delete(e), this;
		}
		get(e) {
			let t = e._zod.parent;
			if (t) {
				let n = { ...this.get(t) ?? {} };
				delete n.id;
				let r = {
					...n,
					...this._map.get(e)
				};
				return Object.keys(r).length ? r : void 0;
			}
			return this._map.get(e);
		}
		has(e) {
			return this._map.has(e);
		}
	}, (Sf = globalThis).__zod_globalRegistry ?? (Sf.__zod_globalRegistry = xf()), wf = globalThis.__zod_globalRegistry;
})), Ef = B((() => {}));
// ../../../node_modules/zod/v4/core/api.js
function Df(e) {
	return e.checks &&= [...e.checks], e;
}
// @__NO_SIDE_EFFECTS__
function Of(e, t) {
	return new e(Df({
		type: "string",
		...W(t)
	}));
}
// @__NO_SIDE_EFFECTS__
function kf(e, t) {
	return new e({
		type: "string",
		format: "email",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Af(e, t) {
	return new e({
		type: "string",
		format: "guid",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function jf(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Mf(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v4",
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Nf(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v6",
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Pf(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v7",
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ff(e, t) {
	return new e({
		type: "string",
		format: "url",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function If(e, t) {
	return new e({
		type: "string",
		format: "emoji",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Lf(e, t) {
	return new e({
		type: "string",
		format: "nanoid",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Rf(e, t) {
	return new e({
		type: "string",
		format: "cuid",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function zf(e, t) {
	return new e({
		type: "string",
		format: "cuid2",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Bf(e, t) {
	return new e({
		type: "string",
		format: "ulid",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Vf(e, t) {
	return new e({
		type: "string",
		format: "xid",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Hf(e, t) {
	return new e({
		type: "string",
		format: "ksuid",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Uf(e, t) {
	return new e({
		type: "string",
		format: "ipv4",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Wf(e, t) {
	return new e({
		type: "string",
		format: "ipv6",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Gf(e, t) {
	return new e({
		type: "string",
		format: "cidrv4",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Kf(e, t) {
	return new e({
		type: "string",
		format: "cidrv6",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function qf(e, t) {
	return new e({
		type: "string",
		format: "base64",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Jf(e, t) {
	return new e({
		type: "string",
		format: "base64url",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Yf(e, t) {
	return new e({
		type: "string",
		format: "e164",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Xf(e, t) {
	return new e({
		type: "string",
		format: "jwt",
		check: "string_format",
		abort: !1,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Zf(e, t) {
	return new e({
		type: "string",
		format: "datetime",
		check: "string_format",
		offset: !1,
		local: !1,
		precision: null,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Qf(e, t) {
	return new e({
		type: "string",
		format: "date",
		check: "string_format",
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function $f(e, t) {
	return new e({
		type: "string",
		format: "time",
		check: "string_format",
		precision: null,
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function ep(e, t) {
	return new e({
		type: "string",
		format: "duration",
		check: "string_format",
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function tp(e, t) {
	return new e({
		type: "boolean",
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function np(e) {
	return new e({ type: "unknown" });
}
// @__NO_SIDE_EFFECTS__
function rp(e, t) {
	return new e({
		type: "never",
		...W(t)
	});
}
// @__NO_SIDE_EFFECTS__
function ip(e, t) {
	return new uu({
		check: "max_length",
		...W(t),
		maximum: e
	});
}
// @__NO_SIDE_EFFECTS__
function ap(e, t) {
	return new du({
		check: "min_length",
		...W(t),
		minimum: e
	});
}
// @__NO_SIDE_EFFECTS__
function op(e, t) {
	return new fu({
		check: "length_equals",
		...W(t),
		length: e
	});
}
// @__NO_SIDE_EFFECTS__
function sp(e, t) {
	return new mu({
		check: "string_format",
		format: "regex",
		...W(t),
		pattern: e
	});
}
// @__NO_SIDE_EFFECTS__
function cp(e) {
	return new hu({
		check: "string_format",
		format: "lowercase",
		...W(e)
	});
}
// @__NO_SIDE_EFFECTS__
function lp(e) {
	return new gu({
		check: "string_format",
		format: "uppercase",
		...W(e)
	});
}
// @__NO_SIDE_EFFECTS__
function up(e, t) {
	return new _u({
		check: "string_format",
		format: "includes",
		...W(t),
		includes: e
	});
}
// @__NO_SIDE_EFFECTS__
function dp(e, t) {
	return new vu({
		check: "string_format",
		format: "starts_with",
		...W(t),
		prefix: e
	});
}
// @__NO_SIDE_EFFECTS__
function fp(e, t) {
	return new yu({
		check: "string_format",
		format: "ends_with",
		...W(t),
		suffix: e
	});
}
// @__NO_SIDE_EFFECTS__
function pp(e) {
	return new bu({
		check: "overwrite",
		tx: e
	});
}
// @__NO_SIDE_EFFECTS__
function mp(e) {
	return /* @__PURE__ */ pp((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function hp() {
	return /* @__PURE__ */ pp((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function gp() {
	return /* @__PURE__ */ pp((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function _p() {
	return /* @__PURE__ */ pp((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function vp() {
	return /* @__PURE__ */ pp((e) => Xs(e));
}
// @__NO_SIDE_EFFECTS__
function yp(e, t, n) {
	return new e({
		type: "array",
		element: t,
		...W(n)
	});
}
// @__NO_SIDE_EFFECTS__
function bp(e, t, n) {
	return new e({
		type: "custom",
		check: "custom",
		fn: t,
		...W(n)
	});
}
// @__NO_SIDE_EFFECTS__
function xp(e, t) {
	let n = /* @__PURE__ */ Sp((t) => (t.addIssue = (e) => {
		if (typeof e == "string") t.issues.push(Cc(e, t.value, n._zod.def));
		else {
			let r = e;
			r.fatal && (r.continue = !1), r.code ??= "custom", "input" in r || (r.input = t.value), r.inst ??= n, r.continue ??= !n._zod.def.abort, t.issues.push(Cc(r));
		}
	}, e(t.value, t)), t);
	return n;
}
// @__NO_SIDE_EFFECTS__
function Sp(e, t) {
	let n = new cu({
		check: "custom",
		...W(t)
	});
	return n._zod.check = e, n;
}
var Cp = B((() => {
	xu(), Uc();
}));
// ../../../node_modules/zod/v4/core/to-json-schema.js
function wp(e, ...t) {
	for (let n of t) for (let t of Reflect.ownKeys(n)) Object.prototype.propertyIsEnumerable.call(n, t) && Vs(e, t, n[t]);
	return e;
}
function Tp(e) {
	let t = e?.target ?? "draft-2020-12";
	return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
		processors: e.processors ?? {},
		metadataRegistry: e?.metadata ?? wf,
		target: t,
		unrepresentable: e?.unrepresentable ?? "throw",
		override: e?.override ?? (() => {}),
		io: e?.io ?? "output",
		counter: 0,
		seen: /* @__PURE__ */ new Map(),
		sharedDefsExtractedFor: void 0,
		sharedEmitDoneFor: void 0,
		cycles: e?.cycles ?? "ref",
		reused: e?.reused ?? "inline",
		intersections: [],
		deferred: [],
		external: e?.external ?? void 0
	};
}
function Ep(e, t, n, r, i) {
	let a = typeof t.unrepresentable == "function" ? t.unrepresentable({
		zodSchema: e,
		path: r.path,
		message: i
	}) : t.unrepresentable;
	if (a === "any") return !1;
	if (a === void 0 || a === "throw") throw Error(i);
	return Object.assign(n, a), !0;
}
function Dp(e, t, n = {
	path: [],
	schemaPath: []
}) {
	var r;
	let i = e._zod.def, a = t.seen.get(e);
	if (a) return a.count++, n.schemaPath.includes(e) && (a.cycle = n.path), a.schema;
	let o = {
		schema: {},
		count: 1,
		cycle: void 0,
		path: n.path
	};
	t.seen.set(e, o), t.sharedDefsExtractedFor = void 0, t.sharedEmitDoneFor = void 0;
	let s = e._zod.toJSONSchema?.();
	if (s) o.schema = s;
	else {
		let r = {
			...n,
			schemaPath: [...n.schemaPath, e],
			path: n.path
		};
		if (e._zod.processJSONSchema) e._zod.processJSONSchema(t, o.schema, r);
		else {
			let n = o.schema, a = t.processors[i.type];
			if (!a) throw Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
			a(e, t, n, r);
		}
		let a = e._zod.parent;
		a && (o.ref ||= a, Dp(a, t, r), t.seen.get(a).isParent = !0);
	}
	let c = t.metadataRegistry.get(e);
	return c && wp(o.schema, c), t.io === "input" && Fp(e) && (delete o.schema.examples, delete o.schema.default), t.io === "input" && "_prefault" in o.schema && ((r = o.schema).default ?? (r.default = o.schema._prefault)), delete o.schema._prefault, t.seen.get(e).schema;
}
function Op(e) {
	return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function kp(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	if (e.external && e.sharedDefsExtractedFor === e.external) return;
	let r = /* @__PURE__ */ new Map();
	for (let t of e.seen.entries()) {
		let n = e.metadataRegistry.get(t[0])?.id;
		if (n) {
			let e = r.get(n);
			if (e && e !== t[0]) throw Error(`Duplicate schema id "${n}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
			r.set(n, t[0]);
		}
	}
	let i = (t) => {
		let r = e.target === "draft-2020-12" ? "$defs" : "definitions";
		if (e.external) {
			let n = e.external.registry.get(t[0])?.id, i = e.external.uri ?? ((e) => e);
			if (n) return { ref: i(n) };
			let a = t[1].defId ?? t[1].schema.id ?? `schema${e.counter++}`;
			return t[1].defId = a, {
				defId: a,
				ref: `${i("__shared")}#/${r}/${Op(a)}`
			};
		}
		let i = `#/${r}/`;
		if (t[1] === n && !t[1].schema.id) return { ref: "#" };
		let a = t[1].schema.id ?? `__schema${e.counter++}`;
		return {
			defId: a,
			ref: i + Op(a)
		};
	}, a = (e) => {
		if (e[1].schema.$ref) return;
		let t = e[1], { ref: n, defId: r } = i(e);
		t.def = { ...t.schema }, r && (t.defId = r);
		let a = t.schema;
		for (let e in a) delete a[e];
		a.$ref = n;
	};
	if (e.cycles === "throw") for (let t of e.seen.entries()) {
		let e = t[1];
		if (e.cycle) throw Error(`Cycle detected: #/${e.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
	}
	for (let n of e.seen.entries()) {
		let r = n[1];
		if (t === n[0]) a(n);
		else {
			if (e.external) {
				let r = e.external.registry.get(n[0])?.id;
				if (t !== n[0] && r) {
					a(n);
					continue;
				}
			}
			(e.metadataRegistry.get(n[0])?.id || r.cycle || r.count > 1 && e.reused === "ref") && a(n);
		}
	}
	e.external && (e.sharedDefsExtractedFor = e.external);
}
function Ap(e) {
	let t = e.anyOf;
	if (!Array.isArray(t) || t.length === 0 || e.type !== void 0) return;
	let n = [];
	for (let e of t) {
		if (!e || typeof e != "object") return;
		Ap(e);
		let t = Object.keys(e);
		if (t.length !== 1 || t[0] !== "type") return;
		let r = e.type;
		for (let e of Array.isArray(r) ? r : [r]) {
			if (typeof e != "string") return;
			n.includes(e) || n.push(e);
		}
	}
	delete e.anyOf, e.type = n.length === 1 ? n[0] : n;
}
function jp(e) {
	let t = e.additionalProperties;
	return t === void 0 || t === !1 || typeof t != "object" || !t ? null : Object.keys(t).length ? t : null;
}
function Mp(e) {
	let t = [];
	for (let n of e) {
		if (typeof n != "object" || n.type !== "object") return null;
		for (let e in n) if (!Ip.has(e)) return null;
		t.push(n);
	}
	let n = {}, r = /* @__PURE__ */ new Set();
	for (let e of t) {
		for (let r in e.properties) {
			if (Object.prototype.hasOwnProperty.call(n, r)) continue;
			let e = [];
			for (let n of t) {
				let t = n.properties?.[r] ?? jp(n);
				t != null && (e.some((e) => JSON.stringify(e) === JSON.stringify(t)) || e.push(t));
			}
			Vs(n, r, e.length === 1 ? e[0] : Mp(e) ?? { allOf: e });
		}
		for (let t of e.required ?? []) r.add(t);
	}
	let i = {
		type: "object",
		properties: n
	};
	if (r.size && (i.required = [...r]), t.every((e) => e.additionalProperties === !1)) i.additionalProperties = !1;
	else {
		let e = [];
		for (let n of t) {
			let t = jp(n);
			t && !e.some((e) => JSON.stringify(e) === JSON.stringify(t)) && e.push(t);
		}
		e.length === 1 ? i.additionalProperties = e[0] : e.length > 1 && (i.additionalProperties = { allOf: e });
	}
	return i;
}
function Np(e) {
	let t = e.allOf;
	if (!Array.isArray(t) || t.length < 2) return;
	for (let t of Ip) if (t in e) return;
	let n = t.filter((e) => Lp.some((t) => Array.isArray(e[t]))), r = null;
	if (!n.length) r = Mp(t);
	else {
		let e = n[0], i = Lp.find((t) => Array.isArray(e[t]));
		if (Object.keys(e).length !== 1) return;
		let a = t.filter((t) => t !== e), o = e[i].map((e) => Mp([...a, e]));
		if (o.some((e) => !e)) return;
		r = { [i]: o };
	}
	r && (delete e.allOf, wp(e, r));
}
function Pp(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	let r = (t) => {
		let n = e.seen.get(t);
		if (n.ref === null) return;
		let i = n.def ?? n.schema, a = { ...i }, o = n.ref;
		if (n.ref = null, o) {
			r(o);
			let n = e.seen.get(o), s = n.schema;
			if (s.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (i.allOf = i.allOf ?? [], i.allOf.push(s)) : wp(i, s), wp(i, a), t._zod.parent === o) for (let e in i) e !== "$ref" && e !== "allOf" && (e in a || delete i[e]);
			if (s.$ref && n.def) for (let e in i) e !== "$ref" && e !== "allOf" && e in n.def && JSON.stringify(i[e]) === JSON.stringify(n.def[e]) && delete i[e];
		}
		let s = t._zod.parent;
		if (s && s !== o) {
			r(s);
			let t = e.seen.get(s);
			if (t?.schema.$ref && (i.$ref = t.schema.$ref, t.def)) for (let e in i) e !== "$ref" && e !== "allOf" && e in t.def && JSON.stringify(i[e]) === JSON.stringify(t.def[e]) && delete i[e];
		}
		e.override({
			zodSchema: t,
			jsonSchema: i,
			path: n.path ?? []
		});
	};
	if (!e.external || e.sharedEmitDoneFor !== e.external) {
		for (let t of [...e.seen.entries()].reverse()) r(t[0]);
		if (e.target !== "openapi-3.0") for (let t of e.seen.entries()) Ap(t[1].def ?? t[1].schema);
		for (let t of e.deferred) t();
		if (e.intersections.length) {
			let t = /* @__PURE__ */ new Map();
			for (let n of e.seen.values()) for (let e of [n.schema, n.def]) {
				let n = e?.allOf;
				if (!Array.isArray(n)) continue;
				let r = t.get(n);
				r ? r.push(e) : t.set(n, [e]);
			}
			for (let n of e.intersections) for (let e of t.get(n) ?? []) Np(e);
		}
	}
	let i = {};
	if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, e.external?.uri) {
		let n = e.external.registry.get(t)?.id;
		if (!n) throw Error("Schema is missing an `id` property");
		i.$id = e.external.uri(n);
	}
	wp(i, n.defId ? n.schema : n.def ?? n.schema);
	let a = e.metadataRegistry.get(t)?.id;
	a !== void 0 && i.id === a && delete i.id;
	let o = e.external?.defs ?? {};
	if (!e.external || e.sharedEmitDoneFor !== e.external) for (let t of e.seen.entries()) {
		let e = t[1];
		e.def && e.defId && (e.def.id === e.defId && delete e.def.id, Vs(o, e.defId, e.def));
	}
	e.external && (e.sharedEmitDoneFor = e.external), e.external || Object.keys(o).length > 0 && (e.target === "draft-2020-12" ? i.$defs = o : i.definitions = o);
	try {
		let n = JSON.parse(JSON.stringify(i));
		return Object.defineProperty(n, "~standard", {
			value: {
				...t["~standard"],
				jsonSchema: {
					input: zp(t, "input", e.processors),
					output: zp(t, "output", e.processors)
				}
			},
			enumerable: !1,
			writable: !1
		}), n;
	} catch {
		throw Error("Error converting schema to JSON.");
	}
}
function Fp(e, t) {
	let n = t ?? { seen: /* @__PURE__ */ new Set() };
	if (n.seen.has(e)) return !1;
	n.seen.add(e);
	let r = e._zod.def;
	if (r.type === "transform") return !0;
	if (r.type === "array") return Fp(r.element, n);
	if (r.type === "set") return Fp(r.valueType, n);
	if (r.type === "lazy") return Fp(r.getter(), n);
	if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault" || r.type === "catch") return Fp(r.innerType, n);
	if (r.type === "intersection") return Fp(r.left, n) || Fp(r.right, n);
	if (r.type === "record" || r.type === "map") return Fp(r.keyType, n) || Fp(r.valueType, n);
	if (r.type === "pipe") return e._zod.traits.has("$ZodCodec") ? !0 : Fp(r.in, n) || Fp(r.out, n);
	if (r.type === "object") {
		for (let e in r.shape) if (Fp(r.shape[e], n)) return !0;
		return !1;
	}
	if (r.type === "union") {
		for (let e of r.options) if (Fp(e, n)) return !0;
		return !1;
	}
	if (r.type === "tuple") {
		for (let e of r.items) if (Fp(e, n)) return !0;
		return !!(r.rest && Fp(r.rest, n));
	}
	return !1;
}
var Ip, Lp, Rp, zp, Bp = B((() => {
	Tf(), Uc(), Ip = /* @__PURE__ */ new Set([
		"type",
		"properties",
		"required",
		"additionalProperties"
	]), Lp = ["oneOf", "anyOf"], Rp = (e, t = {}) => (n) => {
		let r = Tp({
			...n,
			processors: t
		});
		return Dp(e, r), kp(r, e), Pp(r, e);
	}, zp = (e, t, n = {}) => (r) => {
		let { libraryOptions: i, target: a } = r ?? {}, o = Tp({
			...i ?? {},
			target: a,
			io: t,
			processors: n
		});
		return Dp(e, o), kp(o, e), Pp(o, e);
	};
}));
// ../../../node_modules/zod/v4/core/json-schema-processors.js
function Vp(e) {
	let t = {}, n = e._zod.def, r = e._zod.traits.has("$ZodCheck") ? [e, ...n.checks ?? []] : n.checks ?? [];
	for (let e of r) em[e._zod.def.check]?.(t, e._zod.def);
	let i = e._zod.bag;
	i.minimum !== void 0 && Wp(t, "minimum", i.minimum), i.exclusiveMinimum !== void 0 && Wp(t, "exclusiveMinimum", i.exclusiveMinimum), i.maximum !== void 0 && Gp(t, "maximum", i.maximum), i.exclusiveMaximum !== void 0 && Gp(t, "exclusiveMaximum", i.exclusiveMaximum), i.multipleOf !== void 0 && qp(t, i.multipleOf), i.format !== void 0 && (t.format ??= i.format, i.format.includes("int") && (t.isInt = !0)), i.mime && Yp(t, i.mime);
	for (let e of i.patterns ?? []) Jp(t, e);
	return t;
}
function Hp(e) {
	let t = e._zod.def;
	return t.type === "pipe" && t.in._zod.traits.has("$ZodTransform") ? Hp(t.out) : t.type === "catch" ? Hp(t.innerType) : e._zod.optin;
}
function Up(e, t, n, r, i) {
	let a = !1, o = JSON.stringify(e, (e, t) => typeof t == "bigint" ? (a = !0, null) : t);
	return a ? (Ep(t, n, r, i, "BigInt defaults cannot be represented in JSON Schema"), vm) : JSON.parse(o);
}
var Wp, Gp, Kp, qp, Jp, Yp, Xp, Zp, Qp, $p, em, tm, nm, rm, im, am, om, sm, cm, lm, um, dm, fm, pm, mm, hm, gm, _m, vm, ym, bm, xm, Sm, Cm, wm, Tm = B((() => {
	su(), Qd(), Bp(), Uc(), Wp = (e, t, n) => {
		(e[t] === void 0 || n > e[t]) && (e[t] = n);
	}, Gp = (e, t, n) => {
		(e[t] === void 0 || n < e[t]) && (e[t] = n);
	}, Kp = (e, t) => {
		Wp(e, "minimum", t), Gp(e, "maximum", t);
	}, qp = (e, t) => {
		e.multipleOf ??= [], e.multipleOf.includes(t) || e.multipleOf.push(t);
	}, Jp = (e, t) => {
		e.patterns ??= /* @__PURE__ */ new Set(), e.patterns.add(t);
	}, Yp = (e, t) => {
		e.mime = e.mime ? e.mime.filter((e) => t.includes(e)) : [...t];
	}, Xp = (e, t) => {
		e.format = t, t.includes("int") && (e.isInt = !0);
	}, Zp = (e, t) => Wp(e, "minimum", t.minimum), Qp = (e, t) => Gp(e, "maximum", t.maximum), $p = (e) => (t, n) => {
		Xp(t, n.format);
		let [r, i] = e[n.format];
		Wp(t, "minimum", r), Gp(t, "maximum", i);
	}, em = {
		greater_than: (e, t) => Wp(e, t.inclusive ? "minimum" : "exclusiveMinimum", t.value),
		less_than: (e, t) => Gp(e, t.inclusive ? "maximum" : "exclusiveMaximum", t.value),
		multiple_of: (e, t) => qp(e, t.value),
		number_format: $p(Ic),
		bigint_format: $p(Lc),
		min_length: Zp,
		max_length: Qp,
		length_equals: (e, t) => Kp(e, t.length),
		min_size: Zp,
		max_size: Qp,
		size_equals: (e, t) => Kp(e, t.size),
		string_format: (e, t) => {
			Xp(e, t.format), t.pattern && Jp(e, t.pattern), (t.format === "base64" || t.format === "base64url") && (e.contentEncoding = t.format), (t.local || t.precision === -1) && (e.laxFormat = !0);
		},
		mime_type: (e, t) => Yp(e, t.mime)
	}, tm = {
		guid: "uuid",
		url: "uri",
		datetime: "date-time",
		json_string: "json-string",
		regex: ""
	}, nm = /* @__PURE__ */ new Map([[Cd, Zl], [Td, Ql]]), rm = (e) => nm.get(e) ?? e, im = (e, t, n, r) => {
		let i = n;
		i.type = "string";
		let { minimum: a, maximum: o, format: s, patterns: c, contentEncoding: l, laxFormat: u } = Vp(e);
		if (typeof a == "number" && (i.minLength = a), typeof o == "number" && (i.maxLength = o), s && (i.format = tm[s] ?? s, i.format === "" && delete i.format, (s === "time" || u) && delete i.format), l && (i.contentEncoding = l), c && c.size > 0) {
			let e = [...c].map(rm);
			e.length === 1 ? i.pattern = e[0].source : e.length > 1 && (i.allOf = [...e.map((e) => ({
				...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
				pattern: e.source
			}))]);
		}
	}, am = (e, t, n, r) => {
		n.type = "boolean";
	}, om = (e, t, n, r) => {
		n.not = {};
	}, sm = (e, t, n, r) => {}, cm = (e, t, n, r) => {
		let i = e._zod.def, a = Fs(i.entries);
		a.length === 0 ? n.not = {} : (a.every((e) => typeof e == "number") && (n.type = "number"), a.every((e) => typeof e == "string") && (n.type = "string"), n.enum = a);
	}, lm = (e, t, n, r) => {
		let i = e._zod.def;
		if (i.values.length === 0) {
			n.not = {};
			return;
		}
		let a = [];
		for (let o of i.values) if (o === void 0) {
			if (Ep(e, t, n, r, "Literal `undefined` cannot be represented in JSON Schema")) return;
		} else if (typeof o == "bigint") {
			if (Ep(e, t, n, r, "BigInt literals cannot be represented in JSON Schema")) return;
			a.push(Number(o));
		} else a.push(o);
		if (a.length !== 0) {
			if (a.length === 1) {
				let e = a[0];
				n.type = e === null ? "null" : typeof e, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [e] : n.const = e;
			} else a.every((e) => typeof e == "number") && (n.type = "number"), a.every((e) => typeof e == "string") && (n.type = "string"), a.every((e) => typeof e == "boolean") && (n.type = "boolean"), a.every((e) => e === null) && (n.type = "null"), n.enum = a;
		}
	}, um = (e, t, n, r) => {
		Ep(e, t, n, r, "Custom types cannot be represented in JSON Schema");
	}, dm = (e, t, n, r) => {
		Ep(e, t, n, r, "Transforms cannot be represented in JSON Schema");
	}, fm = (e, t, n, r) => {
		let i = n, a = e._zod.def, { minimum: o, maximum: s } = Vp(e);
		typeof o == "number" && (i.minItems = o), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = Dp(a.element, t, {
			...r,
			path: [...r.path, "items"]
		});
	}, pm = (e, t, n, r) => {
		let i = n, a = e._zod.def, o = a.shape;
		if (Object.getOwnPropertySymbols(o).length && Ep(e, t, i, r, "Symbol keys cannot be represented in JSON Schema")) return;
		i.type = "object", i.properties = {};
		for (let e in o) Vs(i.properties, e, Dp(o[e], t, {
			...r,
			path: [
				...r.path,
				"properties",
				e
			]
		}));
		let s = [];
		for (let e of Object.keys(o)) {
			let n = a.shape[e];
			(t.io === "input" ? Hp(n) === void 0 : n._zod.optout === void 0) && s.push(e);
		}
		s.length > 0 && (i.required = s), a.catchall?._zod.def.type === "never" ? i.additionalProperties = !1 : a.catchall ? a.catchall && (i.additionalProperties = Dp(a.catchall, t, {
			...r,
			path: [...r.path, "additionalProperties"]
		})) : t.io === "output" && (i.additionalProperties = !1);
	}, mm = (e, t, n, r) => {
		let i = e._zod.def, a = i.inclusive === !1, o = i.options.map((e, n) => Dp(e, t, {
			...r,
			path: [
				...r.path,
				a ? "oneOf" : "anyOf",
				n
			]
		}));
		a ? n.oneOf = o : n.anyOf = o;
	}, hm = (e, t, n, r) => {
		let i = e._zod.def, a = Dp(i.left, t, {
			...r,
			path: [
				...r.path,
				"allOf",
				0
			]
		}), o = Dp(i.right, t, {
			...r,
			path: [
				...r.path,
				"allOf",
				1
			]
		}), s = (e) => "allOf" in e && Object.keys(e).length === 1, c = [...s(a) ? a.allOf : [a], ...s(o) ? o.allOf : [o]];
		n.allOf = c, t.intersections.push(c);
	}, gm = (e, t, n, r) => {
		let i = e._zod.def, a = Dp(i.innerType, t, r), o = t.seen.get(e);
		t.target === "openapi-3.0" ? (o.ref = i.innerType, n.nullable = !0) : n.anyOf = [a, { type: "null" }];
	}, _m = (e, t, n, r) => {
		let i = e._zod.def;
		Dp(i.innerType, t, r);
		let a = t.seen.get(e);
		a.ref = i.innerType;
	}, vm = Symbol(), ym = (e, t, n, r) => {
		let i = e._zod.def;
		Dp(i.innerType, t, r);
		let a = t.seen.get(e);
		a.ref = i.innerType;
		let o = Up(i.defaultValue, e, t, n, r);
		o !== vm && (n.default = o);
	}, bm = (e, t, n, r) => {
		let i = e._zod.def;
		Dp(i.innerType, t, r);
		let a = t.seen.get(e);
		if (a.ref = i.innerType, t.io !== "input") return;
		let o = Up(i.defaultValue, e, t, n, r);
		o !== vm && (n._prefault = o);
	}, xm = (e, t, n, r) => {
		let i = e._zod.def;
		Dp(i.innerType, t, r);
		let a = t.seen.get(e);
		a.ref = i.innerType;
		let o;
		try {
			o = i.catchValue(void 0);
		} catch {
			Ep(e, t, n, r, "Dynamic catch values are not supported in JSON Schema");
			return;
		}
		n.default = o;
	}, Sm = (e, t, n, r) => {
		let i = e._zod.def, a = i.in._zod.traits.has("$ZodTransform"), o = t.io === "input" ? a ? i.out : i.in : i.out;
		Dp(o, t, r);
		let s = t.seen.get(e);
		s.ref = o;
	}, Cm = (e, t, n, r) => {
		let i = e._zod.def;
		Dp(i.innerType, t, r);
		let a = t.seen.get(e);
		a.ref = i.innerType, n.readOnly = !0;
	}, wm = (e, t, n, r) => {
		let i = e._zod.def;
		Dp(i.innerType, t, r);
		let a = t.seen.get(e);
		a.ref = i.innerType;
	};
})), Em = B((() => {
	Qc(), kl(), ll(), Qd(), _f(), xu(), Tu(), Uc(), su(), bf(), Tf(), Cu(), Ef(), Cp(), Bp(), Tm(), Bp();
})), Dm = B((() => {
	Em();
}));
// ../../../node_modules/zod/v4/classic/errors.js
function Om(e, t, n) {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		get() {
			let e = n(this);
			return Object.defineProperty(this, t, {
				value: e,
				configurable: !0,
				writable: !0
			}), e;
		},
		set(e) {
			Object.defineProperty(this, t, {
				value: e,
				configurable: !0,
				writable: !0
			});
		}
	});
}
var km, Am, jm, Mm = B((() => {
	Em(), Uc(), km = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]), Am = (e, t) => {
		cl.init(e, t), e.name = "ZodError";
		let n = Object.getPrototypeOf(e);
		km.has(n) || (km.add(n), Om(n, "format", (e) => (t) => rl(e, t)), Om(n, "flatten", (e) => (t) => nl(e, t)), Om(n, "addIssue", (e) => (t) => {
			e.issues.push(t), e.message = JSON.stringify(e.issues, Ls, 2);
		}), Om(n, "addIssues", (e) => (t) => {
			e.issues.push(...t), e.message = JSON.stringify(e.issues, Ls, 2);
		}), Object.defineProperty(n, "isEmpty", {
			configurable: !0,
			enumerable: !1,
			get() {
				return this.issues.length === 0;
			}
		}));
	}, jm = /*@__PURE__*/ K("ZodError", Am, void 0, { Parent: Error });
})), Nm, Pm, Fm, Im, Lm, Rm, zm, Bm, Vm, Hm, Um, Wm, Gm = B((() => {
	Em(), Mm(), Nm = /* @__PURE__ */ pl(jm), Pm = /* @__PURE__ */ ml(jm), Fm = /* @__PURE__ */ hl(jm), Im = /* @__PURE__ */ gl(jm), Lm = /* @__PURE__ */ xl(jm), Rm = /* @__PURE__ */ Sl(jm), zm = /* @__PURE__ */ Cl(jm), Bm = /* @__PURE__ */ wl(jm), Vm = /* @__PURE__ */ Tl(jm), Hm = /* @__PURE__ */ El(jm), Um = /* @__PURE__ */ Dl(jm), Wm = /* @__PURE__ */ Ol(jm);
}));
// ../../../node_modules/zod/v4/classic/schemas.js
function Km() {
	Zc.localeError || Gc(vf());
}
function qm() {
	Zc.memoizer || Gc({ memoizer: af() });
}
function Y(e) {
	return /* @__PURE__ */ Of(vh, e);
}
function Jm(e) {
	return /* @__PURE__ */ Af(wh, e);
}
function Ym(e) {
	return /* @__PURE__ */ Ff(Eh, e);
}
function Xm(e) {
	return /* @__PURE__ */ tp(Hh, e);
}
function Zm() {
	return /* @__PURE__ */ np(Uh);
}
function Qm(e) {
	return /* @__PURE__ */ rp(Wh, e);
}
function $m(e, t) {
	return /* @__PURE__ */ yp(Gh, e, t);
}
function eh(e, t) {
	let n = {
		type: "object",
		shape: e ?? {},
		...W(t)
	};
	return new Kh(n);
}
function th(e, t) {
	return new qh({
		type: "union",
		options: e,
		...W(t)
	});
}
function nh(e, t) {
	return new Jh({
		type: "intersection",
		left: e,
		right: t
	});
}
function rh(e, t) {
	let n = Array.isArray(e) ? Object.fromEntries(e.map((e) => [e, e])) : e;
	return new Yh({
		type: "enum",
		entries: n,
		...W(t)
	});
}
function ih(e, t) {
	return new Xh({
		type: "literal",
		values: Array.isArray(e) ? e : [e],
		...W(t)
	});
}
function ah(e) {
	return new Zh({
		type: "transform",
		transform: e
	});
}
function oh(e) {
	return new Qh({
		type: "optional",
		innerType: e
	});
}
function sh(e) {
	return new $h({
		type: "optional",
		innerType: e
	});
}
function ch(e) {
	return new eg({
		type: "nullable",
		innerType: e
	});
}
function lh(e, t) {
	return new tg({
		type: "default",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : $s(t);
		}
	});
}
function uh(e, t) {
	return new ng({
		type: "prefault",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : $s(t);
		}
	});
}
function dh(e, t) {
	return new rg({
		type: "nonoptional",
		innerType: e,
		...W(t)
	});
}
function fh(e, t) {
	return new ig({
		type: "catch",
		innerType: e,
		catchValue: typeof t == "function" ? t : jc(t)
	});
}
function ph(e, t) {
	return new ag({
		type: "pipe",
		in: e,
		out: t
	});
}
function mh(e) {
	return new og({
		type: "readonly",
		innerType: e
	});
}
function hh(e, t = {}) {
	return /* @__PURE__ */ bp(sg, e, t);
}
function gh(e, t) {
	return /* @__PURE__ */ xp(e, t);
}
var X, _h, vh, Z, yh, bh, xh, Sh, Ch, wh, Th, Eh, Dh, Oh, kh, Ah, jh, Mh, Nh, Ph, Fh, Ih, Lh, Rh, zh, Bh, Vh, Hh, Uh, Wh, Gh, Kh, qh, Jh, Yh, Xh, Zh, Qh, $h, eg, tg, ng, rg, ig, ag, og, sg, cg = B((() => {
	Em(), Tm(), Bp(), bf(), Dm(), Gm(), X = /*@__PURE__*/ K("ZodType", (e, t) => (Km(), q.init(e, t), e.def = t, e.type = t.type, e), {
		check(...e) {
			let t = this.def;
			return this.clone(Js(t, { checks: [...t.checks ?? [], ...e.map((e) => typeof e == "function" ? { _zod: {
				check: e,
				def: { check: "custom" },
				onattach: []
			} } : e)] }), { parent: !0 });
		},
		with(...e) {
			return this.check(...e);
		},
		clone(e, t) {
			return tc(this, e, t);
		},
		brand() {
			return this;
		},
		register(e, t) {
			return e.add(this, t), this;
		},
		refine(e, t) {
			return this.check(hh(e, t));
		},
		superRefine(e, t) {
			return this.check(gh(e, t));
		},
		overwrite(e) {
			return this.check(/* @__PURE__ */ pp(e));
		},
		optional() {
			return oh(this);
		},
		exactOptional() {
			return sh(this);
		},
		nullable() {
			return ch(this);
		},
		nullish() {
			return oh(ch(this));
		},
		nonoptional(e) {
			return dh(this, e);
		},
		array() {
			return $m(this);
		},
		or(e) {
			return th([this, e]);
		},
		and(e) {
			return nh(this, e);
		},
		transform(e) {
			return ph(this, ah(e));
		},
		default(e) {
			return lh(this, e);
		},
		prefault(e) {
			return uh(this, e);
		},
		catch(e) {
			return fh(this, e);
		},
		pipe(e) {
			return ph(this, e);
		},
		readonly() {
			return mh(this);
		},
		describe(e) {
			let t = this.clone();
			return wf.add(t, { description: e }), t;
		},
		meta(...e) {
			if (e.length === 0) return wf.get(this);
			let t = this.clone();
			return wf.add(t, e[0]), t;
		},
		isOptional() {
			return this.safeParse(void 0).success;
		},
		isNullable() {
			return this.safeParse(null).success;
		},
		apply(e, ...t) {
			return t.length === 0 ? e(this) : e(this, ...t);
		},
		get "~standard"() {
			return Ec(this, "~standard", {
				...Du(this),
				jsonSchema: {
					input: zp(this, "input"),
					output: zp(this, "output")
				}
			});
		},
		set "~standard"(e) {
			Tc(this, "~standard", e);
		},
		parse: function e(t, n) {
			return Nm(this, t, n, { callee: e });
		},
		parseAsync: async function e(t, n) {
			return await Pm(this, t, n, { callee: e });
		},
		safeParse(e, t) {
			return Fm(this, e, t);
		},
		async safeParseAsync(e, t) {
			return Im(this, e, t);
		},
		get spa() {
			return this?.safeParseAsync;
		},
		set spa(e) {
			Tc(this, "spa", e);
		},
		validate(e, t) {
			return yl(this, e, t);
		},
		validateAsync(e, t) {
			return bl(this, e, t);
		},
		encode: function e(t, n) {
			return Lm(this, t, n, { callee: e });
		},
		decode: function e(t, n) {
			return Rm(this, t, n, { callee: e });
		},
		encodeAsync: async function e(t, n) {
			return await zm(this, t, n, { callee: e });
		},
		decodeAsync: async function e(t, n) {
			return await Bm(this, t, n, { callee: e });
		},
		safeEncode(e, t) {
			return Vm(this, e, t);
		},
		safeDecode(e, t) {
			return Hm(this, e, t);
		},
		async safeEncodeAsync(e, t) {
			return Um(this, e, t);
		},
		async safeDecodeAsync(e, t) {
			return Wm(this, e, t);
		},
		toJSONSchema(e) {
			return Rp(this, {})(e);
		},
		get description() {
			return wf.get(this)?.description;
		},
		get _def() {
			return this._zod.def;
		}
	}), _h = /*@__PURE__*/ K("_ZodString", (e, t) => {
		td.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => im(e, t, n, r);
	}, /*@__PURE__*/ Dc({
		format: (e) => Vp(e).format ?? null,
		minLength: (e) => Vp(e).minimum ?? null,
		maxLength: (e) => Vp(e).maximum ?? null
	}, {
		regex(...e) {
			return this.check(/* @__PURE__ */ sp(...e));
		},
		includes(...e) {
			return this.check(/* @__PURE__ */ up(...e));
		},
		startsWith(...e) {
			return this.check(/* @__PURE__ */ dp(...e));
		},
		endsWith(...e) {
			return this.check(/* @__PURE__ */ fp(...e));
		},
		min(...e) {
			return this.check(/* @__PURE__ */ ap(...e));
		},
		max(...e) {
			return this.check(/* @__PURE__ */ ip(...e));
		},
		length(...e) {
			return this.check(/* @__PURE__ */ op(...e));
		},
		nonempty(...e) {
			return this.check(/* @__PURE__ */ ap(1, ...e));
		},
		lowercase(e) {
			return this.check(/* @__PURE__ */ cp(e));
		},
		uppercase(e) {
			return this.check(/* @__PURE__ */ lp(e));
		},
		trim() {
			return this.check(/* @__PURE__ */ hp());
		},
		normalize(...e) {
			return this.check(/* @__PURE__ */ mp(...e));
		},
		toLowerCase() {
			return this.check(/* @__PURE__ */ gp());
		},
		toUpperCase() {
			return this.check(/* @__PURE__ */ _p());
		},
		slugify() {
			return this.check(/* @__PURE__ */ vp());
		}
	})), vh = /*@__PURE__*/ K("ZodString", (e, t) => {
		td.init(e, t), _h.init(e, t);
	}, {
		email(e) {
			return this.check(/* @__PURE__ */ kf(Ch, e));
		},
		url(e) {
			return this.check(/* @__PURE__ */ Ff(Eh, e));
		},
		jwt(e) {
			return this.check(/* @__PURE__ */ Xf(Vh, e));
		},
		emoji(e) {
			return this.check(/* @__PURE__ */ If(Dh, e));
		},
		guid(e) {
			return this.check(/* @__PURE__ */ Af(wh, e));
		},
		uuid(e) {
			return this.check(/* @__PURE__ */ jf(Th, e));
		},
		uuidv4(e) {
			return this.check(/* @__PURE__ */ Mf(Th, e));
		},
		uuidv6(e) {
			return this.check(/* @__PURE__ */ Nf(Th, e));
		},
		uuidv7(e) {
			return this.check(/* @__PURE__ */ Pf(Th, e));
		},
		nanoid(e) {
			return this.check(/* @__PURE__ */ Lf(Oh, e));
		},
		cuid(e) {
			return this.check(/* @__PURE__ */ Rf(kh, e));
		},
		cuid2(e) {
			return this.check(/* @__PURE__ */ zf(Ah, e));
		},
		ulid(e) {
			return this.check(/* @__PURE__ */ Bf(jh, e));
		},
		base64(e) {
			return this.check(/* @__PURE__ */ qf(Rh, e));
		},
		base64url(e) {
			return this.check(/* @__PURE__ */ Jf(zh, e));
		},
		xid(e) {
			return this.check(/* @__PURE__ */ Vf(Mh, e));
		},
		ksuid(e) {
			return this.check(/* @__PURE__ */ Hf(Nh, e));
		},
		ipv4(e) {
			return this.check(/* @__PURE__ */ Uf(Ph, e));
		},
		ipv6(e) {
			return this.check(/* @__PURE__ */ Wf(Fh, e));
		},
		cidrv4(e) {
			return this.check(/* @__PURE__ */ Gf(Ih, e));
		},
		cidrv6(e) {
			return this.check(/* @__PURE__ */ Kf(Lh, e));
		},
		e164(e) {
			return this.check(/* @__PURE__ */ Yf(Bh, e));
		},
		datetime(e) {
			return this.check(/* @__PURE__ */ Zf(yh, e));
		},
		date(e) {
			return this.check(/* @__PURE__ */ Qf(bh, e));
		},
		time(e) {
			return this.check(/* @__PURE__ */ $f(xh, e));
		},
		duration(e) {
			return this.check(/* @__PURE__ */ ep(Sh, e));
		}
	}), Z = /*@__PURE__*/ K("ZodStringFormat", (e, t) => {
		J.init(e, t), _h.init(e, t);
	}), yh = /*@__PURE__*/ K("ZodISODateTime", (e, t) => {
		md.init(e, t), Z.init(e, t);
	}), bh = /*@__PURE__*/ K("ZodISODate", (e, t) => {
		hd.init(e, t), Z.init(e, t);
	}), xh = /*@__PURE__*/ K("ZodISOTime", (e, t) => {
		gd.init(e, t), Z.init(e, t);
	}), Sh = /*@__PURE__*/ K("ZodISODuration", (e, t) => {
		_d.init(e, t), Z.init(e, t);
	}), Ch = /*@__PURE__*/ K("ZodEmail", (e, t) => {
		id.init(e, t), Z.init(e, t);
	}), wh = /*@__PURE__*/ K("ZodGUID", (e, t) => {
		nd.init(e, t), Z.init(e, t);
	}), Th = /*@__PURE__*/ K("ZodUUID", (e, t) => {
		rd.init(e, t), Z.init(e, t);
	}), Eh = /*@__PURE__*/ K("ZodURL", (e, t) => {
		od.init(e, t), Z.init(e, t);
	}), Dh = /*@__PURE__*/ K("ZodEmoji", (e, t) => {
		sd.init(e, t), Z.init(e, t);
	}), Oh = /*@__PURE__*/ K("ZodNanoID", (e, t) => {
		cd.init(e, t), Z.init(e, t);
	}), kh = /*@__PURE__*/ K("ZodCUID", (e, t) => {
		ld.init(e, t), Z.init(e, t);
	}), Ah = /*@__PURE__*/ K("ZodCUID2", (e, t) => {
		ud.init(e, t), Z.init(e, t);
	}), jh = /*@__PURE__*/ K("ZodULID", (e, t) => {
		dd.init(e, t), Z.init(e, t);
	}), Mh = /*@__PURE__*/ K("ZodXID", (e, t) => {
		fd.init(e, t), Z.init(e, t);
	}), Nh = /*@__PURE__*/ K("ZodKSUID", (e, t) => {
		pd.init(e, t), Z.init(e, t);
	}), Ph = /*@__PURE__*/ K("ZodIPv4", (e, t) => {
		vd.init(e, t), Z.init(e, t);
	}), Fh = /*@__PURE__*/ K("ZodIPv6", (e, t) => {
		bd.init(e, t), Z.init(e, t);
	}), Ih = /*@__PURE__*/ K("ZodCIDRv4", (e, t) => {
		xd.init(e, t), Z.init(e, t);
	}), Lh = /*@__PURE__*/ K("ZodCIDRv6", (e, t) => {
		Sd.init(e, t), Z.init(e, t);
	}), Rh = /*@__PURE__*/ K("ZodBase64", (e, t) => {
		wd.init(e, t), Z.init(e, t);
	}), zh = /*@__PURE__*/ K("ZodBase64URL", (e, t) => {
		Ed.init(e, t), Z.init(e, t);
	}), Bh = /*@__PURE__*/ K("ZodE164", (e, t) => {
		Dd.init(e, t), Z.init(e, t);
	}), Vh = /*@__PURE__*/ K("ZodJWT", (e, t) => {
		Od.init(e, t), Z.init(e, t);
	}), Hh = /*@__PURE__*/ K("ZodBoolean", (e, t) => {
		kd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => am(e, t, n, r);
	}), Uh = /*@__PURE__*/ K("ZodUnknown", (e, t) => {
		Ad.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => sm(e, t, n, r);
	}), Wh = /*@__PURE__*/ K("ZodNever", (e, t) => {
		jd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => om(e, t, n, r);
	}), Gh = /*@__PURE__*/ K("ZodArray", (e, t) => {
		qm(), Nd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => fm(e, t, n, r), e.element = t.element;
	}, {
		min(e, t) {
			return this.check(/* @__PURE__ */ ap(e, t));
		},
		nonempty(e) {
			return this.check(/* @__PURE__ */ ap(1, e));
		},
		max(e, t) {
			return this.check(/* @__PURE__ */ ip(e, t));
		},
		length(e, t) {
			return this.check(/* @__PURE__ */ op(e, t));
		},
		unwrap() {
			return this.element;
		}
	}), Kh = /*@__PURE__*/ K("ZodObject", (e, t) => {
		qm(), Id.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => pm(e, t, n, r), Ac(e, "shape", (e) => e._zod.def.shape, !1);
	}, {
		keyof() {
			return rh(Object.keys(this._zod.def.shape));
		},
		catchall(e) {
			return this.clone(Js(this._zod.def, { catchall: e }));
		},
		passthrough() {
			return this.clone(Js(this._zod.def, { catchall: Zm() }));
		},
		loose() {
			return this.clone(Js(this._zod.def, { catchall: Zm() }));
		},
		strict() {
			return this.clone(Js(this._zod.def, { catchall: Qm() }));
		},
		strip() {
			return this.clone(Js(this._zod.def, { catchall: void 0 }));
		},
		extend(e) {
			return sc(this, e);
		},
		safeExtend(e) {
			return lc(this, e);
		},
		merge(e) {
			return uc(this, e);
		},
		pick(e) {
			return ic(this, e);
		},
		omit(e) {
			return oc(this, e);
		},
		partial(...e) {
			return dc(Qh, this, e[0]);
		},
		exactPartial(...e) {
			return dc($h, this, e[0], "exactPartial");
		},
		required(...e) {
			return fc(rg, this, e[0]);
		}
	}), qh = /*@__PURE__*/ K("ZodUnion", (e, t) => {
		Ld.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => mm(e, t, n, r), e.options = t.options;
	}), Jh = /*@__PURE__*/ K("ZodIntersection", (e, t) => {
		Rd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => hm(e, t, n, r);
	}), Yh = /*@__PURE__*/ K("ZodEnum", (e, t) => {
		zd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => cm(e, t, n, r), e.enum = t.entries, e.options = [...e._zod.values];
		let n = new Set(Object.keys(t.entries));
		e.extract = (e, r) => {
			let i = {};
			for (let r of e) if (n.has(r)) i[r] = t.entries[r];
			else throw Error(`Key ${r} not found in enum`);
			return new Yh({
				...t,
				checks: [],
				...W(r),
				entries: i
			});
		}, e.exclude = (e, r) => {
			let i = { ...t.entries };
			for (let t of e) if (n.has(t)) delete i[t];
			else throw Error(`Key ${t} not found in enum`);
			return new Yh({
				...t,
				checks: [],
				...W(r),
				entries: i
			});
		};
	}), Xh = /*@__PURE__*/ K("ZodLiteral", (e, t) => {
		Bd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => lm(e, t, n, r), e.values = new Set(t.values), Object.defineProperty(e, "value", { get() {
			if (t.values.length > 1) throw Error("This schema contains multiple valid literal values. Use `.values` instead.");
			return t.values[0];
		} });
	}), Zh = /*@__PURE__*/ K("ZodTransform", (e, t) => {
		qm(), Vd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => dm(e, t, n, r), e._zod.parse = (n, r) => {
			if (r.direction === "backward") throw new Xc(e.constructor.name);
			n.addIssue = (r) => {
				if (typeof r == "string") n.issues.push(Cc(r, n.value, t));
				else {
					let t = r;
					t.fatal && (t.continue = !1), t.code ??= "custom", "input" in t || (t.input = n.value), t.inst ??= e, n.issues.push(Cc(t));
				}
			};
			let i = t.transform(n.value, n);
			return i instanceof Promise ? i.then((e) => (n.value = e, n)) : (n.value = i, n);
		};
	}), Qh = /*@__PURE__*/ K("ZodOptional", (e, t) => {
		Hd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => wm(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
	}), $h = /*@__PURE__*/ K("ZodExactOptional", (e, t) => {
		Ud.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => wm(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
	}), eg = /*@__PURE__*/ K("ZodNullable", (e, t) => {
		Wd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => gm(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
	}), tg = /*@__PURE__*/ K("ZodDefault", (e, t) => {
		Gd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => ym(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
	}), ng = /*@__PURE__*/ K("ZodPrefault", (e, t) => {
		Kd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => bm(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
	}), rg = /*@__PURE__*/ K("ZodNonOptional", (e, t) => {
		qd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => _m(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
	}), ig = /*@__PURE__*/ K("ZodCatch", (e, t) => {
		Jd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => xm(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
	}), ag = /*@__PURE__*/ K("ZodPipe", (e, t) => {
		Yd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => Sm(e, t, n, r), e.in = t.in, e.out = t.out;
	}), og = /*@__PURE__*/ K("ZodReadonly", (e, t) => {
		Xd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => Cm(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
	}), sg = /*@__PURE__*/ K("ZodCustom", (e, t) => {
		Zd.init(e, t), X.init(e, t), e._zod.processJSONSchema = (t, n, r) => um(e, t, n, r);
	});
})), lg = B((() => {
	Em();
})), ug = B((() => {
	Em(), cg(), Dm(), Mm(), Gm(), lg(), Tm(), Tf(), Uc(), Dm(), cg(), Qd(), bf();
})), dg = B((() => {
	ug(), ug();
})), fg, pg, mg = B((() => {
	dg(), fg = /^[a-z0-9]+(-[a-z0-9]+)*$/i, pg = eh({
		subdomain: Y().min(3, { error: "Subdomains must be at least 3 characters long" }).regex(fg, { error: "Only letters, numbers and hyphens are allowed" }),
		subdomainValidations: $m(Y()).max(0)
	});
}));
// src/components/subdomainInput.tsx
function hg({ control: e, subdomainPath: t, subdomainValidationsPath: n, subdomainAvailability: r }) {
	return /* @__PURE__ */ R(Ie, {
		control: e,
		name: t,
		render: ({ field: t }) => /* @__PURE__ */ R(Ie, {
			control: e,
			name: n,
			render: ({ field: e }) => /* @__PURE__ */ R(gg, {
				subdomainField: t,
				subdomainAvailability: r,
				onChangeField: e.onChange
			})
		})
	});
}
function gg({ subdomainField: e, subdomainAvailability: t, onChangeField: n }) {
	let { errors: r, loading: i, data: a } = t, o = i ? "Validating subdomain..." : void 0, s = !o && a && e.value?.length && !i && r && !r.length ? "Your domain is valid and available" : void 0, c = !o && !i && r.length ? r?.[0] : void 0;
	return P(() => {
		n(r);
	}, [r.toString()]), /* @__PURE__ */ R(w, {
		description: o,
		label: "Subdomain",
		meta: {
			error: c,
			success: s
		},
		required: !0,
		children: /* @__PURE__ */ R(ne, {
			ref: e.ref,
			value: e.value,
			onChange: e.onChange,
			prefix: {
				type: "custom",
				value: "https://"
			},
			placeholder: "beautiful-avocado",
			suffix: {
				type: "custom",
				value: ".dixa.help"
			},
			required: !0
		})
	});
}
var _g = B((() => {}));
// src/hooks/useHelpCenterCreateMutation.ts
function vg({ onCompleted: e, onError: t }) {
	let [n, r] = Lt({
		update: (e, t) => {
			let n = e.readQuery({
				query: Nn,
				variables: { languageId: t.data?.helpCenterCreate?.translation?.languageId }
			}), r = t.data?.helpCenterCreate;
			if (!n || !r) return;
			let i = {
				...n,
				helpCenters: {
					...n.helpCenters,
					results: [{
						__typename: "HelpCenter",
						id: r.id,
						hostname: r.hostname || "",
						isActive: r.isActive ?? !1,
						collection: r.collection,
						customHostname: r.customHostname,
						name: r.name
					}, ...n.helpCenters.results]
				}
			};
			e.writeQuery({
				query: Nn,
				data: i
			});
		},
		onCompleted: e,
		onError: t
	});
	function i({ collectionId: e, defaultLanguage: t, helpCenterName: r, subdomain: i }) {
		n({ variables: {
			subdomain: i,
			name: r,
			translations: [{
				languageId: t[0].id,
				title: r,
				tagline: "Help Center"
			}],
			collectionId: e,
			defaultLanguageId: t[0].id,
			isHelpCenterIndexable: !1
		} });
	}
	return [i, r];
}
var yg = B((() => {
	U();
})), bg, xg, Sg = B((() => {
	bg = "_noFieldLabel_m67db_1", xg = { noFieldLabel: bg };
}));
// src/modals/helpCenterAddModal.tsx
function Cg() {
	let { hideModal: e } = $r(), { errorNotify: t, successNotify: n } = Ns(), r = je(), { enabledLanguages: i } = Ce(Yr), { formState: { errors: a, isValid: o }, watch: s, control: c, handleSubmit: l } = Be({
		resolver: Xi(wg),
		defaultValues: {
			helpCenterName: "",
			collectionId: "",
			defaultLanguage: [],
			subdomain: "",
			isHelpCenterIndexable: !1
		},
		reValidateMode: "onChange",
		mode: "all"
	}), [u, d] = vg({
		onCompleted: (t) => {
			let i = t?.helpCenterCreate;
			i && (n({
				title: "Help Center created",
				text: `"${i.name}" has been created.`
			}), Ve.knowledgeHelpCenterCreated({ helpCenterId: i.id }), e(), r(Ii.helpCenterSettingsPath({ helpCenterId: i.id })));
		},
		onError: (e) => {
			throw t({
				title: "Unable to create Help Center",
				text: "Please try again. If this issue persists, please contact customer support."
			}), e;
		}
	}), f = js({
		subdomain: s("subdomain"),
		initialSubdomain: "",
		subdomainErrorMessage: a.subdomain?.message
	}), p = d.loading || f.loading, m = i.map((e) => ({
		id: e.languageId,
		name: e.description
	})) || [];
	return /* @__PURE__ */ R(ai, { children: /* @__PURE__ */ z("form", {
		onSubmit: l(u),
		children: [
			/* @__PURE__ */ R(ae, {
				title: "New Help Center",
				onClose: e
			}),
			/* @__PURE__ */ z(ie, { children: [
				/* @__PURE__ */ R(os, {
					control: c,
					label: "Name",
					name: "helpCenterName",
					required: !0
				}),
				/* @__PURE__ */ R(w, {
					noAlert: !0,
					noLabel: !0,
					required: !0,
					className: xg.noFieldLabel,
					children: /* @__PURE__ */ R(Ie, {
						control: c,
						name: "collectionId",
						render: ({ field: e }) => /* @__PURE__ */ R(Ds, {
							collectionId: e.value,
							setCollectionId: e.onChange,
							excludeInternalOnly: !0,
							required: !0
						})
					})
				}),
				/* @__PURE__ */ R(hg, {
					subdomainPath: "subdomain",
					subdomainValidationsPath: "subdomainValidations",
					control: c,
					subdomainAvailability: f
				}),
				/* @__PURE__ */ R(w, {
					noLabel: !0,
					required: !0,
					className: xg.noFieldLabel,
					children: /* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(ds, {
						control: c,
						name: "defaultLanguage",
						label: "Default language",
						itemsLoading: !1,
						placeholders: {
							loading: "Loading available languages...",
							empty: "Select default language"
						},
						equalityFn: (e, t) => e.id === t.id,
						listItems: m,
						multiple: !1,
						required: !0
					}) })
				})
			] }),
			/* @__PURE__ */ R(k, { children: /* @__PURE__ */ z(T, {
				justifyContent: "flex-end",
				gap: "100",
				children: [/* @__PURE__ */ R(h, {
					disabled: p,
					variant: "tertiary",
					onClick: e,
					children: "Cancel"
				}), /* @__PURE__ */ R(h, {
					disabled: p || !o,
					type: "submit",
					children: "Save"
				})]
			}) })
		]
	}) });
}
var wg, Tg = B((() => {
	Zi(), Cs(), Os(), Xr(), Ms(), Ps(), Li(), dg(), mg(), _g(), yg(), Sg(), wg = eh({
		helpCenterName: Y().min(1, { error: "A name must be provided" }),
		collectionId: Y().min(1, { error: "A collection must be provided" }),
		defaultLanguage: $m(eh({
			id: Y(),
			name: Y()
		})).min(1, { error: "A default language must be provided" }),
		isHelpCenterIndexable: Xm()
	}).extend(pg.shape);
}));
// src/hooks/useHelpCenterDelete.ts
function Eg({ helpCenterId: e, helpCenterTitle: t, onComplete: n }) {
	let [r, { loading: i }] = Vt({
		variables: {
			id: e,
			deregisterCustomHostname: !0
		},
		onCompleted: () => {
			a({
				title: "Deleted",
				text: `"${t}" Help Center was deleted`
			}), Ve.knowledgeHelpCenterDeleted({ helpCenterId: e }), n();
		},
		onError: () => {
			o({
				title: "Unable to delete",
				text: "There was an error while deleting. Please try again."
			});
		},
		update: (t, n) => {
			let r = t.readQuery({
				query: Nn,
				variables: { languageId: Qt.En }
			}), i = n.data?.helpCenterDelete;
			if (!r || !i) return;
			let a = {
				...r,
				helpCenters: {
					...r.helpCenters,
					results: [...r.helpCenters.results.filter((t) => t.id !== e)]
				}
			};
			t.writeQuery({
				query: Nn,
				data: a
			});
		}
	}), { successNotify: a, errorNotify: o } = Ns();
	return {
		deleteMutation: r,
		deleteLoading: i
	};
}
var Dg = B((() => {
	U(), Ps();
}));
// src/modals/helpCenterDeleteModal.tsx
function Og({ helpCenterId: e, helpCenterTitle: t }) {
	let { hideModal: n } = $r(), { deleteMutation: r, deleteLoading: i } = Eg({
		helpCenterId: e,
		helpCenterTitle: t,
		onComplete: n
	});
	return /* @__PURE__ */ z(ai, { children: [
		/* @__PURE__ */ R(ae, {
			title: "Delete Help Center",
			onClose: n
		}),
		/* @__PURE__ */ R(ie, { children: /* @__PURE__ */ z(M.Paragraph, { children: [
			"Are you sure you want to permanently delete",
			" ",
			/* @__PURE__ */ z("strong", { children: [
				"“",
				t,
				"”"
			] }),
			"? This can not be undone."
		] }) }),
		/* @__PURE__ */ R(k, { children: /* @__PURE__ */ z(T, {
			justifyContent: "flex-end",
			gap: "200",
			children: [/* @__PURE__ */ R(h, {
				disabled: i,
				variant: "tertiary",
				onClick: n,
				children: "Cancel"
			}), /* @__PURE__ */ R(h, {
				disabled: i,
				onClick: r,
				variant: "danger",
				children: "Delete"
			})]
		}) })
	] });
}
var kg = B((() => {
	si(), Dg();
})), Ag, jg, Mg, Ng, Pg, Fg, Ig, Lg, Rg, zg, Bg = B((() => {
	Ag = "_tableWrapper_1vb1f_1", jg = "_table_1vb1f_1", Mg = "_tableRow_1vb1f_10", Ng = "_isSyncedWithElevio_1vb1f_10", Pg = "_th_1vb1f_21", Fg = "_td_1vb1f_22", Ig = "_actionColumn_1vb1f_42", Lg = "_externalLink_1vb1f_46", Rg = "_internalLink_1vb1f_52", zg = {
		tableWrapper: Ag,
		table: jg,
		tableRow: Mg,
		isSyncedWithElevio: Ng,
		th: Pg,
		td: Fg,
		actionColumn: Ig,
		externalLink: Lg,
		internalLink: Rg
	};
})), Vg = /* @__PURE__ */ Je({ default: () => Hg });
function Hg() {
	let { data: e, loading: t, error: n } = Yt({ fetchPolicy: "network-only" }), { showModal: r } = $r(), i = je();
	if (n) return /* @__PURE__ */ R(m, {
		padding: "400",
		children: /* @__PURE__ */ R(Ri, { errorMessage: n.message })
	});
	if ((!e || !e.helpCenters.results.length) && !t) return /* @__PURE__ */ R(Ug, {});
	let a = e?.helpCenters.results || [];
	return /* @__PURE__ */ z(kt, { children: [/* @__PURE__ */ R(kt.Head, { slotLeft: /* @__PURE__ */ R(kt.HeadTitle, { title: "Help centers" }) }), /* @__PURE__ */ R(kt.Body, {
		padding: "400",
		children: /* @__PURE__ */ R(T, {
			flexDirection: "column",
			width: "100%",
			children: /* @__PURE__ */ R(m, {
				padding: "400",
				children: t ? /* @__PURE__ */ R(Gg, {}) : /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ z(T, {
					justifyContent: "space-between",
					alignItems: "center",
					margin: "0 0 300",
					children: [/* @__PURE__ */ z(M.Paragraph, {
						variant: "1",
						children: [
							"All Help centers",
							" ",
							/* @__PURE__ */ R(f, {
								variant: "secondary",
								size: "small",
								children: a.length
							})
						]
					}), e && /* @__PURE__ */ R(Kg, {})]
				}), /* @__PURE__ */ z(j, {
					className: zg.table,
					children: [/* @__PURE__ */ R(j.Thead, { children: /* @__PURE__ */ z(j.Tr, { children: [
						/* @__PURE__ */ R(j.Th, { children: "Name" }),
						/* @__PURE__ */ R(j.Th, { children: "Domain" }),
						/* @__PURE__ */ R(j.Th, { children: "Collection" }),
						/* @__PURE__ */ R(j.Th, { children: "Status" }),
						/* @__PURE__ */ R(j.Th, {})
					] }) }), /* @__PURE__ */ R(j.Tbody, { children: a.map(({ id: e, name: t, isActive: n, hostname: a, customHostname: o, collection: s }) => /* @__PURE__ */ z(j.Tr, { children: [
						/* @__PURE__ */ R(j.Td, { children: /* @__PURE__ */ R(De, {
							to: Ii.helpCenterSettingsPath({ helpCenterId: e }),
							className: zg.internalLink,
							"data-testid": "help-center-link",
							children: t
						}, e) }),
						/* @__PURE__ */ R(j.Td, { children: /* @__PURE__ */ z(T, {
							flexDirection: "column",
							children: [/* @__PURE__ */ R(m, { children: /* @__PURE__ */ z(M.ExternalLink, {
								href: `https://${a}`,
								target: "_blank",
								className: zg.externalLink,
								children: [
									/* @__PURE__ */ R(ee, { name: "external-link" }),
									" ",
									a
								]
							}) }), o && /* @__PURE__ */ R(m, { children: o.hostname })]
						}) }),
						/* @__PURE__ */ R(j.Td, { children: s?.title || "Not linked to a collection" }),
						/* @__PURE__ */ R(j.Td, { children: n ? /* @__PURE__ */ R(de, {
							color: "var(--dixa-color-green-500)",
							children: "Active"
						}) : /* @__PURE__ */ R(de, {
							color: "var(--dixa-color-red-500)",
							children: "Inactive"
						}) }),
						/* @__PURE__ */ R(j.Td, { children: /* @__PURE__ */ R(T, {
							justifyContent: "flex-end",
							children: /* @__PURE__ */ R(y, {
								icon: "dots-h",
								fixed: !0,
								buttonProps: { variant: "tertiary" },
								dropdown: /* @__PURE__ */ R(L, { children: /* @__PURE__ */ z(g, { children: [/* @__PURE__ */ R(g.Item, {
									icon: "pen",
									onClick: () => i(Ii.helpCenterSettingsPath({ helpCenterId: e })),
									children: "Edit"
								}), /* @__PURE__ */ R(g.Item, {
									icon: "trash",
									onClick: () => r(Og, {
										helpCenterId: e,
										helpCenterTitle: t || ""
									}),
									children: "Delete"
								})] }) })
							})
						}) })
					] }, e)) })]
				})] })
			})
		})
	})] });
}
function Ug() {
	return /* @__PURE__ */ z(kt, { children: [/* @__PURE__ */ R(kt.Head, { slotLeft: /* @__PURE__ */ R(kt.Head, { slotLeft: /* @__PURE__ */ R(kt.HeadTitle, { title: "Help centers" }) }) }), /* @__PURE__ */ R(kt.Body, {
		padding: "400",
		children: /* @__PURE__ */ R(T, {
			padding: "400",
			width: "100%",
			justifyContent: "center",
			children: /* @__PURE__ */ R(b, {
				size: "small",
				iconColor: "var(--dixa-typography-color-tertiary)",
				title: "No Help Centers",
				description: /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(M.Paragraph, {
					subdued: !0,
					withMarginBottom: !0,
					children: "Create your first Help Center to start sharing Knowledge with your customers. Learn more."
				}), /* @__PURE__ */ R(Kg, {})] }),
				icon: "info"
			})
		})
	})] });
}
function Wg() {
	return /* @__PURE__ */ z(j.Tr, { children: [
		/* @__PURE__ */ R(j.Td, { children: /* @__PURE__ */ R(A, {
			height: "24px",
			width: "128px",
			animation: "wave"
		}) }),
		/* @__PURE__ */ R(j.Td, { children: /* @__PURE__ */ R(A, {
			height: "24px",
			width: "128px",
			animation: "wave"
		}) }),
		/* @__PURE__ */ R(j.Td, { children: /* @__PURE__ */ R(A, {
			height: "24px",
			width: "64px",
			animation: "wave"
		}) }),
		/* @__PURE__ */ R(j.Td, { children: /* @__PURE__ */ R(A, {
			height: "24px",
			width: "64px",
			animation: "wave"
		}) }),
		/* @__PURE__ */ R(j.Td, { children: /* @__PURE__ */ R(A, {
			height: "24px",
			width: "24px",
			animation: "wave"
		}) })
	] });
}
function Gg() {
	return /* @__PURE__ */ z(T, {
		gap: "200",
		justifyContent: "space-between",
		flexDirection: "column",
		children: [/* @__PURE__ */ R(T, {
			gap: "100",
			alignItems: "center",
			margin: "0 0 16px",
			children: /* @__PURE__ */ z(T, {
				justifyContent: "space-between",
				alignItems: "center",
				margin: "0 0 300",
				width: "100%",
				children: [/* @__PURE__ */ z(T, {
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					children: [/* @__PURE__ */ R(M.Paragraph, {
						variant: "1",
						children: "All Help centers"
					}), /* @__PURE__ */ R(A, {
						borderRadius: "8px",
						height: "16px",
						width: "22px",
						animation: "wave"
					})]
				}), /* @__PURE__ */ R(A, {
					borderRadius: "4px",
					height: "28px",
					width: "96px",
					animation: "wave"
				})]
			})
		}), /* @__PURE__ */ z(j, {
			className: zg.table,
			wrapperProps: { style: { height: "100%" } },
			children: [/* @__PURE__ */ R(j.Thead, { children: /* @__PURE__ */ z(j.Tr, { children: [
				/* @__PURE__ */ R(j.Th, { children: "Name" }),
				/* @__PURE__ */ R(j.Th, { children: "Domain" }),
				/* @__PURE__ */ R(j.Th, { children: "Collection" }),
				/* @__PURE__ */ R(j.Th, { children: "Status" }),
				/* @__PURE__ */ R(j.Th, {})
			] }) }), /* @__PURE__ */ z(j.Tbody, { children: [
				/* @__PURE__ */ R(Wg, {}),
				/* @__PURE__ */ R(Wg, {}),
				/* @__PURE__ */ R(Wg, {}),
				/* @__PURE__ */ R(Wg, {}),
				/* @__PURE__ */ R(Wg, {})
			] })]
		})]
	});
}
function Kg() {
	let { showModal: e } = $r();
	return /* @__PURE__ */ R(h, {
		onClick: () => e(Cg, {}),
		children: "New Help Center"
	});
}
var qg = B((() => {
	U(), si(), At(), Li(), zi(), Tg(), kg(), Bg();
}));
// src/hooks/useHelpcenterUpdateAdvancedCustomizationMutation.ts
function Jg({ onCompletedCallback: e }) {
	let { successNotify: t, errorNotify: n } = Ns(), [r, { loading: i }] = Gt({
		onCompleted: (n) => {
			let r = n.helpCenterUpdate;
			r && (t({
				title: "Success",
				text: "Help center has been updated."
			}), Ve.knowledgeHelpCenterUpdated({ helpCenterId: r.id }), e(n));
		},
		onError: (e) => {
			n({
				title: "Unable to update Help Center",
				text: `Error saving: ${e.message}.`
			});
		},
		notifyOnNetworkStatusChange: !0
	});
	return {
		updateMutation: r,
		updateLoading: i
	};
}
var Yg = B((() => {
	U(), Ps();
})), Xg, Zg, Qg, $g, e_, t_ = B((() => {
	Xg = "_wrapper_1j5v5_1", Zg = "_header_1j5v5_7", Qg = "_body_1j5v5_15", $g = "_bodyOpen_1j5v5_21", e_ = {
		wrapper: Xg,
		header: Zg,
		body: Qg,
		bodyOpen: $g
	};
}));
// src/components/controls/accordion/index.tsx
function n_({ children: e, title: t, icon: n, initialOpen: r }) {
	let [i, a] = I(r || !1);
	return /* @__PURE__ */ R(m, {
		className: e_.wrapper,
		children: /* @__PURE__ */ R(_, {
			header: /* @__PURE__ */ R(m, {
				onClick: () => a(!i),
				children: /* @__PURE__ */ R(r_, {
					title: t,
					isOpen: i,
					icon: n
				})
			}),
			isOpen: i,
			children: /* @__PURE__ */ R(m, {
				className: pe(e_.body, { [e_.bodyOpen]: i }),
				children: e
			})
		})
	});
}
function r_({ title: e, icon: t, isOpen: n }) {
	let r = n ? "angle-up" : "angle-down", i = be(e) ? e : /* @__PURE__ */ z(T, {
		alignItems: "center",
		gap: "200",
		children: [t && /* @__PURE__ */ R(ee, { name: t }), /* @__PURE__ */ R(M.Paragraph, {
			variant: "2",
			subdued: !0,
			children: e
		})]
	});
	return /* @__PURE__ */ z(T, {
		className: e_.header,
		children: [/* @__PURE__ */ R(m, { children: i }), /* @__PURE__ */ R(ee, {
			name: r,
			color: "primary"
		})]
	});
}
var i_ = B((() => {
	t_();
}));
// src/components/formHeaderLoadingPlaceholder.tsx
function a_() {
	return /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(E, {
		span: 5,
		children: /* @__PURE__ */ R(w, {
			noLabel: !0,
			children: /* @__PURE__ */ R(A, {
				animation: "wave",
				width: "80px",
				height: "20px"
			})
		})
	}), /* @__PURE__ */ R(E, {
		span: 1,
		children: /* @__PURE__ */ R(w, {
			noLabel: !0,
			children: /* @__PURE__ */ R(A, {
				animation: "wave",
				width: "100%",
				height: "36px"
			})
		})
	})] });
}
var o_ = B((() => {})), s_, c_ = B((() => {
	s_ = ({ isValid: e, loading: t, label: n, disabled: r }) => /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(E, {
		span: 3,
		children: /* @__PURE__ */ R(M.Paragraph, {
			subdued: !0,
			variant: "1",
			children: n
		})
	}), /* @__PURE__ */ R(E, {
		span: 3,
		children: /* @__PURE__ */ R(T, {
			justifyContent: "flex-end",
			children: /* @__PURE__ */ R(h, {
				type: "submit",
				disabled: t || !e || r,
				isLoading: t,
				loadingIndicator: /* @__PURE__ */ R(ce, { size: 16 }),
				children: "Save Changes"
			})
		})
	})] });
})), l_, u_, d_ = B((() => {
	l_ = "_code_1w4at_18", u_ = { code: l_ };
})), f_, p_ = B((() => {
	dg(), f_ = eh({
		enableCustomCss: Xm(),
		customCss: Y(),
		enableCustomJs: Xm(),
		customJs: Y(),
		enableCustomHeaderHtml: Xm(),
		customHeaderHtml: Y(),
		enableCustomFooterHtml: Xm(),
		customFooterHtml: Y()
	});
}));
// src/components/advancedCustomizationForm/index.tsx
function m_({ helpCenterId: e }) {
	let { loading: t, data: n, error: r } = Ut({ variables: { id: e } });
	return r ? /* @__PURE__ */ R(Ri, { errorMessage: r.message }) : !t && n && n.helpCenter ? /* @__PURE__ */ R(__, { helpCenter: n.helpCenter }) : /* @__PURE__ */ R(h_, {});
}
function h_() {
	return /* @__PURE__ */ R("form", { children: /* @__PURE__ */ z(D, { children: [/* @__PURE__ */ R(a_, {}), Array.from([
		,
		,
		,
		,
	]).map((e, t) => /* @__PURE__ */ z(ge, { children: [/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(w, {
		noLabel: !0,
		children: /* @__PURE__ */ R(A, {
			animation: "wave",
			width: "100%",
			height: "72px"
		})
	}) }), /* @__PURE__ */ R(E, { children: /* @__PURE__ */ z(w, {
		noLabel: !0,
		children: [/* @__PURE__ */ R(A, {
			height: "16px",
			width: "64px",
			animation: "wave",
			margin: "0 0 8px"
		}), /* @__PURE__ */ R(A, {
			height: "240px",
			width: "100%",
			animation: "wave"
		})]
	}) })] }, t))] }) });
}
function g_({ css: e, js: t, headerHtml: n, footerHtml: r }) {
	return {
		enableCustomCss: e.enabled || !1,
		customCss: e.value || "",
		enableCustomJs: t.enabled || !1,
		customJs: t.value || "",
		enableCustomHeaderHtml: n.enabled || !1,
		customHeaderHtml: n.value || "",
		enableCustomFooterHtml: r.enabled || !1,
		customFooterHtml: r.value || ""
	};
}
function __({ helpCenter: e }) {
	let { id: t, themeCustomization: n } = e, { control: r, formState: { isValid: i, isDirty: a }, handleSubmit: o, reset: s, setError: c, clearErrors: l } = Be({
		resolver: Xi(f_),
		defaultValues: g_(n),
		reValidateMode: "onChange",
		mode: "all"
	}), u = {
		setError: c,
		clearErrors: l
	}, { updateLoading: d, updateMutation: f } = Jg({ onCompletedCallback: (e) => {
		e.helpCenterUpdate && s(g_(e.helpCenterUpdate.themeCustomization));
	} });
	function p(e) {
		let { enableCustomCss: n, customCss: r, enableCustomJs: i, customJs: a, enableCustomHeaderHtml: o, customHeaderHtml: s, enableCustomFooterHtml: c, customFooterHtml: l } = e;
		f({ variables: {
			helpCenterId: t,
			themeCustomization: {
				css: {
					enabled: n,
					value: r
				},
				js: {
					enabled: i,
					value: a
				},
				headerHtml: {
					enabled: o,
					value: s
				},
				footerHtml: {
					enabled: c,
					value: l
				}
			}
		} });
	}
	return /* @__PURE__ */ R("form", {
		onSubmit: o(p),
		children: /* @__PURE__ */ z(D, { children: [
			/* @__PURE__ */ R(s_, {
				label: "Advanced",
				loading: d,
				isValid: i,
				disabled: !a
			}),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(xs, {
				control: r,
				name: "enableCustomCss",
				heading: "Enable Custom CSS",
				subHeading: "Customise your Help Center’s look & feel with custom CSS.",
				noAlert: !0,
				dark: !0
			}) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(es, {
				control: r,
				name: "customCss",
				label: "Custom CSS",
				language: "css",
				...u
			}) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(xs, {
				control: r,
				name: "enableCustomJs",
				heading: "Enable Custom JS",
				subHeading: "Customise your Help Center’s functionality with custom javascript.",
				noAlert: !0,
				dark: !0
			}) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(es, {
				control: r,
				name: "customJs",
				label: "Custom JS",
				language: "javascript",
				...u
			}) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(xs, {
				control: r,
				name: "enableCustomHeaderHtml",
				heading: "Enable Custom Header HTML",
				subHeading: "Replace your Help Center’s header with custom HTML.",
				noAlert: !0,
				dark: !0
			}) }),
			/* @__PURE__ */ z(E, { children: [/* @__PURE__ */ R(es, {
				control: r,
				name: "customHeaderHtml",
				label: "Custom Header HTML",
				language: "html",
				...u
			}), /* @__PURE__ */ R(n_, {
				icon: "info",
				title: "Custom Header HTML tips",
				initialOpen: !1,
				children: /* @__PURE__ */ R(v_, { name: "Header" })
			})] }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(xs, {
				control: r,
				name: "enableCustomFooterHtml",
				heading: "Enable Custom Footer HTML",
				subHeading: "Replace your Help Center’s footer with custom HTML.",
				noAlert: !0,
				dark: !0
			}) }),
			/* @__PURE__ */ z(E, { children: [/* @__PURE__ */ R(es, {
				control: r,
				name: "customFooterHtml",
				label: "Custom Footer HTML",
				language: "html",
				...u
			}), /* @__PURE__ */ R(n_, {
				icon: "info",
				title: "Custom Footer HTML tips",
				initialOpen: !1,
				children: /* @__PURE__ */ R(v_, { name: "Footer" })
			})] })
		] })
	});
}
function v_({ name: e }) {
	let { enabledLanguages: t } = Ce(Yr), n = /* @__PURE__ */ R(L, { children: t.map((e, n) => /* @__PURE__ */ z(ge, { children: [/* @__PURE__ */ R("code", { children: e.languageId }), n === t.length - 1 ? "" : ", "] }, e.languageId)) });
	return /* @__PURE__ */ z(m, {
		className: u_.code,
		children: [
			/* @__PURE__ */ z(M.Paragraph, { children: [
				`In the Custom ${e} HTML input, you can use the following `,
				/* @__PURE__ */ R(M.ExternalLink, {
					href: "https://liquidjs.com/tutorials/intro-to-liquid.html",
					target: "_blank",
					rel: "noopener noreferrer",
					children: "LiquidJS"
				}),
				` "templating" to insert dynamic elements specific to the ${e.toLowerCase()}:`
			] }),
			/* @__PURE__ */ z("ul", { children: [
				/* @__PURE__ */ R("li", { children: /* @__PURE__ */ z(M.Paragraph, { children: [/* @__PURE__ */ R("code", { children: "{% site_title %}" }), " - This will be replaced with the title of your site."] }) }),
				/* @__PURE__ */ R("li", { children: /* @__PURE__ */ z(M.Paragraph, { children: [/* @__PURE__ */ R("code", { children: "{% site_tagline %}" }), " - This will be replaced with the tagline of your site."] }) }),
				/* @__PURE__ */ z("li", { children: [
					/* @__PURE__ */ z(M.Paragraph, { children: [/* @__PURE__ */ R("code", { children: "{% search_input %}" }), " - This will insert a search input field."] }),
					/* @__PURE__ */ R(M.Paragraph, { children: "You can customize this tag further with the following optional \"filters\" that can optionally be multi-line separated separated, here's some examples:" }),
					/* @__PURE__ */ z("ul", { children: [
						/* @__PURE__ */ z("li", { children: [/* @__PURE__ */ z(M.Paragraph, { children: [/* @__PURE__ */ R("code", { children: "placeholder: \"Your name here...\"" }), " - Specify the placeholder text for the search input."] }), /* @__PURE__ */ R(p, {
							variant: "announcement",
							description: /* @__PURE__ */ z(M.Paragraph, { children: [
								/* @__PURE__ */ R("strong", { children: "Note:" }),
								" ",
								/* @__PURE__ */ R("code", { children: "placeholder" }),
								" is a fallback and will be overridden by other language specific placeholders if available, see below"
							] })
						})] }),
						/* @__PURE__ */ z("li", { children: [
							/* @__PURE__ */ R(M.Paragraph, { children: "Language specific placeholders are also supported by specifying the language code as a prefix, examples:" }),
							/* @__PURE__ */ z(M.Paragraph, { children: [/* @__PURE__ */ R("code", { children: "en: \"Search...\"" }), " - English output"] }),
							/* @__PURE__ */ z(M.Paragraph, { children: [/* @__PURE__ */ R("code", { children: "de: \"Suche...\"" }), " - German output"] }),
							/* @__PURE__ */ z(M.Paragraph, { children: ["Your organisation currently has the following language codes enabled:", " "] }),
							/* @__PURE__ */ R(M.Paragraph, { children: n })
						] }),
						/* @__PURE__ */ R("li", { children: /* @__PURE__ */ z(M.Paragraph, { children: [/* @__PURE__ */ R("code", { children: "inputClass: \"searchBar\"" }), " - Add additional CSS classes to the search input element."] }) }),
						/* @__PURE__ */ R("li", { children: /* @__PURE__ */ z(M.Paragraph, { children: [
							/* @__PURE__ */ R("code", { children: "unstyled: true" }),
							" - Output a pure html input with no styling, see example below. Setting to ",
							/* @__PURE__ */ R("code", { children: "false" }),
							" or completely omitting the flag will output a Dixa styled search input instead."
						] }) })
					] })
				] })
			] }),
			/* @__PURE__ */ R(M.Paragraph, { children: "Example 1:" }),
			/* @__PURE__ */ R("pre", {
				style: { overflowX: "auto" },
				children: "<div>\n  {%\n    search_input\n    inputClass: \"custom\"\n    placeholder: \"Search...\"\n    unstyled: true\n  %}\n</div>"
			}),
			/* @__PURE__ */ R(M.Paragraph, { children: "Outputs a plain unstyled html input:" }),
			/* @__PURE__ */ R("pre", { children: "<div>\n  <input\n    type=\"text\"\n    class=\"search-input custom\"\n    placeholder=\"Search...\"\n    name=\"q\"\n  />\n</div>" }),
			/* @__PURE__ */ R("br", {}),
			/* @__PURE__ */ R(M.Paragraph, { children: "Example 2 (multi language):" }),
			/* @__PURE__ */ R("pre", {
				style: { overflowX: "auto" },
				children: "<div>\n  {%\n    search_input\n    inputClass: \"custom\"\n    en: \"Search...\"\n    de: \"Suche...\"\n    unstyled: false\n  %}\n</div>"
			}),
			/* @__PURE__ */ z(M.Paragraph, { children: [
				"Outputs a plain unstyled html input if your language is ",
				/* @__PURE__ */ R("code", { children: "/de" }),
				":"
			] }),
			/* @__PURE__ */ R("pre", { children: "<div>\n  <input\n    type=\"text\"\n    class=\"search-input custom\"\n    placeholder=\"Suche...\"\n    name=\"q\"\n  />\n</div>" }),
			/* @__PURE__ */ z(M.Paragraph, { children: [
				"And if your language is ",
				/* @__PURE__ */ R("code", { children: "/en" }),
				":"
			] }),
			/* @__PURE__ */ R("pre", { children: "<div>\n  <input\n    type=\"text\"\n    class=\"search-input custom\"\n    placeholder=\"Search...\"\n    name=\"q\"\n  />\n</div>" }),
			/* @__PURE__ */ z(M.Paragraph, { children: [
				"Please make sure to include the necessary HTML tags to structure your",
				" ",
				e.toLowerCase(),
				" properly. You can use any valid HTML along with the LiquidJS tags listed above."
			] }),
			/* @__PURE__ */ z(M.Paragraph, { children: [
				"For more details on LiquidJS templating syntax, you can refer to the",
				" ",
				/* @__PURE__ */ R(M.ExternalLink, {
					href: "https://liquidjs.com/tutorials/intro-to-liquid.html",
					target: "_blank",
					rel: "noopener noreferrer",
					children: "LiquidJS documentation"
				}),
				"."
			] })
		]
	});
}
var y_ = B((() => {
	Zi(), Cs(), Xr(), U(), Yg(), i_(), o_(), zi(), c_(), d_(), p_();
})), b_, x_, S_, C_ = B((() => {
	b_ = "_fieldSet_2u3fk_1", x_ = "_fieldSetLegend_2u3fk_11", S_ = {
		fieldSet: b_,
		fieldSetLegend: x_
	};
}));
// ../management-common/src/components/fieldSet/index.tsx
function w_({ children: e, legend: t, classNames: n }) {
	return /* @__PURE__ */ z("fieldset", {
		className: pe(S_.fieldSet, n?.fieldset),
		children: [/* @__PURE__ */ R("legend", {
			className: pe(S_.fieldSetLegend, n?.legend),
			children: /* @__PURE__ */ R(M.Paragraph, {
				variant: "3",
				subdued: !0,
				className: n?.legendText,
				children: t
			})
		}), e]
	});
}
var T_ = B((() => {
	C_();
}));
// ../../../node_modules/tslib/tslib.es6.mjs
function E_(e, t, n, r) {
	function i(e) {
		return e instanceof n ? e : new n(function(t) {
			t(e);
		});
	}
	return new (n ||= Promise)(function(n, a) {
		function o(e) {
			try {
				c(r.next(e));
			} catch (e) {
				a(e);
			}
		}
		function s(e) {
			try {
				c(r.throw(e));
			} catch (e) {
				a(e);
			}
		}
		function c(e) {
			e.done ? n(e.value) : i(e.value).then(o, s);
		}
		c((r = r.apply(e, t || [])).next());
	});
}
var D_ = B((() => {}));
// ../../../node_modules/react-use/esm/useMountedState.js
function O_() {
	var e = F(!1), t = N(function() {
		return e.current;
	}, []);
	return P(function() {
		return e.current = !0, function() {
			e.current = !1;
		};
	}, []), t;
}
var k_ = B((() => {})), A_, j_ = B((() => {
	A_ = function(e) {
		e === void 0 && (e = {});
		var t = I(e), n = t[0], r = t[1];
		return [n, N(function(e) {
			r(function(t) {
				return Object.assign({}, t, e instanceof Function ? e(t) : e);
			});
		}, [])];
	};
})), M_ = /* @__PURE__ */ V(((e, t) => {
	t.exports = function() {
		var e = document.getSelection();
		if (!e.rangeCount) return function() {};
		for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++) n.push(e.getRangeAt(r));
		switch (t.tagName.toUpperCase()) {
			case "INPUT":
			case "TEXTAREA":
				t.blur();
				break;
			default: t = null;
		}
		return e.removeAllRanges(), function() {
			e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(t) {
				e.addRange(t);
			}), t && t.focus();
		};
	};
})), N_ = /* @__PURE__ */ V(((e, t) => {
	var n = M_(), r = {
		"text/plain": "Text",
		"text/html": "Url",
		default: "Text"
	}, i = "Copy to clipboard: #{key}, Enter";
	function a(e) {
		var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
		return e.replace(/#{\s*key\s*}/g, t);
	}
	function o(e, t) {
		var o, s, c, l, u, d, f = !1;
		t ||= {}, o = t.debug || !1;
		try {
			if (c = n(), l = document.createRange(), u = document.getSelection(), d = document.createElement("span"), d.textContent = e, d.ariaHidden = "true", d.style.all = "unset", d.style.position = "fixed", d.style.top = 0, d.style.clip = "rect(0, 0, 0, 0)", d.style.whiteSpace = "pre", d.style.webkitUserSelect = "text", d.style.MozUserSelect = "text", d.style.msUserSelect = "text", d.style.userSelect = "text", d.addEventListener("copy", function(n) {
				if (n.stopPropagation(), t.format) {
					if (n.preventDefault(), n.clipboardData === void 0) {
						o && console.warn("unable to use e.clipboardData"), o && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
						var i = r[t.format] || r.default;
						window.clipboardData.setData(i, e);
					} else n.clipboardData.clearData(), n.clipboardData.setData(t.format, e);
				}
				t.onCopy && (n.preventDefault(), t.onCopy(n.clipboardData));
			}), document.body.appendChild(d), l.selectNodeContents(d), u.addRange(l), !document.execCommand("copy")) throw Error("copy command was unsuccessful");
			f = !0;
		} catch (n) {
			o && console.error("unable to copy using execCommand: ", n), o && console.warn("trying IE specific stuff");
			try {
				window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), f = !0;
			} catch (n) {
				o && console.error("unable to copy using clipboardData: ", n), o && console.error("falling back to prompt"), s = a("message" in t ? t.message : i), window.prompt(s, e);
			}
		} finally {
			u && (typeof u.removeRange == "function" ? u.removeRange(l) : u.removeAllRanges()), d && document.body.removeChild(d), c();
		}
		return f;
	}
	t.exports = o;
})), P_, F_, I_ = B((() => {
	P_ = /* @__PURE__ */ Xe(N_()), k_(), j_(), F_ = function() {
		var e = O_(), t = A_({
			value: void 0,
			error: void 0,
			noUserInteraction: !0
		}), n = t[0], r = t[1];
		return [n, N(function(t) {
			if (e()) {
				var n, i;
				try {
					if (typeof t != "string" && typeof t != "number") {
						var a = /* @__PURE__ */ Error("Cannot copy typeof " + typeof t + " to clipboard, must be a string");
						process.env.NODE_ENV === "development" && console.error(a), r({
							value: t,
							error: a,
							noUserInteraction: !0
						});
						return;
					}
					if (t === "") {
						var a = /* @__PURE__ */ Error("Cannot copy empty string to clipboard.");
						process.env.NODE_ENV === "development" && console.error(a), r({
							value: t,
							error: a,
							noUserInteraction: !0
						});
						return;
					}
					i = t.toString(), n = (0, P_.default)(i), r({
						value: i,
						error: void 0,
						noUserInteraction: n
					});
				} catch (e) {
					r({
						value: i,
						error: e,
						noUserInteraction: n
					});
				}
			}
		}, [])];
	};
})), L_ = /* @__PURE__ */ V(((e, t) => {
	t.exports = Object.prototype.hasOwnProperty.call(me, "module.exports") ? me["module.exports"] : { ...me };
})), R_ = B((() => {
	D_(), k_(), j_(), I_();
}));
// ../utils/src/hooks/useCopyToClipboard.ts
function z_(e) {
	let [t, n] = F_(), [r, i] = I(!1);
	return P(() => {
		let n = null;
		return t.value && (i(!0), n = setTimeout(() => {
			i(!1);
		}, e ?? B_)), () => {
			n && clearTimeout(n);
		};
	}, [t, e]), {
		clipboard: t,
		setClipboard: n,
		timedClipboardIndicator: r
	};
}
var B_, V_ = B((() => {
	R_(), B_ = 3e3;
})), H_, U_, W_, G_, K_, q_, J_ = B((() => {
	H_ = "_formField_1bcx8_1", U_ = "_fieldSet_1bcx8_5", W_ = "_pre_1bcx8_10", G_ = "_copyIcon_1bcx8_18", K_ = "_copied_1bcx8_22", q_ = {
		formField: H_,
		fieldSet: U_,
		pre: W_,
		copyIcon: G_,
		copied: K_
	};
})), Y_, X_ = B((() => {
	dg(), Y_ = eh({ customHostname: Y().min(1, "Hostname is required").refine((e) => /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.[A-Za-z0-9-]{1,63})*\.[A-Za-z]{2,}$/.test(e), { error: "Invalid hostname format. Only a domain name (with optional subdomain) is allowed." }) });
}));
// src/components/customHostnameForm/searchEngineStatus.tsx
function Z_(e, t) {
	return e === $t.Error || t === $t.Error ? $t.Error : e === $t.Active && t === $t.Active ? $t.Active : $t.Pending;
}
function Q_({ customHostname: e, subdomainHostname: t, cnameStatus: n, sslStatus: r, verificationErrors: i }) {
	let a = t ?? "your help center address";
	switch (Z_(n, r)) {
		case $t.Active: return null;
		case $t.Error: return /* @__PURE__ */ R(p, {
			variant: "fail",
			icon: null,
			description: /* @__PURE__ */ z(M.Paragraph, { children: [
				"Verification failed, search engines still use",
				" ",
				/* @__PURE__ */ R("strong", { children: a }),
				".",
				i.length ? ` Error(s): ${i.join(" ")}` : ""
			] })
		});
		case $t.Pending: return /* @__PURE__ */ R(p, {
			variant: "info",
			icon: null,
			description: /* @__PURE__ */ z(M.Paragraph, { children: [
				"Search engines might use ",
				/* @__PURE__ */ R("strong", { children: a }),
				" until",
				" ",
				/* @__PURE__ */ R("strong", { children: e }),
				" is verified. Verification can take a few hours after DNS changes. If it stays pending, check the records below and click Recheck status."
			] })
		});
	}
}
var $_ = B((() => {
	U();
}));
// src/components/customHostnameForm/customHostnameFormContent.tsx
function ev({ helpCenterId: e, isActive: t }) {
	let { data: n } = Rt({
		variables: { id: e },
		skip: !t
	});
	return n?.helpCenter?.customHostname ? /* @__PURE__ */ R(nv, {
		helpCenterId: e,
		customHostname: n.helpCenter.customHostname
	}) : /* @__PURE__ */ R(tv, { helpCenterId: e });
}
function tv({ helpCenterId: e }) {
	let { errorNotify: t, successNotify: n } = Ns(), { formState: { submitCount: r, isValid: i }, handleSubmit: a, control: o } = Be({
		defaultValues: { customHostname: "" },
		resolver: Xi(Y_),
		mode: "all",
		reValidateMode: "onChange"
	}), [s, { loading: c }] = Wt({
		onCompleted: () => {
			n({
				title: "Success",
				text: "Custom hostname successfully added"
			});
		},
		onError: (e) => {
			throw t({
				title: "Unable to register custom hostname",
				text: "Please try again. If this issue persists contact customer support."
			}), e;
		}
	}), l = (t) => {
		s({ variables: {
			id: e,
			customHostname: t.customHostname
		} });
	}, u = c || !!r && !i;
	return /* @__PURE__ */ R("form", {
		onSubmit: a(l),
		children: /* @__PURE__ */ z(D, { children: [/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(os, {
			control: o,
			name: "customHostname",
			label: "Custom hostname URL",
			description: "A URL must be a valid format. Do not start with 'https://' or 'http://'",
			placeholder: "yoursite.com",
			prefix: "https://"
		}) }), /* @__PURE__ */ z(E, {
			span: 6,
			children: [/* @__PURE__ */ R(h, {
				onClick: a(l),
				disabled: u,
				isLoading: c,
				loadingIndicator: /* @__PURE__ */ z(T, {
					gap: "200",
					children: [/* @__PURE__ */ R(ce, { size: 16 }), /* @__PURE__ */ R(M.Paragraph, {
						variant: "3",
						as: "span",
						style: { color: "unset" },
						children: "Registering..."
					})]
				}),
				children: "Register"
			}), c && /* @__PURE__ */ R(M.Paragraph, {
				variant: "4",
				subdued: !0,
				margin: "100 0 0",
				children: "(this may take some time)"
			})]
		})] })
	});
}
function nv({ customHostname: e, helpCenterId: t }) {
	let { errorNotify: n, successNotify: r } = Ns(), { loading: i, refetch: a } = Rt({
		variables: { id: t },
		notifyOnNetworkStatusChange: !0
	}), [o, { loading: s }] = Ht({
		variables: { id: t },
		onCompleted: () => {
			r({
				title: "Success",
				text: "Custom hostname successfully deregistered"
			});
		},
		onError: (e) => {
			throw n({
				title: "Unable to deregister custom hostname",
				text: "Please try again. If this issue persists contact customer support."
			}), e;
		}
	}), { data: c } = Ut({ variables: { id: t } }), l = s || i, u = e?.records?.ssl.records ?? [], d = u.length > 0 ? u : [void 0];
	return /* @__PURE__ */ R("form", { children: /* @__PURE__ */ z(D, {
		className: q_.formGrid,
		children: [
			e && /* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(Q_, {
				customHostname: e.hostname,
				subdomainHostname: c?.helpCenter?.hostname,
				cnameStatus: e.records?.cname.status,
				sslStatus: e.records?.ssl.status,
				verificationErrors: e.records?.cname.verificationErrors ?? []
			}) }),
			/* @__PURE__ */ R(E, {
				className: q_.formField,
				children: /* @__PURE__ */ R(w_, {
					legend: "CNAME",
					classNames: { fieldset: q_.fieldSet },
					children: /* @__PURE__ */ z(D, { children: [
						/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(rv, {
							label: "Hostname",
							value: e?.hostname
						}) }),
						/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(rv, {
							label: "Alias",
							value: e?.records?.cname.record?.aliasOf
						}) }),
						/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(rv, {
							label: "Status",
							value: e?.records?.cname.status,
							showCopyButton: !1
						}) })
					] })
				})
			}),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(w_, {
				legend: "SSL",
				classNames: { fieldset: q_.fieldSet },
				children: /* @__PURE__ */ z(D, { children: [d.map((e, t) => /* @__PURE__ */ z(ge, { children: [/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(rv, {
					label: "Name",
					value: e?.name
				}) }), /* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(rv, {
					label: "Value",
					value: e?.value
				}) })] }, `${e?.name}-${e?.value}-${t}`)), /* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(rv, {
					label: "Status",
					value: e?.records?.ssl.status,
					showCopyButton: !1
				}) })] })
			}) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ z(T, {
				gap: "250",
				children: [/* @__PURE__ */ R(h, {
					variant: "danger",
					isLoading: s,
					loadingIndicator: s ? /* @__PURE__ */ z(T, {
						gap: "200",
						children: [/* @__PURE__ */ R(ce, { size: 16 }), /* @__PURE__ */ R(M.Paragraph, {
							variant: "3",
							as: "span",
							style: { color: "unset" },
							children: "De-registering..."
						})]
					}) : "Deregister",
					disabled: l,
					onClick: () => o(),
					children: "Deregister"
				}), /* @__PURE__ */ R(h, {
					variant: "secondary",
					disabled: l,
					onClick: () => a(),
					children: "Recheck status"
				})]
			}) })
		]
	}) });
}
function rv({ value: e, label: t, showCopyButton: n = !0 }) {
	let { timedClipboardIndicator: r, setClipboard: i } = z_(), { successNotify: a } = Ns(), o = () => {
		e && (i(e), a({
			title: "Success",
			text: "Copied to clipboard",
			time: 1e3
		}));
	}, s = pe(q_.copyIcon, { [q_.copied]: r });
	return /* @__PURE__ */ z(m, { children: [/* @__PURE__ */ R(M.Paragraph, {
		variant: "4",
		children: t
	}), /* @__PURE__ */ z(T, {
		alignItems: "stretch",
		gap: "200",
		children: [/* @__PURE__ */ R("pre", {
			className: q_.pre,
			children: e
		}), n && /* @__PURE__ */ R(te, {
			variant: "secondary",
			icon: r ? "check-circle-filled" : "copy",
			onClick: o,
			className: s
		})]
	})] });
}
var iv = B((() => {
	Zi(), Cs(), T_(), U(), V_(), Ps(), J_(), X_(), $_();
}));
// src/components/customHostnameForm/customHostnameFormLoadingPlaceholder.tsx
function av() {
	return /* @__PURE__ */ R("form", { children: /* @__PURE__ */ z(T, {
		flexDirection: "column",
		gap: "200",
		children: [
			/* @__PURE__ */ R(A, {
				height: "16px",
				width: "140px",
				animation: "wave"
			}),
			/* @__PURE__ */ R(A, {
				height: "38px",
				width: "100%",
				animation: "wave"
			}),
			/* @__PURE__ */ R(A, {
				height: "12px",
				width: "350px",
				animation: "wave"
			}),
			/* @__PURE__ */ R(A, {
				height: "32px",
				width: "70px",
				animation: "wave",
				margin: "200 0 0"
			})
		]
	}) });
}
var ov = B((() => {}));
// src/components/customHostnameForm/index.tsx
function sv({ helpCenterId: e, isActive: t }) {
	let { loading: n, data: r, error: i } = Rt({ variables: { id: e } });
	return !n && r && r.helpCenter ? /* @__PURE__ */ R(ev, {
		helpCenterId: e,
		isActive: t
	}) : i ? /* @__PURE__ */ R(Ri, { errorMessage: i.message }) : /* @__PURE__ */ R(av, {});
}
var cv = B((() => {
	U(), zi(), iv(), ov();
}));
// ../management-common/src/utils/language.ts
function lv({ languageId: e, languages: t }) {
	let n = t.find((t) => t.languageId === e);
	if (n === void 0) {
		let t = `Unknown lang: "${e}"`;
		return {
			description: t,
			nativeDescription: t
		};
	}
	return {
		description: n.description,
		nativeDescription: n.nativeDescription
	};
}
var uv = B((() => {})), dv, fv, pv, mv, hv, gv = B((() => {
	U(), dg(), dv = /^#([A-Fa-f0-9]{6})$/, fv = Y().refine((e) => dv.test(e), "Invalid color format: must be a valid 6 character long Hex value"), pv = eh({
		languageId: rh(Qt),
		tagline: th([ih(""), Y().min(3, { error: "If provided, a site tagline must be at least 3 characters long" })])
	}), mv = eh({
		languageId: rh(Qt),
		title: th([ih(""), Y().min(3, { error: "If provided, a site title must be at least 3 characters long" })])
	}), hv = eh({
		companyUrl: th([ih(""), Y().trim().pipe(Ym({ error: "A URL must be a valid format and start with 'https://' or 'http://'" }))]),
		helpCenterTitles: $m(mv),
		helpCenterTaglines: $m(pv),
		colors: eh({
			websiteBackground: fv,
			pageBackground: fv,
			text: fv,
			link: fv,
			accent: fv,
			accentText: fv
		}),
		themeId: Jm()
	});
})), _v, vv, yv, bv, xv, Sv, Cv = B((() => {
	_v = "_alert_smz2d_1", vv = "_uploadDropzoneWrapper_smz2d_5", yv = "_uploadImageWrapper_smz2d_6", bv = "_uploadDropzoneLoadingWrapper_smz2d_7", xv = "_uploadImage_smz2d_6", Sv = {
		alert: _v,
		uploadDropzoneWrapper: vv,
		uploadImageWrapper: yv,
		uploadDropzoneLoadingWrapper: bv,
		uploadImage: xv
	};
})), wv = /* @__PURE__ */ V(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), Tv = /* @__PURE__ */ V(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
		function b(e) {
			return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
		}
		function x(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n:
						var p = e.type;
						switch (p) {
							case l:
							case u:
							case i:
							case o:
							case a:
							case f: return p;
							default:
								var g = p && p.$$typeof;
								switch (g) {
									case c:
									case d:
									case h:
									case m:
									case s: return g;
									default: return t;
								}
						}
					case r: return t;
				}
			}
		}
		var S = l, C = u, w = c, T = s, E = n, D = d, ee = i, te = h, O = m, ne = r, re = o, ie = a, k = f, ae = !1;
		function oe(e) {
			return ae || (ae = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), se(e) || x(e) === l;
		}
		function se(e) {
			return x(e) === u;
		}
		function A(e) {
			return x(e) === c;
		}
		function ce(e) {
			return x(e) === s;
		}
		function le(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}
		function j(e) {
			return x(e) === d;
		}
		function ue(e) {
			return x(e) === i;
		}
		function de(e) {
			return x(e) === h;
		}
		function M(e) {
			return x(e) === m;
		}
		function fe(e) {
			return x(e) === r;
		}
		function pe(e) {
			return x(e) === o;
		}
		function me(e) {
			return x(e) === a;
		}
		function he(e) {
			return x(e) === f;
		}
		e.AsyncMode = S, e.ConcurrentMode = C, e.ContextConsumer = w, e.ContextProvider = T, e.Element = E, e.ForwardRef = D, e.Fragment = ee, e.Lazy = te, e.Memo = O, e.Portal = ne, e.Profiler = re, e.StrictMode = ie, e.Suspense = k, e.isAsyncMode = oe, e.isConcurrentMode = se, e.isContextConsumer = A, e.isContextProvider = ce, e.isElement = le, e.isForwardRef = j, e.isFragment = ue, e.isLazy = de, e.isMemo = M, e.isPortal = fe, e.isProfiler = pe, e.isStrictMode = me, e.isSuspense = he, e.isValidElementType = b, e.typeOf = x;
	})();
})), Ev = /* @__PURE__ */ V(((e, t) => {
	t.exports = process.env.NODE_ENV === "production" ? wv() : Tv();
})), Dv = /* @__PURE__ */ V(((e, t) => {
	var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
	function a(e) {
		if (e == null) throw TypeError("Object.assign cannot be called with null or undefined");
		return Object(e);
	}
	function o() {
		try {
			if (!Object.assign) return !1;
			var e = /* @__PURE__ */ new String("abc");
			if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
			for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
			if (Object.getOwnPropertyNames(t).map(function(e) {
				return t[e];
			}).join("") !== "0123456789") return !1;
			var r = {};
			return "abcdefghijklmnopqrst".split("").forEach(function(e) {
				r[e] = e;
			}), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
		} catch {
			return !1;
		}
	}
	t.exports = o() ? Object.assign : function(e, t) {
		for (var o, s = a(e), c, l = 1; l < arguments.length; l++) {
			for (var u in o = Object(arguments[l]), o) r.call(o, u) && (s[u] = o[u]);
			if (n) {
				c = n(o);
				for (var d = 0; d < c.length; d++) i.call(o, c[d]) && (s[c[d]] = o[c[d]]);
			}
		}
		return s;
	};
})), Ov = /* @__PURE__ */ V(((e, t) => {
	t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
})), kv = /* @__PURE__ */ V(((e, t) => {
	t.exports = Function.call.bind(Object.prototype.hasOwnProperty);
})), Av = /* @__PURE__ */ V(((e, t) => {
	var n = function() {};
	if (process.env.NODE_ENV !== "production") {
		var r = Ov(), i = {}, a = kv();
		n = function(e) {
			var t = "Warning: " + e;
			typeof console < "u" && console.error(t);
			try {
				throw Error(t);
			} catch {}
		};
	}
	function o(e, t, o, s, c) {
		if (process.env.NODE_ENV !== "production") {
			for (var l in e) if (a(e, l)) {
				var u;
				try {
					if (typeof e[l] != "function") {
						var d = Error((s || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						throw d.name = "Invariant Violation", d;
					}
					u = e[l](t, l, s, o, null, r);
				} catch (e) {
					u = e;
				}
				if (u && !(u instanceof Error) && n((s || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in i)) {
					i[u.message] = !0;
					var f = c ? c() : "";
					n("Failed " + o + " type: " + u.message + (f ?? ""));
				}
			}
		}
	}
	o.resetWarningCache = function() {
		process.env.NODE_ENV !== "production" && (i = {});
	}, t.exports = o;
})), jv = /* @__PURE__ */ V(((e, t) => {
	var n = Ev(), r = Dv(), i = Ov(), a = kv(), o = Av(), s = function() {};
	process.env.NODE_ENV !== "production" && (s = function(e) {
		var t = "Warning: " + e;
		typeof console < "u" && console.error(t);
		try {
			throw Error(t);
		} catch {}
	});
	function c() {
		return null;
	}
	t.exports = function(e, t) {
		var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
		function d(e) {
			var t = e && (l && e[l] || e[u]);
			if (typeof t == "function") return t;
		}
		var f = "<<anonymous>>", p = {
			array: _("array"),
			bigint: _("bigint"),
			bool: _("boolean"),
			func: _("function"),
			number: _("number"),
			object: _("object"),
			string: _("string"),
			symbol: _("symbol"),
			any: v(),
			arrayOf: y,
			element: b(),
			elementType: x(),
			instanceOf: S,
			node: E(),
			objectOf: w,
			oneOf: C,
			oneOfType: T,
			shape: ee,
			exact: te
		};
		function m(e, t) {
			return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
		}
		function h(e, t) {
			this.message = e, this.data = t && typeof t == "object" ? t : {}, this.stack = "";
		}
		h.prototype = Error.prototype;
		function g(e) {
			if (process.env.NODE_ENV !== "production") var n = {}, r = 0;
			function a(a, o, c, l, u, d, p) {
				if (l ||= f, d ||= c, p !== i) {
					if (t) {
						var m = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
						throw m.name = "Invariant Violation", m;
					}
					if (process.env.NODE_ENV !== "production" && typeof console < "u") {
						var g = l + ":" + c;
						!n[g] && r < 3 && (s("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[g] = !0, r++);
					}
				}
				return o[c] == null ? a ? o[c] === null ? new h("The " + u + " `" + d + "` is marked as required " + ("in `" + l + "`, but its value is `null`.")) : new h("The " + u + " `" + d + "` is marked as required in " + ("`" + l + "`, but its value is `undefined`.")) : null : e(o, c, l, u, d);
			}
			var o = a.bind(null, !1);
			return o.isRequired = a.bind(null, !0), o;
		}
		function _(e) {
			function t(t, n, r, i, a, o) {
				var s = t[n];
				if (re(s) !== e) {
					var c = ie(s);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."), { expectedType: e });
				}
				return null;
			}
			return g(t);
		}
		function v() {
			return g(c);
		}
		function y(e) {
			function t(t, n, r, a, o) {
				if (typeof e != "function") return new h("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
				var s = t[n];
				if (!Array.isArray(s)) {
					var c = re(s);
					return new h("Invalid " + a + " `" + o + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected an array."));
				}
				for (var l = 0; l < s.length; l++) {
					var u = e(s, l, r, a, o + "[" + l + "]", i);
					if (u instanceof Error) return u;
				}
				return null;
			}
			return g(t);
		}
		function b() {
			function t(t, n, r, i, a) {
				var o = t[n];
				if (!e(o)) {
					var s = re(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement."));
				}
				return null;
			}
			return g(t);
		}
		function x() {
			function e(e, t, r, i, a) {
				var o = e[t];
				if (!n.isValidElementType(o)) {
					var s = re(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement type."));
				}
				return null;
			}
			return g(e);
		}
		function S(e) {
			function t(t, n, r, i, a) {
				if (!(t[n] instanceof e)) {
					var o = e.name || f, s = ae(t[n]);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected ") + ("instance of `" + o + "`."));
				}
				return null;
			}
			return g(t);
		}
		function C(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : s("Invalid argument supplied to oneOf, expected an array.")), c;
			function t(t, n, r, i, a) {
				for (var o = t[n], s = 0; s < e.length; s++) if (m(o, e[s])) return null;
				var c = JSON.stringify(e, function(e, t) {
					return ie(t) === "symbol" ? String(t) : t;
				});
				return new h("Invalid " + i + " `" + a + "` of value `" + String(o) + "` " + ("supplied to `" + r + "`, expected one of " + c + "."));
			}
			return g(t);
		}
		function w(e) {
			function t(t, n, r, o, s) {
				if (typeof e != "function") return new h("Property `" + s + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
				var c = t[n], l = re(c);
				if (l !== "object") return new h("Invalid " + o + " `" + s + "` of type " + ("`" + l + "` supplied to `" + r + "`, expected an object."));
				for (var u in c) if (a(c, u)) {
					var d = e(c, u, r, o, s + "." + u, i);
					if (d instanceof Error) return d;
				}
				return null;
			}
			return g(t);
		}
		function T(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), c;
			for (var t = 0; t < e.length; t++) {
				var n = e[t];
				if (typeof n != "function") return s("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + k(n) + " at index " + t + "."), c;
			}
			function r(t, n, r, o, s) {
				for (var c = [], l = 0; l < e.length; l++) {
					var u = e[l], d = u(t, n, r, o, s, i);
					if (d == null) return null;
					d.data && a(d.data, "expectedType") && c.push(d.data.expectedType);
				}
				var f = c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "";
				return new h("Invalid " + o + " `" + s + "` supplied to " + ("`" + r + "`" + f + "."));
			}
			return g(r);
		}
		function E() {
			function e(e, t, n, r, i) {
				return O(e[t]) ? null : new h("Invalid " + r + " `" + i + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
			}
			return g(e);
		}
		function D(e, t, n, r, i) {
			return new h((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + i + "`.");
		}
		function ee(e) {
			function t(t, n, r, a, o) {
				var s = t[n], c = re(s);
				if (c !== "object") return new h("Invalid " + a + " `" + o + "` of type `" + c + "` " + ("supplied to `" + r + "`, expected `object`."));
				for (var l in e) {
					var u = e[l];
					if (typeof u != "function") return D(r, a, o, l, ie(u));
					var d = u(s, l, r, a, o + "." + l, i);
					if (d) return d;
				}
				return null;
			}
			return g(t);
		}
		function te(e) {
			function t(t, n, o, s, c) {
				var l = t[n], u = re(l);
				if (u !== "object") return new h("Invalid " + s + " `" + c + "` of type `" + u + "` " + ("supplied to `" + o + "`, expected `object`."));
				for (var d in r({}, t[n], e)) {
					var f = e[d];
					if (a(e, d) && typeof f != "function") return D(o, s, c, d, ie(f));
					if (!f) return new h("Invalid " + s + " `" + c + "` key `" + d + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
					var p = f(l, d, o, s, c + "." + d, i);
					if (p) return p;
				}
				return null;
			}
			return g(t);
		}
		function O(t) {
			switch (typeof t) {
				case "number":
				case "string":
				case "undefined": return !0;
				case "boolean": return !t;
				case "object":
					if (Array.isArray(t)) return t.every(O);
					if (t === null || e(t)) return !0;
					var n = d(t);
					if (n) {
						var r = n.call(t), i;
						if (n !== t.entries) {
							for (; !(i = r.next()).done;) if (!O(i.value)) return !1;
						} else for (; !(i = r.next()).done;) {
							var a = i.value;
							if (a && !O(a[1])) return !1;
						}
					} else return !1;
					return !0;
				default: return !1;
			}
		}
		function ne(e, t) {
			return e === "symbol" ? !0 : t ? t["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && t instanceof Symbol : !1;
		}
		function re(e) {
			var t = typeof e;
			return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : ne(t, e) ? "symbol" : t;
		}
		function ie(e) {
			if (e == null) return "" + e;
			var t = re(e);
			if (t === "object") {
				if (e instanceof Date) return "date";
				if (e instanceof RegExp) return "regexp";
			}
			return t;
		}
		function k(e) {
			var t = ie(e);
			switch (t) {
				case "array":
				case "object": return "an " + t;
				case "boolean":
				case "date":
				case "regexp": return "a " + t;
				default: return t;
			}
		}
		function ae(e) {
			return !e.constructor || !e.constructor.name ? f : e.constructor.name;
		}
		return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
	};
})), Mv = /* @__PURE__ */ V(((e, t) => {
	var n = Ov();
	function r() {}
	function i() {}
	i.resetWarningCache = r, t.exports = function() {
		function e(e, t, r, i, a, o) {
			if (o !== n) {
				var s = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
				throw s.name = "Invariant Violation", s;
			}
		}
		e.isRequired = e;
		function t() {
			return e;
		}
		var a = {
			array: e,
			bigint: e,
			bool: e,
			func: e,
			number: e,
			object: e,
			string: e,
			symbol: e,
			any: e,
			arrayOf: t,
			element: e,
			elementType: e,
			instanceOf: t,
			node: e,
			objectOf: t,
			oneOf: t,
			oneOfType: t,
			shape: t,
			exact: t,
			checkPropTypes: i,
			resetWarningCache: r
		};
		return a.PropTypes = a, a;
	};
})), Nv = /* @__PURE__ */ V(((e, t) => {
	if (process.env.NODE_ENV !== "production") {
		var n = Ev();
		t.exports = jv()(n.isElement, !0);
	} else t.exports = Mv()();
}));
// ../../../node_modules/file-selector/dist/es2015/file.js
function Pv(e, t, n) {
	let r = Fv(e), { webkitRelativePath: i } = e, a = typeof t == "string" ? t : typeof i == "string" && i.length > 0 ? i : `./${e.name}`;
	return typeof r.path != "string" && Iv(r, "path", a), n !== void 0 && Object.defineProperty(r, "handle", {
		value: n,
		writable: !1,
		configurable: !1,
		enumerable: !0
	}), Iv(r, "relativePath", a), r;
}
function Fv(e) {
	let { name: t } = e;
	if (t && t.lastIndexOf(".") !== -1 && !e.type) {
		let n = t.split(".").pop().toLowerCase(), r = Lv.get(n);
		r && Object.defineProperty(e, "type", {
			value: r,
			writable: !1,
			configurable: !1,
			enumerable: !0
		});
	}
	return e;
}
function Iv(e, t, n) {
	Object.defineProperty(e, t, {
		value: n,
		writable: !1,
		configurable: !1,
		enumerable: !0
	});
}
var Lv, Rv = B((() => {
	Lv = /* @__PURE__ */ new Map([
		["1km", "application/vnd.1000minds.decision-model+xml"],
		["3dml", "text/vnd.in3d.3dml"],
		["3ds", "image/x-3ds"],
		["3g2", "video/3gpp2"],
		["3gp", "video/3gp"],
		["3gpp", "video/3gpp"],
		["3mf", "model/3mf"],
		["7z", "application/x-7z-compressed"],
		["7zip", "application/x-7z-compressed"],
		["123", "application/vnd.lotus-1-2-3"],
		["aab", "application/x-authorware-bin"],
		["aac", "audio/x-acc"],
		["aam", "application/x-authorware-map"],
		["aas", "application/x-authorware-seg"],
		["abw", "application/x-abiword"],
		["ac", "application/vnd.nokia.n-gage.ac+xml"],
		["ac3", "audio/ac3"],
		["acc", "application/vnd.americandynamics.acc"],
		["ace", "application/x-ace-compressed"],
		["acu", "application/vnd.acucobol"],
		["acutc", "application/vnd.acucorp"],
		["adp", "audio/adpcm"],
		["aep", "application/vnd.audiograph"],
		["afm", "application/x-font-type1"],
		["afp", "application/vnd.ibm.modcap"],
		["ahead", "application/vnd.ahead.space"],
		["ai", "application/pdf"],
		["aif", "audio/x-aiff"],
		["aifc", "audio/x-aiff"],
		["aiff", "audio/x-aiff"],
		["air", "application/vnd.adobe.air-application-installer-package+zip"],
		["ait", "application/vnd.dvb.ait"],
		["ami", "application/vnd.amiga.ami"],
		["amr", "audio/amr"],
		["apk", "application/vnd.android.package-archive"],
		["apng", "image/apng"],
		["appcache", "text/cache-manifest"],
		["application", "application/x-ms-application"],
		["apr", "application/vnd.lotus-approach"],
		["arc", "application/x-freearc"],
		["arj", "application/x-arj"],
		["asc", "application/pgp-signature"],
		["asf", "video/x-ms-asf"],
		["asm", "text/x-asm"],
		["aso", "application/vnd.accpac.simply.aso"],
		["asx", "video/x-ms-asf"],
		["atc", "application/vnd.acucorp"],
		["atom", "application/atom+xml"],
		["atomcat", "application/atomcat+xml"],
		["atomdeleted", "application/atomdeleted+xml"],
		["atomsvc", "application/atomsvc+xml"],
		["atx", "application/vnd.antix.game-component"],
		["au", "audio/x-au"],
		["avi", "video/x-msvideo"],
		["avif", "image/avif"],
		["aw", "application/applixware"],
		["azf", "application/vnd.airzip.filesecure.azf"],
		["azs", "application/vnd.airzip.filesecure.azs"],
		["azv", "image/vnd.airzip.accelerator.azv"],
		["azw", "application/vnd.amazon.ebook"],
		["b16", "image/vnd.pco.b16"],
		["bat", "application/x-msdownload"],
		["bcpio", "application/x-bcpio"],
		["bdf", "application/x-font-bdf"],
		["bdm", "application/vnd.syncml.dm+wbxml"],
		["bdoc", "application/x-bdoc"],
		["bed", "application/vnd.realvnc.bed"],
		["bh2", "application/vnd.fujitsu.oasysprs"],
		["bin", "application/octet-stream"],
		["blb", "application/x-blorb"],
		["blorb", "application/x-blorb"],
		["bmi", "application/vnd.bmi"],
		["bmml", "application/vnd.balsamiq.bmml+xml"],
		["bmp", "image/bmp"],
		["book", "application/vnd.framemaker"],
		["box", "application/vnd.previewsystems.box"],
		["boz", "application/x-bzip2"],
		["bpk", "application/octet-stream"],
		["bpmn", "application/octet-stream"],
		["bsp", "model/vnd.valve.source.compiled-map"],
		["btif", "image/prs.btif"],
		["buffer", "application/octet-stream"],
		["bz", "application/x-bzip"],
		["bz2", "application/x-bzip2"],
		["c", "text/x-c"],
		["c4d", "application/vnd.clonk.c4group"],
		["c4f", "application/vnd.clonk.c4group"],
		["c4g", "application/vnd.clonk.c4group"],
		["c4p", "application/vnd.clonk.c4group"],
		["c4u", "application/vnd.clonk.c4group"],
		["c11amc", "application/vnd.cluetrust.cartomobile-config"],
		["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
		["cab", "application/vnd.ms-cab-compressed"],
		["caf", "audio/x-caf"],
		["cap", "application/vnd.tcpdump.pcap"],
		["car", "application/vnd.curl.car"],
		["cat", "application/vnd.ms-pki.seccat"],
		["cb7", "application/x-cbr"],
		["cba", "application/x-cbr"],
		["cbr", "application/x-cbr"],
		["cbt", "application/x-cbr"],
		["cbz", "application/x-cbr"],
		["cc", "text/x-c"],
		["cco", "application/x-cocoa"],
		["cct", "application/x-director"],
		["ccxml", "application/ccxml+xml"],
		["cdbcmsg", "application/vnd.contact.cmsg"],
		["cda", "application/x-cdf"],
		["cdf", "application/x-netcdf"],
		["cdfx", "application/cdfx+xml"],
		["cdkey", "application/vnd.mediastation.cdkey"],
		["cdmia", "application/cdmi-capability"],
		["cdmic", "application/cdmi-container"],
		["cdmid", "application/cdmi-domain"],
		["cdmio", "application/cdmi-object"],
		["cdmiq", "application/cdmi-queue"],
		["cdr", "application/cdr"],
		["cdx", "chemical/x-cdx"],
		["cdxml", "application/vnd.chemdraw+xml"],
		["cdy", "application/vnd.cinderella"],
		["cer", "application/pkix-cert"],
		["cfs", "application/x-cfs-compressed"],
		["cgm", "image/cgm"],
		["chat", "application/x-chat"],
		["chm", "application/vnd.ms-htmlhelp"],
		["chrt", "application/vnd.kde.kchart"],
		["cif", "chemical/x-cif"],
		["cii", "application/vnd.anser-web-certificate-issue-initiation"],
		["cil", "application/vnd.ms-artgalry"],
		["cjs", "application/node"],
		["cla", "application/vnd.claymore"],
		["class", "application/octet-stream"],
		["clkk", "application/vnd.crick.clicker.keyboard"],
		["clkp", "application/vnd.crick.clicker.palette"],
		["clkt", "application/vnd.crick.clicker.template"],
		["clkw", "application/vnd.crick.clicker.wordbank"],
		["clkx", "application/vnd.crick.clicker"],
		["clp", "application/x-msclip"],
		["cmc", "application/vnd.cosmocaller"],
		["cmdf", "chemical/x-cmdf"],
		["cml", "chemical/x-cml"],
		["cmp", "application/vnd.yellowriver-custom-menu"],
		["cmx", "image/x-cmx"],
		["cod", "application/vnd.rim.cod"],
		["coffee", "text/coffeescript"],
		["com", "application/x-msdownload"],
		["conf", "text/plain"],
		["cpio", "application/x-cpio"],
		["cpp", "text/x-c"],
		["cpt", "application/mac-compactpro"],
		["crd", "application/x-mscardfile"],
		["crl", "application/pkix-crl"],
		["crt", "application/x-x509-ca-cert"],
		["crx", "application/x-chrome-extension"],
		["cryptonote", "application/vnd.rig.cryptonote"],
		["csh", "application/x-csh"],
		["csl", "application/vnd.citationstyles.style+xml"],
		["csml", "chemical/x-csml"],
		["csp", "application/vnd.commonspace"],
		["csr", "application/octet-stream"],
		["css", "text/css"],
		["cst", "application/x-director"],
		["csv", "text/csv"],
		["cu", "application/cu-seeme"],
		["curl", "text/vnd.curl"],
		["cww", "application/prs.cww"],
		["cxt", "application/x-director"],
		["cxx", "text/x-c"],
		["dae", "model/vnd.collada+xml"],
		["daf", "application/vnd.mobius.daf"],
		["dart", "application/vnd.dart"],
		["dataless", "application/vnd.fdsn.seed"],
		["davmount", "application/davmount+xml"],
		["dbf", "application/vnd.dbf"],
		["dbk", "application/docbook+xml"],
		["dcr", "application/x-director"],
		["dcurl", "text/vnd.curl.dcurl"],
		["dd2", "application/vnd.oma.dd2+xml"],
		["ddd", "application/vnd.fujixerox.ddd"],
		["ddf", "application/vnd.syncml.dmddf+xml"],
		["dds", "image/vnd.ms-dds"],
		["deb", "application/x-debian-package"],
		["def", "text/plain"],
		["deploy", "application/octet-stream"],
		["der", "application/x-x509-ca-cert"],
		["dfac", "application/vnd.dreamfactory"],
		["dgc", "application/x-dgc-compressed"],
		["dic", "text/x-c"],
		["dir", "application/x-director"],
		["dis", "application/vnd.mobius.dis"],
		["disposition-notification", "message/disposition-notification"],
		["dist", "application/octet-stream"],
		["distz", "application/octet-stream"],
		["djv", "image/vnd.djvu"],
		["djvu", "image/vnd.djvu"],
		["dll", "application/octet-stream"],
		["dmg", "application/x-apple-diskimage"],
		["dmn", "application/octet-stream"],
		["dmp", "application/vnd.tcpdump.pcap"],
		["dms", "application/octet-stream"],
		["dna", "application/vnd.dna"],
		["doc", "application/msword"],
		["docm", "application/vnd.ms-word.template.macroEnabled.12"],
		["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
		["dot", "application/msword"],
		["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
		["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
		["dp", "application/vnd.osgi.dp"],
		["dpg", "application/vnd.dpgraph"],
		["dra", "audio/vnd.dra"],
		["drle", "image/dicom-rle"],
		["dsc", "text/prs.lines.tag"],
		["dssc", "application/dssc+der"],
		["dtb", "application/x-dtbook+xml"],
		["dtd", "application/xml-dtd"],
		["dts", "audio/vnd.dts"],
		["dtshd", "audio/vnd.dts.hd"],
		["dump", "application/octet-stream"],
		["dvb", "video/vnd.dvb.file"],
		["dvi", "application/x-dvi"],
		["dwd", "application/atsc-dwd+xml"],
		["dwf", "model/vnd.dwf"],
		["dwg", "image/vnd.dwg"],
		["dxf", "image/vnd.dxf"],
		["dxp", "application/vnd.spotfire.dxp"],
		["dxr", "application/x-director"],
		["ear", "application/java-archive"],
		["ecelp4800", "audio/vnd.nuera.ecelp4800"],
		["ecelp7470", "audio/vnd.nuera.ecelp7470"],
		["ecelp9600", "audio/vnd.nuera.ecelp9600"],
		["ecma", "application/ecmascript"],
		["edm", "application/vnd.novadigm.edm"],
		["edx", "application/vnd.novadigm.edx"],
		["efif", "application/vnd.picsel"],
		["ei6", "application/vnd.pg.osasli"],
		["elc", "application/octet-stream"],
		["emf", "image/emf"],
		["eml", "message/rfc822"],
		["emma", "application/emma+xml"],
		["emotionml", "application/emotionml+xml"],
		["emz", "application/x-msmetafile"],
		["eol", "audio/vnd.digital-winds"],
		["eot", "application/vnd.ms-fontobject"],
		["eps", "application/postscript"],
		["epub", "application/epub+zip"],
		["es", "application/ecmascript"],
		["es3", "application/vnd.eszigno3+xml"],
		["esa", "application/vnd.osgi.subsystem"],
		["esf", "application/vnd.epson.esf"],
		["et3", "application/vnd.eszigno3+xml"],
		["etx", "text/x-setext"],
		["eva", "application/x-eva"],
		["evy", "application/x-envoy"],
		["exe", "application/octet-stream"],
		["exi", "application/exi"],
		["exp", "application/express"],
		["exr", "image/aces"],
		["ext", "application/vnd.novadigm.ext"],
		["ez", "application/andrew-inset"],
		["ez2", "application/vnd.ezpix-album"],
		["ez3", "application/vnd.ezpix-package"],
		["f", "text/x-fortran"],
		["f4v", "video/mp4"],
		["f77", "text/x-fortran"],
		["f90", "text/x-fortran"],
		["fbs", "image/vnd.fastbidsheet"],
		["fcdt", "application/vnd.adobe.formscentral.fcdt"],
		["fcs", "application/vnd.isac.fcs"],
		["fdf", "application/vnd.fdf"],
		["fdt", "application/fdt+xml"],
		["fe_launch", "application/vnd.denovo.fcselayout-link"],
		["fg5", "application/vnd.fujitsu.oasysgp"],
		["fgd", "application/x-director"],
		["fh", "image/x-freehand"],
		["fh4", "image/x-freehand"],
		["fh5", "image/x-freehand"],
		["fh7", "image/x-freehand"],
		["fhc", "image/x-freehand"],
		["fig", "application/x-xfig"],
		["fits", "image/fits"],
		["flac", "audio/x-flac"],
		["fli", "video/x-fli"],
		["flo", "application/vnd.micrografx.flo"],
		["flv", "video/x-flv"],
		["flw", "application/vnd.kde.kivio"],
		["flx", "text/vnd.fmi.flexstor"],
		["fly", "text/vnd.fly"],
		["fm", "application/vnd.framemaker"],
		["fnc", "application/vnd.frogans.fnc"],
		["fo", "application/vnd.software602.filler.form+xml"],
		["for", "text/x-fortran"],
		["fpx", "image/vnd.fpx"],
		["frame", "application/vnd.framemaker"],
		["fsc", "application/vnd.fsc.weblaunch"],
		["fst", "image/vnd.fst"],
		["ftc", "application/vnd.fluxtime.clip"],
		["fti", "application/vnd.anser-web-funds-transfer-initiation"],
		["fvt", "video/vnd.fvt"],
		["fxp", "application/vnd.adobe.fxp"],
		["fxpl", "application/vnd.adobe.fxp"],
		["fzs", "application/vnd.fuzzysheet"],
		["g2w", "application/vnd.geoplan"],
		["g3", "image/g3fax"],
		["g3w", "application/vnd.geospace"],
		["gac", "application/vnd.groove-account"],
		["gam", "application/x-tads"],
		["gbr", "application/rpki-ghostbusters"],
		["gca", "application/x-gca-compressed"],
		["gdl", "model/vnd.gdl"],
		["gdoc", "application/vnd.google-apps.document"],
		["geo", "application/vnd.dynageo"],
		["geojson", "application/geo+json"],
		["gex", "application/vnd.geometry-explorer"],
		["ggb", "application/vnd.geogebra.file"],
		["ggt", "application/vnd.geogebra.tool"],
		["ghf", "application/vnd.groove-help"],
		["gif", "image/gif"],
		["gim", "application/vnd.groove-identity-message"],
		["glb", "model/gltf-binary"],
		["gltf", "model/gltf+json"],
		["gml", "application/gml+xml"],
		["gmx", "application/vnd.gmx"],
		["gnumeric", "application/x-gnumeric"],
		["gpg", "application/gpg-keys"],
		["gph", "application/vnd.flographit"],
		["gpx", "application/gpx+xml"],
		["gqf", "application/vnd.grafeq"],
		["gqs", "application/vnd.grafeq"],
		["gram", "application/srgs"],
		["gramps", "application/x-gramps-xml"],
		["gre", "application/vnd.geometry-explorer"],
		["grv", "application/vnd.groove-injector"],
		["grxml", "application/srgs+xml"],
		["gsf", "application/x-font-ghostscript"],
		["gsheet", "application/vnd.google-apps.spreadsheet"],
		["gslides", "application/vnd.google-apps.presentation"],
		["gtar", "application/x-gtar"],
		["gtm", "application/vnd.groove-tool-message"],
		["gtw", "model/vnd.gtw"],
		["gv", "text/vnd.graphviz"],
		["gxf", "application/gxf"],
		["gxt", "application/vnd.geonext"],
		["gz", "application/gzip"],
		["gzip", "application/gzip"],
		["h", "text/x-c"],
		["h261", "video/h261"],
		["h263", "video/h263"],
		["h264", "video/h264"],
		["hal", "application/vnd.hal+xml"],
		["hbci", "application/vnd.hbci"],
		["hbs", "text/x-handlebars-template"],
		["hdd", "application/x-virtualbox-hdd"],
		["hdf", "application/x-hdf"],
		["heic", "image/heic"],
		["heics", "image/heic-sequence"],
		["heif", "image/heif"],
		["heifs", "image/heif-sequence"],
		["hej2", "image/hej2k"],
		["held", "application/atsc-held+xml"],
		["hh", "text/x-c"],
		["hjson", "application/hjson"],
		["hlp", "application/winhlp"],
		["hpgl", "application/vnd.hp-hpgl"],
		["hpid", "application/vnd.hp-hpid"],
		["hps", "application/vnd.hp-hps"],
		["hqx", "application/mac-binhex40"],
		["hsj2", "image/hsj2"],
		["htc", "text/x-component"],
		["htke", "application/vnd.kenameaapp"],
		["htm", "text/html"],
		["html", "text/html"],
		["hvd", "application/vnd.yamaha.hv-dic"],
		["hvp", "application/vnd.yamaha.hv-voice"],
		["hvs", "application/vnd.yamaha.hv-script"],
		["i2g", "application/vnd.intergeo"],
		["icc", "application/vnd.iccprofile"],
		["ice", "x-conference/x-cooltalk"],
		["icm", "application/vnd.iccprofile"],
		["ico", "image/x-icon"],
		["ics", "text/calendar"],
		["ief", "image/ief"],
		["ifb", "text/calendar"],
		["ifm", "application/vnd.shana.informed.formdata"],
		["iges", "model/iges"],
		["igl", "application/vnd.igloader"],
		["igm", "application/vnd.insors.igm"],
		["igs", "model/iges"],
		["igx", "application/vnd.micrografx.igx"],
		["iif", "application/vnd.shana.informed.interchange"],
		["img", "application/octet-stream"],
		["imp", "application/vnd.accpac.simply.imp"],
		["ims", "application/vnd.ms-ims"],
		["in", "text/plain"],
		["ini", "text/plain"],
		["ink", "application/inkml+xml"],
		["inkml", "application/inkml+xml"],
		["install", "application/x-install-instructions"],
		["iota", "application/vnd.astraea-software.iota"],
		["ipfix", "application/ipfix"],
		["ipk", "application/vnd.shana.informed.package"],
		["irm", "application/vnd.ibm.rights-management"],
		["irp", "application/vnd.irepository.package+xml"],
		["iso", "application/x-iso9660-image"],
		["itp", "application/vnd.shana.informed.formtemplate"],
		["its", "application/its+xml"],
		["ivp", "application/vnd.immervision-ivp"],
		["ivu", "application/vnd.immervision-ivu"],
		["jad", "text/vnd.sun.j2me.app-descriptor"],
		["jade", "text/jade"],
		["jam", "application/vnd.jam"],
		["jar", "application/java-archive"],
		["jardiff", "application/x-java-archive-diff"],
		["java", "text/x-java-source"],
		["jhc", "image/jphc"],
		["jisp", "application/vnd.jisp"],
		["jls", "image/jls"],
		["jlt", "application/vnd.hp-jlyt"],
		["jng", "image/x-jng"],
		["jnlp", "application/x-java-jnlp-file"],
		["joda", "application/vnd.joost.joda-archive"],
		["jp2", "image/jp2"],
		["jpe", "image/jpeg"],
		["jpeg", "image/jpeg"],
		["jpf", "image/jpx"],
		["jpg", "image/jpeg"],
		["jpg2", "image/jp2"],
		["jpgm", "video/jpm"],
		["jpgv", "video/jpeg"],
		["jph", "image/jph"],
		["jpm", "video/jpm"],
		["jpx", "image/jpx"],
		["js", "application/javascript"],
		["json", "application/json"],
		["json5", "application/json5"],
		["jsonld", "application/ld+json"],
		["jsonl", "application/jsonl"],
		["jsonml", "application/jsonml+json"],
		["jsx", "text/jsx"],
		["jxr", "image/jxr"],
		["jxra", "image/jxra"],
		["jxrs", "image/jxrs"],
		["jxs", "image/jxs"],
		["jxsc", "image/jxsc"],
		["jxsi", "image/jxsi"],
		["jxss", "image/jxss"],
		["kar", "audio/midi"],
		["karbon", "application/vnd.kde.karbon"],
		["kdb", "application/octet-stream"],
		["kdbx", "application/x-keepass2"],
		["key", "application/x-iwork-keynote-sffkey"],
		["kfo", "application/vnd.kde.kformula"],
		["kia", "application/vnd.kidspiration"],
		["kml", "application/vnd.google-earth.kml+xml"],
		["kmz", "application/vnd.google-earth.kmz"],
		["kne", "application/vnd.kinar"],
		["knp", "application/vnd.kinar"],
		["kon", "application/vnd.kde.kontour"],
		["kpr", "application/vnd.kde.kpresenter"],
		["kpt", "application/vnd.kde.kpresenter"],
		["kpxx", "application/vnd.ds-keypoint"],
		["ksp", "application/vnd.kde.kspread"],
		["ktr", "application/vnd.kahootz"],
		["ktx", "image/ktx"],
		["ktx2", "image/ktx2"],
		["ktz", "application/vnd.kahootz"],
		["kwd", "application/vnd.kde.kword"],
		["kwt", "application/vnd.kde.kword"],
		["lasxml", "application/vnd.las.las+xml"],
		["latex", "application/x-latex"],
		["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
		["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
		["les", "application/vnd.hhe.lesson-player"],
		["less", "text/less"],
		["lgr", "application/lgr+xml"],
		["lha", "application/octet-stream"],
		["link66", "application/vnd.route66.link66+xml"],
		["list", "text/plain"],
		["list3820", "application/vnd.ibm.modcap"],
		["listafp", "application/vnd.ibm.modcap"],
		["litcoffee", "text/coffeescript"],
		["lnk", "application/x-ms-shortcut"],
		["log", "text/plain"],
		["lostxml", "application/lost+xml"],
		["lrf", "application/octet-stream"],
		["lrm", "application/vnd.ms-lrm"],
		["ltf", "application/vnd.frogans.ltf"],
		["lua", "text/x-lua"],
		["luac", "application/x-lua-bytecode"],
		["lvp", "audio/vnd.lucent.voice"],
		["lwp", "application/vnd.lotus-wordpro"],
		["lzh", "application/octet-stream"],
		["m1v", "video/mpeg"],
		["m2a", "audio/mpeg"],
		["m2v", "video/mpeg"],
		["m3a", "audio/mpeg"],
		["m3u", "text/plain"],
		["m3u8", "application/vnd.apple.mpegurl"],
		["m4a", "audio/x-m4a"],
		["m4p", "application/mp4"],
		["m4s", "video/iso.segment"],
		["m4u", "application/vnd.mpegurl"],
		["m4v", "video/x-m4v"],
		["m13", "application/x-msmediaview"],
		["m14", "application/x-msmediaview"],
		["m21", "application/mp21"],
		["ma", "application/mathematica"],
		["mads", "application/mads+xml"],
		["maei", "application/mmt-aei+xml"],
		["mag", "application/vnd.ecowin.chart"],
		["maker", "application/vnd.framemaker"],
		["man", "text/troff"],
		["manifest", "text/cache-manifest"],
		["map", "application/json"],
		["mar", "application/octet-stream"],
		["markdown", "text/markdown"],
		["mathml", "application/mathml+xml"],
		["mb", "application/mathematica"],
		["mbk", "application/vnd.mobius.mbk"],
		["mbox", "application/mbox"],
		["mc1", "application/vnd.medcalcdata"],
		["mcd", "application/vnd.mcd"],
		["mcurl", "text/vnd.curl.mcurl"],
		["md", "text/markdown"],
		["mdb", "application/x-msaccess"],
		["mdi", "image/vnd.ms-modi"],
		["mdx", "text/mdx"],
		["me", "text/troff"],
		["mesh", "model/mesh"],
		["meta4", "application/metalink4+xml"],
		["metalink", "application/metalink+xml"],
		["mets", "application/mets+xml"],
		["mfm", "application/vnd.mfmp"],
		["mft", "application/rpki-manifest"],
		["mgp", "application/vnd.osgeo.mapguide.package"],
		["mgz", "application/vnd.proteus.magazine"],
		["mid", "audio/midi"],
		["midi", "audio/midi"],
		["mie", "application/x-mie"],
		["mif", "application/vnd.mif"],
		["mime", "message/rfc822"],
		["mj2", "video/mj2"],
		["mjp2", "video/mj2"],
		["mjs", "application/javascript"],
		["mk3d", "video/x-matroska"],
		["mka", "audio/x-matroska"],
		["mkd", "text/x-markdown"],
		["mks", "video/x-matroska"],
		["mkv", "video/x-matroska"],
		["mlp", "application/vnd.dolby.mlp"],
		["mmd", "application/vnd.chipnuts.karaoke-mmd"],
		["mmf", "application/vnd.smaf"],
		["mml", "text/mathml"],
		["mmr", "image/vnd.fujixerox.edmics-mmr"],
		["mng", "video/x-mng"],
		["mny", "application/x-msmoney"],
		["mobi", "application/x-mobipocket-ebook"],
		["mods", "application/mods+xml"],
		["mov", "video/quicktime"],
		["movie", "video/x-sgi-movie"],
		["mp2", "audio/mpeg"],
		["mp2a", "audio/mpeg"],
		["mp3", "audio/mpeg"],
		["mp4", "video/mp4"],
		["mp4a", "audio/mp4"],
		["mp4s", "application/mp4"],
		["mp4v", "video/mp4"],
		["mp21", "application/mp21"],
		["mpc", "application/vnd.mophun.certificate"],
		["mpd", "application/dash+xml"],
		["mpe", "video/mpeg"],
		["mpeg", "video/mpeg"],
		["mpg", "video/mpeg"],
		["mpg4", "video/mp4"],
		["mpga", "audio/mpeg"],
		["mpkg", "application/vnd.apple.installer+xml"],
		["mpm", "application/vnd.blueice.multipass"],
		["mpn", "application/vnd.mophun.application"],
		["mpp", "application/vnd.ms-project"],
		["mpt", "application/vnd.ms-project"],
		["mpy", "application/vnd.ibm.minipay"],
		["mqy", "application/vnd.mobius.mqy"],
		["mrc", "application/marc"],
		["mrcx", "application/marcxml+xml"],
		["ms", "text/troff"],
		["mscml", "application/mediaservercontrol+xml"],
		["mseed", "application/vnd.fdsn.mseed"],
		["mseq", "application/vnd.mseq"],
		["msf", "application/vnd.epson.msf"],
		["msg", "application/vnd.ms-outlook"],
		["msh", "model/mesh"],
		["msi", "application/x-msdownload"],
		["msl", "application/vnd.mobius.msl"],
		["msm", "application/octet-stream"],
		["msp", "application/octet-stream"],
		["msty", "application/vnd.muvee.style"],
		["mtl", "model/mtl"],
		["mts", "model/vnd.mts"],
		["mus", "application/vnd.musician"],
		["musd", "application/mmt-usd+xml"],
		["musicxml", "application/vnd.recordare.musicxml+xml"],
		["mvb", "application/x-msmediaview"],
		["mvt", "application/vnd.mapbox-vector-tile"],
		["mwf", "application/vnd.mfer"],
		["mxf", "application/mxf"],
		["mxl", "application/vnd.recordare.musicxml"],
		["mxmf", "audio/mobile-xmf"],
		["mxml", "application/xv+xml"],
		["mxs", "application/vnd.triscape.mxs"],
		["mxu", "video/vnd.mpegurl"],
		["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
		["n3", "text/n3"],
		["nb", "application/mathematica"],
		["nbp", "application/vnd.wolfram.player"],
		["nc", "application/x-netcdf"],
		["ncx", "application/x-dtbncx+xml"],
		["nfo", "text/x-nfo"],
		["ngdat", "application/vnd.nokia.n-gage.data"],
		["nitf", "application/vnd.nitf"],
		["nlu", "application/vnd.neurolanguage.nlu"],
		["nml", "application/vnd.enliven"],
		["nnd", "application/vnd.noblenet-directory"],
		["nns", "application/vnd.noblenet-sealer"],
		["nnw", "application/vnd.noblenet-web"],
		["npx", "image/vnd.net-fpx"],
		["nq", "application/n-quads"],
		["nsc", "application/x-conference"],
		["nsf", "application/vnd.lotus-notes"],
		["nt", "application/n-triples"],
		["ntf", "application/vnd.nitf"],
		["numbers", "application/x-iwork-numbers-sffnumbers"],
		["nzb", "application/x-nzb"],
		["oa2", "application/vnd.fujitsu.oasys2"],
		["oa3", "application/vnd.fujitsu.oasys3"],
		["oas", "application/vnd.fujitsu.oasys"],
		["obd", "application/x-msbinder"],
		["obgx", "application/vnd.openblox.game+xml"],
		["obj", "model/obj"],
		["oda", "application/oda"],
		["odb", "application/vnd.oasis.opendocument.database"],
		["odc", "application/vnd.oasis.opendocument.chart"],
		["odf", "application/vnd.oasis.opendocument.formula"],
		["odft", "application/vnd.oasis.opendocument.formula-template"],
		["odg", "application/vnd.oasis.opendocument.graphics"],
		["odi", "application/vnd.oasis.opendocument.image"],
		["odm", "application/vnd.oasis.opendocument.text-master"],
		["odp", "application/vnd.oasis.opendocument.presentation"],
		["ods", "application/vnd.oasis.opendocument.spreadsheet"],
		["odt", "application/vnd.oasis.opendocument.text"],
		["oga", "audio/ogg"],
		["ogex", "model/vnd.opengex"],
		["ogg", "audio/ogg"],
		["ogv", "video/ogg"],
		["ogx", "application/ogg"],
		["omdoc", "application/omdoc+xml"],
		["onepkg", "application/onenote"],
		["onetmp", "application/onenote"],
		["onetoc", "application/onenote"],
		["onetoc2", "application/onenote"],
		["opf", "application/oebps-package+xml"],
		["opml", "text/x-opml"],
		["oprc", "application/vnd.palm"],
		["opus", "audio/ogg"],
		["org", "text/x-org"],
		["osf", "application/vnd.yamaha.openscoreformat"],
		["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
		["osm", "application/vnd.openstreetmap.data+xml"],
		["otc", "application/vnd.oasis.opendocument.chart-template"],
		["otf", "font/otf"],
		["otg", "application/vnd.oasis.opendocument.graphics-template"],
		["oth", "application/vnd.oasis.opendocument.text-web"],
		["oti", "application/vnd.oasis.opendocument.image-template"],
		["otp", "application/vnd.oasis.opendocument.presentation-template"],
		["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
		["ott", "application/vnd.oasis.opendocument.text-template"],
		["ova", "application/x-virtualbox-ova"],
		["ovf", "application/x-virtualbox-ovf"],
		["owl", "application/rdf+xml"],
		["oxps", "application/oxps"],
		["oxt", "application/vnd.openofficeorg.extension"],
		["p", "text/x-pascal"],
		["p7a", "application/x-pkcs7-signature"],
		["p7b", "application/x-pkcs7-certificates"],
		["p7c", "application/pkcs7-mime"],
		["p7m", "application/pkcs7-mime"],
		["p7r", "application/x-pkcs7-certreqresp"],
		["p7s", "application/pkcs7-signature"],
		["p8", "application/pkcs8"],
		["p10", "application/x-pkcs10"],
		["p12", "application/x-pkcs12"],
		["pac", "application/x-ns-proxy-autoconfig"],
		["pages", "application/x-iwork-pages-sffpages"],
		["pas", "text/x-pascal"],
		["paw", "application/vnd.pawaafile"],
		["pbd", "application/vnd.powerbuilder6"],
		["pbm", "image/x-portable-bitmap"],
		["pcap", "application/vnd.tcpdump.pcap"],
		["pcf", "application/x-font-pcf"],
		["pcl", "application/vnd.hp-pcl"],
		["pclxl", "application/vnd.hp-pclxl"],
		["pct", "image/x-pict"],
		["pcurl", "application/vnd.curl.pcurl"],
		["pcx", "image/x-pcx"],
		["pdb", "application/x-pilot"],
		["pde", "text/x-processing"],
		["pdf", "application/pdf"],
		["pem", "application/x-x509-user-cert"],
		["pfa", "application/x-font-type1"],
		["pfb", "application/x-font-type1"],
		["pfm", "application/x-font-type1"],
		["pfr", "application/font-tdpfr"],
		["pfx", "application/x-pkcs12"],
		["pgm", "image/x-portable-graymap"],
		["pgn", "application/x-chess-pgn"],
		["pgp", "application/pgp"],
		["php", "application/x-httpd-php"],
		["php3", "application/x-httpd-php"],
		["php4", "application/x-httpd-php"],
		["phps", "application/x-httpd-php-source"],
		["phtml", "application/x-httpd-php"],
		["pic", "image/x-pict"],
		["pkg", "application/octet-stream"],
		["pki", "application/pkixcmp"],
		["pkipath", "application/pkix-pkipath"],
		["pkpass", "application/vnd.apple.pkpass"],
		["pl", "application/x-perl"],
		["plb", "application/vnd.3gpp.pic-bw-large"],
		["plc", "application/vnd.mobius.plc"],
		["plf", "application/vnd.pocketlearn"],
		["pls", "application/pls+xml"],
		["pm", "application/x-perl"],
		["pml", "application/vnd.ctc-posml"],
		["png", "image/png"],
		["pnm", "image/x-portable-anymap"],
		["portpkg", "application/vnd.macports.portpkg"],
		["pot", "application/vnd.ms-powerpoint"],
		["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
		["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
		["ppa", "application/vnd.ms-powerpoint"],
		["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
		["ppd", "application/vnd.cups-ppd"],
		["ppm", "image/x-portable-pixmap"],
		["pps", "application/vnd.ms-powerpoint"],
		["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
		["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
		["ppt", "application/powerpoint"],
		["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
		["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
		["pqa", "application/vnd.palm"],
		["prc", "application/x-pilot"],
		["pre", "application/vnd.lotus-freelance"],
		["prf", "application/pics-rules"],
		["provx", "application/provenance+xml"],
		["ps", "application/postscript"],
		["psb", "application/vnd.3gpp.pic-bw-small"],
		["psd", "application/x-photoshop"],
		["psf", "application/x-font-linux-psf"],
		["pskcxml", "application/pskc+xml"],
		["pti", "image/prs.pti"],
		["ptid", "application/vnd.pvi.ptid1"],
		["pub", "application/x-mspublisher"],
		["pvb", "application/vnd.3gpp.pic-bw-var"],
		["pwn", "application/vnd.3m.post-it-notes"],
		["pya", "audio/vnd.ms-playready.media.pya"],
		["pyv", "video/vnd.ms-playready.media.pyv"],
		["qam", "application/vnd.epson.quickanime"],
		["qbo", "application/vnd.intu.qbo"],
		["qfx", "application/vnd.intu.qfx"],
		["qps", "application/vnd.publishare-delta-tree"],
		["qt", "video/quicktime"],
		["qwd", "application/vnd.quark.quarkxpress"],
		["qwt", "application/vnd.quark.quarkxpress"],
		["qxb", "application/vnd.quark.quarkxpress"],
		["qxd", "application/vnd.quark.quarkxpress"],
		["qxl", "application/vnd.quark.quarkxpress"],
		["qxt", "application/vnd.quark.quarkxpress"],
		["ra", "audio/x-realaudio"],
		["ram", "audio/x-pn-realaudio"],
		["raml", "application/raml+yaml"],
		["rapd", "application/route-apd+xml"],
		["rar", "application/x-rar"],
		["ras", "image/x-cmu-raster"],
		["rcprofile", "application/vnd.ipunplugged.rcprofile"],
		["rdf", "application/rdf+xml"],
		["rdz", "application/vnd.data-vision.rdz"],
		["relo", "application/p2p-overlay+xml"],
		["rep", "application/vnd.businessobjects"],
		["res", "application/x-dtbresource+xml"],
		["rgb", "image/x-rgb"],
		["rif", "application/reginfo+xml"],
		["rip", "audio/vnd.rip"],
		["ris", "application/x-research-info-systems"],
		["rl", "application/resource-lists+xml"],
		["rlc", "image/vnd.fujixerox.edmics-rlc"],
		["rld", "application/resource-lists-diff+xml"],
		["rm", "audio/x-pn-realaudio"],
		["rmi", "audio/midi"],
		["rmp", "audio/x-pn-realaudio-plugin"],
		["rms", "application/vnd.jcp.javame.midlet-rms"],
		["rmvb", "application/vnd.rn-realmedia-vbr"],
		["rnc", "application/relax-ng-compact-syntax"],
		["rng", "application/xml"],
		["roa", "application/rpki-roa"],
		["roff", "text/troff"],
		["rp9", "application/vnd.cloanto.rp9"],
		["rpm", "audio/x-pn-realaudio-plugin"],
		["rpss", "application/vnd.nokia.radio-presets"],
		["rpst", "application/vnd.nokia.radio-preset"],
		["rq", "application/sparql-query"],
		["rs", "application/rls-services+xml"],
		["rsa", "application/x-pkcs7"],
		["rsat", "application/atsc-rsat+xml"],
		["rsd", "application/rsd+xml"],
		["rsheet", "application/urc-ressheet+xml"],
		["rss", "application/rss+xml"],
		["rtf", "text/rtf"],
		["rtx", "text/richtext"],
		["run", "application/x-makeself"],
		["rusd", "application/route-usd+xml"],
		["rv", "video/vnd.rn-realvideo"],
		["s", "text/x-asm"],
		["s3m", "audio/s3m"],
		["saf", "application/vnd.yamaha.smaf-audio"],
		["sass", "text/x-sass"],
		["sbml", "application/sbml+xml"],
		["sc", "application/vnd.ibm.secure-container"],
		["scd", "application/x-msschedule"],
		["scm", "application/vnd.lotus-screencam"],
		["scq", "application/scvp-cv-request"],
		["scs", "application/scvp-cv-response"],
		["scss", "text/x-scss"],
		["scurl", "text/vnd.curl.scurl"],
		["sda", "application/vnd.stardivision.draw"],
		["sdc", "application/vnd.stardivision.calc"],
		["sdd", "application/vnd.stardivision.impress"],
		["sdkd", "application/vnd.solent.sdkm+xml"],
		["sdkm", "application/vnd.solent.sdkm+xml"],
		["sdp", "application/sdp"],
		["sdw", "application/vnd.stardivision.writer"],
		["sea", "application/octet-stream"],
		["see", "application/vnd.seemail"],
		["seed", "application/vnd.fdsn.seed"],
		["sema", "application/vnd.sema"],
		["semd", "application/vnd.semd"],
		["semf", "application/vnd.semf"],
		["senmlx", "application/senml+xml"],
		["sensmlx", "application/sensml+xml"],
		["ser", "application/java-serialized-object"],
		["setpay", "application/set-payment-initiation"],
		["setreg", "application/set-registration-initiation"],
		["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
		["sfs", "application/vnd.spotfire.sfs"],
		["sfv", "text/x-sfv"],
		["sgi", "image/sgi"],
		["sgl", "application/vnd.stardivision.writer-global"],
		["sgm", "text/sgml"],
		["sgml", "text/sgml"],
		["sh", "application/x-sh"],
		["shar", "application/x-shar"],
		["shex", "text/shex"],
		["shf", "application/shf+xml"],
		["shtml", "text/html"],
		["sid", "image/x-mrsid-image"],
		["sieve", "application/sieve"],
		["sig", "application/pgp-signature"],
		["sil", "audio/silk"],
		["silo", "model/mesh"],
		["sis", "application/vnd.symbian.install"],
		["sisx", "application/vnd.symbian.install"],
		["sit", "application/x-stuffit"],
		["sitx", "application/x-stuffitx"],
		["siv", "application/sieve"],
		["skd", "application/vnd.koan"],
		["skm", "application/vnd.koan"],
		["skp", "application/vnd.koan"],
		["skt", "application/vnd.koan"],
		["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
		["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
		["slim", "text/slim"],
		["slm", "text/slim"],
		["sls", "application/route-s-tsid+xml"],
		["slt", "application/vnd.epson.salt"],
		["sm", "application/vnd.stepmania.stepchart"],
		["smf", "application/vnd.stardivision.math"],
		["smi", "application/smil"],
		["smil", "application/smil"],
		["smv", "video/x-smv"],
		["smzip", "application/vnd.stepmania.package"],
		["snd", "audio/basic"],
		["snf", "application/x-font-snf"],
		["so", "application/octet-stream"],
		["spc", "application/x-pkcs7-certificates"],
		["spdx", "text/spdx"],
		["spf", "application/vnd.yamaha.smaf-phrase"],
		["spl", "application/x-futuresplash"],
		["spot", "text/vnd.in3d.spot"],
		["spp", "application/scvp-vp-response"],
		["spq", "application/scvp-vp-request"],
		["spx", "audio/ogg"],
		["sql", "application/x-sql"],
		["src", "application/x-wais-source"],
		["srt", "application/x-subrip"],
		["sru", "application/sru+xml"],
		["srx", "application/sparql-results+xml"],
		["ssdl", "application/ssdl+xml"],
		["sse", "application/vnd.kodak-descriptor"],
		["ssf", "application/vnd.epson.ssf"],
		["ssml", "application/ssml+xml"],
		["sst", "application/octet-stream"],
		["st", "application/vnd.sailingtracker.track"],
		["stc", "application/vnd.sun.xml.calc.template"],
		["std", "application/vnd.sun.xml.draw.template"],
		["stf", "application/vnd.wt.stf"],
		["sti", "application/vnd.sun.xml.impress.template"],
		["stk", "application/hyperstudio"],
		["stl", "model/stl"],
		["stpx", "model/step+xml"],
		["stpxz", "model/step-xml+zip"],
		["stpz", "model/step+zip"],
		["str", "application/vnd.pg.format"],
		["stw", "application/vnd.sun.xml.writer.template"],
		["styl", "text/stylus"],
		["stylus", "text/stylus"],
		["sub", "text/vnd.dvb.subtitle"],
		["sus", "application/vnd.sus-calendar"],
		["susp", "application/vnd.sus-calendar"],
		["sv4cpio", "application/x-sv4cpio"],
		["sv4crc", "application/x-sv4crc"],
		["svc", "application/vnd.dvb.service"],
		["svd", "application/vnd.svd"],
		["svg", "image/svg+xml"],
		["svgz", "image/svg+xml"],
		["swa", "application/x-director"],
		["swf", "application/x-shockwave-flash"],
		["swi", "application/vnd.aristanetworks.swi"],
		["swidtag", "application/swid+xml"],
		["sxc", "application/vnd.sun.xml.calc"],
		["sxd", "application/vnd.sun.xml.draw"],
		["sxg", "application/vnd.sun.xml.writer.global"],
		["sxi", "application/vnd.sun.xml.impress"],
		["sxm", "application/vnd.sun.xml.math"],
		["sxw", "application/vnd.sun.xml.writer"],
		["t", "text/troff"],
		["t3", "application/x-t3vm-image"],
		["t38", "image/t38"],
		["taglet", "application/vnd.mynfc"],
		["tao", "application/vnd.tao.intent-module-archive"],
		["tap", "image/vnd.tencent.tap"],
		["tar", "application/x-tar"],
		["tcap", "application/vnd.3gpp2.tcap"],
		["tcl", "application/x-tcl"],
		["td", "application/urc-targetdesc+xml"],
		["teacher", "application/vnd.smart.teacher"],
		["tei", "application/tei+xml"],
		["teicorpus", "application/tei+xml"],
		["tex", "application/x-tex"],
		["texi", "application/x-texinfo"],
		["texinfo", "application/x-texinfo"],
		["text", "text/plain"],
		["tfi", "application/thraud+xml"],
		["tfm", "application/x-tex-tfm"],
		["tfx", "image/tiff-fx"],
		["tga", "image/x-tga"],
		["tgz", "application/x-tar"],
		["thmx", "application/vnd.ms-officetheme"],
		["tif", "image/tiff"],
		["tiff", "image/tiff"],
		["tk", "application/x-tcl"],
		["tmo", "application/vnd.tmobile-livetv"],
		["toml", "application/toml"],
		["torrent", "application/x-bittorrent"],
		["tpl", "application/vnd.groove-tool-template"],
		["tpt", "application/vnd.trid.tpt"],
		["tr", "text/troff"],
		["tra", "application/vnd.trueapp"],
		["trig", "application/trig"],
		["trm", "application/x-msterminal"],
		["ts", "video/mp2t"],
		["tsd", "application/timestamped-data"],
		["tsv", "text/tab-separated-values"],
		["ttc", "font/collection"],
		["ttf", "font/ttf"],
		["ttl", "text/turtle"],
		["ttml", "application/ttml+xml"],
		["twd", "application/vnd.simtech-mindmapper"],
		["twds", "application/vnd.simtech-mindmapper"],
		["txd", "application/vnd.genomatix.tuxedo"],
		["txf", "application/vnd.mobius.txf"],
		["txt", "text/plain"],
		["u8dsn", "message/global-delivery-status"],
		["u8hdr", "message/global-headers"],
		["u8mdn", "message/global-disposition-notification"],
		["u8msg", "message/global"],
		["u32", "application/x-authorware-bin"],
		["ubj", "application/ubjson"],
		["udeb", "application/x-debian-package"],
		["ufd", "application/vnd.ufdl"],
		["ufdl", "application/vnd.ufdl"],
		["ulx", "application/x-glulx"],
		["umj", "application/vnd.umajin"],
		["unityweb", "application/vnd.unity"],
		["uoml", "application/vnd.uoml+xml"],
		["uri", "text/uri-list"],
		["uris", "text/uri-list"],
		["urls", "text/uri-list"],
		["usdz", "model/vnd.usdz+zip"],
		["ustar", "application/x-ustar"],
		["utz", "application/vnd.uiq.theme"],
		["uu", "text/x-uuencode"],
		["uva", "audio/vnd.dece.audio"],
		["uvd", "application/vnd.dece.data"],
		["uvf", "application/vnd.dece.data"],
		["uvg", "image/vnd.dece.graphic"],
		["uvh", "video/vnd.dece.hd"],
		["uvi", "image/vnd.dece.graphic"],
		["uvm", "video/vnd.dece.mobile"],
		["uvp", "video/vnd.dece.pd"],
		["uvs", "video/vnd.dece.sd"],
		["uvt", "application/vnd.dece.ttml+xml"],
		["uvu", "video/vnd.uvvu.mp4"],
		["uvv", "video/vnd.dece.video"],
		["uvva", "audio/vnd.dece.audio"],
		["uvvd", "application/vnd.dece.data"],
		["uvvf", "application/vnd.dece.data"],
		["uvvg", "image/vnd.dece.graphic"],
		["uvvh", "video/vnd.dece.hd"],
		["uvvi", "image/vnd.dece.graphic"],
		["uvvm", "video/vnd.dece.mobile"],
		["uvvp", "video/vnd.dece.pd"],
		["uvvs", "video/vnd.dece.sd"],
		["uvvt", "application/vnd.dece.ttml+xml"],
		["uvvu", "video/vnd.uvvu.mp4"],
		["uvvv", "video/vnd.dece.video"],
		["uvvx", "application/vnd.dece.unspecified"],
		["uvvz", "application/vnd.dece.zip"],
		["uvx", "application/vnd.dece.unspecified"],
		["uvz", "application/vnd.dece.zip"],
		["vbox", "application/x-virtualbox-vbox"],
		["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
		["vcard", "text/vcard"],
		["vcd", "application/x-cdlink"],
		["vcf", "text/x-vcard"],
		["vcg", "application/vnd.groove-vcard"],
		["vcs", "text/x-vcalendar"],
		["vcx", "application/vnd.vcx"],
		["vdi", "application/x-virtualbox-vdi"],
		["vds", "model/vnd.sap.vds"],
		["vhd", "application/x-virtualbox-vhd"],
		["vis", "application/vnd.visionary"],
		["viv", "video/vnd.vivo"],
		["vlc", "application/videolan"],
		["vmdk", "application/x-virtualbox-vmdk"],
		["vob", "video/x-ms-vob"],
		["vor", "application/vnd.stardivision.writer"],
		["vox", "application/x-authorware-bin"],
		["vrml", "model/vrml"],
		["vsd", "application/vnd.visio"],
		["vsf", "application/vnd.vsf"],
		["vss", "application/vnd.visio"],
		["vst", "application/vnd.visio"],
		["vsw", "application/vnd.visio"],
		["vtf", "image/vnd.valve.source.texture"],
		["vtt", "text/vtt"],
		["vtu", "model/vnd.vtu"],
		["vxml", "application/voicexml+xml"],
		["w3d", "application/x-director"],
		["wad", "application/x-doom"],
		["wadl", "application/vnd.sun.wadl+xml"],
		["war", "application/java-archive"],
		["wasm", "application/wasm"],
		["wav", "audio/x-wav"],
		["wax", "audio/x-ms-wax"],
		["wbmp", "image/vnd.wap.wbmp"],
		["wbs", "application/vnd.criticaltools.wbs+xml"],
		["wbxml", "application/wbxml"],
		["wcm", "application/vnd.ms-works"],
		["wdb", "application/vnd.ms-works"],
		["wdp", "image/vnd.ms-photo"],
		["weba", "audio/webm"],
		["webapp", "application/x-web-app-manifest+json"],
		["webm", "video/webm"],
		["webmanifest", "application/manifest+json"],
		["webp", "image/webp"],
		["wg", "application/vnd.pmi.widget"],
		["wgt", "application/widget"],
		["wks", "application/vnd.ms-works"],
		["wm", "video/x-ms-wm"],
		["wma", "audio/x-ms-wma"],
		["wmd", "application/x-ms-wmd"],
		["wmf", "image/wmf"],
		["wml", "text/vnd.wap.wml"],
		["wmlc", "application/wmlc"],
		["wmls", "text/vnd.wap.wmlscript"],
		["wmlsc", "application/vnd.wap.wmlscriptc"],
		["wmv", "video/x-ms-wmv"],
		["wmx", "video/x-ms-wmx"],
		["wmz", "application/x-msmetafile"],
		["woff", "font/woff"],
		["woff2", "font/woff2"],
		["word", "application/msword"],
		["wpd", "application/vnd.wordperfect"],
		["wpl", "application/vnd.ms-wpl"],
		["wps", "application/vnd.ms-works"],
		["wqd", "application/vnd.wqd"],
		["wri", "application/x-mswrite"],
		["wrl", "model/vrml"],
		["wsc", "message/vnd.wfa.wsc"],
		["wsdl", "application/wsdl+xml"],
		["wspolicy", "application/wspolicy+xml"],
		["wtb", "application/vnd.webturbo"],
		["wvx", "video/x-ms-wvx"],
		["x3d", "model/x3d+xml"],
		["x3db", "model/x3d+fastinfoset"],
		["x3dbz", "model/x3d+binary"],
		["x3dv", "model/x3d-vrml"],
		["x3dvz", "model/x3d+vrml"],
		["x3dz", "model/x3d+xml"],
		["x32", "application/x-authorware-bin"],
		["x_b", "model/vnd.parasolid.transmit.binary"],
		["x_t", "model/vnd.parasolid.transmit.text"],
		["xaml", "application/xaml+xml"],
		["xap", "application/x-silverlight-app"],
		["xar", "application/vnd.xara"],
		["xav", "application/xcap-att+xml"],
		["xbap", "application/x-ms-xbap"],
		["xbd", "application/vnd.fujixerox.docuworks.binder"],
		["xbm", "image/x-xbitmap"],
		["xca", "application/xcap-caps+xml"],
		["xcs", "application/calendar+xml"],
		["xdf", "application/xcap-diff+xml"],
		["xdm", "application/vnd.syncml.dm+xml"],
		["xdp", "application/vnd.adobe.xdp+xml"],
		["xdssc", "application/dssc+xml"],
		["xdw", "application/vnd.fujixerox.docuworks"],
		["xel", "application/xcap-el+xml"],
		["xenc", "application/xenc+xml"],
		["xer", "application/patch-ops-error+xml"],
		["xfdf", "application/vnd.adobe.xfdf"],
		["xfdl", "application/vnd.xfdl"],
		["xht", "application/xhtml+xml"],
		["xhtml", "application/xhtml+xml"],
		["xhvml", "application/xv+xml"],
		["xif", "image/vnd.xiff"],
		["xl", "application/excel"],
		["xla", "application/vnd.ms-excel"],
		["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
		["xlc", "application/vnd.ms-excel"],
		["xlf", "application/xliff+xml"],
		["xlm", "application/vnd.ms-excel"],
		["xls", "application/vnd.ms-excel"],
		["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
		["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
		["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
		["xlt", "application/vnd.ms-excel"],
		["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
		["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
		["xlw", "application/vnd.ms-excel"],
		["xm", "audio/xm"],
		["xml", "application/xml"],
		["xns", "application/xcap-ns+xml"],
		["xo", "application/vnd.olpc-sugar"],
		["xop", "application/xop+xml"],
		["xpi", "application/x-xpinstall"],
		["xpl", "application/xproc+xml"],
		["xpm", "image/x-xpixmap"],
		["xpr", "application/vnd.is-xpr"],
		["xps", "application/vnd.ms-xpsdocument"],
		["xpw", "application/vnd.intercon.formnet"],
		["xpx", "application/vnd.intercon.formnet"],
		["xsd", "application/xml"],
		["xsl", "application/xml"],
		["xslt", "application/xslt+xml"],
		["xsm", "application/vnd.syncml+xml"],
		["xspf", "application/xspf+xml"],
		["xul", "application/vnd.mozilla.xul+xml"],
		["xvm", "application/xv+xml"],
		["xvml", "application/xv+xml"],
		["xwd", "image/x-xwindowdump"],
		["xyz", "chemical/x-xyz"],
		["xz", "application/x-xz"],
		["yaml", "text/yaml"],
		["yang", "application/yang"],
		["yin", "application/yin+xml"],
		["yml", "text/yaml"],
		["ymp", "text/x-suse-ymp"],
		["z", "application/x-compress"],
		["z1", "application/x-zmachine"],
		["z2", "application/x-zmachine"],
		["z3", "application/x-zmachine"],
		["z4", "application/x-zmachine"],
		["z5", "application/x-zmachine"],
		["z6", "application/x-zmachine"],
		["z7", "application/x-zmachine"],
		["z8", "application/x-zmachine"],
		["zaz", "application/vnd.zzazz.deck+xml"],
		["zip", "application/zip"],
		["zir", "application/vnd.zul"],
		["zirz", "application/vnd.zul"],
		["zmm", "application/vnd.handheld-entertainment+xml"],
		["zsh", "text/x-scriptzsh"]
	]);
}));
// ../../../node_modules/file-selector/dist/es2015/file-selector.js
function zv(e) {
	return E_(this, void 0, void 0, function* () {
		return Hv(e) && Bv(e.dataTransfer) ? Gv(e.dataTransfer, e.type) : Vv(e) ? Uv(e) : Array.isArray(e) && e.every((e) => "getFile" in e && typeof e.getFile == "function") ? Wv(e) : [];
	});
}
function Bv(e) {
	return Hv(e);
}
function Vv(e) {
	return Hv(e) && Hv(e.target);
}
function Hv(e) {
	return typeof e == "object" && !!e;
}
function Uv(e) {
	return qv(e.target.files).map((e) => Pv(e));
}
function Wv(e) {
	return E_(this, void 0, void 0, function* () {
		return (yield Promise.all(e.map((e) => e.getFile()))).map((e) => Pv(e));
	});
}
function Gv(e, t) {
	return E_(this, void 0, void 0, function* () {
		if (e.items) {
			let n = qv(e.items).filter((e) => e.kind === "file");
			return t === "drop" ? Kv(Yv(yield Promise.all(n.map(Jv)))) : n;
		}
		return Kv(qv(e.files).map((e) => Pv(e)));
	});
}
function Kv(e) {
	return e.filter((e) => ey.indexOf(e.name) === -1);
}
function qv(e) {
	if (e === null) return [];
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		t.push(r);
	}
	return t;
}
function Jv(e) {
	if (typeof e.webkitGetAsEntry != "function") return Xv(e);
	let t = e.webkitGetAsEntry();
	return t && t.isDirectory ? Qv(t) : Xv(e, t);
}
function Yv(e) {
	return e.reduce((e, t) => [...e, ...Array.isArray(t) ? Yv(t) : [t]], []);
}
function Xv(e, t) {
	return E_(this, void 0, void 0, function* () {
		if (globalThis.isSecureContext && typeof e.getAsFileSystemHandle == "function") {
			let t = yield e.getAsFileSystemHandle();
			if (t === null) throw Error(`${e} is not a File`);
			if (t !== void 0) {
				let e = yield t.getFile();
				return e.handle = t, Pv(e);
			}
		}
		let n = e.getAsFile();
		if (!n) throw Error(`${e} is not a File`);
		return Pv(n, t?.fullPath ?? void 0);
	});
}
function Zv(e) {
	return E_(this, void 0, void 0, function* () {
		return e.isDirectory ? Qv(e) : $v(e);
	});
}
function Qv(e) {
	let t = e.createReader();
	return new Promise((e, n) => {
		let r = [];
		function i() {
			t.readEntries((t) => E_(this, void 0, void 0, function* () {
				if (t.length) {
					let e = Promise.all(t.map(Zv));
					r.push(e), i();
				} else try {
					e(yield Promise.all(r));
				} catch (e) {
					n(e);
				}
			}), (e) => {
				n(e);
			});
		}
		i();
	});
}
function $v(e) {
	return E_(this, void 0, void 0, function* () {
		return new Promise((t, n) => {
			e.file((n) => {
				t(Pv(n, e.fullPath));
			}, (e) => {
				n(e);
			});
		});
	});
}
var ey, ty = B((() => {
	D_(), Rv(), ey = [".DS_Store", "Thumbs.db"];
})), ny = B((() => {
	ty();
})), ry = /* @__PURE__ */ V(((e) => {
	e.__esModule = !0, e.default = function(e, t) {
		if (e && t) {
			var n = Array.isArray(t) ? t : t.split(",");
			if (n.length === 0) return !0;
			var r = e.name || "", i = (e.type || "").toLowerCase(), a = i.replace(/\/.*$/, "");
			return n.some(function(e) {
				var t = e.trim().toLowerCase();
				return t.charAt(0) === "." ? r.toLowerCase().endsWith(t) : t.endsWith("/*") ? a === t.replace(/\/.*$/, "") : i === t;
			});
		}
		return !0;
	};
}));
// ../../../node_modules/react-dropzone/dist/es/utils/index.js
function iy(e) {
	return sy(e) || oy(e) || py(e) || ay();
}
function ay() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function oy(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function sy(e) {
	if (Array.isArray(e)) return my(e);
}
function cy(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ly(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? cy(Object(n), !0).forEach(function(t) {
			uy(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cy(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function uy(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function dy(e, t) {
	return gy(e) || hy(e, t) || py(e, t) || fy();
}
function fy() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function py(e, t) {
	if (e) {
		if (typeof e == "string") return my(e, t);
		var n = Object.prototype.toString.call(e).slice(8, -1);
		if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
		if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return my(e, t);
	}
}
function my(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function hy(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r = [], i = !0, a = !1, o, s;
		try {
			for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0);
		} catch (e) {
			a = !0, s = e;
		} finally {
			try {
				!i && n.return != null && n.return();
			} finally {
				if (a) throw s;
			}
		}
		return r;
	}
}
function gy(e) {
	if (Array.isArray(e)) return e;
}
function _y(e) {
	return e.type === "" && typeof e.getAsFile == "function";
}
function vy(e, t) {
	var n = e.type === "application/x-moz-file" || Ly(e, t) || _y(e);
	return [n, n ? null : Hy(t)];
}
function yy(e, t, n) {
	if (by(e.size)) {
		if (by(t) && by(n)) {
			if (e.size > n) return [!1, Uy(n)];
			if (e.size < t) return [!1, Wy(t)];
		} else if (by(t) && e.size < t) return [!1, Wy(t)];
		else if (by(n) && e.size > n) return [!1, Uy(n)];
	}
	return [!0, null];
}
function by(e) {
	return e != null;
}
function xy(e) {
	var t = e.files, n = e.accept, r = e.minSize, i = e.maxSize, a = e.multiple, o = e.maxFiles, s = e.validator;
	return !a && t.length > 1 || a && o >= 1 && t.length > o ? !1 : t.every(function(e) {
		var t = dy(vy(e, n), 1)[0], a = dy(yy(e, r, i), 1)[0], o = s ? s(e) : null;
		return t && a && !o;
	});
}
function Sy(e) {
	return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : e.cancelBubble !== void 0 && e.cancelBubble;
}
function Cy(e) {
	return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(e) {
		return e === "Files" || e === "application/x-moz-file";
	}) : !!e.target && !!e.target.files;
}
function wy(e) {
	e.preventDefault();
}
function Ty(e) {
	return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function Ey(e) {
	return e.indexOf("Edge/") !== -1;
}
function Dy() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
	return Ty(e) || Ey(e);
}
function Oy() {
	var e = [...arguments];
	return function(t) {
		var n = [...arguments].slice(1);
		return e.some(function(e) {
			return !Sy(t) && e && e.apply(void 0, [t].concat(n)), Sy(t);
		});
	};
}
function ky() {
	return "showOpenFilePicker" in window;
}
function Ay(e) {
	return by(e) ? [{
		description: "Files",
		accept: Object.entries(e).filter(function(e) {
			var t = dy(e, 2), n = t[0], r = t[1], i = !0;
			return Py(n) || (console.warn(`Skipped "${n}" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.`), i = !1), Array.isArray(r) && r.every(Fy) || (console.warn(`Skipped "${n}" because an invalid file extension was provided.`), i = !1), i;
		}).reduce(function(e, t) {
			var n = dy(t, 2), r = n[0], i = n[1];
			return ly(ly({}, e), {}, uy({}, r, i));
		}, {})
	}] : e;
}
function jy(e) {
	if (by(e)) return Object.entries(e).reduce(function(e, t) {
		var n = dy(t, 2), r = n[0], i = n[1];
		return [].concat(iy(e), [r], iy(i));
	}, []).filter(function(e) {
		return Py(e) || Fy(e);
	}).join(",");
}
function My(e) {
	return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function Ny(e) {
	return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function Py(e) {
	return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function Fy(e) {
	return /^.*\.[\w]+$/.test(e);
}
var Iy, Ly, Ry, zy, By, Vy, Hy, Uy, Wy, Gy, Ky = B((() => {
	Iy = /* @__PURE__ */ Xe(ry()), Ly = typeof Iy.default == "function" ? Iy.default : Iy.default.default, Ry = "file-invalid-type", zy = "file-too-large", By = "file-too-small", Vy = "too-many-files", Hy = function() {
		var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "").split(","), t = e.length > 1 ? `one of ${e.join(", ")}` : e[0];
		return {
			code: Ry,
			message: `File type must be ${t}`
		};
	}, Uy = function(e) {
		return {
			code: zy,
			message: `File is larger than ${e} ${e === 1 ? "byte" : "bytes"}`
		};
	}, Wy = function(e) {
		return {
			code: By,
			message: `File is smaller than ${e} ${e === 1 ? "byte" : "bytes"}`
		};
	}, Gy = {
		code: Vy,
		message: "Too many files"
	};
}));
// ../../../node_modules/react-dropzone/dist/es/index.js
function qy(e) {
	return Xy(e) || Yy(e) || $y(e) || Jy();
}
function Jy() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Yy(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Xy(e) {
	if (Array.isArray(e)) return eb(e);
}
function Zy(e, t) {
	return nb(e) || tb(e, t) || $y(e, t) || Qy();
}
function Qy() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $y(e, t) {
	if (e) {
		if (typeof e == "string") return eb(e, t);
		var n = Object.prototype.toString.call(e).slice(8, -1);
		if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
		if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return eb(e, t);
	}
}
function eb(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function tb(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r = [], i = !0, a = !1, o, s;
		try {
			for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0);
		} catch (e) {
			a = !0, s = e;
		} finally {
			try {
				!i && n.return != null && n.return();
			} finally {
				if (a) throw s;
			}
		}
		return r;
	}
}
function nb(e) {
	if (Array.isArray(e)) return e;
}
function rb(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Q(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? rb(Object(n), !0).forEach(function(t) {
			ib(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rb(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function ib(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function ab(e, t) {
	if (e == null) return {};
	var n = ob(e, t), r, i;
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (i = 0; i < a.length; i++) r = a[i], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
	}
	return n;
}
function ob(e, t) {
	if (e == null) return {};
	for (var n = {}, r = Object.keys(e), i, a = 0; a < r.length; a++) i = r[a], t.indexOf(i) >= 0 || (n[i] = e[i]);
	return n;
}
function sb() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = Q(Q({}, hb), e), n = t.accept, r = t.disabled, i = t.getFilesFromEvent, a = t.maxSize, o = t.minSize, s = t.multiple, c = t.maxFiles, l = t.onDragEnter, u = t.onDragLeave, d = t.onDragOver, f = t.onDrop, p = t.onDropAccepted, m = t.onDropRejected, h = t.onFileDialogCancel, g = t.onFileDialogOpen, _ = t.useFsAccessApi, v = t.autoFocus, y = t.preventDropOnDocument, b = t.noClick, x = t.noKeyboard, S = t.noDrag, C = t.noDragEventsBubbling, w = t.onError, T = t.validator, E = Te(function() {
		return jy(n);
	}, [n]), D = Te(function() {
		return Ay(n);
	}, [n]), ee = Te(function() {
		return typeof g == "function" ? g : lb;
	}, [g]), te = Te(function() {
		return typeof h == "function" ? h : lb;
	}, [h]), O = F(null), ne = F(null), re = Zy(Ee(cb, gb), 2), ie = re[0], k = re[1], ae = ie.isFocused, oe = ie.isFileDialogActive, se = F(typeof window < "u" && window.isSecureContext && _ && ky()), A = function() {
		!se.current && oe && setTimeout(function() {
			ne.current && (ne.current.files.length || (k({ type: "closeDialog" }), te()));
		}, 300);
	};
	P(function() {
		return window.addEventListener("focus", A, !1), function() {
			window.removeEventListener("focus", A, !1);
		};
	}, [
		ne,
		oe,
		te,
		se
	]);
	var ce = F([]), le = F([]), j = function(e) {
		O.current && O.current.contains(e.target) || (e.preventDefault(), ce.current = []);
	};
	P(function() {
		return y && (document.addEventListener("dragover", wy, !1), document.addEventListener("drop", j, !1)), function() {
			y && (document.removeEventListener("dragover", wy), document.removeEventListener("drop", j));
		};
	}, [O, y]), P(function() {
		var e = function(e) {
			le.current = [].concat(qy(le.current), [e.target]), Cy(e) && k({
				isDragGlobal: !0,
				type: "setDragGlobal"
			});
		}, t = function(e) {
			le.current = le.current.filter(function(t) {
				return t !== e.target && t !== null;
			}), le.current.length > 0 || k({
				isDragGlobal: !1,
				type: "setDragGlobal"
			});
		}, n = function() {
			le.current = [], k({
				isDragGlobal: !1,
				type: "setDragGlobal"
			});
		}, r = function() {
			le.current = [], k({
				isDragGlobal: !1,
				type: "setDragGlobal"
			});
		};
		return document.addEventListener("dragenter", e, !1), document.addEventListener("dragleave", t, !1), document.addEventListener("dragend", n, !1), document.addEventListener("drop", r, !1), function() {
			document.removeEventListener("dragenter", e), document.removeEventListener("dragleave", t), document.removeEventListener("dragend", n), document.removeEventListener("drop", r);
		};
	}, [O]), P(function() {
		return !r && v && O.current && O.current.focus(), function() {};
	}, [
		O,
		v,
		r
	]);
	var ue = N(function(e) {
		w ? w(e) : console.error(e);
	}, [w]), de = N(function(e) {
		e.preventDefault(), e.persist(), Ce(e), ce.current = [].concat(qy(ce.current), [e.target]), Cy(e) && Promise.resolve(i(e)).then(function(t) {
			if (!Sy(e) || C) {
				var n = t.length, r = n > 0 && xy({
					files: t,
					accept: E,
					minSize: o,
					maxSize: a,
					multiple: s,
					maxFiles: c,
					validator: T
				});
				k({
					isDragAccept: r,
					isDragReject: n > 0 && !r,
					isDragActive: !0,
					type: "setDraggedFiles"
				}), l && l(e);
			}
		}).catch(function(e) {
			return ue(e);
		});
	}, [
		i,
		l,
		ue,
		C,
		E,
		o,
		a,
		s,
		c,
		T
	]), M = N(function(e) {
		e.preventDefault(), e.persist(), Ce(e);
		var t = Cy(e);
		if (t && e.dataTransfer) try {
			e.dataTransfer.dropEffect = "copy";
		} catch {}
		return t && d && d(e), !1;
	}, [d, C]), fe = N(function(e) {
		e.preventDefault(), e.persist(), Ce(e);
		var t = ce.current.filter(function(e) {
			return O.current && O.current.contains(e);
		}), n = t.indexOf(e.target);
		n !== -1 && t.splice(n, 1), ce.current = t, t.length > 0 || (k({
			type: "setDraggedFiles",
			isDragActive: !1,
			isDragAccept: !1,
			isDragReject: !1
		}), Cy(e) && u && u(e));
	}, [
		O,
		u,
		C
	]), pe = N(function(e, t) {
		var n = [], r = [];
		e.forEach(function(e) {
			var t = Zy(vy(e, E), 2), i = t[0], s = t[1], c = Zy(yy(e, o, a), 2), l = c[0], u = c[1], d = T ? T(e) : null;
			if (i && l && !d) n.push(e);
			else {
				var f = [s, u];
				d && (f = f.concat(d)), r.push({
					file: e,
					errors: f.filter(function(e) {
						return e;
					})
				});
			}
		}), (!s && n.length > 1 || s && c >= 1 && n.length > c) && (n.forEach(function(e) {
			r.push({
				file: e,
				errors: [Gy]
			});
		}), n.splice(0)), k({
			acceptedFiles: n,
			fileRejections: r,
			isDragReject: r.length > 0,
			type: "setFiles"
		}), f && f(n, r, t), r.length > 0 && m && m(r, t), n.length > 0 && p && p(n, t);
	}, [
		k,
		s,
		E,
		o,
		a,
		c,
		f,
		p,
		m,
		T
	]), me = N(function(e) {
		e.preventDefault(), e.persist(), Ce(e), ce.current = [], Cy(e) && Promise.resolve(i(e)).then(function(t) {
			(!Sy(e) || C) && pe(t, e);
		}).catch(function(e) {
			return ue(e);
		}), k({ type: "reset" });
	}, [
		i,
		pe,
		ue,
		C
	]), he = N(function() {
		if (se.current) {
			k({ type: "openDialog" }), ee();
			var e = {
				multiple: s,
				types: D
			};
			window.showOpenFilePicker(e).then(function(e) {
				return i(e);
			}).then(function(e) {
				pe(e, null), k({ type: "closeDialog" });
			}).catch(function(e) {
				My(e) ? (te(e), k({ type: "closeDialog" })) : Ny(e) ? (se.current = !1, ne.current ? (ne.current.value = null, ne.current.click()) : ue(/* @__PURE__ */ Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : ue(e);
			});
		} else ne.current && (k({ type: "openDialog" }), ee(), ne.current.value = null, ne.current.click());
	}, [
		k,
		ee,
		te,
		_,
		pe,
		ue,
		D,
		s
	]), ge = N(function(e) {
		O.current && O.current.isEqualNode(e.target) && (e.key === " " || e.key === "Enter" || e.keyCode === 32 || e.keyCode === 13) && (e.preventDefault(), he());
	}, [O, he]), _e = N(function() {
		k({ type: "focus" });
	}, []), ve = N(function() {
		k({ type: "blur" });
	}, []), ye = N(function() {
		b || (Dy() ? setTimeout(he, 0) : he());
	}, [b, he]), be = function(e) {
		return r ? null : e;
	}, xe = function(e) {
		return x ? null : be(e);
	}, Se = function(e) {
		return S ? null : be(e);
	}, Ce = function(e) {
		C && e.stopPropagation();
	}, we = Te(function() {
		return function() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.refKey, n = t === void 0 ? "ref" : t, i = e.role, a = e.onKeyDown, o = e.onFocus, s = e.onBlur, c = e.onClick, l = e.onDragEnter, u = e.onDragOver, d = e.onDragLeave, f = e.onDrop, p = ab(e, fb);
			return Q(Q(ib({
				onKeyDown: xe(Oy(a, ge)),
				onFocus: xe(Oy(o, _e)),
				onBlur: xe(Oy(s, ve)),
				onClick: be(Oy(c, ye)),
				onDragEnter: Se(Oy(l, de)),
				onDragOver: Se(Oy(u, M)),
				onDragLeave: Se(Oy(d, fe)),
				onDrop: Se(Oy(f, me)),
				role: typeof i == "string" && i !== "" ? i : "presentation"
			}, n, O), !r && !x ? { tabIndex: 0 } : {}), p);
		};
	}, [
		O,
		ge,
		_e,
		ve,
		ye,
		de,
		M,
		fe,
		me,
		x,
		S,
		r
	]), I = N(function(e) {
		e.stopPropagation();
	}, []), De = Te(function() {
		return function() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.refKey, n = t === void 0 ? "ref" : t, r = e.onChange, i = e.onClick, a = ab(e, pb);
			return Q(Q({}, ib({
				accept: E,
				multiple: s,
				type: "file",
				style: {
					border: 0,
					clip: "rect(0, 0, 0, 0)",
					clipPath: "inset(50%)",
					height: "1px",
					margin: "0 -1px -1px 0",
					overflow: "hidden",
					padding: 0,
					position: "absolute",
					width: "1px",
					whiteSpace: "nowrap"
				},
				onChange: be(Oy(r, me)),
				onClick: be(Oy(i, I)),
				tabIndex: -1
			}, n, ne)), a);
		};
	}, [
		ne,
		n,
		s,
		me,
		r
	]);
	return Q(Q({}, ie), {}, {
		isFocused: ae && !r,
		getRootProps: we,
		getInputProps: De,
		rootRef: O,
		inputRef: ne,
		open: be(he)
	});
}
function cb(e, t) {
	/* istanbul ignore next */
	switch (t.type) {
		case "focus": return Q(Q({}, e), {}, { isFocused: !0 });
		case "blur": return Q(Q({}, e), {}, { isFocused: !1 });
		case "openDialog": return Q(Q({}, gb), {}, { isFileDialogActive: !0 });
		case "closeDialog": return Q(Q({}, e), {}, { isFileDialogActive: !1 });
		case "setDraggedFiles": return Q(Q({}, e), {}, {
			isDragActive: t.isDragActive,
			isDragAccept: t.isDragAccept,
			isDragReject: t.isDragReject
		});
		case "setFiles": return Q(Q({}, e), {}, {
			acceptedFiles: t.acceptedFiles,
			fileRejections: t.fileRejections,
			isDragReject: t.isDragReject
		});
		case "setDragGlobal": return Q(Q({}, e), {}, { isDragGlobal: t.isDragGlobal });
		case "reset": return Q({}, gb);
		default: return e;
	}
}
function lb() {}
var $, ub, db, fb, pb, mb, hb, gb, _b = B((() => {
	$ = /* @__PURE__ */ Xe(Nv()), ny(), Ky(), ub = ["children"], db = ["open"], fb = [
		"refKey",
		"role",
		"onKeyDown",
		"onFocus",
		"onBlur",
		"onClick",
		"onDragEnter",
		"onDragOver",
		"onDragLeave",
		"onDrop"
	], pb = [
		"refKey",
		"onChange",
		"onClick"
	], mb = /*#__PURE__*/ ye(function(e, t) {
		var n = e.children, r = sb(ab(e, ub)), i = r.open, a = ab(r, db);
		return we(t, function() {
			return { open: i };
		}, [i]), /*#__PURE__*/ he.createElement(ge, null, n(Q(Q({}, a), {}, { open: i })));
	}), mb.displayName = "Dropzone", hb = {
		disabled: !1,
		getFilesFromEvent: zv,
		maxSize: Infinity,
		minSize: 0,
		multiple: !0,
		maxFiles: 0,
		preventDropOnDocument: !0,
		noClick: !1,
		noKeyboard: !1,
		noDrag: !1,
		noDragEventsBubbling: !1,
		validator: null,
		useFsAccessApi: !1,
		autoFocus: !1
	}, mb.defaultProps = hb, mb.propTypes = {
		children: $.default.func,
		accept: $.default.objectOf($.default.arrayOf($.default.string)),
		multiple: $.default.bool,
		preventDropOnDocument: $.default.bool,
		noClick: $.default.bool,
		noKeyboard: $.default.bool,
		noDrag: $.default.bool,
		noDragEventsBubbling: $.default.bool,
		minSize: $.default.number,
		maxSize: $.default.number,
		maxFiles: $.default.number,
		disabled: $.default.bool,
		getFilesFromEvent: $.default.func,
		onFileDialogCancel: $.default.func,
		onFileDialogOpen: $.default.func,
		useFsAccessApi: $.default.bool,
		autoFocus: $.default.bool,
		onDragEnter: $.default.func,
		onDragLeave: $.default.func,
		onDragOver: $.default.func,
		onDrop: $.default.func,
		onDropAccepted: $.default.func,
		onDropRejected: $.default.func,
		onError: $.default.func,
		validator: $.default.func
	}, gb = {
		isFocused: !1,
		isFileDialogActive: !1,
		isDragActive: !1,
		isDragAccept: !1,
		isDragReject: !1,
		isDragGlobal: !1,
		acceptedFiles: [],
		fileRejections: []
	};
})), vb, yb, bb, xb, Sb, Cb, wb, Tb = B((() => {
	vb = "_dropzone_1wf8u_1", yb = "_isFocused_1wf8u_7", bb = "_isDragAccept_1wf8u_11", xb = "_isDragReject_1wf8u_15", Sb = "_heading_1wf8u_20", Cb = "_uploadErrorText_1wf8u_24", wb = {
		dropzone: vb,
		isFocused: yb,
		isDragAccept: bb,
		isDragReject: xb,
		heading: Sb,
		uploadErrorText: Cb
	};
})), Eb, Db, Ob, kb, Ab, jb = B((() => {
	_b(), Tb(), Eb = ({ file: e, onDrop: t, uploadError: n, padding: r, title: i, description: a, height: o = "160px", width: s = "100%" }) => {
		let { getRootProps: c, getInputProps: l, open: u, isFocused: d, isDragAccept: f, isDragReject: p } = sb({
			noClick: !0,
			maxFiles: 1,
			onDrop: t,
			accept: { "image/*": [
				".png",
				".jpg",
				".jpeg"
			] }
		});
		return /* @__PURE__ */ z(m, {
			padding: r,
			children: [/* @__PURE__ */ z(T, {
				...c({
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					className: pe(wb.dropzone, {
						[wb.isFocused]: d,
						[wb.isDragAccept]: f,
						[wb.isDragReject]: p
					}),
					onClick: u,
					color: "#46597C",
					gap: "200",
					minWidth: "305px",
					style: {
						height: o,
						width: s
					}
				}),
				children: [e && !n ? /* @__PURE__ */ R(Ab, { filename: e.name }) : /* @__PURE__ */ z(L, { children: [
					f && /* @__PURE__ */ R(Ob, {}),
					p && /* @__PURE__ */ R(kb, {}),
					!f && !p && /* @__PURE__ */ R(Db, {
						title: i,
						description: a
					})
				] }), /* @__PURE__ */ R("input", { ...l() })]
			}), n && e && /* @__PURE__ */ R(M.Input, {
				className: wb.uploadErrorText,
				variant: "error",
				clamp: 5,
				wrap: "pre-wrap",
				children: `File could not be uploaded. ${n.message}`
			})]
		});
	}, Db = ({ title: e, description: t }) => /* @__PURE__ */ z(L, { children: [
		/* @__PURE__ */ R(ee, {
			name: "cloud-upload",
			size: 20
		}),
		e && /* @__PURE__ */ R(M.Paragraph, {
			variant: "1",
			className: wb.heading,
			children: e
		}),
		t && /* @__PURE__ */ R(M.Paragraph, {
			color: "secondary",
			variant: "4",
			children: t
		})
	] }), Ob = () => /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(ee, {
		name: "check-circle-filled",
		size: 20,
		className: wb.dropzoneIcon
	}), /* @__PURE__ */ R(M.Heading, { children: "Drop to upload image" })] }), kb = () => /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(ee, {
		name: "exclamation-circle-filled",
		size: 20,
		className: wb.dropzoneIcon
	}), /* @__PURE__ */ R(M.Heading, { children: "Image will not upload" })] }), Ab = ({ filename: e }) => /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(ce, {
		className: wb.dropzoneIcon,
		size: 20
	}), /* @__PURE__ */ z(M.Heading, { children: ["Uploading ", e] })] });
}));
// ../management-common/src/components/imageUpload/index.tsx
function Mb({ uploading: e, removing: t, uploadError: n, image: r, onDrop: i, onRemoveImage: a }) {
	let o = F(null), s = (e) => {
		e.target.files && i && i(Array.from(e.target.files), [], e);
	}, c = () => {
		a();
	}, l = r?.url;
	return /* @__PURE__ */ z(m, { children: [/* @__PURE__ */ z(T, {
		gap: "300",
		alignItems: "center",
		children: [
			!r && !e && /* @__PURE__ */ R(m, {
				className: Sv.uploadDropzoneWrapper,
				children: /* @__PURE__ */ R(Eb, {
					file: null,
					onDrop: i,
					uploadError: n,
					description: "Choose an image...",
					width: "160px",
					height: "80px"
				})
			}),
			e && /* @__PURE__ */ R(Nb, { label: "Uploading..." }),
			t && /* @__PURE__ */ R(Nb, { label: "Removing..." }),
			!!r && !e && !t && /* @__PURE__ */ R(Pb, { image: r }),
			/* @__PURE__ */ R("input", {
				id: "change-image",
				type: "file",
				ref: o,
				style: { display: "none" },
				onChange: s
			}),
			!e && n && /* @__PURE__ */ R(h, {
				variant: "secondary",
				onClick: c,
				children: "Try again"
			}),
			!e && !t && l && !n && /* @__PURE__ */ z(T, {
				gap: "200",
				children: [/* @__PURE__ */ R(h, {
					variant: "secondary",
					children: /* @__PURE__ */ R("label", {
						htmlFor: "change-image",
						children: "Change..."
					})
				}), /* @__PURE__ */ R(h, {
					variant: "secondary",
					onClick: a,
					children: "Remove"
				})]
			})
		]
	}), n && /* @__PURE__ */ R(x, {
		variant: "error",
		className: Sv.alert,
		children: n.message || "Image failed to upload. Please try again or try a new image."
	})] });
}
function Nb({ label: e }) {
	return /* @__PURE__ */ z(T, {
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		id: "wrapper",
		width: "160px",
		height: "80px",
		gap: "200",
		className: Sv.uploadDropzoneLoadingWrapper,
		children: [/* @__PURE__ */ R(ce, { size: 16 }), /* @__PURE__ */ R(M.Paragraph, {
			subdued: !0,
			variant: "4",
			children: e
		})]
	});
}
function Pb({ image: e }) {
	return /* @__PURE__ */ R(m, {
		className: Sv.uploadImageWrapper,
		children: /* @__PURE__ */ R("img", {
			className: Sv.uploadImage,
			src: e.url,
			alt: `Image filename: ${e.filename}`
		})
	});
}
var Fb = B((() => {
	Cv(), jb();
}));
// ../utils/src/string.ts
function Ib(e) {
	return e.substring(e.lastIndexOf("/") + 1);
}
var Lb = B((() => {}));
// ../management-common/src/hooks/useUploadImage.ts
function Rb(e) {
	let t = new DataView(e, 10), n = 0, r = t.getUint8(0), i = 0;
	r & 128 && (i = 3 * 2 ** ((r & 7) + 1)), n = 3 + i;
	let a = t.getUint8(n), o = t.getUint8(n + 1), s = 0;
	return a & 33 && o & 249 && (s = t.getUint16(n + 4)), s > 0;
}
async function zb(e) {
	if (e.type === "image/gif") {
		let t = await e.arrayBuffer();
		try {
			if (Rb(t) && e.size > Ub) return /* @__PURE__ */ Error("File size exceeds max allowed");
		} catch {}
	}
	return e.size > Hb ? /* @__PURE__ */ Error("File size exceeds max allowed") : null;
}
function Bb() {
	let [e, { error: t, reset: n }] = Nt(), [r, i] = I(void 0), [a, o] = I(!1);
	return [
		N(async (t) => {
			n(), i(void 0);
			let r = await zb(t);
			if (r) {
				i(r);
				return;
			}
			let { data: a } = await e({ variables: { fileName: t.name } }), s = a?.fileUploadRequest;
			if (!s) {
				i(/* @__PURE__ */ Error("Upload URL can't be found"));
				return;
			}
			let c = {
				url: s.availableAt,
				filename: Ib(s.availableAt),
				width: void 0,
				height: void 0
			}, l = { "Content-Type": s.contentType };
			s.customHeaders.forEach((e) => {
				let [t, n] = e.split(":");
				l[t] = n;
			});
			try {
				o(!0), await fetch(s.uploadUrl, {
					method: s.method,
					headers: l,
					body: t
				});
			} catch (e) {
				o(!1), i(e instanceof Error ? e : /* @__PURE__ */ Error("Upload failed"));
				return;
			}
			try {
				o(!0);
				let e = await fetch(Vb(s.availableAt), { method: "GET" });
				if (!e.ok) {
					o(!1), i(/* @__PURE__ */ Error(e.status === 413 ? "File size exceeds max allowed" : "Upload failed"));
					return;
				}
				c.width = Number.parseInt(e.headers.get("x-amz-meta-original-width") || "") || void 0, c.height = Number.parseInt(e.headers.get("x-amz-meta-original-height") || "") || void 0;
			} catch (e) {
				i(e instanceof Error ? e : /* @__PURE__ */ Error("Upload failed"));
				return;
			} finally {
				o(!1);
			}
			return c;
		}, [e, n]),
		t || r,
		a
	];
}
function Vb(e, t) {
	return `${e}?width=${Math.min(Wb, t || Wb)}`;
}
var Hb, Ub, Wb, Gb = B((() => {
	U(), Lb(), Hb = 52428800, Ub = 6291456, Wb = 1280;
})), Kb, qb, Jb, Yb, Xb, Zb, Qb, $b, ex, tx, nx, rx, ix, ax, ox, sx = B((() => {
	Kb = Symbol(), qb = Symbol(), Jb = "a", Yb = "w", Xb = (e, t) => new Proxy(e, t), Zb = Object.getPrototypeOf, Qb = /* @__PURE__ */ new WeakMap(), $b = (e) => e && (Qb.has(e) ? Qb.get(e) : Zb(e) === Object.prototype || Zb(e) === Array.prototype), ex = (e) => typeof e == "object" && !!e, tx = (e) => {
		if (Array.isArray(e)) return Array.from(e);
		let t = Object.getOwnPropertyDescriptors(e);
		return Object.values(t).forEach((e) => {
			e.configurable = !0;
		}), Object.create(Zb(e), t);
	}, nx = (e) => e[qb] || e, rx = (e, t, n, r) => {
		if (!$b(e)) return e;
		let i = r && r.get(e);
		if (!i) {
			let t = nx(e);
			i = ((e) => Object.values(Object.getOwnPropertyDescriptors(e)).some((e) => !e.configurable && !e.writable))(t) ? [t, tx(t)] : [t], r?.set(e, i);
		}
		let [a, o] = i, s = n && n.get(a);
		return s && s[1].f === !!o || (s = ((e, t) => {
			let n = { f: t }, r = !1, i = (t, i) => {
				if (!r) {
					let r = n[Jb].get(e);
					if (r || (r = {}, n[Jb].set(e, r)), t === Yb) r[Yb] = !0;
					else {
						let e = r[t];
						e || (e = /* @__PURE__ */ new Set(), r[t] = e), e.add(i);
					}
				}
			}, a = {
				get: (t, r) => r === qb ? e : (i("k", r), rx(Reflect.get(t, r), n[Jb], n.c, n.t)),
				has: (t, a) => a === Kb ? (r = !0, n[Jb].delete(e), !0) : (i("h", a), Reflect.has(t, a)),
				getOwnPropertyDescriptor: (e, t) => (i("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
				ownKeys: (e) => (i(Yb), Reflect.ownKeys(e))
			};
			return t && (a.set = a.deleteProperty = () => !1), [a, n];
		})(a, !!o), s[1].p = Xb(o || a, s[0]), n && n.set(a, s)), s[1][Jb] = t, s[1].c = n, s[1].t = r, s[1].p;
	}, ix = (e, t, n, r, i = Object.is) => {
		if (i(e, t)) return !1;
		if (!ex(e) || !ex(t)) return !0;
		let a = n.get(nx(e));
		if (!a) return !0;
		if (r) {
			let n = r.get(e);
			if (n && n.n === t) return n.g;
			r.set(e, {
				n: t,
				g: !1
			});
		}
		let o = null;
		try {
			for (let n of a.h || []) if (o = Reflect.has(e, n) !== Reflect.has(t, n), o) return o;
			if (!0 === a[Yb]) {
				if (o = ((e, t) => {
					let n = Reflect.ownKeys(e), r = Reflect.ownKeys(t);
					return n.length !== r.length || n.some((e, t) => e !== r[t]);
				})(e, t), o) return o;
			} else for (let n of a.o || []) if (o = !!Reflect.getOwnPropertyDescriptor(e, n) != !!Reflect.getOwnPropertyDescriptor(t, n), o) return o;
			for (let s of a.k || []) if (o = ix(e[s], t[s], n, r, i), o) return o;
			return o === null && (o = !0), o;
		} finally {
			r && r.set(e, {
				n: t,
				g: o
			});
		}
	}, ax = (e) => $b(e) && e[qb] || null, ox = (e, t = !0) => {
		Qb.set(e, t);
	};
}));
// ../../../node_modules/valtio/esm/vanilla.mjs
function cx(e = {}) {
	return hx(e);
}
function lx(e, t, n) {
	let r = fx.get(e), i, a = [], o = r[3], s = !1, c = o((e) => {
		a.push(e), n ? t(a.splice(0)) : i ||= Promise.resolve().then(() => {
			i = void 0, s && t(a.splice(0));
		});
	});
	return s = !0, () => {
		s = !1, c();
	};
}
function ux(e, t) {
	let [n, r, i] = fx.get(e);
	return i(n, r(), t);
}
var dx, fx, px, mx, hx, gx = B((() => {
	sx(), dx = (e) => typeof e == "object" && !!e, fx = /* @__PURE__ */ new WeakMap(), px = /* @__PURE__ */ new WeakSet(), mx = (e = Object.is, t = (e, t) => new Proxy(e, t), n = (e) => dx(e) && !px.has(e) && (Array.isArray(e) || !(Symbol.iterator in e)) && !(e instanceof WeakMap) && !(e instanceof WeakSet) && !(e instanceof Error) && !(e instanceof Number) && !(e instanceof Date) && !(e instanceof String) && !(e instanceof RegExp) && !(e instanceof ArrayBuffer), r = (e) => {
		switch (e.status) {
			case "fulfilled": return e.value;
			case "rejected": throw e.reason;
			default: throw e;
		}
	}, i = /* @__PURE__ */ new WeakMap(), a = (e, t, n = r) => {
		let o = i.get(e);
		if (o?.[0] === t) return o[1];
		let s = Array.isArray(e) ? [] : Object.create(Object.getPrototypeOf(e));
		return ox(s, !0), i.set(e, [t, s]), Reflect.ownKeys(e).forEach((t) => {
			if (Object.getOwnPropertyDescriptor(s, t)) return;
			let r = Reflect.get(e, t), { enumerable: i } = Reflect.getOwnPropertyDescriptor(e, t), o = {
				value: r,
				enumerable: i,
				configurable: !0
			};
			if (px.has(r)) ox(r, !1);
			else if (r instanceof Promise) delete o.value, o.get = () => n(r);
			else if (fx.has(r)) {
				let [e, t] = fx.get(r);
				o.value = a(e, t(), n);
			}
			Object.defineProperty(s, t, o);
		}), Object.preventExtensions(s);
	}, o = /* @__PURE__ */ new WeakMap(), s = [1, 1], c = (r) => {
		if (!dx(r)) throw Error("object required");
		let i = o.get(r);
		if (i) return i;
		let l = s[0], u = /* @__PURE__ */ new Set(), d = (e, t = ++s[0]) => {
			l !== t && (l = t, u.forEach((n) => n(e, t)));
		}, f = s[1], p = (e = ++s[1]) => (f !== e && !u.size && (f = e, h.forEach(([t]) => {
			let n = t[1](e);
			n > l && (l = n);
		})), l), m = (e) => (t, n) => {
			let r = [...t];
			r[1] = [e, ...r[1]], d(r, n);
		}, h = /* @__PURE__ */ new Map(), g = (e, t) => {
			if (u.size) {
				let n = t[3](m(e));
				h.set(e, [t, n]);
			} else h.set(e, [t]);
		}, _ = (e) => {
			var t;
			let n = h.get(e);
			n && (h.delete(e), (t = n[1]) == null || t.call(n));
		}, v = (e) => (u.add(e), u.size === 1 && h.forEach(([e, t], n) => {
			let r = e[3](m(n));
			h.set(n, [e, r]);
		}), () => {
			u.delete(e), u.size === 0 && h.forEach(([e, t], n) => {
				t && (t(), h.set(n, [e]));
			});
		}), y = Array.isArray(r) ? [] : Object.create(Object.getPrototypeOf(r)), b = t(y, {
			deleteProperty(e, t) {
				let n = Reflect.get(e, t);
				_(t);
				let r = Reflect.deleteProperty(e, t);
				return r && d([
					"delete",
					[t],
					n
				]), r;
			},
			set(t, r, i, a) {
				let s = Reflect.has(t, r), l = Reflect.get(t, r, a);
				if (s && (e(l, i) || o.has(i) && e(l, o.get(i)))) return !0;
				_(r), dx(i) && (i = ax(i) || i);
				let u = i;
				if (i instanceof Promise) i.then((e) => {
					i.status = "fulfilled", i.value = e, d([
						"resolve",
						[r],
						e
					]);
				}).catch((e) => {
					i.status = "rejected", i.reason = e, d([
						"reject",
						[r],
						e
					]);
				});
				else {
					!fx.has(i) && n(i) && (u = c(i));
					let e = !px.has(u) && fx.get(u);
					e && g(r, e);
				}
				return Reflect.set(t, r, u, a), d([
					"set",
					[r],
					i,
					l
				]), !0;
			}
		});
		o.set(r, b);
		let x = [
			y,
			p,
			a,
			v
		];
		return fx.set(b, x), Reflect.ownKeys(r).forEach((e) => {
			let t = Object.getOwnPropertyDescriptor(r, e);
			"value" in t && (b[e] = r[e], delete t.value, delete t.writable), Object.defineProperty(y, e, t);
		}), b;
	}) => [
		c,
		fx,
		px,
		e,
		t,
		n,
		r,
		i,
		a,
		o,
		s
	], [hx] = mx();
})), _x = /* @__PURE__ */ V(((e) => {
	var t = L_();
	function n(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var r = typeof Object.is == "function" ? Object.is : n, i = t.useState, a = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
	function c(e, t) {
		var n = t(), r = i({ inst: {
			value: n,
			getSnapshot: t
		} }), c = r[0].inst, u = r[1];
		return o(function() {
			c.value = n, c.getSnapshot = t, l(c) && u({ inst: c });
		}, [
			e,
			n,
			t
		]), a(function() {
			return l(c) && u({ inst: c }), e(function() {
				l(c) && u({ inst: c });
			});
		}, [e]), s(n), n;
	}
	function l(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !r(e, n);
		} catch {
			return !0;
		}
	}
	function u(e, t) {
		return t();
	}
	var d = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? u : c;
	e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? d : t.useSyncExternalStore;
})), vx = /* @__PURE__ */ V(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(/* @__PURE__ */ Error());
		var t = L_(), n = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
		function r(e) {
			i("error", e, [...arguments].slice(1));
		}
		function i(e, t, r) {
			var i = n.ReactDebugCurrentFrame.getStackAddendum();
			i !== "" && (t += "%s", r = r.concat([i]));
			var a = r.map(function(e) {
				return String(e);
			});
			a.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, a);
		}
		function a(e, t) {
			return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
		}
		var o = typeof Object.is == "function" ? Object.is : a, s = t.useState, c = t.useEffect, l = t.useLayoutEffect, u = t.useDebugValue, d = !1, f = !1;
		function p(e, n, i) {
			d || t.startTransition !== void 0 && (d = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
			var a = n();
			f || o(a, n()) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
			var p = s({ inst: {
				value: a,
				getSnapshot: n
			} }), h = p[0].inst, g = p[1];
			return l(function() {
				h.value = a, h.getSnapshot = n, m(h) && g({ inst: h });
			}, [
				e,
				a,
				n
			]), c(function() {
				return m(h) && g({ inst: h }), e(function() {
					m(h) && g({ inst: h });
				});
			}, [e]), u(a), a;
		}
		function m(e) {
			var t = e.getSnapshot, n = e.value;
			try {
				return !o(n, t());
			} catch {
				return !0;
			}
		}
		function h(e, t, n) {
			return t();
		}
		var g = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? h : p;
		e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? g : t.useSyncExternalStore, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(/* @__PURE__ */ Error());
	})();
})), yx = /* @__PURE__ */ V(((e, t) => {
	t.exports = process.env.NODE_ENV === "production" ? _x() : vx();
}));
// ../../../node_modules/valtio/esm/react.mjs
function bx(e, t) {
	let n = t?.sync, r = F(), i = F(), a = !0, o = Cx(N((t) => {
		let r = lx(e, t, n);
		return t(), r;
	}, [e, n]), () => {
		let t = ux(e, Sx);
		try {
			if (!a && r.current && i.current && !ix(r.current, t, i.current, /* @__PURE__ */ new WeakMap())) return r.current;
		} catch {}
		return t;
	}, () => ux(e, Sx));
	a = !1;
	let s = /* @__PURE__ */ new WeakMap();
	P(() => {
		r.current = o, i.current = s;
	});
	let c = Te(() => /* @__PURE__ */ new WeakMap(), []);
	return rx(o, s, c, wx);
}
var xx, Sx, Cx, wx, Tx = B((() => {
	sx(), xx = /* @__PURE__ */ Xe(yx(), 1), gx(), {use: Sx} = he, {useSyncExternalStore: Cx} = xx.default, wx = /* @__PURE__ */ new WeakMap();
})), Ex = B((() => {
	gx(), Tx();
})), Dx, Ox, kx, Ax, jx = B((() => {
	Ex(), Dx = cx({
		companyLogo: null,
		favicon: null
	}), Ox = () => {
		Dx.companyLogo = null, Dx.favicon = null;
	}, kx = (e) => {
		Dx.companyLogo = e;
	}, Ax = (e) => {
		Dx.favicon = e;
	};
}));
// src/components/customizationForm/image/fieldCompanyLogoUploader.tsx
function Mx({ helpCenterId: e }) {
	let [t, { loading: n }] = Bt(), [r, i, a] = Bb(), [o, { loading: s }] = Ft(), { successNotify: c, errorNotify: l } = Ns(), u = bx(Dx);
	function d() {
		t({
			variables: { helpCenterId: e },
			onCompleted: () => {
				kx(null), c({
					title: "Image deleted",
					text: "Image was successfully deleted"
				});
			},
			onError: (e) => {
				l({
					text: `Please try again. Cause: ${e.message}`,
					title: "Unable to update Help Center"
				});
			}
		});
	}
	let f = N(({ onChange: t, attachMutation: n, uploadMutation: r }) => async function(i) {
		if (i?.length !== 1) return;
		let a = i[0].type;
		if (a !== "image/jpg" && a !== "image/jpeg" && a !== "image/png") {
			l({
				title: "Not allowed",
				text: "Images must be .jpg, .jpeg or .png format only"
			});
			return;
		}
		let o = await r(i[0]);
		o && e && n({
			variables: {
				id: e,
				logo: o.url
			},
			onCompleted: () => {
				c({
					title: "Image uploaded",
					text: "Image was uploaded successfully"
				}), t(o);
			},
			onError: (e) => {
				l({
					title: "Image could not be saved",
					text: e.message
				});
			}
		});
	}, [
		l,
		e,
		c
	]);
	return /* @__PURE__ */ R(w, {
		label: "Company logo",
		noAlert: !0,
		children: /* @__PURE__ */ R(Mb, {
			uploading: a || s,
			removing: n,
			onDrop: f({
				onChange: kx,
				attachMutation: o,
				uploadMutation: r
			}),
			uploadError: i,
			image: u.companyLogo,
			onRemoveImage: d
		})
	});
}
var Nx = B((() => {
	Fb(), U(), Gb(), Ps(), Ex(), jx();
}));
// src/components/customizationForm/image/fieldFaviconUploader.tsx
function Px({ helpCenterId: e }) {
	let [t, n, r] = Bb(), [i, { loading: a }] = zt(), [o, { loading: s }] = It(), { successNotify: c, errorNotify: l } = Ns(), u = bx(Dx);
	function d() {
		i({
			variables: { helpCenterId: e },
			onCompleted: () => {
				Ax(null), c({
					title: "Favicon deleted",
					text: "Favicon was successfully deleted"
				});
			},
			onError: (e) => {
				l({
					text: `Please try again. Cause: ${e.message}`,
					title: "Unable to update Help Center"
				});
			}
		});
	}
	let f = N(({ onChange: t, attachMutation: n, uploadMutation: r }) => async function(i) {
		if (i?.length !== 1) return;
		let a = i[0].type;
		if (a !== "image/jpg" && a !== "image/jpeg" && a !== "image/png") {
			l({
				title: "Not allowed",
				text: "Images must be .jpg, .jpeg or .png format only"
			});
			return;
		}
		let o = await r(i[0]);
		o && e && n({
			variables: {
				id: e,
				favicon: o.url
			},
			onCompleted: () => {
				c({
					title: "Favicon uploaded",
					text: "Favicon was uploaded successfully"
				}), t(o);
			},
			onError: (e) => {
				l({
					title: "Image could not be saved",
					text: e.message
				});
			}
		});
	}, [
		l,
		e,
		c
	]);
	return /* @__PURE__ */ R(w, {
		label: "Favicon",
		noAlert: !0,
		children: /* @__PURE__ */ R(Mb, {
			uploading: r || s,
			removing: a,
			onDrop: f({
				onChange: Ax,
				attachMutation: o,
				uploadMutation: t
			}),
			uploadError: n,
			image: u.favicon,
			onRemoveImage: d
		})
	});
}
var Fx = B((() => {
	Fb(), U(), Gb(), Ps(), Ex(), jx();
}));
// ../utils/src/colors.ts
function Ix(e) {
	return e.length === 9 ? e.slice(0, 7) : e;
}
var Lx = B((() => {}));
// src/utils/colors.ts
function Rx(e) {
	let t = {};
	for (let n in e) if (Object.prototype.hasOwnProperty.call(e, n)) {
		let r = e[n];
		t[n] = Ix(r);
	}
	return t;
}
var zx = B((() => {
	Lx();
}));
// src/components/customizationForm/useCustomizationFormSchemaInitialValues.ts
function Bx({ helpCenter: e }) {
	let { enabledLanguages: t } = Ce(Yr), { companyUrl: n, theme: { colors: r, id: i }, translations: a } = e;
	return Te(() => ({
		companyUrl: n || "",
		helpCenterTaglines: t.map((e) => {
			let t = a.find((t) => t.languageId === e.languageId);
			return {
				languageId: e.languageId,
				tagline: t?.tagline || ""
			};
		}),
		helpCenterTitles: t.map((e) => {
			let t = a.find((t) => t.languageId === e.languageId);
			return {
				languageId: e.languageId,
				title: t?.title || ""
			};
		}),
		themeId: i,
		colors: Rx(r)
	}), [
		t,
		a,
		r,
		n,
		i
	]);
}
var Vx = B((() => {
	Xr(), zx();
}));
// src/components/customizationForm/useUpdateCustomizationSettingsForm.ts
function Hx({ onCompleted: e, onError: t }) {
	let { enabledLanguages: n } = Ce(Yr), [r, { loading: i }] = Kt({ onError: t }), [a, { loading: o }] = qt({ onError: t });
	return [async ({ helpCenterId: i, touchedFields: o, formValues: s }) => {
		let c = r({
			onError: t,
			variables: {
				helpCenterId: i,
				colors: s.colors,
				companyUrl: s.companyUrl,
				themeId: s.themeId
			}
		}), l = n.map((e, t) => {
			let n = s.helpCenterTitles, r = s.helpCenterTaglines, c = n.find((t) => t.languageId === e.languageId), l = r.find((t) => t.languageId === e.languageId), u = o.helpCenterTitles?.[t]?.title || !1, d = o.helpCenterTaglines?.[t]?.tagline || !1;
			return !u && !d ? null : a({ variables: {
				helpCenterId: i,
				translation: {
					languageId: e.languageId,
					tagline: l?.tagline || "",
					title: c?.title || ""
				}
			} });
		});
		await Promise.all([c, ...l]), e(s);
	}, { loading: i || o }];
}
var Ux = B((() => {
	Xr(), U();
}));
// src/components/customizationForm/customizationFormContent.tsx
function Wx({ helpCenter: e }) {
	let { id: t, logo: n, favicon: r } = e;
	P(() => {
		Ox();
	}, [t]), Gx({
		initialLogo: n,
		initialFavicon: r
	});
	let { enabledLanguages: i } = Ce(Yr), a = Bx({ helpCenter: e }), { control: o, handleSubmit: s, formState: { isValid: c, isDirty: l, touchedFields: u }, reset: d, getValues: f } = Be({
		defaultValues: a,
		resolver: Xi(hv),
		reValidateMode: "onChange",
		mode: "all"
	}), { errorNotify: p, successNotify: m } = Ns(), [h, { loading: g }] = Hx({
		onCompleted: (e) => {
			m({
				title: "Success",
				text: "Help center has been updated."
			}), d(e), Ve.knowledgeHelpCenterUpdated({ helpCenterId: t });
		},
		onError: (e) => {
			throw p({
				title: "Unable to update Help Center",
				text: "Please try again. If this issue persists contact customer support."
			}), e;
		}
	});
	function _(e) {
		h({
			formValues: e,
			helpCenterId: t,
			touchedFields: u
		});
	}
	let v = g || !l, y = f("helpCenterTitles");
	return /* @__PURE__ */ R(L, { children: /* @__PURE__ */ R("form", {
		onSubmit: s(_),
		children: /* @__PURE__ */ z(D, { children: [
			/* @__PURE__ */ R(s_, {
				label: "Customization",
				loading: g,
				isValid: c,
				disabled: v
			}),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(Mx, { helpCenterId: t }) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(Px, { helpCenterId: t }) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(os, {
				control: o,
				name: "companyUrl",
				label: "Company URL",
				description: "A URL must be a valid format and start with 'https://' or 'http://'",
				placeholder: "https://yoursite.com"
			}) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(w_, {
				legend: "Help center title",
				children: /* @__PURE__ */ R(D, { children: y.map(({ languageId: e }, t) => /* @__PURE__ */ R(ls, {
					control: o,
					fieldName: `helpCenterTitles.${t}.title`,
					label: lv({
						languageId: e,
						languages: i
					}).description
				}, e)) })
			}) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(w_, {
				legend: "Help center tagline",
				children: /* @__PURE__ */ R(D, { children: y.map(({ languageId: e }, t) => /* @__PURE__ */ R(ls, {
					control: o,
					fieldName: `helpCenterTaglines.${t}.tagline`,
					label: lv({
						languageId: e,
						languages: i
					}).description
				}, e)) })
			}) }),
			/* @__PURE__ */ R(E, {
				span: 3,
				children: /* @__PURE__ */ R(is, {
					control: o,
					label: "Website background color",
					name: "colors.websiteBackground"
				})
			}),
			/* @__PURE__ */ R(E, {
				span: 3,
				children: /* @__PURE__ */ R(is, {
					control: o,
					label: "Page background color",
					name: "colors.pageBackground"
				})
			}),
			/* @__PURE__ */ R(E, {
				span: 3,
				children: /* @__PURE__ */ R(is, {
					control: o,
					label: "Text color",
					name: "colors.text"
				})
			}),
			/* @__PURE__ */ R(E, {
				span: 3,
				children: /* @__PURE__ */ R(is, {
					control: o,
					label: "Link color",
					name: "colors.link"
				})
			}),
			/* @__PURE__ */ R(E, {
				span: 3,
				children: /* @__PURE__ */ R(is, {
					control: o,
					label: "Accent color",
					name: "colors.accent"
				})
			}),
			/* @__PURE__ */ R(E, {
				span: 3,
				children: /* @__PURE__ */ R(is, {
					control: o,
					label: "Accent text color",
					name: "colors.accentText"
				})
			})
		] })
	}) });
}
function Gx({ initialLogo: e, initialFavicon: t }) {
	P(() => {
		e && (Dx.companyLogo = {
			filename: e.filename,
			url: e.availableAt,
			width: e.size,
			height: 0
		}), t && (Dx.favicon = {
			filename: t.filename,
			url: t.availableAt,
			width: t.size,
			height: 0
		});
	}, []);
}
var Kx = B((() => {
	Zi(), Cs(), T_(), Xr(), uv(), Ps(), c_(), gv(), Nx(), Fx(), jx(), Vx(), Ux();
}));
// src/components/customizationForm/customizationFormLoadingPlaceholder.tsx
function qx() {
	let e = () => /* @__PURE__ */ R(E, {
		span: 3,
		children: /* @__PURE__ */ R(E, { children: /* @__PURE__ */ z(w, {
			noLabel: !0,
			children: [/* @__PURE__ */ R(A, {
				height: "16px",
				width: "64px",
				animation: "wave",
				margin: "0 0 8px"
			}), /* @__PURE__ */ R(A, {
				height: "40px",
				width: "100%",
				animation: "wave"
			})]
		}) })
	});
	return /* @__PURE__ */ R("form", { children: /* @__PURE__ */ z(D, { children: [
		/* @__PURE__ */ R(a_, {}),
		/* @__PURE__ */ R(E, { children: /* @__PURE__ */ z(w, {
			noLabel: !0,
			children: [/* @__PURE__ */ R(A, {
				height: "16px",
				width: "64px",
				animation: "wave",
				margin: "0 0 8px"
			}), /* @__PURE__ */ R(A, {
				height: "80px",
				width: "160px",
				animation: "wave"
			})]
		}) }),
		/* @__PURE__ */ R(E, { children: /* @__PURE__ */ z(w, {
			noLabel: !0,
			children: [/* @__PURE__ */ R(A, {
				height: "16px",
				width: "64px",
				animation: "wave",
				margin: "0 0 8px"
			}), /* @__PURE__ */ R(A, {
				height: "80px",
				width: "160px",
				animation: "wave"
			})]
		}) }),
		Array.from([
			,
			,
			,
		]).map((e, t) => /* @__PURE__ */ R(E, { children: /* @__PURE__ */ z(w, {
			noLabel: !0,
			children: [/* @__PURE__ */ R(A, {
				height: "16px",
				width: "64px",
				animation: "wave",
				margin: "0 0 8px"
			}), /* @__PURE__ */ R(A, {
				height: "40px",
				width: "100%",
				animation: "wave"
			})]
		}) }, t)),
		Array.from([
			,
			,
			,
			,
			,
			,
		]).map((t, n) => /* @__PURE__ */ R(e, {}, n))
	] }) });
}
var Jx = B((() => {
	o_();
}));
// src/components/customizationForm/index.tsx
function Yx({ helpCenterId: e }) {
	let { loading: t, data: n, error: r } = Ut({ variables: { id: e } });
	return !t && n && n.helpCenter ? /* @__PURE__ */ R(Wx, { helpCenter: n.helpCenter }) : r ? /* @__PURE__ */ R(Ri, { errorMessage: r.message }) : /* @__PURE__ */ R(qx, {});
}
var Xx = B((() => {
	U(), zi(), Kx(), Jx();
}));
// src/utils/googleSiteVerification.ts
function Zx(e) {
	return (new DOMParser().parseFromString(e, "text/html").querySelector("meta[name=\"google-site-verification\"]")?.getAttribute("content") ?? e).trim();
}
var Qx = B((() => {}));
// src/hooks/useHelpCenterUpdateSettingsMutation.ts
function $x({ helpCenterId: e, subdomainChanged: t, onCompleted: n, onError: r }) {
	let [i, a] = Jt({
		onCompleted: n,
		onError: r
	});
	function o(n) {
		let { enabledLanguages: r, disabledLanguages: a } = eS({ settingsFormLanguages: n.languages });
		i({ variables: {
			id: e,
			active: n.active,
			collectionId: n.collectionId,
			subdomain: t ? n.subdomain : void 0,
			name: n.name,
			enableLanguages: r,
			disableLanguages: a,
			isHelpCenterIndexable: n.isHelpCenterIndexable,
			defaultLanguage: n.defaultLanguage.at(0)?.id,
			googleSiteVerification: Zx(n.googleSiteVerification)
		} });
	}
	return [o, a];
}
function eS({ settingsFormLanguages: e }) {
	let { enabled: t, disabled: n } = e.reduce((e, t) => (t.enabled ? e.enabled.push(t.languageId) : e.disabled.push(t.languageId), e), {
		enabled: [],
		disabled: []
	});
	return {
		enabledLanguages: t.length ? t : void 0,
		disabledLanguages: n.length ? n : void 0
	};
}
var tS = B((() => {
	U(), Qx();
}));
// src/components/settingsForm/defaultLanguageSelect.tsx
function nS({ control: e, watch: t, availableLanguages: n }) {
	let r = t("languages"), i = Te(() => r.filter((e) => e.enabled).map((e) => {
		let t = n.find((t) => t.languageId === e.languageId)?.description || "";
		return {
			id: e.languageId,
			name: t
		};
	}), [n, r]);
	return /* @__PURE__ */ R(ds, {
		control: e,
		name: "defaultLanguage",
		label: "Default language",
		itemsLoading: !1,
		placeholders: {
			loading: "Loading available languages...",
			empty: "Select default language"
		},
		equalityFn: (e, t) => e.id === t.id,
		listItems: i,
		multiple: !1,
		required: !0
	});
}
var rS = B((() => {
	Cs();
})), iS, aS, oS = B((() => {
	iS = "_table_tz287_1", aS = { table: iS };
}));
// src/components/settingsForm/languagesPanel.tsx
function sS(e) {
	return /* @__PURE__ */ R(w, {
		label: "Languages",
		required: !0,
		children: /* @__PURE__ */ z(j, {
			className: aS.table,
			children: [/* @__PURE__ */ R(j.Thead, { children: /* @__PURE__ */ z(j.Tr, { children: [/* @__PURE__ */ R(j.Th, { children: "Language" }), /* @__PURE__ */ R(j.Th, {})] }) }), /* @__PURE__ */ R(j.Tbody, { children: /* @__PURE__ */ R(cS, { ...e }) })]
		})
	});
}
function cS({ watch: e, setValue: t, availableLanguages: n }) {
	let r = e("languages"), i = r.map((e) => ({
		languageId: e.languageId,
		enabled: e.enabled,
		description: n.find((t) => t.languageId === e.languageId)?.description || "",
		nativeDescription: n.find((t) => t.languageId === e.languageId)?.nativeDescription || ""
	})), a = e("defaultLanguage"), o = ({ index: e }) => {
		t(`languages.${e}.enabled`, !r[e].enabled, {
			shouldDirty: !0,
			shouldTouch: !0
		});
	};
	return /* @__PURE__ */ R(L, { children: i.map(({ languageId: e, enabled: t }, n) => {
		let r = e === a[0]?.id, s = lv({
			languageId: e,
			languages: i
		}).description;
		return /* @__PURE__ */ z(j.Tr, { children: [/* @__PURE__ */ R(j.Td, { children: r ? `${s} (Default)` : s }), /* @__PURE__ */ R(j.Td, { children: /* @__PURE__ */ R(le, {
			name: e,
			value: t?.toString(),
			checked: t,
			disabled: r,
			onChange: () => o({ index: n })
		}) })] }, e);
	}) });
}
var lS = B((() => {
	uv(), oS();
}));
// src/components/settingsForm/settingsFormSchema.ts
function uS({ helpCenterEnabledLanguages: e, enabledLanguages: t }) {
	return t.map((t) => ({
		languageId: t.languageId,
		enabled: e.some((e) => e.languageId === t.languageId)
	}));
}
var dS, fS, pS, mS, hS = B((() => {
	U(), dg(), mg(), dS = eh({
		languageId: rh(Qt),
		enabled: Xm()
	}), fS = eh({
		active: Xm(),
		name: Y().min(1, { error: "A name must be provided." }),
		collectionId: Jm({ error: "A collection must be chosen" }),
		isHelpCenterIndexable: Xm(),
		googleSiteVerification: Y(),
		defaultLanguage: $m(eh({
			id: rh(Qt),
			name: Y()
		})),
		languages: $m(dS)
	}), pS = fS.extend(pg.shape), mS = ({ helpCenter: e, enabledLanguages: t }) => ({
		active: e.isActive,
		name: e.name,
		collectionId: e.collection?.id || "",
		subdomain: e.subdomain,
		isHelpCenterIndexable: e.isHelpCenterIndexable,
		googleSiteVerification: e.googleSiteVerification ?? "",
		subdomainValidations: [],
		languages: uS({
			helpCenterEnabledLanguages: e.enabledLanguages || [],
			enabledLanguages: t
		}),
		defaultLanguage: [{
			id: e.defaultLanguage.languageId,
			name: e.defaultLanguage.description
		}]
	});
}));
// src/components/settingsForm/index.tsx
function gS({ helpCenterId: e }) {
	let { loading: t, data: n, error: r } = Ut({ variables: { id: e } });
	return !t && n && n.helpCenter ? /* @__PURE__ */ R(vS, { helpCenter: n.helpCenter }) : r ? /* @__PURE__ */ R(Ri, { errorMessage: r.message }) : /* @__PURE__ */ R(_S, {});
}
function _S() {
	return /* @__PURE__ */ R("form", { children: /* @__PURE__ */ z(D, { children: [
		/* @__PURE__ */ R(a_, {}),
		/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(w, {
			noLabel: !0,
			children: /* @__PURE__ */ R(A, {
				animation: "wave",
				width: "100%",
				height: "72px"
			})
		}) }),
		Array.from([
			,
			,
			,
		]).map((e, t) => /* @__PURE__ */ R(E, { children: /* @__PURE__ */ z(w, {
			noLabel: !0,
			children: [/* @__PURE__ */ R(A, {
				height: "16px",
				width: "64px",
				animation: "wave",
				margin: "0 0 8px"
			}), /* @__PURE__ */ R(A, {
				height: "40px",
				width: "100%",
				animation: "wave"
			})]
		}) }, t))
	] }) });
}
function vS({ helpCenter: e }) {
	let { successNotify: t, errorNotify: n } = Ns(), { enabledLanguages: r, availableLanguages: i } = Ce(Yr), { seoMeta: a } = Ce(hi), o = mS({
		helpCenter: e,
		enabledLanguages: r
	}), { reset: s, control: c, watch: l, formState: { defaultValues: u, errors: d, dirtyFields: f, isDirty: p, isValid: h }, setValue: g, handleSubmit: _ } = Be({
		resolver: Xi(pS),
		defaultValues: o,
		reValidateMode: "onChange",
		mode: "all"
	}), v = f.subdomain, [y, b] = $x({
		helpCenterId: e.id,
		subdomainChanged: v,
		onCompleted: (e) => {
			let n = e.helpCenterUpdate;
			if (!n) return;
			t({
				title: "Help Center Updated",
				text: `${n.name} has been updated.`
			}), Ve.knowledgeHelpCenterUpdated({ helpCenterId: n.id });
			let i = mS({
				helpCenter: n,
				enabledLanguages: r
			});
			s(i);
		},
		onError: (e) => {
			throw n({
				title: "Unable to update Help Center",
				text: e.message || "Please try again. If this issue persists contact customer support."
			}), e;
		}
	}), x = l("subdomain"), S = js({
		initialSubdomain: u?.subdomain || "",
		subdomain: x,
		subdomainErrorMessage: d.subdomain?.message
	}), C = b.loading;
	return /* @__PURE__ */ R("form", {
		onSubmit: _(y),
		children: /* @__PURE__ */ z(D, { children: [
			/* @__PURE__ */ R(s_, {
				label: "Settings",
				loading: C,
				isValid: h,
				disabled: !p
			}),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(xs, {
				control: c,
				name: "active",
				heading: "Enable Help Center",
				subHeading: "Make your Help Center publicly available",
				dark: !0
			}) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(os, {
				control: c,
				name: "name",
				label: "Name",
				required: !0
			}) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(m, { children: /* @__PURE__ */ R(Ie, {
				name: "collectionId",
				control: c,
				render: ({ field: e, fieldState: t }) => /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(Ds, {
					collectionId: e.value,
					setCollectionId: e.onChange,
					excludeInternalOnly: !0,
					required: !0
				}), t.error && /* @__PURE__ */ R(M.Paragraph, {
					color: "var(--dixa-typography-color-error)	",
					children: t.error.message
				})] })
			}) }) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(hg, {
				control: c,
				subdomainAvailability: S,
				subdomainPath: "subdomain",
				subdomainValidationsPath: "subdomainValidations"
			}) }),
			a && /* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(os, {
				control: c,
				name: "googleSiteVerification",
				label: "Google Search Console verification",
				helpIcon: { text: "Paste the HTML tag or its code from Google Search Console's HTML tag verification method." },
				placeholder: "<meta name=\"google-site-verification\" content=\"…\" />"
			}) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(xs, {
				control: c,
				name: "isHelpCenterIndexable",
				heading: "Allow search engines to index Help Center",
				subHeading: "Manage whether your public Help Center content appears in search engine results."
			}) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(nS, {
				control: c,
				watch: l,
				availableLanguages: i
			}) }),
			/* @__PURE__ */ R(E, { children: /* @__PURE__ */ R(sS, {
				setValue: g,
				watch: l,
				availableLanguages: i
			}) })
		] })
	});
}
var yS = B((() => {
	Zi(), Cs(), Os(), Xr(), U(), Ms(), Ps(), gi(), tS(), o_(), zi(), c_(), _g(), rS(), lS(), hS();
})), bS, xS, SS, CS, wS, TS, ES, DS, OS, kS = B((() => {
	bS = "_tabContentWrapper_1315b_1", xS = "_tabContentContainer_1315b_5", SS = "_tabContent_1315b_1", CS = "_inactive_1315b_14", wS = "_preview_1315b_19", TS = "_customHostname_1315b_27", ES = "_tab_1315b_1", DS = "_tabsWrapper_1315b_49", OS = {
		tabContentWrapper: bS,
		tabContentContainer: xS,
		tabContent: SS,
		inactive: CS,
		preview: wS,
		customHostname: TS,
		tab: ES,
		tabsWrapper: DS
	};
})), AS = /* @__PURE__ */ Je({
	BackButton: () => PS,
	default: () => MS
});
function jS({ tabId: e, helpCenterId: t, isActive: n }) {
	let r = pe(OS.tabContent, {
		[OS.inactive]: !n,
		[OS.customHostname]: e === IS.CustomHostname
	});
	if (!t) return null;
	let i;
	switch (e) {
		case IS.Settings:
			i = /* @__PURE__ */ R(gS, { helpCenterId: t });
			break;
		case IS.Customization:
			i = /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(Yx, { helpCenterId: t }), /* @__PURE__ */ R("div", { className: OS.preview })] });
			break;
		case IS.Advanced:
			i = /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(m_, { helpCenterId: t }), /* @__PURE__ */ R("div", { className: OS.preview })] });
			break;
		case IS.CustomHostname:
			i = /* @__PURE__ */ R(sv, {
				helpCenterId: t,
				isActive: n
			});
			break;
		default: i = null;
	}
	return /* @__PURE__ */ R(m, {
		className: r,
		children: i
	});
}
function MS() {
	let { helpCenterId: e } = Me(), [t, n] = I(IS.Settings);
	return /* @__PURE__ */ R(kt, { children: /* @__PURE__ */ R(kt.Body, { children: /* @__PURE__ */ z(T, {
		flexDirection: "column",
		width: "100%",
		className: OS.tabContentWrapper,
		children: [
			/* @__PURE__ */ R(kt.Head, {
				slotLeft: /* @__PURE__ */ R(kt.HeadBackLink, {
					backText: "Back",
					backProps: { to: Ii.helpCentersPath() }
				}),
				slotCenter: /* @__PURE__ */ R(kt.HeadTitle, { title: "Dixa Help Center" }),
				slotRight: /* @__PURE__ */ R(FS, { helpCenterId: e })
			}),
			/* @__PURE__ */ R(ue, {
				tabs: LS,
				onChange: n,
				activeId: t,
				tabClassName: OS.tab,
				className: OS.tabsWrapper
			}),
			/* @__PURE__ */ R(NS, { children: LS.map((n) => /* @__PURE__ */ R(jS, {
				tabId: n.id,
				helpCenterId: e,
				isActive: t === n.id
			}, n.id)) })
		]
	}) }) });
}
function NS({ children: e }) {
	return /* @__PURE__ */ R(m, {
		className: OS.tabContentContainer,
		children: e
	});
}
function PS() {
	return /* @__PURE__ */ R(De, {
		to: Ii.helpCentersPath(),
		children: "Back"
	});
}
function FS({ helpCenterId: e = "" }) {
	if (!e) throw Error("No helpCenterId provided");
	let { loading: t, data: n } = Ut({ variables: { id: e } });
	return n?.helpCenter?.isActive ? /* @__PURE__ */ R("a", {
		href: n?.helpCenter?.hostname ? `https://${n.helpCenter.hostname}/en` : "",
		target: "_blank",
		rel: "noreferrer",
		children: /* @__PURE__ */ R(h, {
			variant: "secondary",
			disabled: t,
			icon: "external-link",
			children: "Open"
		})
	}) : /* @__PURE__ */ R(fe, {
		content: "This help center is not currently active",
		children: /* @__PURE__ */ R(h, {
			variant: "secondary",
			disabled: !0,
			icon: "external-link",
			children: "Open"
		})
	});
}
var IS, LS, RS = B((() => {
	U(), At(), Li(), y_(), cv(), Xx(), yS(), kS(), IS = {
		CustomHostname: "customHostname",
		Settings: "settings",
		Customization: "customization",
		Advanced: "advanced"
	}, LS = [
		{
			id: IS.Settings,
			label: "Settings"
		},
		{
			id: IS.Customization,
			label: "Customization"
		},
		{
			id: IS.Advanced,
			label: "Advanced"
		},
		{
			id: IS.CustomHostname,
			label: "Custom hostname"
		}
	];
}));
si(), pi(), qr(), gi();
var zS = xe(() => Promise.resolve().then(() => (qg(), Vg))), BS = xe(() => Promise.resolve().then(() => (RS(), AS))), VS = [{
	path: "/",
	element: /* @__PURE__ */ R(zS, {})
}, {
	path: "/:helpCenterId",
	element: /* @__PURE__ */ R(BS, {})
}];
function HS() {
	return Ne(VS);
}
var US = ({ notify: e, featureFlags: t }) => {
	let n = st();
	return /* @__PURE__ */ R(ci, {
		fallback: /* @__PURE__ */ R(ui, {}),
		children: /* @__PURE__ */ R(fi.Provider, {
			value: e,
			children: /* @__PURE__ */ R(hi.Provider, {
				value: t,
				children: /* @__PURE__ */ R(r, {
					client: n,
					children: /* @__PURE__ */ R(_e, {
						fallback: /* @__PURE__ */ R(di, {}),
						children: /* @__PURE__ */ R(Er, {
							adapter: mi,
							children: /* @__PURE__ */ R(Zr, { children: /* @__PURE__ */ R(Qr, { children: /* @__PURE__ */ R(HS, {}) }) })
						})
					})
				})
			})
		})
	});
};
export { US as default, VS as helpCenterRoutesData };

//# sourceMappingURL=index.js.map